/*
 * @license
 * Pipeline Theme (c) Groupthought Themes
 *
 * This file is included for advanced development by
 * Shopify Agencies.  Modified versions of the theme
 * code are not supported by Shopify or Groupthought.
 *
 * In order to use this file you will need to change
 * theme.js to theme.dev.js in /layout/theme.liquid
 *
 */

(function (
  FlickityFade,
  bodyScrollLock,
  MicroModal,
  Rellax,
  Flickity,
  themeCurrency,
  Sqrl,
  axios,
  themeAddresses,
  ellipsed,
  FlickitySync,
  AOS
) {
  "use strict";

  function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== "default") {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(
            n,
            k,
            d.get
              ? d
              : {
                  enumerable: true,
                  get: function () {
                    return e[k];
                  },
                }
          );
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var Sqrl__namespace = /*#__PURE__*/ _interopNamespaceDefault(Sqrl);

  window.theme = window.theme || {};

  window.theme.sizes = {
    small: 480,
    medium: 768,
    large: 990,
    widescreen: 1400,
  };

  window.theme.keyboardKeys = {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    SPACE: 32,
    LEFTARROW: 37,
    RIGHTARROW: 39,
  };

  function moveModals(container) {
    const modals = container.querySelectorAll("[data-modal]");
    const modalBin = document.querySelector("[data-modal-container]");
    modals.forEach((element) => {
      const alreadyAdded = modalBin.querySelector(`[id="${element.id}"]`);
      if (!alreadyAdded) {
        modalBin.appendChild(element);
      }
    });
  }

  const classes$q = ["neighbor--white", "neighbor--light", "neighbor--dark", "neighbor--black"];

  function moveTags(container) {
    container.querySelectorAll("shopify-section").forEach((element) => {
      element.classList.remove(classes$q);
    });
    container.querySelectorAll(".bg--neutral").forEach((element) => {
      element.parentElement.classList.add("neighbor--white");
    });
    container.querySelectorAll(".bg--accent").forEach((element) => {
      element.parentElement.classList.add("neighbor--light");
    });
    container.querySelectorAll(".bg--invert").forEach((element) => {
      element.parentElement.classList.add("neighbor--dark");
    });
    container.querySelectorAll(".bg--invert--accent").forEach((element) => {
      element.parentElement.classList.add("neighbor--black");
    });
  }

  function floatLabels(container) {
    const floats = container.querySelectorAll(".float__wrapper");
    floats.forEach((element) => {
      const label = element.querySelector("label");
      const input = element.querySelector("input, textarea");
      if (label) {
        input.addEventListener("keyup", (event) => {
          if (event.target.value !== "") {
            label.classList.add("label--float");
          } else {
            label.classList.remove("label--float");
          }
        });
      }
      if (input && input.value && input.value.length) {
        label.classList.add("label--float");
      }
    });
  }

  function errorTabIndex(container) {
    const errata = container.querySelectorAll(".errors");
    errata.forEach((element) => {
      element.setAttribute("tabindex", "0");
      element.setAttribute("aria-live", "assertive");
      element.setAttribute("role", "alert");
    });
  }

  function lazyPostLoad(container) {
    document.addEventListener("theme:resize", loadDesktop.bind(null, container));
    loadDesktop(container);
  }

  function loadDesktop(container) {
    if (window.innerWidth > window.theme.sizes.small) {
      setTimeout(() => {
        const elements = container.querySelectorAll(".lazypostload-desktop");
        elements.forEach((element) => {
          element.style.visibility = "visible";
        });
      }, 2000);
    }
  }

  function readHeights() {
    const h = {};
    h.windowHeight = window.innerHeight;
    h.announcementHeight = getHeight("#shopify-section-announcement");
    h.footerHeight = getHeight('[data-section-type*="footer"]');
    h.menuHeight = getHeight("[data-header-height]");
    h.headerHeight = h.menuHeight + h.announcementHeight;
    h.logoHeight = getFooterLogoWithPadding();
    return h;
  }

  function setVarsOnResize() {
    document.addEventListener("theme:resize", resizeVars);
    setVars();
  }

  function setVars() {
    const { windowHeight, announcementHeight, headerHeight, logoHeight, menuHeight, footerHeight } = readHeights();

    document.documentElement.style.setProperty("--footer-logo", `${logoHeight}px`);
    document.documentElement.style.setProperty("--full-screen", `${windowHeight}px`);
    document.documentElement.style.setProperty("--three-quarters", `${windowHeight * 0.75}px`);
    document.documentElement.style.setProperty("--two-thirds", `${windowHeight * 0.66}px`);
    document.documentElement.style.setProperty("--one-half", `${windowHeight * 0.5}px`);
    document.documentElement.style.setProperty("--one-third", `${windowHeight * 0.33}px`);
    document.documentElement.style.setProperty("--one-fifth", `${windowHeight * 0.2}px`);
    document.documentElement.style.setProperty("--menu-height", `${menuHeight}px`);
    document.documentElement.style.setProperty("--announcement-height", `${announcementHeight}px`);
    document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);

    document.documentElement.style.setProperty("--footer-height", `${footerHeight}px`);
    document.documentElement.style.setProperty("--content-full", `${windowHeight - headerHeight - logoHeight / 2}px`);
    document.documentElement.style.setProperty("--content-min", `${windowHeight - headerHeight - footerHeight}px`);

    document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    );
  }

  function resizeVars() {
    // restrict the heights that are changed on resize to avoid iOS jump when URL bar is shown and hidden
    const { windowHeight, announcementHeight, headerHeight, logoHeight, menuHeight, footerHeight } = readHeights();
    document.documentElement.style.setProperty("--menu-height", `${menuHeight}px`);
    document.documentElement.style.setProperty("--announcement-height", `${announcementHeight}px`);
    document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);

    document.documentElement.style.setProperty("--footer-height", `${footerHeight}px`);
    document.documentElement.style.setProperty("--content-full", `${windowHeight - headerHeight - logoHeight / 2}px`);
    document.documentElement.style.setProperty("--content-min", `${windowHeight - headerHeight - footerHeight}px`);
  }

  function getHeight(selector) {
    const el = document.querySelector(selector);
    if (el) {
      return el.clientHeight;
    } else {
      return 0;
    }
  }

  function getFooterLogoWithPadding() {
    const height = getHeight("[data-footer-logo]");
    if (height > 0) {
      return height + 20;
    } else {
      return 0;
    }
  }

  function singles(frame, wrappers) {
    // sets the height of any frame passed in with the
    // tallest js-overflow-content as well as any image in that frame
    let padding = 64;
    let tallest = 0;

    wrappers.forEach((wrap) => {
      if (wrap.offsetHeight > tallest) {
        const getMarginTop = parseInt(window.getComputedStyle(wrap).marginTop);
        const getMarginBottom = parseInt(window.getComputedStyle(wrap).marginBottom);
        const getMargin = getMarginTop + getMarginBottom;
        if (getMargin > padding) {
          padding = getMargin;
        }

        tallest = wrap.offsetHeight;
      }
    });
    const images = frame.querySelectorAll("[data-overflow-background]");
    const frames = [frame, ...images];
    frames.forEach((el) => {
      el.style.setProperty("min-height", `calc(${tallest + padding}px + var(--menu-height))`);
    });
  }

  function doubles(section) {
    let footerLogoH = document.querySelector("[data-footer-logo]")
      ? document.querySelector("[data-footer-logo]").clientHeight + 20
      : 0;
    const lastSection = document.querySelector("#MainContent .shopify-section:last-child [data-section-id]");
    const lastSectionAttrID = lastSection ? lastSection.getAttribute("data-section-id") : null;

    if ((lastSectionAttrID !== null && section.getAttribute("data-section-id") !== lastSectionAttrID) || !lastSection) {
      footerLogoH = 0;
    }

    if (window.innerWidth < window.theme.sizes.medium) {
      // if we are below the small breakpoint, the double section acts like two independent
      // single frames
      let singleFrames = section.querySelectorAll("[data-overflow-frame]");
      singleFrames.forEach((singleframe) => {
        const wrappers = singleframe.querySelectorAll("[data-overflow-content]");
        singles(singleframe, wrappers);
      });
      return;
    }

    const padding = parseInt(getComputedStyle(section).getPropertyValue("--outer")) * 2;
    let tallest = 0;

    const frames = section.querySelectorAll("[data-overflow-frame]");
    const contentWrappers = section.querySelectorAll("[data-overflow-content]");
    contentWrappers.forEach((content) => {
      if (content.offsetHeight > tallest) {
        tallest = content.offsetHeight;
      }
    });
    const images = section.querySelectorAll("[data-overflow-background]");
    let applySizes = [...frames, ...images];
    applySizes.forEach((el) => {
      el.style.setProperty("min-height", `${tallest + padding}px`);
    });
    section.style.setProperty("min-height", `${tallest + padding + 2 + footerLogoH}px`);
  }

  function preventOverflow(container) {
    const singleFrames = container.querySelectorAll(".js-overflow-container");
    if (singleFrames) {
      singleFrames.forEach((frame) => {
        const wrappers = frame.querySelectorAll(".js-overflow-content");
        singles(frame, wrappers);
        document.addEventListener("theme:resize", () => {
          singles(frame, wrappers);
        });
      });

      // Reload slides if container has slideshow
      const slideshows = container.querySelectorAll("[data-slideshow-wrapper]");

      if (slideshows.length) {
        slideshows.forEach((slideshow) => {
          const slideshowInstance = FlickityFade.data(slideshow);
          if (typeof slideshowInstance !== "undefined") {
            slideshow.dispatchEvent(
              new CustomEvent("theme:slideshow:reload", {
                bubbles: true,
              })
            );
          }
        });
      }
    }

    const doubleSections = container.querySelectorAll("[data-overflow-wrapper]");
    if (doubleSections) {
      doubleSections.forEach((section) => {
        doubles(section);
        document.addEventListener("theme:resize", () => {
          doubles(section);
        });
      });
    }
  }

  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  let lastWindowWidth = window.innerWidth;
  let lastWindowHeight = window.innerHeight;

  function dispatch$1() {
    document.dispatchEvent(
      new CustomEvent("theme:resize", {
        bubbles: true,
      })
    );

    if (lastWindowWidth !== window.innerWidth) {
      document.dispatchEvent(
        new CustomEvent("theme:resize:width", {
          bubbles: true,
        })
      );

      lastWindowWidth = window.innerWidth;
    }

    if (lastWindowHeight !== window.innerHeight) {
      document.dispatchEvent(
        new CustomEvent("theme:resize:height", {
          bubbles: true,
        })
      );

      lastWindowHeight = window.innerHeight;
    }
  }

  function resizeListener() {
    window.addEventListener(
      "resize",
      debounce(function () {
        dispatch$1();
      }, 50)
    );
  }

  let prev = window.pageYOffset;
  let up = null;
  let down = null;
  let wasUp = null;
  let wasDown = null;
  let scrollLockTimeout = 0;

  function dispatch() {
    const position = window.pageYOffset;
    if (position > prev) {
      down = true;
      up = false;
    } else if (position < prev) {
      down = false;
      up = true;
    } else {
      up = null;
      down = null;
    }
    prev = position;
    document.dispatchEvent(
      new CustomEvent("theme:scroll", {
        detail: {
          up,
          down,
          position,
        },
        bubbles: false,
      })
    );
    if (up && !wasUp) {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:up", {
          detail: { position },
          bubbles: false,
        })
      );
    }
    if (down && !wasDown) {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:down", {
          detail: { position },
          bubbles: false,
        })
      );
    }
    wasDown = down;
    wasUp = up;
  }

  function lock(e) {
    let element = e.target;
    if (e.detail && e.detail instanceof Element) {
      element = e.detail;
    }
    bodyScrollLock.disableBodyScroll(element);
    document.documentElement.setAttribute("data-scroll-locked", "");
  }

  function unlock() {
    // Prevent body scroll lock race conditions
    scrollLockTimeout = setTimeout(() => {
      document.body.removeAttribute("data-drawer-closing");
    }, 20);

    if (document.body.hasAttribute("data-drawer-closing")) {
      document.body.removeAttribute("data-drawer-closing");

      if (scrollLockTimeout) {
        clearTimeout(scrollLockTimeout);
      }

      return;
    } else {
      document.body.setAttribute("data-drawer-closing", "");
    }

    document.documentElement.removeAttribute("data-scroll-locked");
    bodyScrollLock.clearAllBodyScrollLocks();
  }

  function scrollListener() {
    let timeout;
    window.addEventListener(
      "scroll",
      function () {
        if (timeout) {
          window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(function () {
          dispatch();
        });
      },
      { passive: true }
    );

    window.addEventListener("theme:scroll:lock", lock);
    window.addEventListener("theme:scroll:unlock", unlock);
  }

  resizeListener();
  scrollListener();

  window.addEventListener("load", () => {
    setVarsOnResize();
    floatLabels(document);
    errorTabIndex(document);
    moveTags(document);
    moveModals(document);
    preventOverflow(document);
    lazyPostLoad(document);
  });

  document.addEventListener("shopify:section:load", (e) => {
    const container = e.target;
    floatLabels(container);
    errorTabIndex(container);
    moveModals(container);
    moveTags(container);
    preventOverflow(container);
    lazyPostLoad(container);
  });

  document.addEventListener("shopify:section:reorder", () => {
    document.dispatchEvent(new CustomEvent("header:check", { bubbles: false }));
  });

  const showElement = (elem, removeProp = false, prop = "block") => {
    if (elem) {
      if (removeProp) {
        elem.style.removeProperty("display");
      } else {
        elem.style.display = prop;
      }
    }
  };

  function FetchError(object) {
    this.status = object.status || null;
    this.headers = object.headers || null;
    this.json = object.json || null;
    this.body = object.body || null;
  }
  FetchError.prototype = Error.prototype;

  const selectors$T = {
    elements: {
      scrollbar: "data-scrollbar-slider",
      scrollbarArrowPrev: "[data-scrollbar-arrow-prev]",
      scrollbarArrowNext: "[data-scrollbar-arrow-next]",
    },
    classes: {
      hide: "is-hidden",
      siblingLinks: "siblings__link ",
    },
    times: {
      delay: 200,
    },
  };

  class NativeScrollbar {
    constructor(scrollbar) {
      this.scrollbar = scrollbar;

      this.arrowNext = this.scrollbar.parentNode.querySelector(selectors$T.elements.scrollbarArrowNext);
      this.arrowPrev = this.scrollbar.parentNode.querySelector(selectors$T.elements.scrollbarArrowPrev);

      this.init();
      this.resize();

      if (this.scrollbar.hasAttribute(selectors$T.elements.scrollbar)) {
        this.scrollToVisibleElement();
      }
    }

    init() {
      if (this.arrowNext && this.arrowPrev) {
        if (window.isRTL) {
          this.togglePrevArrow();
        } else {
          this.toggleNextArrow();
        }

        this.events();
      }
    }

    resize() {
      document.addEventListener("theme:resize", () => {
        if (window.isRTL) {
          this.togglePrevArrow();
        } else {
          this.toggleNextArrow();
        }
      });
    }

    events() {
      this.arrowNext.addEventListener("click", (event) => {
        event.preventDefault();

        this.goToNext();
      });

      this.arrowPrev.addEventListener("click", (event) => {
        event.preventDefault();

        this.goToPrev();
      });

      this.scrollbar.addEventListener("scroll", () => {
        this.togglePrevArrow();
        this.toggleNextArrow();
      });
    }

    goToNext() {
      const position = this.scrollbar.getBoundingClientRect().width / 2 + this.scrollbar.scrollLeft;

      this.move(position);

      this.arrowPrev.classList.remove(selectors$T.classes.hide);

      this.toggleNextArrow();
    }

    goToPrev() {
      const position = this.scrollbar.scrollLeft - this.scrollbar.getBoundingClientRect().width / 2;

      this.move(position);

      this.arrowNext.classList.remove(selectors$T.classes.hide);

      this.togglePrevArrow();
    }

    toggleNextArrow() {
      setTimeout(() => {
        if (window.isRTL) {
          this.arrowNext.classList.toggle(selectors$T.classes.hide, this.scrollbar.scrollLeft === 0);
        } else {
          this.arrowNext.classList.toggle(
            selectors$T.classes.hide,
            Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >=
              this.scrollbar.scrollWidth
          );
        }
      }, selectors$T.times.delay);
    }

    togglePrevArrow() {
      setTimeout(() => {
        if (window.isRTL) {
          this.arrowPrev.classList.toggle(
            selectors$T.classes.hide,
            Math.abs(this.scrollbar.scrollLeft) + this.scrollbar.getBoundingClientRect().width + 1 >=
              this.scrollbar.scrollWidth
          );
        } else {
          this.arrowPrev.classList.toggle(selectors$T.classes.hide, this.scrollbar.scrollLeft <= 0);
        }
      }, selectors$T.times.delay);
    }

    scrollToVisibleElement() {
      [].forEach.call(this.scrollbar.children, (element) => {
        element.addEventListener("click", (event) => {
          if (
            !event.target.classList.contains(selectors$T.classes.siblingLinks) &&
            !event.target.closest(`.${selectors$T.classes.siblingLinks}`)
          ) {
            event.preventDefault();
          }

          this.move(element.offsetLeft - element.clientWidth);
        });
      });
    }

    move(offsetLeft) {
      this.scrollbar.scrollTo({
        top: 0,
        left: offsetLeft,
        behavior: "smooth",
      });
    }
  }

  const selectors$S = {
    siblingsInnerHolder: "[data-sibling-inner]",
  };

  class Siblings {
    constructor(holder) {
      this.siblings = holder.querySelectorAll(selectors$S.siblingsInnerHolder);

      this.init();
    }

    init() {
      this.siblings.forEach((sibling) => {
        new NativeScrollbar(sibling);
      });
    }
  }

  const siblings = {
    onLoad() {
      new Siblings(this.container);
    },
  };

  const cookieDefaultValues = {
    expires: 7,
    path: "/",
    domain: window.location.hostname,
  };

  class Cookies {
    constructor(options = {}) {
      this.options = {
        ...cookieDefaultValues,
        ...options,
      };
    }

    /**
     * Write cookie
     * @param value - String
     */
    write(value) {
      document.cookie = `${this.options.name}=${value}; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
    }

    /**
     * Read cookies and returns an array of values
     * @returns Array
     */
    read() {
      let cookieValuesArr = [];
      const hasCookieWithThisName = document.cookie.split("; ").find((row) => row.startsWith(this.options.name));

      if (document.cookie.indexOf("; ") !== -1 && hasCookieWithThisName) {
        const cookieValue = document.cookie
          .split("; ")
          .find((row) => row.startsWith(this.options.name))
          .split("=")[1];

        if (cookieValue !== null) {
          cookieValuesArr = cookieValue.split(",");
        }
      }

      return cookieValuesArr;
    }

    destroy() {
      document.cookie = `${this.options.name}=null; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
    }

    remove(removedValue) {
      const cookieValue = this.read();
      const position = cookieValue.indexOf(removedValue);

      if (position !== -1) {
        cookieValue.splice(position, 1);
        this.write(cookieValue);
      }
    }
  }

  const config = {
    howManyToShow: 4,
    howManyToStoreInMemory: 10,
    wrapper: "[data-recently-viewed-products]",
    limit: "data-limit",
    recentTabLink: "[data-recent-link-tab]",
    recentWrapper: "[data-recent-wrapper]",
    recentViewedTab: "[data-recently-viewed-tab]",
    tabsHolderScroll: "[data-tabs-holder-scroll]",
    apiContent: "[data-api-content]",
    dataMinimum: "data-minimum",
  };

  const cookieConfig = {
    expires: 90,
    name: "shopify_recently_viewed",
  };

  const sections$n = [];
  const excludedHandles = [];

  class RecentProducts {
    constructor(section) {
      this.container = section.container;
      this.cookie = new Cookies(cookieConfig);
      this.wrapper = this.container.querySelector(config.wrapper);

      if (this.wrapper === null) {
        return;
      }

      this.howManyToShow =
        parseInt(this.container.querySelector(config.recentWrapper).getAttribute(config.limit)) || config.howManyToShow;
      this.minimum = parseInt(this.container.querySelector(config.recentWrapper).getAttribute(config.dataMinimum));

      this.recentViewedTab = this.container.querySelector(config.recentViewedTab);
      this.recentViewedLink = this.container.querySelector(config.recentTabLink);
      this.tabsHolderScroll = this.container.querySelector(config.tabsHolderScroll);

      this.renderProducts();
    }

    renderProducts() {
      const recentlyViewedHandlesArray = this.cookie.read();
      const arrayURLs = [];
      let counter = 0;

      if (recentlyViewedHandlesArray.length > 0) {
        for (let index = 0; index < recentlyViewedHandlesArray.length; index++) {
          const handle = recentlyViewedHandlesArray[index];

          if (excludedHandles.includes(handle)) {
            continue;
          }

          const url = `${window.theme.routes.root_url}products/${handle}?section_id=api-product-grid-item`;

          arrayURLs.push(url);

          counter++;

          if (counter === this.howManyToShow || counter === recentlyViewedHandlesArray.length - 1) {
            break;
          }
        }

        if (arrayURLs.length > 0 && arrayURLs.length >= this.minimum) {
          this.container.classList.remove("hide");

          if (this.recentViewedLink && this.recentViewedLink.previousElementSibling) {
            this.tabsHolderScroll.classList.remove("hide");
          }

          const fecthRequests = arrayURLs.map((url) => fetch(url, { mode: "no-cors" }).then(this.handleErrors));
          const productMarkups = [];

          Promise.allSettled(fecthRequests)
            .then((responses) => {
              return Promise.all(
                responses.map(async (response) => {
                  if (response.status === "fulfilled") {
                    productMarkups.push(await response.value.text());
                  }
                })
              );
            })
            .then(() => {
              productMarkups.forEach((markup) => {
                const buffer = document.createElement("div");
                const slide = document.createElement("div");
                buffer.innerHTML = markup;

                slide.classList.add("product-grid-slide");
                slide.innerHTML = buffer.querySelector(config.apiContent).innerHTML;

                this.wrapper.appendChild(slide);
              });

              new Siblings(this.container);
            })
            .then(() => {
              showElement(this.wrapper, true);

              this.container.dispatchEvent(new CustomEvent("recent-products:added", { bubbles: true }));
            });
        } else if (this.recentViewedTab) {
          const hasSiblingTabs =
            Array.prototype.filter.call(this.recentViewedTab.parentNode.children, (child) => {
              return child !== this.recentViewedTab;
            }).length > 1;

          if (this.recentViewedLink && this.recentViewedLink.previousElementSibling) {
            this.tabsHolderScroll.classList.add("hide");
          }

          if (!hasSiblingTabs) {
            this.container.classList.add("hide");
          }
        } else {
          this.container.classList.add("hide");
        }
      }
    }

    handleErrors(response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          const e = new FetchError({
            status: response.statusText,
            headers: response.headers,
            text: text,
          });
          throw e;
        });
      }
      return response;
    }
  }

  class RecordRecentlyViewed {
    constructor(handle) {
      this.handle = handle;
      this.cookie = new Cookies(cookieConfig);

      if (typeof this.handle === "undefined") {
        return;
      }

      excludedHandles.push(this.handle);

      this.updateCookie();
    }

    updateCookie() {
      let recentlyViewed = this.cookie.read();

      // In what position is that product in memory.
      const position = recentlyViewed.indexOf(this.handle);

      // If not in memory.
      if (position === -1) {
        // Add product at the start of the list.
        recentlyViewed.unshift(this.handle);
        // Only keep what we need.
        recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
      } else {
        // Remove the product and place it at start of list.
        recentlyViewed.splice(position, 1);
        recentlyViewed.unshift(this.handle);
      }

      // Update cookie.
      this.cookie.write(recentlyViewed);
    }
  }

  const recentProducts = {
    onLoad() {
      sections$n[this.id] = new RecentProducts(this);
    },
  };

  const selectors$R = {
    templateAddresses: "[data-address-wrapper]",
    addressNewForm: "[data-new-address-form]",
    addressNewFormInner: "[new-address-form-inner]",
    btnSubmit: "[data-address-submit]",
    btnDelete: ".address-delete",
    classHide: "hide",
    dataFormId: "data-form-id",
    dataConfirmMessage: "data-confirm-message",
    defaultConfirmMessage: "Are you sure you wish to delete this address?",
    editAddress: "#EditAddress",
    addressCountryNew: "AddressCountryNew",
    addressProvinceNew: "AddressProvinceNew",
    addressProvinceContainerNew: "AddressProvinceContainerNew",
    addressCountryOption: ".address-country-option",
    addressCountry: "AddressCountry",
    addressProvince: "AddressProvince",
    addressProvinceContainer: "AddressProvinceContainer",
  };

  class Addresses {
    constructor(section) {
      this.section = section;
      this.addressNewForm = this.section.querySelector(selectors$R.addressNewForm);
      this.formElem = this.addressNewForm.querySelector("form");
      this.init();

      modal("address");
    }

    init() {
      if (this.addressNewForm) {
        const section = this.section;
        this.customerAddresses();

        const deleteButtons = section.querySelectorAll(selectors$R.btnDelete);
        if (deleteButtons.length) {
          deleteButtons.forEach((element) => {
            element.addEventListener("click", function () {
              const formId = this.getAttribute(selectors$R.dataFormId);
              Shopify.postLink(window.theme.routes.account_addresses_url + "/" + formId, {
                parameters: { _method: "delete" },
              });
            });
          });
        }

        const submitButtons = section.querySelectorAll(selectors$R.btnSubmit);
        if (submitButtons.length) {
          submitButtons.forEach((button) => button.addEventListener("click", () => button.classList.add("loading")));
        }
      }
    }

    customerAddresses() {
      // Initialize observers on address selectors, defined in shopify_common.js
      if (Shopify.CountryProvinceSelector) {
        new Shopify.CountryProvinceSelector(selectors$R.addressCountryNew, selectors$R.addressProvinceNew, {
          hideElement: selectors$R.addressProvinceContainerNew,
        });
      }

      // Initialize each edit form's country/province selector
      const countryOptions = this.section.querySelectorAll(selectors$R.addressCountryOption);
      countryOptions.forEach((element) => {
        const formId = element.getAttribute(selectors$R.dataFormId);
        const countrySelector = `${selectors$R.addressCountry}_${formId}`;
        const provinceSelector = `${selectors$R.addressProvince}_${formId}`;
        const containerSelector = `${selectors$R.addressProvinceContainer}_${formId}`;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector,
        });
      });
    }
  }

  const template = document.querySelector(selectors$R.templateAddresses);
  if (template) {
    new Addresses(template);
  }

  /**
   * Password Template Script
   * ------------------------------------------------------------------------------
   * A file that contains code for the Password template.
   *
   * @namespace password
   */

  (function () {
    var recoverPasswordForm = document.querySelector("#RecoverPassword");
    if (recoverPasswordForm) {
      customerLogin();
    }

    function customerLogin() {
      var config = {
        recoverPasswordForm: "#RecoverPassword",
        hideRecoverPasswordLink: "#HideRecoverPasswordLink",
      };

      checkUrlHash();
      resetPasswordSuccess();

      document.querySelector(config.recoverPasswordForm).addEventListener("click", onShowHidePasswordForm);
      document.querySelector(config.hideRecoverPasswordLink).addEventListener("click", onShowHidePasswordForm);

      function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      }

      function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === "#recover") {
          toggleRecoverPasswordForm();
        }
      }

      /**
       *  Show/Hide recover password form
       */
      function toggleRecoverPasswordForm() {
        var emailValue = document.querySelector("#CustomerEmail").value;
        document.querySelector("#RecoverEmail").value = emailValue;
        document.querySelector("#RecoverPasswordForm").classList.toggle("display-none");
        document.querySelector("#CustomerLoginForm").classList.toggle("display-none");
      }

      /**
       *  Show reset password success message
       */
      function resetPasswordSuccess() {
        var formSuccess = document.querySelector(".reset-password-success");
        // check if reset password form was successfully submited.
        if (formSuccess) {
          document.querySelector("#ResetSuccess").classList.remove("display-none");
        }
      }
    }
  })();

  window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};
  window.Shopify.theme.sections = window.Shopify.theme.sections || {};

  window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
  window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
  const registered = window.Shopify.theme.sections.registered;
  const instances = window.Shopify.theme.sections.instances;

  const selectors$Q = {
    id: "data-section-id",
    type: "data-section-type",
  };

  class Registration {
    constructor(type = null, components = []) {
      this.type = type;
      this.components = validateComponentsArray(components);
      this.callStack = {
        onLoad: [],
        onUnload: [],
        onSelect: [],
        onDeselect: [],
        onBlockSelect: [],
        onBlockDeselect: [],
        onReorder: [],
      };
      components.forEach((comp) => {
        for (const [key, value] of Object.entries(comp)) {
          const arr = this.callStack[key];
          if (Array.isArray(arr) && typeof value === "function") {
            arr.push(value);
          } else {
            console.warn(`Unregisted function: '${key}' in component: '${this.type}'`);
            console.warn(value);
          }
        }
      });
    }

    getStack() {
      return this.callStack;
    }
  }

  class Section {
    constructor(container, registration) {
      this.container = validateContainerElement(container);
      this.id = container.getAttribute(selectors$Q.id);
      this.type = registration.type;
      this.callStack = registration.getStack();

      try {
        this.onLoad();
      } catch (e) {
        console.warn(`Error in section: ${this.id}`);
        console.warn(this);
        console.warn(e);
      }
    }

    callFunctions(key, e = null) {
      this.callStack[key].forEach((func) => {
        const props = {
          id: this.id,
          type: this.type,
          container: this.container,
        };
        if (e) {
          func.call(props, e);
        } else {
          func.call(props);
        }
      });
    }

    onLoad() {
      this.callFunctions("onLoad");
    }

    onUnload() {
      this.callFunctions("onUnload");
    }

    onSelect(e) {
      this.callFunctions("onSelect", e);
    }

    onDeselect(e) {
      this.callFunctions("onDeselect", e);
    }

    onBlockSelect(e) {
      this.callFunctions("onBlockSelect", e);
    }

    onBlockDeselect(e) {
      this.callFunctions("onBlockDeselect", e);
    }

    onReorder(e) {
      this.callFunctions("onReorder", e);
    }
  }

  function validateContainerElement(container) {
    if (!(container instanceof Element)) {
      throw new TypeError(
        "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
      );
    }
    if (container.getAttribute(selectors$Q.id) === null) {
      throw new Error(
        "Theme Sections: The section container provided does not have an id assigned to the " +
          selectors$Q.id +
          " attribute."
      );
    }

    return container;
  }

  function validateComponentsArray(value) {
    if ((typeof value !== "undefined" && typeof value !== "object") || value === null) {
      throw new TypeError("Theme Sections: The components object provided is not a valid");
    }

    return value;
  }

  /*
   * @shopify/theme-sections
   * -----------------------------------------------------------------------------
   *
   * A framework to provide structure to your Shopify sections and a load and unload
   * lifecycle. The lifecycle is automatically connected to theme editor events so
   * that your sections load and unload as the editor changes the content and
   * settings of your sections.
   */

  function register(type, components) {
    if (typeof type !== "string") {
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    }

    if (typeof registered[type] !== "undefined") {
      throw new Error(
        'Theme Sections: A section of type "' +
          type +
          '" has already been registered. You cannot register the same section type twice'
      );
    }

    if (!Array.isArray(components)) {
      components = [components];
    }

    const section = new Registration(type, components);
    registered[type] = section;

    return registered;
  }

  function load(types, containers) {
    types = normalizeType(types);

    if (typeof containers === "undefined") {
      containers = document.querySelectorAll("[" + selectors$Q.type + "]");
    }

    containers = normalizeContainers(containers);

    types.forEach(function (type) {
      const registration = registered[type];

      if (typeof registration === "undefined") {
        return;
      }

      containers = containers.filter(function (container) {
        // Filter from list of containers because container already has an instance loaded
        if (isInstance(container)) {
          return false;
        }

        // Filter from list of containers because container doesn't have data-section-type attribute
        if (container.getAttribute(selectors$Q.type) === null) {
          return false;
        }

        // Keep in list of containers because current type doesn't match
        if (container.getAttribute(selectors$Q.type) !== type) {
          return true;
        }

        instances.push(new Section(container, registration));

        // Filter from list of containers because container now has an instance loaded
        return false;
      });
    });
  }

  function unload(selector) {
    var instancesToUnload = getInstances(selector);

    instancesToUnload.forEach(function (instance) {
      var index = instances
        .map(function (e) {
          return e.id;
        })
        .indexOf(instance.id);
      instances.splice(index, 1);
      instance.onUnload();
    });
  }

  function reorder(selector) {
    var instancesToReorder = getInstances(selector);

    instancesToReorder.forEach(function (instance) {
      instance.onReorder();
    });
  }

  function getInstances(selector) {
    var filteredInstances = [];

    // Fetch first element if its an array
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
      var firstElement = selector[0];
    }

    // If selector element is DOM element
    if (selector instanceof Element || firstElement instanceof Element) {
      var containers = normalizeContainers(selector);

      containers.forEach(function (container) {
        filteredInstances = filteredInstances.concat(
          instances.filter(function (instance) {
            return instance.container === container;
          })
        );
      });

      // If select is type string
    } else if (typeof selector === "string" || typeof firstElement === "string") {
      var types = normalizeType(selector);

      types.forEach(function (type) {
        filteredInstances = filteredInstances.concat(
          instances.filter(function (instance) {
            return instance.type === type;
          })
        );
      });
    }

    return filteredInstances;
  }

  function getInstanceById(id) {
    var instance;

    for (var i = 0; i < instances.length; i++) {
      if (instances[i].id === id) {
        instance = instances[i];
        break;
      }
    }
    return instance;
  }

  function isInstance(selector) {
    return getInstances(selector).length > 0;
  }

  function normalizeType(types) {
    // If '*' then fetch all registered section types
    if (types === "*") {
      types = Object.keys(registered);

      // If a single section type string is passed, put it in an array
    } else if (typeof types === "string") {
      types = [types];

      // If single section constructor is passed, transform to array with section
      // type string
    } else if (types.constructor === Section) {
      types = [types.prototype.type];

      // If array of typed section constructors is passed, transform the array to
      // type strings
    } else if (Array.isArray(types) && types[0].constructor === Section) {
      types = types.map(function (Section) {
        return Section.type;
      });
    }

    types = types.map(function (type) {
      return type.toLowerCase();
    });

    return types;
  }

  function normalizeContainers(containers) {
    // Nodelist with entries
    if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
      containers = Array.prototype.slice.call(containers);

      // Empty Nodelist
    } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
      containers = [];

      // Handle null (document.querySelector() returns null with no match)
    } else if (containers === null) {
      containers = [];

      // Single DOM element
    } else if (!Array.isArray(containers) && containers instanceof Element) {
      containers = [containers];
    }

    return containers;
  }

  if (window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector("[" + selectors$Q.id + '="' + id + '"]');

      if (container !== null) {
        load(container.getAttribute(selectors$Q.type), container);
      }
    });

    document.addEventListener("shopify:section:reorder", function (event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector("[" + selectors$Q.id + '="' + id + '"]');
      var instance = getInstances(container)[0];

      if (typeof instance === "object") {
        reorder(container);
      }
    });

    document.addEventListener("shopify:section:unload", function (event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector("[" + selectors$Q.id + '="' + id + '"]');
      var instance = getInstances(container)[0];

      if (typeof instance === "object") {
        unload(container);
      }
    });

    document.addEventListener("shopify:section:select", function (event) {
      var instance = getInstanceById(event.detail.sectionId);

      if (typeof instance === "object") {
        instance.onSelect(event);
      }
    });

    document.addEventListener("shopify:section:deselect", function (event) {
      var instance = getInstanceById(event.detail.sectionId);

      if (typeof instance === "object") {
        instance.onDeselect(event);
      }
    });

    document.addEventListener("shopify:block:select", function (event) {
      var instance = getInstanceById(event.detail.sectionId);

      if (typeof instance === "object") {
        instance.onBlockSelect(event);
      }
    });

    document.addEventListener("shopify:block:deselect", function (event) {
      var instance = getInstanceById(event.detail.sectionId);

      if (typeof instance === "object") {
        instance.onBlockDeselect(event);
      }
    });
  }

  /**
   * A11y Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help make your theme more accessible
   */

  /**
   * Moves focus to an HTML element
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects. Used in bindInPageLinks()
   * eg move focus to a modal that is opened. Used in trapFocus()
   *
   * @param {Element} container - Container DOM element to trap focus inside of
   * @param {Object} options - Settings unique to your theme
   * @param {string} options.className - Class name to apply to element on focus.
   */
  function forceFocus(element, options) {
    options = options || {};

    element.focus();
    if (typeof options.className !== "undefined") {
      element.classList.add(options.className);
    }
    element.addEventListener("blur", callback);

    function callback(event) {
      event.target.removeEventListener(event.type, callback);

      if (typeof options.className !== "undefined") {
        element.classList.remove(options.className);
      }
    }
  }

  /**
   * If there's a hash in the url, focus the appropriate element
   * This compensates for older browsers that do not move keyboard focus to anchor links.
   * Recommendation: To be called once the page in loaded.
   *
   * @param {Object} options - Settings unique to your theme
   * @param {string} options.className - Class name to apply to element on focus.
   * @param {string} options.ignore - Selector for elements to not include.
   */

  function focusHash(options) {
    options = options || {};
    var hash = window.location.hash;
    var element = document.getElementById(hash.slice(1));

    // if we are to ignore this element, early return
    if (element && options.ignore && element.matches(options.ignore)) {
      return false;
    }

    if (hash && element) {
      forceFocus(element, options);
    }
  }

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   * This compensates for older browsers that do not move keyboard focus to anchor links.
   * Recommendation: To be called once the page in loaded.
   *
   * @param {Object} options - Settings unique to your theme
   * @param {string} options.className - Class name to apply to element on focus.
   * @param {string} options.ignore - CSS selector for elements to not include.
   */

  function bindInPageLinks(options) {
    options = options || {};
    var links = Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]'));

    function queryCheck(selector) {
      return document.getElementById(selector) !== null;
    }

    return links.filter(function (link) {
      if (link.hash === "#" || link.hash === "") {
        return false;
      }

      if (options.ignore && link.matches(options.ignore)) {
        return false;
      }

      if (!queryCheck(link.hash.substr(1))) {
        return false;
      }

      var element = document.querySelector(link.hash);

      if (!element) {
        return false;
      }

      link.addEventListener("click", function () {
        forceFocus(element, options);
      });

      return true;
    });
  }

  function focusable(container) {
    var elements = Array.prototype.slice.call(
      container.querySelectorAll(
        "[tabindex]," +
          "[draggable]," +
          "a[href]," +
          "area," +
          "button:enabled," +
          "input:not([type=hidden]):enabled," +
          "object," +
          "select:enabled," +
          "textarea:enabled" +
          "[data-focus-element]"
      )
    );

    // Filter out elements that are not visible.
    // Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
    return elements.filter(function (element) {
      return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    });
  }

  /**
   * Traps the focus in a particular container
   *
   * @param {Element} container - Container DOM element to trap focus inside of
   * @param {Element} elementToFocus - Element to be focused on first
   * @param {Object} options - Settings unique to your theme
   * @param {string} options.className - Class name to apply to element on focus.
   */

  var trapFocusHandlers = {};

  function trapFocus(container, options) {
    options = options || {};
    var elements = focusable(container);
    var elementToFocus = options.elementToFocus || container;
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = function (event) {
      if (container !== event.target && !container.contains(event.target) && first && first === event.target) {
        first.focus();
      }

      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
      if (event.keyCode !== 9) return; // If not TAB key

      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      //  On the first focusable element and tab backward, focus the last element.
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    forceFocus(elementToFocus, options);
  }

  /**
   * Removes the trap of focus from the page
   */
  function removeTrapFocus() {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  }

  const selectors$P = {
    focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
  };

  function modal(unique) {
    const uniqueID = `data-popup-${unique}`;
    MicroModal.init({
      openTrigger: uniqueID,
      disableScroll: true,
      onShow: (modal, el, event) => {
        event.preventDefault();
        const firstFocus = modal.querySelector(selectors$P.focusable);
        trapFocus(modal, { elementToFocus: firstFocus });
      },
      onClose: (modal, el, event) => {
        event && event.preventDefault();
        removeTrapFocus();
        el && el.focus();
      },
    });
  }

  const selectors$O = {
    trigger: "[data-toggle-password-modal]",
    errors: ".storefront-password-form .errors",
  };

  const sections$m = {};

  class PasswordPage {
    constructor(section) {
      this.container = section.container;

      this.trigger = this.container.querySelector(selectors$O.trigger);
      this.errors = this.container.querySelector(selectors$O.errors);

      this.init();
    }

    init() {
      modal("password");
      if (this.errors) {
        this.trigger.click();
      }
    }
  }

  const passwordSection = {
    onLoad() {
      sections$m[this.id] = new PasswordPage(this);
    },
  };

  register("password", passwordSection);

  /**
   * Gift Card Template Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly couple code to the Gift Card template.
   */

  (function () {
    var config = {
      qrCode: "#QrCode",
      giftCardCode: ".giftcard__code",
    };

    // init QR code
    const qrCode = document.querySelector(config.qrCode);
    if (qrCode) {
      function loadGiftCard() {
        const qrCodeText = qrCode.getAttribute("data-identifier");
        new QRCode(qrCode, {
          text: qrCodeText,
          width: 120,
          height: 120,
        });
      }
      window.addEventListener("load", loadGiftCard);
    }

    const giftCardCode = document.querySelector(config.giftCardCode);
    if (giftCardCode) {
      // Auto-select gift card code on click, based on ID passed to the function
      function selectText() {
        var text = document.querySelector("#GiftCardDigits");
        var range = "";

        if (document.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(text);
          range.select();
        } else if (window.getSelection) {
          var selection = window.getSelection();
          range = document.createRange();
          range.selectNodeContents(text);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
      giftCardCode.addEventListener("click", selectText());
    }
  })();

  var sections$l = {};

  const parallaxImage = {
    onLoad() {
      sections$l[this.id] = [];
      const frames = this.container.querySelectorAll("[data-parallax-wrapper]");
      frames.forEach((frame) => {
        const inner = frame.querySelector("[data-parallax-img]");
        sections$l[this.id].push(
          new Rellax(inner, {
            center: true,
            round: true,
            frame: frame,
          })
        );
      });
    },
    onUnload: function () {
      sections$l[this.id].forEach((image) => {
        if (typeof image.destroy === "function") {
          image.destroy();
        }
      });
    },
  };

  register("article", parallaxImage);

  const selectors$N = {
    frame: "[data-ticker-frame]",
    scale: "[data-ticker-scale]",
    text: "[data-ticker-text]",
    clone: "data-clone",
    animationClass: "ticker--animated",
    unloadedClass: "ticker--unloaded",
    comparitorClass: "ticker__comparitor",
    moveTime: 1.63, // 100px going to move for 1.63s
    space: 100, // 100px
  };

  class Ticker {
    constructor(el, stopClone = false) {
      this.frame = el;
      this.stopClone = stopClone;
      this.scale = this.frame.querySelector(selectors$N.scale);
      this.text = this.frame.querySelector(selectors$N.text);

      this.comparitor = this.text.cloneNode(true);
      this.comparitor.classList.add(selectors$N.comparitorClass);
      this.frame.appendChild(this.comparitor);
      this.scale.classList.remove(selectors$N.unloadedClass);
      this.resizeEvent = debounce(() => this.checkWidth(), 300);
      this.listen();
    }

    unload() {
      document.removeEventListener("theme:resize", this.resizeEvent);
    }

    listen() {
      document.addEventListener("theme:resize", this.resizeEvent);
      this.checkWidth();
    }

    checkWidth() {
      const padding = window.getComputedStyle(this.frame).paddingLeft.replace("px", "") * 2;

      if (this.frame.clientWidth - padding < this.comparitor.clientWidth || this.stopClone) {
        this.text.classList.add(selectors$N.animationClass);
        if (this.scale.childElementCount === 1) {
          this.clone = this.text.cloneNode(true);
          this.clone.setAttribute("aria-hidden", true);
          this.clone.setAttribute(selectors$N.clone, "");
          this.scale.appendChild(this.clone);

          if (this.stopClone) {
            for (let index = 0; index < 10; index++) {
              const cloneSecond = this.text.cloneNode(true);
              cloneSecond.setAttribute("aria-hidden", true);
              cloneSecond.setAttribute(selectors$N.clone, "");
              this.scale.appendChild(cloneSecond);
            }
          }
        }

        const animationTimeFrame = (this.text.clientWidth / selectors$N.space) * selectors$N.moveTime;

        this.scale.style.setProperty("--animation-time", `${animationTimeFrame}s`);
      } else {
        this.text.classList.add(selectors$N.animationClass);
        let clone = this.scale.querySelector(`[${selectors$N.clone}]`);
        if (clone) {
          this.scale.removeChild(clone);
        }
        this.text.classList.remove(selectors$N.animationClass);
      }
    }
  }

  const selectors$M = {
    slide: "[data-slide]",
    speed: "data-slider-speed",
    slideAttribute: "data-slide",
    dataSlideIndex: "data-slide-index",
  };

  class AnnouncementSlider {
    constructor(container, el) {
      this.container = container;
      this.slideshow = el;
      const speedElement = this.slideshow.getAttribute(selectors$M.speed);
      this.speed = speedElement ? parseInt(speedElement) : false;

      if (!this.slideshow) return;

      this.flkty = null;

      this.init();
    }

    init() {
      const sliderOptions = {
        initialIndex: 0,
        autoPlay: this.speed,
        contain: true,
        pageDots: false,
        adaptiveHeight: true,
        wrapAround: true,
        groupCells: false,
        cellAlign: "left",
        freeScroll: false,
        prevNextButtons: true,
        draggable: true,
        rightToLeft: window.isRTL,
        on: {
          ready: () => {
            setTimeout(() => {
              this.slideshow.dispatchEvent(
                new CustomEvent("theme:announcement:loaded", {
                  bubbles: true,
                  detail: {
                    slider: this,
                  },
                })
              );
            }, 50);
          },
        },
      };

      this.flkty = new Flickity(this.slideshow, sliderOptions);

      document.addEventListener("theme:resize", () => {
        this.flkty.resize();
      });
    }

    onUnload() {
      if (this.slideshow && this.flkty) {
        this.flkty.options.watchCSS = false;
        this.flkty.destroy();
      }
    }

    onBlockSelect(evt) {
      if (!this.slideshow) return;
      // Ignore the cloned version
      const slide = this.slideshow.querySelector(`[${selectors$M.slideAttribute}="${evt.detail.blockId}"]`);

      if (!slide) return;
      const slideIndex = parseInt(slide.getAttribute(selectors$M.dataSlideIndex));

      // Go to selected slide, pause autoplay
      this.flkty.selectCell(slideIndex);
      this.flkty.stopPlayer();
    }

    onBlockDeselect() {
      this.flkty.playPlayer();
    }
  }

  const selectors$L = {
    cartMessage: "[data-cart-message]",
    cartMessageValue: "data-cart-message",
    leftToSpend: "[data-left-to-spend]",
    cartProgress: "[data-cart-progress]",
  };

  const classes$p = {
    isHidden: "is-hidden",
    isSuccess: "is-success",
  };

  class CartShippingMessage {
    constructor(section) {
      this.container = section;
      this.cartMessage = this.container.querySelectorAll(selectors$L.cartMessage);
      if (this.cartMessage.length > 0) {
        this.init();
      }
    }

    init() {
      this.cartFreeLimitShipping = Number(this.cartMessage[0].getAttribute("data-limit")) * 100;
      this.shippingAmount = 0;
      this.circumference = 28 * Math.PI; // radius - stroke * 4 * PI

      this.cartBarProgress();
      this.listen();
    }

    listen() {
      document.addEventListener(
        "theme:cart:change",
        function (event) {
          this.cart = event.detail.cart;
          this.render();
        }.bind(this)
      );
    }

    render() {
      if (this.cart && this.cart.total_price) {
        const totalPrice = this.cart.total_price;
        this.freeShippingMessageHandle(totalPrice);

        // Build cart again if the quantity of the changed product is 0 or cart discounts are changed
        if (this.cartMessage.length > 0) {
          this.shippingAmount = totalPrice;
          this.updateProgress();
        }
      }
    }

    freeShippingMessageHandle(total) {
      if (this.cartMessage.length > 0) {
        this.container.querySelectorAll(selectors$L.cartMessage).forEach((message) => {
          const hasFreeShipping =
            message.hasAttribute(selectors$L.cartMessageValue) &&
            message.getAttribute(selectors$L.cartMessageValue) === "true" &&
            total !== 0;
          const cartMessageClass = hasFreeShipping ? classes$p.isSuccess : classes$p.isHidden;

          message.classList.toggle(cartMessageClass, total >= this.cartFreeLimitShipping);
        });
      }
    }

    cartBarProgress(progress = null) {
      this.container.querySelectorAll(selectors$L.cartProgress).forEach((element) => {
        this.setProgress(element, progress === null ? element.getAttribute("data-percent") : progress);
      });
    }

    setProgress(holder, percent) {
      const offset = this.circumference - ((percent / 100) * this.circumference) / 2;

      holder.style.strokeDashoffset = offset;
    }

    updateProgress() {
      const newPercentValue = (this.shippingAmount / this.cartFreeLimitShipping) * 100;
      const leftToSpend = themeCurrency.formatMoney(
        this.cartFreeLimitShipping - this.shippingAmount,
        theme.moneyFormat
      );

      this.container.querySelectorAll(selectors$L.leftToSpend).forEach((element) => {
        element.innerHTML = leftToSpend.replace(".00", "");
      });

      this.cartBarProgress(newPercentValue > 100 ? 100 : newPercentValue);
    }
  }

  const selectors$K = {
    bar: "[data-bar]",
    barSlide: "[data-slide]",
    frame: "[data-ticker-frame]",
    header: "[data-header-wrapper]",
    slider: "[data-announcement-slider]",
    slideValue: "data-slide",
    tickerScale: "[data-ticker-scale]",
    tickerText: "[data-ticker-text]",
    dataTargetReferrer: "data-target-referrer",
    slideAttribute: "data-slide",
  };

  const classes$o = {
    mobileClass: "mobile",
    desktopClass: "desktop",
  };

  const sections$k = {};

  class Bar {
    constructor(section) {
      this.container = section.container;
      this.barHolder = this.container.querySelector(selectors$K.bar);
      this.locationPath = location.href;

      this.slides = this.barHolder.querySelectorAll(selectors$K.barSlide);
      this.slider = this.barHolder.querySelector(selectors$K.slider);
      this.hasDeviceClass = "";

      new CartShippingMessage(this.container);

      this.init();
    }

    init() {
      this.removeAnnouncement();

      if (!this.slider) {
        this.initTickers(true);
      } else if (this.slider && this.slides && this.slides.length > 1) {
        this.initSliders();
      } else {
        this.initTickers();
      }
    }

    /**
     * Delete announcement which has a target referrer attribute and it is not contained in page URL
     */
    removeAnnouncement() {
      for (let index = 0; index < this.slides.length; index++) {
        const element = this.slides[index];

        if (!element.hasAttribute(selectors$K.dataTargetReferrer)) {
          continue;
        }

        if (
          this.locationPath.indexOf(element.getAttribute(selectors$K.dataTargetReferrer)) === -1 &&
          !window.Shopify.designMode
        ) {
          element.parentNode.removeChild(element);
        }
      }
    }

    /**
     * Init slider
     */
    initSliders() {
      this.slider = new AnnouncementSlider(this.container, this.slider);
      this.slider.flkty.reposition();

      this.barHolder.addEventListener("theme:announcement:loaded", () => {
        this.initTickers();
      });
    }

    /**
     * Init tickers in sliders
     */
    initTickers(stopClone = false) {
      const frame = this.barHolder.querySelector(selectors$K.frame);

      if (frame) {
        new Ticker(frame, stopClone);
      }
    }

    toggleTicker(e, isStoped) {
      const tickerScale = document.querySelector(selectors$K.tickerScale);
      const element = document.querySelector(`[${selectors$K.slideValue}="${e.detail.blockId}"]`);

      if (isStoped && element) {
        tickerScale.setAttribute("data-stop", "");
        tickerScale.querySelectorAll(selectors$K.tickerText).forEach((textHolder) => {
          textHolder.classList.remove("ticker--animated");
          textHolder.style.transform = `translate3d(${-(element.offsetLeft - element.clientWidth)}px, 0, 0)`;
        });
      }

      if (!isStoped && element) {
        tickerScale.querySelectorAll(selectors$K.tickerText).forEach((textHolder) => {
          textHolder.classList.add("ticker--animated");
          textHolder.removeAttribute("style");
        });
        tickerScale.removeAttribute("data-stop");
      }
    }

    onBlockSelect(e) {
      if (this.slider && typeof this.slider.onBlockSelect === "function") {
        this.slider.onBlockSelect(e);
      } else {
        const slides = document.querySelectorAll(`[${selectors$K.slideAttribute}="${e.detail.blockId}"]`);

        slides.forEach((slide) => {
          if (slide.classList.contains(classes$o.mobileClass)) {
            this.hasDeviceClass = classes$o.mobileClass;
          }

          if (slide.classList.contains(classes$o.desktopClass)) {
            this.hasDeviceClass = classes$o.desktopClass;
          }

          if (this.hasDeviceClass !== "") {
            slide.classList.remove(this.hasDeviceClass);
          }
        });

        this.toggleTicker(e, true);
      }
    }

    onBlockDeselect(e) {
      if (this.slider && typeof this.slider.onBlockDeselect === "function") {
        this.slider.onBlockDeselect(e);
      } else {
        if (this.hasDeviceClass !== "") {
          const slides = document.querySelectorAll(`[${selectors$K.slideAttribute}="${e.detail.blockId}"]`);

          slides.forEach((slide) => {
            slide.classList.add(this.hasDeviceClass);
          });
        }

        this.toggleTicker(e, false);
      }
    }
  }

  const bar = {
    onLoad() {
      sections$k[this.id] = [];
      sections$k[this.id].push(new Bar(this));
    },
    onBlockSelect(e) {
      sections$k[this.id].forEach((el) => {
        if (typeof el.onBlockSelect === "function") {
          el.onBlockSelect(e);
        }
      });
    },
    onBlockDeselect(e) {
      sections$k[this.id].forEach((el) => {
        if (typeof el.onBlockSelect === "function") {
          el.onBlockDeselect(e);
        }
      });
    },
  };

  register("announcement", [bar]);

  register("blog", parallaxImage);

  var selectors$J = {
    drawerWrappper: "[data-drawer]",
    drawerScrolls: "[data-drawer-scrolls]",
    underlay: "[data-drawer-underlay]",
    stagger: "[data-stagger-animation]",
    drawerToggle: "data-drawer-toggle",
    focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
  };

  var classes$n = {
    isVisible: "drawer--visible",
    displayNone: "display-none",
  };

  var sections$j = {};

  class Drawer {
    constructor(el) {
      this.drawer = el;
      this.drawerScrolls = this.drawer.querySelector(selectors$J.drawerScrolls);
      this.underlay = this.drawer.querySelector(selectors$J.underlay);
      this.key = this.drawer.dataset.drawer;
      const btnSelector = `[${selectors$J.drawerToggle}='${this.key}']`;
      this.buttons = document.querySelectorAll(btnSelector);
      this.staggers = this.drawer.querySelectorAll(selectors$J.stagger);

      this.connectToggle();
      this.connectDrawer();
      this.closers();
      this.staggerChildAnimations();
    }

    unload() {
      // wipe listeners
    }

    connectToggle() {
      this.buttons.forEach((btn) => {
        btn.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            this.drawer.dispatchEvent(
              new CustomEvent("theme:drawer:toggle", {
                bubbles: false,
              })
            );
          }.bind(this)
        );
      });
    }

    connectDrawer() {
      this.drawer.addEventListener(
        "theme:drawer:toggle",
        function () {
          if (this.drawer.classList.contains(classes$n.isVisible)) {
            this.drawer.dispatchEvent(
              new CustomEvent("theme:drawer:close", {
                bubbles: false,
              })
            );
          } else {
            this.drawer.dispatchEvent(
              new CustomEvent("theme:drawer:open", {
                bubbles: false,
              })
            );
          }
        }.bind(this)
      );
      this.drawer.addEventListener("theme:drawer:close", this.hideDrawer.bind(this));
      this.drawer.addEventListener("theme:drawer:open", this.showDrawer.bind(this));
    }

    staggerChildAnimations() {
      this.staggers.forEach((el) => {
        const children = el.querySelectorAll(":scope > * > [data-animates]");
        children.forEach((child, index) => {
          child.style.transitionDelay = `${index * 50 + 10}ms`;
        });
      });
    }

    closers() {
      this.drawer.addEventListener(
        "keyup",
        function (evt) {
          if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
            return;
          }
          this.hideDrawer();
          this.buttons[0].focus();
        }.bind(this)
      );

      this.underlay.addEventListener(
        "click",
        function () {
          this.hideDrawer();
        }.bind(this)
      );
    }

    showDrawer() {
      this.drawer.classList.remove(classes$n.displayNone);
      // animates after display none is removed
      setTimeout(() => {
        this.buttons.forEach((el) => el.setAttribute("aria-expanded", true));
        this.drawer.classList.add(classes$n.isVisible);
        this.drawerScrolls.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
        const firstFocus = this.drawer.querySelector(selectors$J.focusable);
        trapFocus(this.drawer, { elementToFocus: firstFocus });
      }, 1);
    }

    hideDrawer() {
      this.buttons.forEach((el) => el.setAttribute("aria-expanded", true));
      this.drawer.classList.remove(classes$n.isVisible);
      this.drawerScrolls.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));

      document.dispatchEvent(new CustomEvent("theme:sliderule:close", { bubbles: false }));
      removeTrapFocus();

      // adds display none after animations
      setTimeout(() => {
        if (!this.drawer.classList.contains(classes$n.isVisible)) {
          this.drawer.classList.add(classes$n.displayNone);
        }
      }, 800);
    }
  }

  const drawer = {
    onLoad() {
      sections$j[this.id] = [];
      const els = this.container.querySelectorAll(selectors$J.drawerWrappper);
      els.forEach((el) => {
        sections$j[this.id].push(new Drawer(el));
      });
    },
    onUnload: function () {
      sections$j[this.id].forEach((el) => {
        if (typeof el.unload === "function") {
          el.unload();
        }
      });
    },
  };

  const selectors$I = {
    announcement: "#shopify-section-announcement",
    transparent: "data-header-transparent",
    header: "[data-header-wrapper] header",
  };

  const classes$m = {
    stuck: "js__header__stuck",
    stuckAnimated: "js__header__stuck--animated",
    triggerAnimation: "js__header__stuck--trigger-animation",
    stuckBackdrop: "js__header__stuck__backdrop",
  };

  let sections$i = {};

  class Sticky {
    constructor(el) {
      this.wrapper = el;
      this.type = this.wrapper.dataset.headerSticky;
      this.transparent = this.wrapper.dataset.headerTransparent;
      this.sticks = this.type === "sticky";
      this.animated = this.type === "directional";
      this.currentlyStuck = false;
      this.cls = this.wrapper.classList;
      const announcementEl = document.querySelector(selectors$I.announcement);
      const announcementHeight = announcementEl ? announcementEl.clientHeight : 0;
      const headerHeight = document.querySelector(selectors$I.header).clientHeight;
      this.blur = headerHeight + announcementHeight;
      this.stickDown = headerHeight + announcementHeight;
      this.stickUp = announcementHeight;
      if (this.wrapper.getAttribute(selectors$I.transparent) !== "false") {
        this.blur = announcementHeight;
      }
      if (this.sticks) {
        this.stickDown = announcementHeight;
        this.scrollDownInit();
      }
      this.listen();
    }

    unload() {
      document.removeEventListener("theme:scroll", this.listen);
      document.removeEventListener("theme:scroll:up", this.scrollUpDirectional);
      document.removeEventListener("theme:scroll:down", this.scrollDownDirectional);
    }

    listen() {
      if (this.sticks || this.animated) {
        document.addEventListener("theme:scroll", (e) => {
          if (e.detail.down) {
            if (!this.currentlyStuck && e.detail.position > this.stickDown) {
              this.stickSimple();
            }
            if (!this.currentlyBlurred && e.detail.position > this.blur) {
              this.addBlur();
            }
          } else {
            if (e.detail.position <= this.stickUp) {
              this.unstickSimple();
            }
            if (e.detail.position <= this.blur) {
              this.removeBlur();
            }
          }
        });
      }
      if (this.animated) {
        document.addEventListener("theme:scroll:up", this.scrollUpDirectional.bind(this));
        document.addEventListener("theme:scroll:down", this.scrollDownDirectional.bind(this));
      }
    }

    stickSimple() {
      if (this.animated) {
        this.cls.add(classes$m.stuckAnimated);
      }
      this.cls.add(classes$m.stuck);
      this.wrapper.setAttribute(selectors$I.transparent, false);
      this.currentlyStuck = true;
    }

    unstickSimple() {
      this.cls.remove(classes$m.stuck);
      this.wrapper.setAttribute(selectors$I.transparent, this.transparent);
      if (this.animated) {
        this.cls.remove(classes$m.stuckAnimated);
      }
      this.currentlyStuck = false;
    }

    scrollDownInit() {
      if (window.scrollY > this.stickDown) {
        this.stickSimple();
      }
      if (window.scrollY > this.blur) {
        this.addBlur();
      }
    }

    stickDirectional() {
      this.cls.add(classes$m.triggerAnimation);
    }

    unstickDirectional() {
      this.cls.remove(classes$m.triggerAnimation);
    }

    scrollDownDirectional() {
      this.unstickDirectional();
    }

    scrollUpDirectional() {
      if (window.scrollY <= this.stickDown) {
        this.unstickDirectional();
      } else {
        this.stickDirectional();
      }
    }

    addBlur() {
      this.cls.add(classes$m.stuckBackdrop);
      this.currentlyBlurred = true;
    }

    removeBlur() {
      this.cls.remove(classes$m.stuckBackdrop);
      this.currentlyBlurred = false;
    }
  }

  const stickyHeader = {
    onLoad() {
      sections$i = new Sticky(this.container);
    },
    onUnload: function () {
      if (typeof sections$i.unload === "function") {
        sections$i.unload();
      }
    },
  };

  const selectors$H = {
    disclosureToggle: "data-hover-disclosure-toggle",
    disclosureWrappper: "[data-hover-disclosure]",
    link: "[data-top-link]",
    wrapper: "[data-header-wrapper]",
    stagger: "[data-stagger]",
    staggerPair: "[data-stagger-first]",
    staggerAfter: "[data-stagger-second]",
    staggerImage: "[data-grid-item], [data-header-image]",
    focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
  };

  const classes$l = {
    isVisible: "is-visible",
    meganavVisible: "meganav--visible",
  };

  let sections$h = {};
  let disclosures = {};

  class HoverDisclosure {
    constructor(el) {
      this.disclosure = el;
      this.wrapper = el.closest(selectors$H.wrapper);
      this.key = this.disclosure.id;
      const btnSelector = `[${selectors$H.disclosureToggle}='${this.key}']`;
      this.trigger = document.querySelector(btnSelector);
      this.link = this.trigger.querySelector(selectors$H.link);
      this.grandparent = this.trigger.classList.contains("grandparent");

      this.trigger.setAttribute("aria-haspopup", true);
      this.trigger.setAttribute("aria-expanded", false);
      this.trigger.setAttribute("aria-controls", this.key);

      this.connectHoverToggle();
      this.handleTablets();
      this.staggerChildAnimations();
    }

    onBlockSelect(evt) {
      if (this.disclosure.contains(evt.target)) {
        this.showDisclosure();
      }
    }

    onBlockDeselect(evt) {
      if (this.disclosure.contains(evt.target)) {
        this.hideDisclosure();
      }
    }

    showDisclosure() {
      if (this.grandparent) {
        this.wrapper.classList.add(classes$l.meganavVisible);
      } else {
        this.wrapper.classList.remove(classes$l.meganavVisible);
      }
      this.trigger.setAttribute("aria-expanded", true);
      this.trigger.classList.add(classes$l.isVisible);
      this.disclosure.classList.add(classes$l.isVisible);
    }

    hideDisclosure() {
      this.disclosure.classList.remove(classes$l.isVisible);
      this.trigger.classList.remove(classes$l.isVisible);
      this.trigger.setAttribute("aria-expanded", false);
      this.wrapper.classList.remove(classes$l.meganavVisible);
    }

    staggerChildAnimations() {
      const simple = this.disclosure.querySelectorAll(selectors$H.stagger);
      simple.forEach((el, index) => {
        el.style.transitionDelay = `${index * 50 + 10}ms`;
      });

      const pairs = this.disclosure.querySelectorAll(selectors$H.staggerPair);
      pairs.forEach((child, i) => {
        const d1 = i * 150;
        child.style.transitionDelay = `${d1}ms`;
        child.parentElement.querySelectorAll(selectors$H.staggerAfter).forEach((grandchild, i2) => {
          const di1 = i2 + 1;
          const d2 = di1 * 20;
          grandchild.style.transitionDelay = `${d1 + d2}ms`;
        });
      });

      const images = this.disclosure.querySelectorAll(selectors$H.staggerImage);
      images.forEach((el, index) => {
        el.style.transitionDelay = `${(index + 1) * 80}ms`;
      });
    }

    handleTablets() {
      // first click opens the popup, second click opens the link
      this.trigger.addEventListener(
        "touchstart",
        function (e) {
          const isOpen = this.disclosure.classList.contains(classes$l.isVisible);
          if (!isOpen) {
            e.preventDefault();
            this.showDisclosure();
          }
        }.bind(this),
        { passive: true }
      );
    }

    connectHoverToggle() {
      this.trigger.addEventListener("mouseenter", this.showDisclosure.bind(this));
      this.link.addEventListener("focus", this.showDisclosure.bind(this));

      this.trigger.addEventListener("mouseleave", this.hideDisclosure.bind(this));
      this.trigger.addEventListener(
        "focusout",
        function (e) {
          const inMenu = this.trigger.contains(e.relatedTarget);
          if (!inMenu) {
            this.hideDisclosure();
          }
        }.bind(this)
      );
      this.disclosure.addEventListener(
        "keyup",
        function (evt) {
          if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
            return;
          }
          this.hideDisclosure();
        }.bind(this)
      );
    }
  }

  const hoverDisclosure = {
    onLoad() {
      sections$h[this.id] = [];
      disclosures = this.container.querySelectorAll(selectors$H.disclosureWrappper);
      disclosures.forEach((el) => {
        sections$h[this.id].push(new HoverDisclosure(el));
      });
    },
    onBlockSelect(evt) {
      sections$h[this.id].forEach((el) => {
        if (typeof el.onBlockSelect === "function") {
          el.onBlockSelect(evt);
        }
      });
    },
    onBlockDeselect(evt) {
      sections$h[this.id].forEach((el) => {
        if (typeof el.onBlockDeselect === "function") {
          el.onBlockDeselect(evt);
        }
      });
    },
    onUnload: function () {
      sections$h[this.id].forEach((el) => {
        if (typeof el.unload === "function") {
          el.unload();
        }
      });
    },
  };

  const selectors$G = {
    item: "[data-main-menu-text-item]",
    wrapper: "[data-text-items-wrapper]",
    text: ".navtext",
    isActive: "data-menu-active",
    sectionOuter: "[data-header-wrapper]",
    underlineCurrent: "data-underline-current",
    defaultItem: ".menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext",
  };

  let sections$g = {};
  let defaultPositions = null;

  class HoverLine {
    constructor(el) {
      this.wrapper = el;
      this.itemList = this.wrapper.querySelectorAll(selectors$G.item);
      this.sectionOuter = document.querySelector(selectors$G.sectionOuter);
      this.underlineCurrent = this.sectionOuter.getAttribute(selectors$G.underlineCurrent) === "true";
      this.defaultItem = null;
      if (this.underlineCurrent) {
        this.defaultItem = this.wrapper.querySelector(selectors$G.defaultItem);
      }
      this.setDefault();
      document.fonts.ready.then(() => {
        this.init();
      });
    }

    init() {
      if (this.itemList.length) {
        this.listen();
        this.listenResize();

        this.textBottom = null;
        this.setHeight();

        if (defaultPositions) {
          if (this.defaultItem) {
            const startingLeft = this.defaultItem.offsetLeft || 0;
            this.sectionOuter.style.setProperty("--bar-left", `${startingLeft}px`);
          }

          this.reset();
        } else {
          // initialize at left edge of first item im menu
          const startingLeft = this.sectionOuter.querySelector(selectors$G.item).offsetLeft;
          this.sectionOuter.style.setProperty("--bar-left", `${startingLeft}px`);
          this.sectionOuter.style.setProperty("--bar-width", "0px");
        }
        this.sectionOuter.style.setProperty("--bar-opacity", "1");
      }
    }

    unload() {
      document.removeEventListener("theme:resize", this.reset);
      defaultPositions = null;
    }

    listenResize() {
      document.addEventListener("theme:resize", this.reset.bind(this));
    }

    setDefault() {
      if (this.defaultItem) {
        defaultPositions = {
          left: this.defaultItem.offsetLeft || null,
          width: this.defaultItem.clientWidth || null,
        };
      }
    }

    setHeight() {
      const height = this.wrapper.clientHeight;
      const text = this.itemList[0].querySelector(selectors$G.text);
      const textHeight = text.clientHeight;
      const textBottom = Math.floor(height / 2 - textHeight / 2) - 4;
      if (this.textBottom !== textBottom) {
        this.sectionOuter.style.setProperty("--bar-text", `${textHeight}px`);
        this.sectionOuter.style.setProperty("--bar-bottom", `${textBottom}px`);
        this.textBottom = textBottom;
      }
    }

    listen() {
      this.itemList.forEach((element) => {
        element.addEventListener("mouseenter", (evt) => {
          const item = evt.target.querySelector(selectors$G.text);
          this.startBar(item);
        });
      });
      this.wrapper.addEventListener("mouseleave", this.clearBar.bind(this));
    }

    startBar(item) {
      this.setHeight();
      let active = this.sectionOuter.getAttribute(selectors$G.isActive) !== "false";
      let left = item.offsetLeft;
      let width = item.clientWidth;
      if (active) {
        this.render(width, left);
      } else {
        this.sectionOuter.setAttribute(selectors$G.isActive, true);
        this.render(0, left);
        setTimeout(() => {
          this.render(width, left);
        }, 10);
      }
    }

    render(width, left) {
      this.sectionOuter.style.setProperty("--bar-left", `${left}px`);
      this.sectionOuter.style.setProperty("--bar-width", `${width}px`);
    }

    reset() {
      this.setDefault();
      if (defaultPositions && defaultPositions.left && defaultPositions.width) {
        this.sectionOuter.style.setProperty("--bar-left", `${defaultPositions.left}px`);
        this.sectionOuter.style.setProperty("--bar-width", `${defaultPositions.width}px`);
      } else {
        this.sectionOuter.style.setProperty("--bar-width", "0px");
      }
    }

    clearBar() {
      // allow the bar to jump between text sections for cart and main menu
      this.sectionOuter.setAttribute(selectors$G.isActive, false);
      setTimeout(() => {
        let active = this.sectionOuter.getAttribute(selectors$G.isActive) !== "false";
        if (!active) {
          this.reset();
        }
      }, 150);
    }
  }

  const hoverUnderline = {
    onLoad() {
      sections$g[this.id] = [];
      const els = this.container.querySelectorAll(selectors$G.wrapper);
      els.forEach((el) => {
        sections$g[this.id].push(new HoverLine(el));
      });
    },
    onUnload: function () {
      sections$g[this.id].forEach((el) => {
        if (typeof el.unload === "function") {
          el.unload();
        }
      });
      delete sections$g[this.id];
    },
  };

  const selectors$F = {
    price: "data-header-cart-price",
    count: "data-header-cart-count",
    dot: "data-header-cart-full",
  };

  class Totals {
    constructor(el) {
      this.section = el;
      this.counts = this.section.querySelectorAll(`[${selectors$F.count}]`);
      this.prices = this.section.querySelectorAll(`[${selectors$F.price}]`);
      this.dots = this.section.querySelectorAll(`[${selectors$F.dot}]`);
      this.cart = null;
      this.listen();
    }

    listen() {
      document.addEventListener(
        "theme:cart:change",
        function (event) {
          this.cart = event.detail.cart;
          this.update();
        }.bind(this)
      );
    }

    update() {
      if (this.cart) {
        this.prices.forEach((price) => {
          price.setAttribute(selectors$F.price, this.cart.total_price);
          const newTotal = themeCurrency.formatMoney(this.cart.total_price, theme.moneyFormat);
          price.innerHTML = newTotal;
        });
        this.counts.forEach((count) => {
          // manual calculation of item count
          var item_count = this.cart.items.reduce(function (a, b) {
            return a + b.quantity;
          }, 0);
          count.setAttribute(selectors$F.count, item_count);
          count.innerHTML = `(${item_count})`;
        });
        this.dots.forEach((dot) => {
          const full = this.cart.item_count > 0;
          dot.setAttribute(selectors$F.dot, full);
        });
      }
    }
  }
  const headerTotals = {
    onLoad() {
      new Totals(this.container);
    },
  };

  const selectors$E = {
    wrapper: "[data-search-popdown-wrap]",
    popdownTrigger: "data-popdown-toggle",
    close: "[data-close-popdown]",
    input: "[data-predictive-search-input]",
    underlay: "[data-search-underlay]",
  };

  const classes$k = {
    underlayVisible: "underlay--visible",
    isVisible: "is-visible",
  };

  let sections$f = {};

  class SearchPopdownTriggers {
    constructor(trigger) {
      this.trigger = trigger;
      this.key = this.trigger.getAttribute(selectors$E.popdownTrigger);

      const popdownSelector = `[id='${this.key}']`;
      this.popdown = document.querySelector(popdownSelector);
      this.input = this.popdown.querySelector(selectors$E.input);
      this.close = this.popdown.querySelector(selectors$E.close);
      this.wrapper = this.popdown.closest(selectors$E.wrapper);
      this.underlay = this.wrapper.querySelector(selectors$E.underlay);

      this.initTriggerEvents();
      this.initPopdownEvents();
    }

    initTriggerEvents() {
      this.trigger.setAttribute("aria-haspopup", true);
      this.trigger.setAttribute("aria-expanded", false);
      this.trigger.setAttribute("aria-controls", this.key);
      this.trigger.addEventListener(
        "click",
        function (evt) {
          evt.preventDefault();
          this.showPopdown();
        }.bind(this)
      );
      this.trigger.addEventListener(
        "keyup",
        function (evt) {
          if (evt.which !== window.theme.keyboardKeys.SPACE) {
            return;
          }
          this.showPopdown();
        }.bind(this)
      );
    }

    initPopdownEvents() {
      this.popdown.addEventListener(
        "keyup",
        function (evt) {
          if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
            return;
          }
          this.hidePopdown();
        }.bind(this)
      );
      this.close.addEventListener(
        "click",
        function () {
          this.hidePopdown();
        }.bind(this)
      );
      this.underlay.addEventListener(
        "click",
        function () {
          this.hidePopdown();
        }.bind(this)
      );
    }

    hidePopdown() {
      this.popdown.classList.remove(classes$k.isVisible);
      this.underlay.classList.remove(classes$k.underlayVisible);
      this.trigger.focus();
      this.input.value = "";
      removeTrapFocus();
      this.input.dispatchEvent(new CustomEvent("clear", { bubbles: false }));
      this.popdown.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
    }

    showPopdown() {
      this.input.value = "";
      this.popdown.classList.add(classes$k.isVisible);
      this.underlay.classList.add(classes$k.underlayVisible);
      trapFocus(this.popdown, { elementToFocus: this.input });
      this.popdown.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
    }
  }

  const searchPopdown = {
    onLoad() {
      sections$f[this.id] = {};
      const trigger = this.container.querySelector(`[${selectors$E.popdownTrigger}]`);
      if (trigger) {
        sections$f[this.id] = new SearchPopdownTriggers(trigger);
      }
    },
    onUnload: function () {
      if (typeof sections$f[this.id].unload === "function") {
        sections$f[this.id].unload();
      }
    },
  };

  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * https://github.com/Shopify/slate.git.
   *
   */

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (typeof src === "undefined" || src === null) {
      src = window.theme.assets.noImage;
    }

    if (size === "master") {
      return removeProtocol(src);
    }

    const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];

      return removeProtocol(`${prefix[0]}_${size}${suffix}`);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  function Listeners() {
    this.entries = [];
  }

  Listeners.prototype.add = function (element, event, fn) {
    this.entries.push({ element: element, event: event, fn: fn });
    element.addEventListener(event, fn);
  };

  Listeners.prototype.removeAll = function () {
    this.entries = this.entries.filter(function (listener) {
      listener.element.removeEventListener(listener.event, listener.fn);
      return false;
    });
  };

  /**
   * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
   * @param {Object} product Product JSON object
   * @param {Number} value Accepts Number (e.g. 6908023078973)
   * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
   */

  /**
   * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
   * @param {Object} product Product JSON object
   * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
   * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
   */
  function getVariantFromSerializedArray(product, collection) {
    _validateProductStructure(product);

    // If value is an array of options
    var optionArray = _createOptionArrayFromOptionCollection(product, collection);
    return getVariantFromOptionArray(product, optionArray);
  }

  /**
   * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
   * @param {Object} product Product JSON object
   * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
   * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
   */
  function getVariantFromOptionArray(product, options) {
    _validateProductStructure(product);
    _validateOptionsArray(options);

    var result = product.variants.filter(function (variant) {
      return options.every(function (option, index) {
        return variant.options[index] === option;
      });
    });

    return result[0] || null;
  }

  /**
   * Creates an array of selected options from the object
   * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
   * @param {Object} product Product JSON object
   * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
   * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
   */
  function _createOptionArrayFromOptionCollection(product, collection) {
    _validateProductStructure(product);
    _validateSerializedArray(collection);

    var optionArray = [];

    collection.forEach(function (option) {
      for (var i = 0; i < product.options.length; i++) {
        var name = product.options[i].name || product.options[i];
        if (name.toLowerCase() === option.name.toLowerCase()) {
          optionArray[i] = option.value;
          break;
        }
      }
    });

    return optionArray;
  }

  /**
   * Check if the product data is a valid JS object
   * Error will be thrown if type is invalid
   * @param {object} product Product JSON object
   */
  function _validateProductStructure(product) {
    if (typeof product !== "object") {
      throw new TypeError(product + " is not an object.");
    }

    if (Object.keys(product).length === 0 && product.constructor === Object) {
      throw new Error(product + " is empty.");
    }
  }

  /**
   * Validate the structure of the array
   * It must be formatted like jQuery's serializeArray()
   * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
   */
  function _validateSerializedArray(collection) {
    if (!Array.isArray(collection)) {
      throw new TypeError(collection + " is not an array.");
    }

    if (collection.length === 0) {
      throw new Error(collection + " is empty.");
    }

    if (collection[0].hasOwnProperty("name")) {
      if (typeof collection[0].name !== "string") {
        throw new TypeError(
          "Invalid value type passed for name of option " + collection[0].name + ". Value should be string."
        );
      }
    } else {
      throw new Error(collection[0] + "does not contain name key.");
    }
  }

  /**
   * Validate the structure of the array
   * It must be formatted as list of values
   * @param {Array} collection Array of object (e.g. ['36', 'Black'])
   */
  function _validateOptionsArray(options) {
    if (Array.isArray(options) && typeof options[0] === "object") {
      throw new Error(options + "is not a valid array of options.");
    }
  }

  var selectors$D = {
    idInput: '[name="id"]',
    planInput: '[name="selling_plan"]',
    optionInput: '[name^="options"]',
    quantityInput: '[name="quantity"]',
    propertyInput: '[name^="properties"]',
  };

  // Public Methods
  // -----------------------------------------------------------------------------

  /**
   * Returns a URL with a variant ID query parameter. Useful for updating window.history
   * with a new URL based on the currently select product variant.
   * @param {string} url - The URL you wish to append the variant ID to
   * @param {number} id  - The variant ID you wish to append to the URL
   * @returns {string} - The new url which includes the variant ID query parameter
   */

  function getUrlWithVariant(url, id) {
    if (/variant=/.test(url)) {
      return url.replace(/(variant=)[^&]+/, "$1" + id);
    } else if (/\?/.test(url)) {
      return url.concat("&variant=").concat(id);
    }

    return url.concat("?variant=").concat(id);
  }

  /**
   * Constructor class that creates a new instance of a product form controller.
   *
   * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
   * @param {Object} product - A product object
   * @param {Object} options - Optional options object
   * @param {Function} options.onOptionChange - Callback for whenever an option input changes
   * @param {Function} options.onPlanChange - Callback for changes to name=selling_plan
   * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
   * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
   * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
   */
  class ProductFormReader {
    constructor(element, product, options) {
      this.element = element;
      this.form = this.element.tagName == "FORM" ? this.element : this.element.querySelector("form");
      this.product = this._validateProductObject(product);
      this.variantElement = this.element.querySelector(selectors$D.idInput);

      options = options || {};
      this.clickedElement = null;

      this._listeners = new Listeners();
      this._listeners.add(this.element, "submit", this._onSubmit.bind(this, options));

      this.optionInputs = this._initInputs(selectors$D.optionInput, options.onOptionChange);

      this.planInputs = this._initInputs(selectors$D.planInput, options.onPlanChange);

      this.quantityInputs = this._initInputs(selectors$D.quantityInput, options.onQuantityChange);

      this.propertyInputs = this._initInputs(selectors$D.propertyInput, options.onPropertyChange);
    }

    /**
     * Cleans up all event handlers that were assigned when the Product Form was constructed.
     * Useful for use when a section needs to be reloaded in the theme editor.
     */
    destroy() {
      this._listeners.removeAll();
    }

    /**
     * Getter method which returns the array of currently selected option values
     *
     * @returns {Array} An array of option values
     */
    options() {
      return this._serializeInputValues(this.optionInputs, function (item) {
        var regex = /(?:^(options\[))(.*?)(?:\])/;
        item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
        return item;
      });
    }

    /**
     * Getter method which returns the currently selected variant, or `null` if variant
     * doesn't exist.
     *
     * @returns {Object|null} Variant object
     */
    variant() {
      const opts = this.options();
      if (opts.length) {
        return getVariantFromSerializedArray(this.product, opts);
      } else {
        return this.product.variants[0];
      }
    }

    /**
     * Getter method which returns the current selling plan, or `null` if plan
     * doesn't exist.
     *
     * @returns {Object|null} Variant object
     */
    plan(variant) {
      let plan = {
        allocation: null,
        group: null,
        detail: null,
      };
      const formData = new FormData(this.form);
      const id = formData.get("selling_plan");

      if (id && variant) {
        plan.allocation = variant.selling_plan_allocations.find(function (item) {
          return item.selling_plan_id.toString() === id.toString();
        });
      }
      if (plan.allocation) {
        plan.group = this.product.selling_plan_groups.find(function (item) {
          return item.id.toString() === plan.allocation.selling_plan_group_id.toString();
        });
      }
      if (plan.group) {
        plan.detail = plan.group.selling_plans.find(function (item) {
          return item.id.toString() === id.toString();
        });
      }

      if (plan && plan.allocation && plan.detail && plan.allocation) {
        return plan;
      } else return null;
    }

    /**
     * Getter method which returns a collection of objects containing name and values
     * of property inputs
     *
     * @returns {Array} Collection of objects with name and value keys
     */
    properties() {
      return this._serializeInputValues(this.propertyInputs, function (item) {
        var regex = /(?:^(properties\[))(.*?)(?:\])/;
        item.name = regex.exec(item.name)[2]; // Use just the value between 'properties[' and ']'
        return item;
      });
    }

    /**
     * Getter method which returns the current quantity or 1 if no quantity input is
     * included in the form
     *
     * @returns {Array} Collection of objects with name and value keys
     */
    quantity() {
      return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
    }

    getFormState() {
      const variant = this.variant();
      return {
        options: this.options(),
        variant: variant,
        properties: this.properties(),
        quantity: this.quantity(),
        plan: this.plan(variant),
      };
    }

    // Private Methods
    // -----------------------------------------------------------------------------
    _setIdInputValue(variant) {
      if (variant && variant.id) {
        this.variantElement.value = variant.id.toString();
      } else {
        this.variantElement.value = "";
      }
      this.variantElement.dispatchEvent(new Event("change"));
    }

    _onSubmit(options, event) {
      event.dataset = this.getFormState();
      if (options.onFormSubmit) {
        options.onFormSubmit(event);
      }
    }

    _onOptionChange(event) {
      this._setIdInputValue(event.dataset.variant);
    }

    _onFormEvent(cb) {
      if (typeof cb === "undefined") {
        return Function.prototype;
      }

      return function (event) {
        event.dataset = this.getFormState();
        this._setIdInputValue(event.dataset.variant);
        cb(event);
      }.bind(this);
    }

    _initInputs(selector, cb) {
      var elements = Array.prototype.slice.call(this.element.querySelectorAll(selector));

      return elements.map(
        function (element) {
          this._listeners.add(element, "change", this._onFormEvent(cb));
          return element;
        }.bind(this)
      );
    }

    _serializeInputValues(inputs, transform) {
      return inputs.reduce(function (options, input) {
        if (
          input.checked || // If input is a checked (means type radio or checkbox)
          (input.type !== "radio" && input.type !== "checkbox") // Or if its any other type of input
        ) {
          options.push(transform({ name: input.name, value: input.value }));
        }

        return options;
      }, []);
    }

    _validateProductObject(product) {
      if (typeof product !== "object") {
        throw new TypeError(product + " is not an object.");
      }

      if (typeof product.variants[0].options === "undefined") {
        throw new TypeError(
          "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
        );
      }
      return product;
    }
  }

  function getProductJson(handle) {
    const requestRoute = `${window.theme.routes.root_url}products/${handle}.js`;
    return window
      .fetch(requestRoute)
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function getScript(url, callback, callbackError) {
    let head = document.getElementsByTagName("head")[0];
    let done = false;
    let script = document.createElement("script");
    script.src = url;

    // Attach handlers for all browsers
    script.onload = script.onreadystatechange = function () {
      if (!done && (!this.readyState || this.readyState == "loaded" || this.readyState == "complete")) {
        done = true;
        callback();
      } else {
        callbackError();
      }
    };

    head.appendChild(script);
  }

  const loaders = {};

  function loadScript(options = {}) {
    if (!options.type) {
      options.type = "json";
    }

    if (options.url) {
      if (loaders[options.url]) {
        return loaders[options.url];
      } else {
        return getScriptWithPromise(options.url, options.type);
      }
    } else if (options.json) {
      if (loaders[options.json]) {
        return Promise.resolve(loaders[options.json]);
      } else {
        return window
          .fetch(options.json)
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            loaders[options.json] = response;
            return response;
          });
      }
    } else if (options.name) {
      const key = "".concat(options.name, options.version);
      if (loaders[key]) {
        return loaders[key];
      } else {
        return loadShopifyWithPromise(options);
      }
    } else {
      return Promise.reject();
    }
  }

  function getScriptWithPromise(url, type) {
    const loader = new Promise((resolve, reject) => {
      if (type === "text") {
        fetch(url)
          .then((response) => response.text())
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        getScript(
          url,
          function () {
            resolve();
          },
          function () {
            reject();
          }
        );
      }
    });

    loaders[url] = loader;
    return loader;
  }

  function loadShopifyWithPromise(options) {
    const key = "".concat(options.name, options.version);
    const loader = new Promise((resolve, reject) => {
      try {
        window.Shopify.loadFeatures([
          {
            name: options.name,
            version: options.version,
            onLoad: (err) => {
              onLoadFromShopify(resolve, reject, err);
            },
          },
        ]);
      } catch (err) {
        reject(err);
      }
    });
    loaders[key] = loader;
    return loader;
  }

  function onLoadFromShopify(resolve, reject, err) {
    if (err) {
      return reject(err);
    } else {
      return resolve();
    }
  }

  const selectors$C = {
    wrapper: "[data-swapper-wrapper]",
    target: "[data-swapper-target]",
    hover: "data-swapper-hover",
  };

  let sections$e = {};

  class Swapper {
    constructor(el) {
      this.container = el;
      this.target = this.container.querySelector(selectors$C.target);
      this.hovers = this.container.querySelectorAll(`[${selectors$C.hover}]`);

      if (this.target && this.hovers.length) {
        this.deafaultContent = this.target.innerHTML;
        this.init();
      }
    }

    init() {
      this.hovers.forEach((hover) => {
        hover.addEventListener(
          "mouseenter",
          function () {
            const newContent = hover.getAttribute(selectors$C.hover);
            this.target.innerHTML = `${newContent}`;
          }.bind(this)
        );
      });
      this.hovers.forEach((hover) => {
        hover.addEventListener(
          "mouseleave",
          function () {
            this.target.innerHTML = this.deafaultContent;
          }.bind(this)
        );
      });
      this.hovers.forEach((hover) => {
        hover.addEventListener(
          "click",
          function () {
            const clickedContent = hover.getAttribute(selectors$C.hover);
            this.deafaultContent = `${clickedContent}`;
          }.bind(this)
        );
      });
    }
  }

  function makeSwappers(instance) {
    sections$e[instance.id] = [];
    const els = instance.container.querySelectorAll(selectors$C.wrapper);
    els.forEach((el) => {
      sections$e[instance.id].push(new Swapper(el));
    });
  }

  const swapperSection = {
    onLoad() {
      makeSwappers(this);
    },
  };

  const defaults = {
    color: "ash",
  };

  const selectors$B = {
    swatch: "data-swatch",
    outerGrid: "[data-grid-item]",
    slide: "[data-grid-slide]",
    image: "data-swatch-image",
    variant: "data-swatch-variant",
    button: "[data-swatch-button]",
    addButton: "data-add-to-cart-variant",
    price: "data-swatch-price",
    comparePrice: "data-swatch-compare-at-price",
    link: "[data-grid-link]",
    wrapper: "[data-grid-swatches]",
    template: "[data-swatch-template]",
    handle: "data-swatch-handle",
    label: "data-swatch-label",
  };

  class ColorMatch {
    constructor(options = {}) {
      this.settings = {
        ...defaults,
        ...options,
      };

      this.match = this.init();
    }

    getColor() {
      return this.match;
    }

    init() {
      const getColors = loadScript({ json: window.theme.assets.swatches });
      return getColors
        .then((colors) => {
          return this.matchColors(colors, this.settings.color);
        })
        .catch((e) => {
          //console.log("failed to load swatch colors script");
          //console.log(e);
        });
    }

    matchColors(colors, name) {
      let bg = "#E5E5E5";
      let img = null;
      const path = window.theme.assets.base || "/";
      const comparisonName = name.toLowerCase().replace(/\s/g, "");
      const array = colors.colors;
      if (array) {
        const variantNameMatch = (nameObject) => {
          const indexName = Object.keys(nameObject).toString();
          const neatName = indexName.toLowerCase().replace(/\s/g, "");
          return neatName === comparisonName;
        };
        const position = array.findIndex(variantNameMatch);
        if (position > -1) {
          const value = Object.values(array[position])[0];
          const valueLowerCase = value.toLowerCase();
          if (
            valueLowerCase.includes(".jpg") ||
            valueLowerCase.includes(".jpeg") ||
            valueLowerCase.includes(".png") ||
            valueLowerCase.includes(".svg")
          ) {
            img = `${path}${value}`;
            bg = "#888888";
          } else {
            bg = value;
          }
        }
      }
      return {
        color: this.settings.color,
        path: img,
        hex: bg,
      };
    }
  }

  const convertMoney = (money, trailingZeros = true) => {
    let decimal = "";
    if (money && money !== "null") {
      if (trailingZeros) {
        decimal = (parseInt(money) / 100).toFixed(2).toString();
      } else {
        decimal = (parseInt(money) / 100).toFixed(0).toString();
      }
      const finalMoney = `$${decimal}`;
      return finalMoney;
    }
    return "";
  };

  class RadioSwatch extends HTMLElement {
    constructor() {
      super();

      this.element = this.querySelector(`[${selectors$B.swatch}]`);
      this.colorString = this.element.getAttribute(selectors$B.swatch);
      this.image = this.element.getAttribute(selectors$B.image);
      this.variant = this.element.getAttribute(selectors$B.variant);
      this.price = this.element.getAttribute(selectors$B.price);
      this.comparePrice = this.element.getAttribute(selectors$B.comparePrice);
      this.outer = this.element.closest(selectors$B.outerGrid);
      const matcher = new ColorMatch({ color: this.colorString });
      matcher.getColor().then((result) => {
        this.colorMatch = result;
        this.init();
      });
    }

    init() {
      this.setStyles();
      if (this.variant && this.outer) {
        this.handleClicks();
      }
    }

    setStyles() {
      if (this.colorMatch.hex) {
        this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`);
      }
      if (this.colorMatch.path) {
        if (this.image) {
          this.element.style.setProperty("background-image", `url(${this.image})`);
        } else {
          this.element.style.setProperty(
            "background-image",
            "url(http://cdn.shopify.com/s/files/1/0742/1755/4238/t/16/assets/blank.svg?v=8055057579596076041686005232)"
          );
          this.element.style.setProperty("filter", "brightness(.95)");
        }
        this.element.style.setProperty("background-size", "cover");
      }
    }

    handleClicks() {
      this.slide = this.outer.querySelector(selectors$B.slide);
      this.linkElement = this.outer.querySelector(selectors$B.link);
      this.linkDestination = getUrlWithVariant(this.linkElement.getAttribute("href"), this.variant);
      this.button = this.element.closest(selectors$B.button);
      this.addButton = this.outer.querySelector(`[${selectors$B.addButton}]`);

      this.button.addEventListener(
        "click",
        function () {
          this.productCard = this.closest(".product-grid-item");
          this.productCardSwatches = this.productCard.querySelectorAll(".swatch__button");
          this.variantNameContainer = this.productCard.querySelector(".product-card__variant-name");
          this.priceContainer = this.productCard.querySelector(".price");
          this.compareAtPriceContainer = this.productCard.querySelector(".compare-at");
          this.priceBadgeContainer = this.productCard.querySelector(".product__badge-product-price");
          this.compareAtPriceBadgeContainer = this.productCard.querySelector(".product__badge-sale-price");
          this.saleLine = this.productCard.querySelector("[data-sale-line]");

          // configure add button
          if (this.addButton && this.variant) {
            this.addButton.setAttribute(selectors$B.addButton, parseFloat(this.variant));
            this.productCardSwatches.forEach((swatch) => {
              swatch.classList.remove("selected");
            });
            this.button.classList.add("selected");
            this.variantNameContainer.innerText = this.colorString;

            if (this.priceContainer) {
              this.priceContainer.innerText = convertMoney(this.price);
            }
            // Update product card price
            if (this.compareAtPriceContainer) {
              if (this.comparePrice && this.comparePrice !== "null") {
                this.compareAtPriceContainer.innerText = convertMoney(this.comparePrice);
              } else {
                this.compareAtPriceContainer.innerText = "";
              }
            }

            // Update badge price
            if (this.comparePrice !== "null") {
              this.priceBadgeContainer.innerText = convertMoney(this.price, false);
              this.saleLine.classList.add("product__badge-product-line");
            } else {
              this.priceBadgeContainer.innerText = "";
              this.saleLine.classList.remove("product__badge-product-line");
            }
            if (this.compareAtPriceBadgeContainer && this.comparePrice && this.comparePrice !== "null") {
              this.compareAtPriceBadgeContainer.innerText = convertMoney(this.comparePrice, false);
            } else {
              this.compareAtPriceBadgeContainer.innerText = "";
            }
          }

          // configure media
          this.linkElement.setAttribute("href", this.linkDestination);
          this.slide.setAttribute("src", this.linkDestination);
          if (this.image) {
            // container width rounded to the nearest 180 pixels
            // increses likelihood that the image will be cached
            let ratio = window.devicePixelRatio || 1;
            let pixels = this.slide.offsetWidth * ratio;
            let widthRounded = Math.ceil(pixels / 180) * 180;
            let sizedImage = getSizedImageUrl(this.image, `${widthRounded}x`);
            window
              .fetch(sizedImage)
              .then((response) => {
                return response.blob();
              })
              .then((blob) => {
                var objectURL = URL.createObjectURL(blob);
                this.slide.style.setProperty("background-color", "#fff");
                this.slide.style.setProperty("background-image", `url("${objectURL}")`);
              })
              .catch((error) => {
                //console.log(`Error: ${error}`);
              });
          }
        }.bind(this)
      );
    }
  }

  class GridSwatch {
    constructor(wrap) {
      this.template = document.querySelector(selectors$B.template).innerHTML;
      this.wrap = wrap;
      this.handle = wrap.getAttribute(selectors$B.handle);
      const label = wrap.getAttribute(selectors$B.label).trim().toLowerCase();
      getProductJson(this.handle).then((product) => {
        this.product = product;
        this.colorOption = product.options.find(function (element) {
          return element.name.toLowerCase() === label || null;
        });
        if (this.colorOption) {
          this.swatches = this.colorOption.values;
          this.init();
        }
      });
    }

    init() {
      this.wrap.innerHTML = "";
      this.swatches.forEach((swatch) => {
        let variant = this.product.variants.find((variant) => {
          return variant.options.includes(swatch);
        });
        const image = variant.featured_media ? variant.featured_media.preview_image.src : "";

        const rand = Math.floor(Math.random() * 9999);

        this.wrap.innerHTML += Sqrl__namespace.render(this.template, {
          color: swatch,
          uniq: `${this.product.id}-${variant.id}-${rand}`,
          variant: variant.id,
          price: variant.price,
          compare: variant.compare_at_price,
          image,
        });
      });

      new NativeScrollbar(this.wrap);
    }
  }

  function makeGridSwatches(container) {
    const gridSwatchWrappers = container.querySelectorAll(selectors$B.wrapper);
    gridSwatchWrappers.forEach((wrap) => {
      new GridSwatch(wrap);
    });
  }

  const swatchGridSection = {
    onLoad() {
      makeGridSwatches(this.container);
      makeSwappers(this);
    },
  };

  const selectors$A = {
    popoutWrapper: "[data-popout]",
    popoutList: "[data-popout-list]",
    popoutToggle: "data-popout-toggle",
    popoutInput: "[data-popout-input]",
    popoutOptions: "[data-popout-option]",
    popoutLabel: "[data-popout-label]",
    popoutPrevent: "data-popout-prevent",
    popoutQuantity: "data-quantity-field",
    dataValue: "data-value",
    ariaExpanded: "aria-expanded",
    ariaCurrent: "aria-current",
  };

  const classes$j = {
    listVisible: "popout-list--visible",
    currentSuffix: "--current",
  };

  class PopoutSelect extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector(selectors$A.popoutWrapper);
      this.popoutList = this.container.querySelector(selectors$A.popoutList);
      this.popoutToggle = this.container.querySelector(`[${selectors$A.popoutToggle}]`);
      this.outsidePopupToggle = document.querySelector(`[${selectors$A.popoutToggle}="${this.popoutList.id}"]`);
      this.popoutInput = this.container.querySelector(selectors$A.popoutInput);
      this.popoutOptions = this.container.querySelectorAll(selectors$A.popoutOptions);
      this.popoutPrevent = this.container.getAttribute(selectors$A.popoutPrevent) === "true";

      this._connectOptions();
      this._connectToggle();
      this._onFocusOut();
      this.popupListMaxWidth();

      if (this.popoutInput && this.popoutInput.hasAttribute(selectors$A.popoutQuantity)) {
        document.addEventListener("popout:updateValue", this.updatePopout.bind(this));
      }

      document.addEventListener("theme:resize", () => {
        this.popupListMaxWidth();
      });
    }

    unload() {
      if (this.popoutOptions.length) {
        this.popoutOptions.forEach((element) => {
          element.removeEventListener("clickDetails", this.popupOptionsClick.bind(this));
          element.removeEventListener("click", this._connectOptionsDispatch.bind(this));
        });
      }

      this.popoutToggle.removeEventListener("click", this.popupToggleClick.bind(this));

      this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this));

      this.popoutList.removeEventListener("focusout", this.popupListFocusout.bind(this));

      this.container.removeEventListener("keyup", this.containerKeyup.bind(this));

      if (this.outsidePopupToggle) {
        this.outsidePopupToggle.removeEventListener("click", this.popupToggleClick.bind(this));

        this.outsidePopupToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this));
      }
    }

    popupToggleClick(evt) {
      const ariaExpanded = evt.currentTarget.getAttribute(selectors$A.ariaExpanded) === "true";
      evt.currentTarget.setAttribute(selectors$A.ariaExpanded, !ariaExpanded);
      this.popoutList.classList.toggle(classes$j.listVisible);
      this.popupListMaxWidth();
    }

    popupToggleFocusout(evt) {
      const popoutLostFocus = this.container.contains(evt.relatedTarget);

      if (!popoutLostFocus) {
        this._hideList();
      }
    }

    popupListFocusout(evt) {
      const childInFocus = evt.currentTarget.contains(evt.relatedTarget);
      const isVisible = this.popoutList.classList.contains(classes$j.listVisible);

      if (isVisible && !childInFocus) {
        this._hideList();
      }
    }

    popupListMaxWidth() {
      this.popoutList.style.maxWidth = `${parseInt(
        document.body.clientWidth - this.popoutList.getBoundingClientRect().left
      )}px`;
    }

    popupOptionsClick(evt) {
      const link = evt.target.closest(selectors$A.popoutOptions);
      const popoutLabel = evt.currentTarget.querySelector(selectors$A.popoutLabel);

      if (link.attributes.href.value === "#") {
        evt.preventDefault();

        let attrValue = "";
        let labelValue = "";

        if (evt.currentTarget.getAttribute(selectors$A.dataValue)) {
          attrValue = evt.currentTarget.getAttribute(selectors$A.dataValue);
        }
        if (popoutLabel && popoutLabel.innerText) {
          labelValue = evt.currentTarget.querySelector(selectors$A.popoutLabel).innerText;
        }

        this.popoutInput.value = attrValue;

        if (this.popoutPrevent) {
          this.popoutInput.dispatchEvent(new Event("change"));

          if (!evt.detail.preventTrigger && this.popoutInput.hasAttribute(selectors$A.popoutQuantity)) {
            this.popoutInput.dispatchEvent(new Event("input"));
          }

          const currentElement = this.popoutList.querySelector(`[class*="${classes$j.currentSuffix}"]`);
          let targetClass = classes$j.currentSuffix;

          if (currentElement && currentElement.classList.length) {
            for (const currentElementClass of currentElement.classList) {
              if (currentElementClass.includes(classes$j.currentSuffix)) {
                targetClass = currentElementClass;
                break;
              }
            }
          }

          const listTargetElement = this.popoutList.querySelector(`.${targetClass}`);

          if (listTargetElement) {
            listTargetElement.classList.remove(`${targetClass}`);
            evt.currentTarget.parentElement.classList.add(`${targetClass}`);
          }

          const targetAttribute = this.popoutList.querySelector(`[${selectors$A.ariaCurrent}]`);

          if (targetAttribute && targetAttribute.hasAttribute(`${selectors$A.ariaCurrent}`)) {
            targetAttribute.removeAttribute(`${selectors$A.ariaCurrent}`);
            evt.currentTarget.setAttribute(`${selectors$A.ariaCurrent}`, "true");
          }

          if (labelValue !== "") {
            this.popoutToggle.textContent = labelValue;

            if (this.outsidePopupToggle) {
              this.outsidePopupToggle.textContent = labelValue;
            }
          }

          this.popupToggleFocusout(evt);
          this.popupListFocusout(evt);
        } else {
          this._submitForm(attrValue);
        }
      }
    }

    updatePopout(evt) {
      const targetElement = this.popoutList.querySelector(`[${selectors$A.dataValue}="${this.popoutInput.value}"]`);
      if (targetElement) {
        targetElement.dispatchEvent(
          new CustomEvent("clickDetails", {
            cancelable: true,
            bubbles: true,
            detail: {
              preventTrigger: true,
            },
          })
        );
      }
    }

    containerKeyup(evt) {
      if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
        return;
      }
      this._hideList();
      this.popoutToggle.focus();
    }

    bodyClick(evt) {
      const isOption = this.container.contains(evt.target);
      const isVisible = this.popoutList.classList.contains(classes$j.listVisible);
      this.outsidePopupToggle === evt.target;

      if (isVisible && !isOption) {
        this._hideList();
      }
    }

    _connectToggle() {
      this.popoutToggle.addEventListener("click", this.popupToggleClick.bind(this));

      if (this.outsidePopupToggle) {
        this.outsidePopupToggle.addEventListener("click", this.popupToggleClick.bind(this));
      }
    }

    _connectOptions() {
      if (this.popoutOptions.length) {
        this.popoutOptions.forEach((element) => {
          element.addEventListener("clickDetails", this.popupOptionsClick.bind(this));
          element.addEventListener("click", this._connectOptionsDispatch.bind(this));
        });
      }
    }

    _connectOptionsDispatch(evt) {
      const event = new CustomEvent("clickDetails", {
        cancelable: true,
        bubbles: true,
        detail: {
          preventTrigger: false,
        },
      });

      if (!evt.target.dispatchEvent(event)) {
        evt.preventDefault();
      }
    }

    _onFocusOut() {
      this.popoutToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this));

      if (this.outsidePopupToggle) {
        this.outsidePopupToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this));
      }

      this.popoutList.addEventListener("focusout", this.popupListFocusout.bind(this));

      this.container.addEventListener("keyup", this.containerKeyup.bind(this));

      document.body.addEventListener("click", this.bodyClick.bind(this));
    }

    _submitForm(value) {
      const form = this.container.closest("form");
      if (form) {
        form.submit();
      }
    }

    _hideList() {
      this.popoutList.classList.remove(classes$j.listVisible);
      this.popoutToggle.setAttribute(selectors$A.ariaExpanded, false);
      if (this.outsidePopupToggle) {
        this.outsidePopupToggle.setAttribute(selectors$A.ariaExpanded, false);
      }
    }
  }

  const selectors$U = {
    popoutWrapper: "[data-multiselect-popout]",
    popoutList: "[data-multiselect-popout-list]",
    popoutToggle: "data-multiselect-popout-toggle",
    popoutInput: "[data-multiselect-popout-input]",
    popoutOptions: "[data-multiselect-popout-option]",
    popoutLabel: "[data-multiselect-popout-label]",
    popoutPrevent: "data-multiselect-popout-prevent",
    countValue: "[data-multiselect-count]",
    limitValue: "data-multiselect-limit",
    swatchValue: "data-multiselect-swatch",
    dataValue: "data-value",
    ariaExpanded: "aria-expanded",
  };

  const classes$r = {
    listVisible: "popout-list--visible",
  };

  class PopoutMultiselect extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector(selectors$U.popoutWrapper);
      this.countValue = this.querySelector(selectors$U.countValue);
      this.limitValue = this.querySelector(`[${selectors$U.limitValue}]`);
      this.swatchValues = this.querySelectorAll(`[${selectors$U.swatchValue}]`);

      this.popoutList = this.container.querySelector(selectors$U.popoutList);
      this.popoutToggle = this.container.querySelector(`[${selectors$U.popoutToggle}]`);
      this.popoutInput = this.container.querySelector(selectors$U.popoutInput);
      this.popoutOptions = this.container.querySelectorAll(`${selectors$U.popoutOptions} input`);
      this.popoutPrevent = this.container.getAttribute(selectors$U.popoutPrevent) === "true";

      this.labelValues = [];

      if (this.swatchValues.length) {
        this.swatchValues.forEach((swatch) => {
          const matcher = new ColorMatch({
            color: swatch.getAttribute(selectors$U.swatchValue),
          });
          matcher.getColor().then((result) => {
            if (result) {
              swatch.style.setProperty("--swatch", `${result.hex}`);
              swatch.classList.remove("hide");
            }
          });
        });
      }

      this._connectOptions();
      this._connectToggle();
      this._onFocusOut();
    }

    popupToggleClick(evt) {
      const ariaExpanded = evt.currentTarget.getAttribute(selectors$U.ariaExpanded) === "true";
      evt.currentTarget.setAttribute(selectors$U.ariaExpanded, !ariaExpanded);
      this.popoutList.classList.toggle(classes$r.listVisible);
    }

    popupOptionsChange(evt) {
      const checkedOptions = this.container.querySelectorAll(`${selectors$U.popoutOptions} input:checked`);
      const uncheckedOptions = this.container.querySelectorAll(
        `${selectors$U.popoutOptions} input:not(:checked):not([data-multiselect-popout-option-disabled])`
      );

      if (this.limitValue) {
        if (checkedOptions.length >= parseInt(this.limitValue.getAttribute(selectors$U.limitValue))) {
          uncheckedOptions.forEach((opt) => (opt.disabled = true));
        } else uncheckedOptions.forEach((opt) => (opt.disabled = false));
      }

      var checkedValues = Array.from(checkedOptions).map((opt) => opt.value);
      var currentLabel = evt.currentTarget
        .closest(selectors$U.popoutOptions)
        .querySelector(selectors$U.popoutLabel).innerText;

      let dataValue = "";

      for (var i = 0; i < checkedOptions.length; i++) {
        if (i !== 0) {
          dataValue = dataValue.concat(":");
        }
        dataValue = dataValue.concat(checkedValues[i]);
      }

      if (currentLabel) {
        if (this.labelValues.indexOf(currentLabel) != -1) {
          this.labelValues.splice(this.labelValues.indexOf(currentLabel), 1);
        } else {
          this.labelValues.push(currentLabel);
        }
      }

      this.popoutInput.value = dataValue;

      if (this.popoutPrevent) {
        this.popoutInput.dispatchEvent(new Event("change"));

        if (this.labelValues.length) {
          this.popoutToggle.textContent = this.labelValues;
        } else {
          this.popoutToggle.textContent = "Make your selection";
        }

        if (this.countValue) {
          this.countValue.textContent = checkedValues.length;
        }
      }
    }

    bodyClick(evt) {
      const isOption = this.container.contains(evt.target);
      const isVisible = this.popoutList.classList.contains(classes$r.listVisible);

      if (isVisible && !isOption) {
        this._hideList();
      }
    }

    _connectToggle() {
      this.popoutToggle.addEventListener("click", this.popupToggleClick.bind(this));
    }

    _connectOptions() {
      if (this.popoutOptions.length) {
        this.popoutOptions.forEach((element) => {
          element.addEventListener("change", this.popupOptionsChange.bind(this));
        });
      }
    }

    _onFocusOut() {
      document.body.addEventListener("click", this.bodyClick.bind(this));
    }

    _hideList() {
      this.popoutList.classList.remove(classes$r.listVisible);
      this.popoutToggle.setAttribute(selectors$U.ariaExpanded, false);
    }
  }

  customElements.define("popout-multiselect", PopoutMultiselect);

  const selectors$X = {
    form: "[data-grid-form]",
    handle: "data-grid-handle",
    addButton: "data-add-to-cart-variant",
    quantityInput: "[data-quantity-input]",
    buyButtonPermalink: "[data-grid-buy-button-permalink]",
  };

  class GridForm {
    constructor(wrap) {
      this.wrap = wrap;
      this.handle = wrap.getAttribute(selectors$X.handle);
      this.addButton = wrap.querySelector(`[${selectors$X.addButton}]`);
      this.quantityInput = wrap.querySelector(selectors$X.quantityInput);
      this.buyButtonPermalink = wrap.querySelector(selectors$X.buyButtonPermalink);

      this.init();
      initQtySection(wrap);
    }

    init() {
      this.updateBuyButtonPermalink();

      document.addEventListener("theme:partner:set", (event) => {
        event.preventDefault();
        this.updateBuyButtonPermalink();
      });
      if (this.quantityInput) {
        this.quantityInput.addEventListener("change", this.updateState.bind(this));
      }
      
      if (this.buyButtonPermalink) {
        this.buyButtonPermalink.addEventListener("click", (evt) => {
          evt.preventDefault();
          location.href = this.buyButtonPermalink.href;
        })
      }
      /*
      if (this.buyButtonPermalink) {
        this.buyButtonPermalink.addEventListener("click", (evt) => {
          evt.preventDefault();
          if (window.zipLocator.zip && window.zipLocator.match) {
            location.href = this.buyButtonPermalink.href;
          } else {
            const zipLocatorTrigger = document.querySelector(selectors$W.trigger);
            if (zipLocatorTrigger) zipLocatorTrigger.click();
          }
        });
      }
        */
    }

    updateState() {
      this.updateBuyButtonPermalink();
    }

    updateBuyButtonPermalink() {
      if (!this.buyButtonPermalink)return;

      const variant = this.addButton.getAttribute(selectors$X.addButton);
      const quantity = this.quantityInput ? this.quantityInput.value : 1;

      let matching = {
        delivery_guarantee_day: window.theme?.storefront_partner?.deliveryGuaranteeDay ?? null,
        name:window.theme?.storefront_partner?.displayName ?? null,
        storefront: window.theme?.storefront_partner?.displayName ?? null,
        usercode: window.theme?.storefront_partner?.betterwarePlusId ?? null,
      }

      
      const context = {
        curSite: localStorage.getItem("CURRENT_PARTNER_STORAGE_KEY") ?? null,
        zip: "",
        matchedConsultant: matching,
        isPartner: window.customer.isPartner,
        betterwarePlusId: window.customer.betterwarePlusId,
      };

      const shopUrl = this.buyButtonPermalink.dataset.shopUrl;
      var permalinkUrl =
        shopUrl +
        "/cart/add?id=" +
        variant +
        "&quantity=" +
        quantity +
        "&attributes[context]=" +
        btoa(JSON.stringify(context));

      this.buyButtonPermalink.href = permalinkUrl;
    }
  }

  function makeGridForms(container) {
    const gridFormWrappers = container.querySelectorAll(selectors$X.form);
    gridFormWrappers.forEach((wrap) => {
      new GridForm(wrap);
    });
  }

  const formGridSection = {
    onLoad() {
      makeGridForms(this.container);
    },
  };

  const slideDown = (target, duration = 500, checkHidden = true) => {
    let display = window.getComputedStyle(target).display;
    if (checkHidden && display !== "none") {
      return;
    }
    target.style.removeProperty("display");
    if (display === "none") display = "block";
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = "border-box";
    target.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)";
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    window.setTimeout(() => {
      target.style.removeProperty("height");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
      target.style.removeProperty("transition-timing-function");
    }, duration);
  };

  const slideUp = (target, duration = 500) => {
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)";
    target.style.transitionDuration = duration + "ms";
    target.style.boxSizing = "border-box";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
      target.style.display = "none";
      target.style.removeProperty("height");
      target.style.removeProperty("padding-top");
      target.style.removeProperty("padding-bottom");
      target.style.removeProperty("margin-top");
      target.style.removeProperty("margin-bottom");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
      target.style.removeProperty("transition-timing-function");
    }, duration);
  };

  let sections$d = {};

/**
 * wrapper: "[data-quantity-selector]",
    increase: "[data-increase-quantity]",
    decrease: "[data-decrease-quantity]",
    input: "[data-quantity-input]",
    increaseError: "[data-increase-quantity-error]",
 */

  const selectors$z = {
    wrapper: "[data-add-action-wrapper]",
    addButton: "[data-add-to-cart]",
    quantityInput: "[data-quantity-input]",
    quantityWrapper: ".quantity__wrapper",
    errors: "[data-add-action-errors]",
    addVariantDetached: "data-add-to-cart-variant",
    popdown: "[data-product-add-popdown-wrapper]",
    drawer: '[data-drawer="drawer-cart"]',
    disabledAjax: '[data-ajax-disable="true"]',
    upsellModal: "[data-upsell-modal]",
    adToasteDelete: "#adtoast-delete",
    adToastAdd:"#adtoast-add",
    isButtonPdp: 'data-pdp',
    times: {
      delay: 1000,
    },
    trashDelete: "#trashDelete",
    increase: "[data-increase-quantity]",
    decrease: "[data-decrease-quantity]",
    input: "[data-quantity-input]",
  };

  const classes$i = {
    loading: "loading",
    success: "has-success",
  };

  class ProductAddButton {
    constructor(wrapper, isCartItem) {
      this.wrapper = wrapper;
      this.isCartItem = isCartItem ? isCartItem : false;
      this.button = wrapper.querySelector(selectors$z.addButton);
      this.trashDelete = wrapper.querySelector(selectors$z.trashDelete);
      this.errors = wrapper.querySelector(selectors$z.errors);
      this.popdown = document.querySelector(selectors$z.popdown);
      this.drawer = document.querySelector(selectors$z.drawer);
      this.disabledAjax = document.querySelector(selectors$z.disabledAjax);
      this.adToastDelete = document.querySelector(selectors$z.adToasteDelete);
      this.adToastAdd = document.querySelector(selectors$z.adToastAdd);
      this.increase = wrapper.querySelector(selectors$z.increase);
      this.decrease = wrapper.querySelector(selectors$z.decrease);
      this.input = wrapper.querySelector(selectors$z.input);
      this.min = parseInt(this.input.getAttribute("min"), 10);

      if (this.button) {
        const isDetached = this.button.hasAttribute(selectors$z.addVariantDetached);
        if (isDetached) {
          this.initDetached();
          this.deleteItem();
          this.changeQuantity();
        } else {
          this.initWithForm();
        }
      }
    }

    initWithForm() {
      this.button.addEventListener(
        "click",
        function (evt) {
          evt.preventDefault();
          const outerForm = evt.target.closest("form");
          if (outerForm.querySelector('[type="file"]')) {
            return;
          }
          if (!this.disabledAjax) {
            evt.preventDefault();
          }

          this.button.setAttribute("disabled", true);
          this.button.classList.add(classes$i.loading);

          const formData = new FormData(outerForm);
          const formString = new URLSearchParams(formData).toString();
          this.addToCartAction(formString);
          /*
          if (window.zipLocator.zip && window.zipLocator.match) {
          }
          else{
            const zipLocatorTrigger = document.querySelector(selectors$W.trigger);
            if (zipLocatorTrigger) zipLocatorTrigger.click();
          }
            */
        }.bind(this)
      );
    }

    initDetached() {
      this.button.addEventListener(
        "click",
        function (evt) {
          this.button.setAttribute("disabled", true);
          this.button.classList.add(classes$i.loading);

          const wrapper = this.button.closest(selectors$z.wrapper);
          const variant = this.button.getAttribute(selectors$z.addVariantDetached);
          const quantityInput = wrapper.querySelector(selectors$z.quantityInput);
          const quantity = quantityInput ? quantityInput.value : 1;
          const formString = `form_type=product&id=${variant}&quantity=${quantity}`;
          this.addToCartAction(formString);
          if (!this.disabledAjax) {
            evt.preventDefault();
          }
          /*
          if (window.zipLocator.zip && window.zipLocator.match) {

          }
          else{
            const zipLocatorTrigger = document.querySelector(selectors$W.trigger);
            if (zipLocatorTrigger) zipLocatorTrigger.click();
          }
            */
        }.bind(this)
      );
    }

    changeQuantity(){
      this.increase.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          let v = parseInt(this.input.value, 10);
          v = isNaN(v) ? 0 : v;
          v++;
          this.input.value = v;
          const formString = `form_type=product&id=${this.button.getAttribute(selectors$z.addVariantDetached)}&quantity=1`;
          this.addToCartAction(formString);
          this.showAdToastAdd();
        }.bind(this)
      );
      this.decrease.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          if(this.input.value > 1){
          let v = parseInt(this.input.value, 10);
          v = isNaN(v) ? 0 : v;
          v--;
          v = Math.max(this.min, v);
          this.input.value = v;
          let variant = this.button.getAttribute(selectors$z.addVariantDetached)
          this.changeCartWithQuantityInput(variant);
          }
        }.bind(this)
      );
    }

    async changeCartWithQuantityInput(variantId) {
      try {
        this.inputsDisabled(true);

        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();

        // 2filter by variant
        const lines = cart.items
          .filter(item => Number(item.variant_id) === Number(variantId));

        if (!lines.length) return;

        lines.sort((a, b) => a.quantity - b.quantity);

        const lineToModify = lines[0];
        const newQuantity = lineToModify.quantity - 1;
        const changeRes = await fetch(`${window.theme.routes.cart}/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: lineToModify.key,
            quantity: newQuantity
          })
        });

        const updatedCart = await changeRes.json();
        this.updateHeaderTotal(updatedCart);

      } catch (error) {
        console.error(error);
      } finally {
        this.inputsDisabled(false);
      }
    }

    deleteItem(){
      this.trashDelete.addEventListener("click", function(evt){
        let variantId = this.trashDelete.dataset.variantId;
        fetch(`${window.theme.routes.cart}/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: variantId,       
            quantity: 0  
          })
        })
        .then(res => res.json())
        .then(cart => {
          this.updateHeaderTotal();
          this.hideQtyInput();
          this.showAdToastDelete();
          this.input.value = 1;
        });
      }.bind(this))
    }

    addToCartAction(formData) {
      const newFormData = `${formData}`;
      const url = `${window.theme.routes.cart}/add.js`;
      const instance = this;
      axios
        .post(url, newFormData, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then(function (response) {
          instance.onSuccessOpenDrawer(response.data);
        })
        .catch(function (error) {
          console.warn(error);
          instance.onError(error.data);
        }); 
    }

    onSuccess(variant) {
      this.updateHeaderTotal();
      this.button.classList.remove(classes$i.loading);
      this.button.classList.add(classes$i.success);
      setTimeout(() => {
        this.button.classList.remove(classes$i.success);
        this.button.removeAttribute("disabled");
      }, 3500);

      if (this.button.closest(selectors$z.upsellModal)) {
        this.button.closest(selectors$z.upsellModal).dispatchEvent(new CustomEvent("theme:upsell:close"));
      }

      if (this.isCartItem) {
        document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
      } else {
        this.popdown.dispatchEvent(
          new CustomEvent("theme:cart:popdown", {
            detail: {
              variant: variant,
            },
            bubbles: true,
          })
        );
      }

      if (this.disabledAjax) {
        window.location.reload();
      }
    }

    onSuccessOpenDrawer(variant) {
      this.updateHeaderTotal();
      this.getCurrentValue(variant);
      this.button.classList.remove(classes$i.loading);
      this.button.classList.add(classes$i.success);
      this.input.setAttribute("data-key", variant.key);
      this.input.setAttribute("data-id", variant.id);
      setTimeout(() => {
        this.showQtyInput();
        this.button.classList.remove(classes$i.success);
        this.button.removeAttribute("disabled");
      }, 3500);

      if (this.button.closest(selectors$z.upsellModal)) {
        this.button.closest(selectors$z.upsellModal).dispatchEvent(new CustomEvent("theme:upsell:close"));
      }

      if (this.isCartItem) {
        document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
      } else {
        setTimeout(() => {
          this.drawer.dispatchEvent(
            new CustomEvent("theme:drawer:open", {
              bubbles: false,
            })
          );
        }, selectors$z.times.delay);
      }

      if (this.disabledAjax) {
        window.location.reload();
      }
    }

    onError(data) {
      let text = "Network error: please try again";
      if (data && data.description) {
        text = data.description;
      }
      const errorsHTML = `<div class="errors">${text}</div>`;

      this.button.classList.remove(classes$i.loading);
      this.button.removeAttribute("disabled");
      this.errors.innerHTML = errorsHTML;
      slideDown(this.errors);
      setTimeout(() => {
        slideUp(this.errors);
      }, 5000);
    }

    updateHeaderTotal() {
      axios
        .get(`${window.theme.routes.cart}.js`)
        .then((response) => {
          document.dispatchEvent(
            new CustomEvent("theme:cart:change", {
              detail: {
                cart: response.data,
              },
              bubbles: true,
            })
          );
        })
        .catch((e) => {
          console.error(e);
        });
    }

    hideQtyInput(){
      const wrapper = this.button.closest(selectors$z.wrapper);
      const quantityWrapper = wrapper.querySelector(selectors$z.quantityWrapper);
      quantityWrapper.style.setProperty("display", "none");
      this.button.style.setProperty("display", "block");
    }

    showQtyInput(){
      const wrapper = this.button.closest(selectors$z.wrapper);
      const quantityWrapper = wrapper.querySelector(selectors$z.quantityWrapper);
      quantityWrapper.style.setProperty("display", "flex");
      this.button.hasAttribute(selectors$z.isButtonPdp) ? this.button.style.setProperty("display", "block") : this.button.style.setProperty("display", "none");
    }

    showAdToastDelete(){
      if(this.adToastDelete){
        this.adToastDelete.classList.add("fade-in-out");
        this.adToastDelete.style.setProperty("display", "flex");
        setTimeout(() => {
          this.adToastDelete.classList.remove("fade-in-out"); 
          this.adToastDelete.style.setProperty("display", "none");
        }, 2000);
      }
    }

    showAdToastAdd(){
      if(this.adToastAdd){
        this.adToastAdd.classList.add("fade-in-out");
        this.adToastAdd.style.setProperty("display", "flex");
        setTimeout(() => {
          this.adToastAdd.classList.remove("fade-in-out"); 
          this.adToastAdd.style.setProperty("display", "none");
        }, 2000);
      }
    }

    inputsDisabled(state){
      this.increase.disabled = state;
      this.decrease.disabled = state;
      this.input.disabled = state;
    }

    getCurrentValue(variant){
      if(this.button.hasAttribute(selectors$z.isButtonPdp)){
        return;
      }
      fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const variantId = variant.id;
        //console.log("cart: ", cart.items)
        const quantity = cart.items.reduce((total, item) => {
          return item.variant_id == variantId
            ? total + item.quantity
            : total;
        }, 0);

      this.input.value = quantity;

      //console.log("Cantidad total:", quantity);
      //console.log(quantity);
      })
      .catch((e) => {
        console.error(e);
      })
    }

}

  // global class for PWS feature products
  window.ProductAddButton = ProductAddButton;

  const productAddSection = {
    onLoad() {
      sections$d[this.id] = [];
      const els = this.container.querySelectorAll(selectors$z.wrapper);
      els.forEach((el) => {
        sections$d[this.id].push(new ProductAddButton(el));
      });
    },
    onUnload: function () {
      sections$d[this.id].forEach((el) => {
        if (typeof el.unload === "function") {
          el.unload();
        }
      });
    },
  };

  const selectors$y = {
    upsellHolder: "data-upsell-holder",
    addButtonWrapper: "[data-add-action-wrapper]",
    modalContent: "[data-product-upsell-ajax]",
    upsellModal: "[data-upsell-modal]",
    upsellModalTemplate: "[data-upsell-modal-template]",
    media: "[data-media-slide]",
    cartLineItems: "[data-line-items]",
    focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
  };

  class UpsellProduct extends HTMLElement {
    constructor() {
      super();

      this.upsellHolder = this.querySelector(`[${selectors$y.upsellHolder}]`);
      this.modalCloseEvent = () => this.modalClose();

      if (this.upsellHolder) {
        this.isCartItem = Boolean(this.upsellHolder.closest(selectors$y.cartLineItems));
        this.modalTemplate = this.upsellHolder.querySelector(selectors$y.upsellModalTemplate);
        this.modal = document.querySelector(selectors$y.upsellModal);
        this.modalID = this.upsellHolder.getAttribute(selectors$y.upsellHolder);
        this.modalContent = null;
        this.triggerButton = document.querySelector(`[data-popup-${this.modalID}]`);
        this.handle = this.triggerButton ? this.triggerButton.getAttribute(`data-popup-${this.modalID}`) : null;

        if (this.modalTemplate && !this.modal) {
          const modalTemplateInner = this.modalTemplate.innerHTML;
          const htmlObject = document.createElement("div");
          htmlObject.innerHTML = modalTemplateInner;
          this.modalHtml = htmlObject.querySelector(selectors$y.upsellModal);
          document.body.appendChild(this.modalHtml);
          this.modal = document.querySelector(selectors$y.upsellModal);
        }

        this.init();
      }
    }

    init() {
      if (this.modalTemplate && this.triggerButton) {
        this.triggerButton.addEventListener("click", (e) => {
          e.preventDefault();

          if (this.modal && this.modalID) {
            this.modal.id = this.modalID;
          }

          this.getUpsellHTML();
        });
      }

      if (this.isCartItem) {
        new ProductAddButton(this.upsellHolder, this.isCartItem);
      }
    }

    getUpsellHTML() {
      window
        .fetch(`${window.theme.routes.root_url}products/${this.handle}?section_id=api-product-upsell`)
        .then(this.handleErrors)
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          const fresh = document.createElement("div");
          fresh.innerHTML = response;
          this.modalContent = document.querySelector(selectors$y.modalContent);
          this.modalContent.innerHTML = fresh.querySelector("[data-api-content]").innerHTML;
          this.modalCreate();
        });
    }

    modalCreate() {
      MicroModal.show(this.modalID, {
        onShow: (modal, el, event) => {
          const addButtonWrapper = modal.querySelector(selectors$y.addButtonWrapper);
          new ProductAddButton(addButtonWrapper, this.isCartItem);

          const firstFocus = modal.querySelector(selectors$y.focusable);
          trapFocus(modal, { elementToFocus: firstFocus });
          this.modal.addEventListener("theme:upsell:close", this.modalCloseEvent);

          this.modalContent.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
        },
        onClose: (modal, el, event) => {
          const allMedia = modal.querySelectorAll(selectors$y.media);

          allMedia.forEach((media) => {
            media.dispatchEvent(new CustomEvent("pause"));
          });

          removeTrapFocus();
          el && el.focus();
          this.modal.removeEventListener("theme:upsell:close", this.modalCloseEvent);
        },
      });
    }

    modalClose() {
      MicroModal.close(this.modalID);
    }

    handleErrors(response) {
      if (!response.ok) {
        return response.json().then(function (json) {
          const e = new FetchError({
            status: response.statusText,
            headers: response.headers,
            json: json,
          });
          throw e;
        });
      }
      return response;
    }
  }

  class CartNotes {
    constructor(element) {
      this.inputs = element.querySelectorAll("[data-cart-note]");
      this.initInputs();
    }

    initInputs() {
      this.inputs.forEach((input) => {
        input.addEventListener(
          "change",
          function (e) {
            const note = e.target.value.toString() || "";
            this.saveNotes(note);
          }.bind(this)
        );
      });
    }

    saveNotes(newNote) {
      window
        .fetch(`${window.theme.routes.cart}/update.js`, {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ note: newNote }),
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  const getUrlString = (params, keys = [], isArray = false) => {
    const p = Object.keys(params)
      .map((key) => {
        let val = params[key];

        if (Object.prototype.toString.call(val) === "[object Object]" || Array.isArray(val)) {
          if (Array.isArray(params)) {
            keys.push("");
          } else {
            keys.push(key);
          }
          return getUrlString(val, keys, Array.isArray(val));
        } else {
          let tKey = key;

          if (keys.length > 0) {
            const tKeys = isArray ? keys : [...keys, key];
            tKey = tKeys.reduce((str, k) => {
              return str === "" ? k : `${str}[${k}]`;
            }, "");
          }
          if (isArray) {
            return `${tKey}[]=${val}`;
          } else {
            return `${tKey}=${val}`;
          }
        }
      })
      .join("&");

    keys.pop();
    return p;
  };

  /**
   * Module to add a shipping rates calculator to cart page.
   *
   */

  const selectors$x = {
    submitButton: "[data-submit-shipping]",
    form: "[data-shipping-estimate-form]",
    template: "[data-response-template]",
    country: "#estimate_address_country",
    province: "#estimate_address_province",
    zip: "#estimate_address_zip",
    wrapper: "[data-response-wrapper]",
    defaultData: "data-default-fullname",
  };

  const classes$h = {
    success: "shipping--success",
    error: "errors",
  };

  class ShippingCalculator {
    constructor(section) {
      this.button = section.container.querySelector(selectors$x.submitButton);
      this.template = section.container.querySelector(selectors$x.template).innerHTML;
      this.ratesWrapper = section.container.querySelector(selectors$x.wrapper);
      this.form = section.container.querySelector(selectors$x.form);
      this.country = section.container.querySelector(selectors$x.country);
      this.province = section.container.querySelector(selectors$x.province);
      this.zip = section.container.querySelector(selectors$x.zip);
      this.init();
    }

    enableButtons() {
      this.button.removeAttribute("disabled");
      this.button.classList.remove("disabled");
    }

    disableButtons() {
      this.button.setAttribute("disabled", "disabled");
      this.button.classList.add("disabled");
    }

    render(rates) {
      if (this.template && this.ratesWrapper) {
        const rendered = Sqrl__namespace.render(this.template, rates);
        this.ratesWrapper.innerHTML = rendered;
      }
      this.enableButtons();
      this.ratesWrapper.style.removeProperty("display");
    }

    estimate(shipping_address) {
      const encodedShippingAddressData = encodeURI(
        getUrlString({
          shipping_address: shipping_address,
        })
      );
      const url = `${window.theme.routes.cart}/shipping_rates.json?${encodedShippingAddressData}`;
      const instance = this;
      axios
        .get(url)
        .then(function (response) {
          // handle success
          const items = instance.sanitize(response);
          instance.render(items);
          instance.enableButtons();
          instance.ratesWrapper.style.removeProperty("display");
        })
        .catch(function (error) {
          // handle errors
          const errors = instance.sanitizeErrors(error);
          instance.render(errors);
        });
    }

    sanitize(response) {
      const sanitized = {};
      sanitized.class = classes$h.success;
      sanitized.items = [];
      if (response.data.shipping_rates && response.data.shipping_rates.length > 0) {
        const rates = response.data.shipping_rates;
        rates.forEach((r) => {
          let item = {};
          item.title = r.presentment_name;
          item.value = themeCurrency.formatMoney(r.price, theme.moneyFormat);
          sanitized.items.push(item);
        });
      } else {
        sanitized.items[0] = { value: theme.strings.noShippingAvailable };
      }
      return sanitized;
    }

    sanitizeErrors(response) {
      const errors = {};
      errors.class = classes$h.error;
      errors.items = [];
      if (typeof response.data === "object") {
        for (const [key, value] of Object.entries(response.data)) {
          let item = {};
          item.title = key.toString();
          item.value = value.toString();
          errors.items.push(item);
        }
      } else {
        errors.items[0] = { value: theme.strings.noShippingAvailable };
      }
      return errors;
    }

    init() {
      const htmlEl = document.querySelector("html");
      let locale = "en";
      if (htmlEl.hasAttribute("lang") && htmlEl.getAttribute("lang") !== "") {
        locale = htmlEl.getAttribute("lang");
      }

      if (this.form) {
        themeAddresses.AddressForm(this.form, locale, {
          shippingCountriesOnly: true,
        });
      }

      if (
        this.country &&
        this.country.hasAttribute("data-default") &&
        this.province &&
        this.province.hasAttribute("data-default")
      ) {
        this.country.addEventListener("change", function () {
          this.country.removeAttribute("data-default");
          this.province.removeAttribute("data-default");
        });
      }

      if (this.button) {
        this.button.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            this.disableButtons();
            while (this.ratesWrapper.firstChild) this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
            this.ratesWrapper.style.display = "none";
            const shippingAddress = {};
            let elemCountryVal = this.country.value;
            let elemProvinceVal = this.province.value;
            const elemCountryData = this.country.getAttribute(selectors$x.defaultData);
            if (elemCountryVal === "" && elemCountryData && elemCountryData !== "") {
              elemCountryVal = elemCountryData;
            }
            const elemProvinceData = this.province.getAttribute(selectors$x.defaultData);
            if (elemProvinceVal === "" && elemProvinceData && elemProvinceData !== "") {
              elemProvinceVal = elemProvinceData;
            }
            shippingAddress.zip = this.zip.value || "";
            shippingAddress.country = elemCountryVal || "";
            shippingAddress.province = elemProvinceVal || "";
            this.estimate(shippingAddress);
          }.bind(this)
        );
      }
    }
  }

  const selectors$w = {
    wrapper: "[data-quantity-selector-pdp]",
    increase: "[data-increase-quantity]",
    decrease: "[data-decrease-quantity]",
    input: "[data-quantity-input]",
    increaseError: "[data-increase-quantity-error]",
  };

  class Quantity {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.increase = this.wrapper.querySelector(selectors$w.increase);
      this.decrease = this.wrapper.querySelector(selectors$w.decrease);
      this.input = this.wrapper.querySelector(selectors$w.input);
      this.min = parseInt(this.input.getAttribute("min"), 10);
      this.increaseError = document.querySelector(selectors$w.increaseError);
      this.initButtons();
      this.initInput();
    }

    initButtons() {
      this.increase?.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          let v = parseInt(this.input.value, 10);
          v = isNaN(v) ? 0 : v;
          v++;
          this.input.value = v;
          this.input.dispatchEvent(new Event("change"));
        }.bind(this)
      );
      this.decrease.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          let v = parseInt(this.input.value, 10);
          v = isNaN(v) ? 0 : v;
          v--;
          v = Math.max(this.min, v);
          this.input.value = v;
          this.input.dispatchEvent(new Event("change"));
        }.bind(this)
      );
    }

    initInput() {
      this.input.addEventListener(
        "change",
        function (e) {
          e.preventDefault();
          if (parseInt(this.input.value) > parseInt(this.input.max)) {
            this.input.value = this.input.max;
            this.showError();
          } else {
            this.hideError();
          }
        }.bind(this)
      );
    }

    showError() {
      if (this.increaseError) {
        if (!this.increaseError.classList.contains("is-visible")) {
          this.increaseError.classList.add("is-visible");
        }
      }
    }

    hideError() {
      if (this.increaseError) {
        if (this.increaseError.classList.contains("is-visible")) {
          this.increaseError.classList.remove("is-visible");
        }
      }
    }
  }

  function initQtySection(container) {
    const quantityWrappers = container.querySelectorAll(selectors$w.wrapper);
    quantityWrappers.forEach((qty) => {
      new Quantity(qty);
    });
  }

  const selectors$v = {
    drawer: '[data-drawer="drawer-cart"]',
    shipping: "[data-shipping-estimate-form]",
    loader: "[data-cart-loading]",
    form: "[data-cart-form]",
    emptystate: "[data-cart-empty]",
    progress: "[data-cart-progress]",
    items: "[data-line-items]",
    related: "[data-related-cart]",
    relatedOuter: "[data-cart-related-wrap]",
    recommended: "[data-cart-recommended]",
    promoOuter: "[data-cart-bottom-promo]",
    promo: "[data-cart-promo]",
    promoWrap: "[data-cart-promo-wrap]",
    promoInputs: "[data-cart-promo-input]",
    subtotal: "[data-cart-subtotal]",
    bottom: "[data-cart-bottom]",
    quantity: "[data-quantity-selector]",
    errors: "[data-form-errors]",
    item: "[data-cart-item]",
    finalPrice: "[data-cart-final]",
    itemCount: "[data-cart-item-count]",
    key: "data-update-cart",
    remove: "data-remove-key",
    upsellProduct: "[data-upsell-holder]",
    cartUpsell: "[data-cart-upsell]",
    cartPage: '[data-section-type="cart"]',
    bar: "[data-cart-bar]",
    ship: "[data-cart-message]",
    subsToggle: "[data-toggles-group]",
    subsChild: "data-group-toggle",
    subsInputs: "[data-sub-input]",
    subsLine: "[data-sub-line]",
    subsKey: "[data-sub-key]",
    permalink: "[data-cart-permalink]",
    shareOuter: "[data-cart-share-wrap]",
    share: "[data-share-cart]",
    shareModalContainer: "[data-share-cart-modal-container]",
    shareModal: "[data-share-cart-modal]",
    openShareModal: "[data-open-share-cart-modal]",
    closeShareModal: "[data-close-share-modal]",
    increase: "[data-increase-quantity]",
    decrease: "[data-decrease-quantity]",
    checkout: "[name='checkout']",
  };

  const classes$g = {
    hide: "hide",
    hidden: "cart--hidden",
    loading: "cart--loading",
    isVisible: "is-visible",
    flickityDisabled: "flickity-disabled",
  };

  class CartItems {
    constructor(section) {
      this.section = section;
      this.container = section.container;
      this.bar = this.container.querySelector(selectors$v.bar);
      this.ship = this.container.querySelector(selectors$v.ship);
      this.drawer = this.container.querySelector(selectors$v.drawer);
      this.form = this.container.querySelector(selectors$v.form);
      this.loader = this.container.querySelector(selectors$v.loader);
      this.related = this.container.querySelectorAll(selectors$v.related);
      this.relatedOuter = this.container.querySelectorAll(selectors$v.relatedOuter);
      this.promoOuter = this.container.querySelector(selectors$v.promoOuter);
      this.promo = this.container.querySelector(selectors$v.promo);
      this.bottom = this.container.querySelector(selectors$v.bottom);
      this.items = this.container.querySelector(selectors$v.items);
      this.subtotal = this.container.querySelector(selectors$v.subtotal);
      this.errors = this.container.querySelector(selectors$v.errors);
      this.finalPrice = this.container.querySelector(selectors$v.finalPrice);
      this.itemCount = this.container.querySelector(selectors$v.itemCount);
      this.permalink = this.container.querySelector(selectors$v.permalink);
      this.shareOuter = this.container.querySelector(selectors$v.shareOuter);
      this.share = this.container.querySelector(selectors$v.share);
      this.shareModalContainer = this.container.querySelector(selectors$v.shareModalContainer);
      this.shareModal = this.container.querySelector(selectors$v.shareModal);
      this.openShareModal = this.container.querySelector(selectors$v.openShareModal);
      this.closeShareModal = this.container.querySelector(selectors$v.closeShareModal);
      this.emptystate = this.container.querySelector(selectors$v.emptystate);
      this.progress = this.container.querySelector(selectors$v.progress);
      this.latestClick = null;
      this.cart = null;
      this.flkty = null;
      this.stale = true;
      this.cartPage = document.querySelector(selectors$v.cartPage);
      this.checkoutButtons = document.querySelectorAll(selectors$v.checkout);
      this.buttonCheckZiplocator = document.querySelectorAll(selectors$v.buttonCheckZiplocator);
      this.listen();
    }

    listen() {
      document.addEventListener(
        "theme:cart:change",
        function (event) {
          this.cart = event.detail.cart;
          this.stale = true; 
          this.cartDrawerupsell(this.cart.items[0])       
        }.bind(this)
      );

      /*
      document.addEventListener(
        "theme:cart:init",
        function () {
          this.init();
        }.bind(this)
      );
      */

      document.addEventListener(
        "theme:cart:reload",
        function (e) {
          this.stale = true;
          if (this.cart) {
            this.loadHTML();
          } else {
            this.init().then(() => this.loadHTML());
          }
        }.bind(this)
      );

      if (this.drawer) {
        this.drawer.addEventListener(
          "theme:drawer:open",
          function () {
            if (this.cart) {
              this.loadHTML();
            } else {
              this.init().then(() => this.loadHTML());
            }
          }.bind(this)
        );
      }

      new CartNotes(this.container);
      new CartShippingMessage(this.container);
    }

    init() {
      return this.fetchCart()
        .then((response) => {
          if (this.shouldWaitForSharedCart(response)) {
            return this.waitForSharedCartRestore(response);
          }
          return response;
        })
        .then((response) => {
          this.cart = response;
          this.fireChange(response);
          return response;
        })
        .catch((e) => {
          console.error(e);
        });
    }

    fetchCart() {
      return window
        .fetch(`${window.theme.routes.cart}.js`)
        .then(this.handleErrors)
        .then((response) => {
          return response.json();
        });
    }

    shouldWaitForSharedCart(cart) {
      const urlParams = new URLSearchParams(window.location.search);
      const isCartLinkId = urlParams.has("cart_link_id");
      const isCartPermalink = /^\/cart\/[^/]+:\d+/.test(window.location.pathname);

      return (isCartLinkId || isCartPermalink) && cart && cart.item_count === 0;
    }

    waitForSharedCartRestore(initialCart) {
      const maxAttempts = 6;
      const retryDelay = 500;

      const retry = (attempt) => {
        return new Promise((resolve) => {
          window.setTimeout(resolve, retryDelay);
        })
          .then(() => this.fetchCart())
          .then((cart) => {
            if (cart.item_count > 0 || attempt >= maxAttempts) {
              return cart;
            }
            return retry(attempt + 1);
          });
      };

      return retry(1)
        .catch((error) => {
          console.error(error);
          return initialCart;
        });
    }

    loadHTML() {
      if (this.stale) {
        if (this.cart && this.cart.item_count > 0) {
          this.loadForm();
        } else {
          this.showEmpty();
        }
      }
      this.stale = false;
    }

    initInputs() {
      this.inputs = this.container.querySelectorAll(`[${selectors$v.key}]`);
      this.inputs.forEach((input) => {
        const key = input.getAttribute(selectors$v.key);
        input.addEventListener(
          "change",
          function (e) {
            const quantity = parseInt(e.target.value, 10);
            this.latestClick = e.target.closest(selectors$v.item);
            this.lockState();
            this.updateCart(key, quantity);
            //this.updateQuantitySelectorCard(id, quantity);
          }.bind(this)
        );
      });
    }

    // this works dynamically with the quantity selector 
    // in the cart drawer and the one in the cart page, 
    // by matching the data-key attribute of the input 
    // with the key of the item in the cart
    updateQuantitySelectorCard(id, quantity){
      const inputs = document.querySelectorAll('[data-id]');
      if(inputs.length === 0) return;
      inputs.forEach((input) => {
        if(input.getAttribute('data-id') == id){
          input.value = parseInt(quantity, 10 );
        }
      });
    }

    validateInputs() {
      this.inputs = this.container.querySelectorAll(`[${selectors$v.key}]`);
      this.cart.items.forEach((item, i) => {
        const kit = "Kit";
        const kitAddOn = "Kit Add-On";
        if (item.product_type == kit || item.product_type == kitAddOn) {
          const input = this.inputs[i];
          input.disabled = true;
          input.nextElementSibling.disabled = true;
          input.previousElementSibling.previousElementSibling.disabled = true;
        }
      });
    }

    initRemove() {
      this.removers = this.container.querySelectorAll(`[${selectors$v.remove}]`);
      this.removers.forEach((remover) => {
        const key = remover.getAttribute(selectors$v.remove);
        remover.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            this.latestClick = e.target.closest(selectors$v.item);
            this.lockState();
            this.updateCart(key, 0);
          }.bind(this)
        );
      });
    }

    lockState() {
      this.latestClick.querySelector(".item--loadbar").style.display = "block";
      this.loader.classList.add(classes$g.loading);

      // disable checkout buttons
      this.checkoutButtons.forEach((button) => {
        button.disabled = true;
      });
    }

    updateCart(clickedKey, newQuantity) {
      let oldCount = null;
      let newCount = null;
      let newItem = null;
      window
        .fetch(`${window.theme.routes.cart}.js`)
        .then(this.handleErrors)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          const matchKeys = (item) => item.key === clickedKey;
          const index = response.items.findIndex(matchKeys);
          // oldCount = response.item_count;
          oldCount = response.items.reduce((a, b) => a + b.quantity, 0); // takes account of Shopify Bundles
          newItem = response.items[index].title;

          var isKitItem =
            response.items[index].product_type === "Kit" || response.items[index].product_type === "Kit Add-On";
          var isSetItem = response.items[index].properties && response.items[index].properties._set;
          if (isKitItem || isSetItem) {
            var data = {};
            if (isKitItem) {
              this.enabledPackageBtn();
              var kit = [response.items[index]];
              var addOns = response.items.filter(
                (item) => item.product_type === "Kit" && item.product_title === "Kit Add-On"
              );
              if (addOns.length) addOns.forEach((addOn) => kit.push(addOn));

              const kits = response.items;
              kits.forEach((item) => {
                if (item.product_type == "Kit" || item.product_type == "Kit Add-On") {
                  data[item.key] = newQuantity;
                }
              });
            }
            if (isSetItem) {
              let setTitle = response.items[index].properties._set;
              let setItems = response.items.filter(
                (item) =>
                  item.properties &&
                  item.properties._set &&
                  item.properties._set.toLowerCase() === setTitle.toLowerCase()
              );

              data = setItems.reduce((obj, item) => {
                obj[item.key] = newQuantity;
                return obj;
              }, {});
            }
            const formData = {
              updates: data,
            };
            return window.fetch(`${window.theme.routes.cart}/update.js`, {
              method: "post",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(formData),
            });
          } else {
            const data = {
              line: `${index + 1}`,
              quantity: newQuantity,
            };
            //console.log("data: ", data);
            return window.fetch(`${window.theme.routes.cart}/change.js`, {
              method: "post",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data),
            });
          }
        })
        .then(this.handleErrors)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.cart = response;
          let variantId =
            this.cart.items_added?.[0]?.variant_id ??
            this.cart.items_removed?.[0]?.variant_id;
          console.log(variantId)
          const totalQuantity = this.cart.items
            .filter(item => item.id === variantId)
            .reduce((sum, item) => sum + item.quantity, 0);
          
          this.updateQuantitySelectorCard(variantId, totalQuantity)
          // newCount = response.item_count;
          newCount = response.items.reduce((a, b) => a + b.quantity, 0); // takes account of Shopify Bundles
          if (oldCount === newCount) {
            // this.stockoutError(newItem);
            this.maxAllowableQuantityError(newItem);
            this.fireChange(response);
            this.stale = true;
          } else {
            slideUp(this.errors);
            this.fireChange(response);
            this.stale = true;
          }
          this.loadHTML();
        })
        .catch((e) => {
          console.error(e);
          let heading = "";
          if (e.status && typeof e.status !== "undefined") {
            heading = `<p>${e.status}</p>`;
          }
          let paragraph = e.json.description || "";
          this.showError(`${heading + paragraph}`);
          this.loadHTML();
        });
    }

    enabledPackageBtn() {
      const packageBtn = document.querySelectorAll("[data-open-package-modal]");
      packageBtn.forEach((btn) => {
        btn.disabled = false;
      });
    }

    updateSellingPlans(key, line, id) {
      window
        .fetch(`${window.theme.routes.cart}.js`)
        .then(this.handleErrors)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          const matchKeys = (item) => item.key === key;
          const index = response.items.findIndex(matchKeys);
          const qty = response.items[index].quantity;
          const data = {
            line: line,
            quantity: qty,
            selling_plan: isNaN(id) ? null : id,
          };
          return window.fetch(`${window.theme.routes.cart}/change.js`, {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          });
        })
        .then(this.handleErrors)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.cart = response;
          slideUp(this.errors);
          this.fireChange(response);
          this.stale = true;
          this.loadHTML();
        })
        .catch((e) => {
          console.error(e);
        });
    }

    addCartPromo(id, qty, req) {
      const data = {
        id: id,
        quantity: qty,
        properties: {
          _t: Date.now(),
          _promo_type: "Free Gift",
          _promo_req: req,
        },
      };

      window
        .fetch(`${window.theme.routes.cart}/add.js`, {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        })
        .then(this.handleErrors)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          return window.fetch(`${window.theme.routes.cart}.js`);
        })
        .then(this.handleErrors)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.cart = response;
          slideUp(this.errors);
          this.fireChange(response);
          this.stale = true;
          this.loadHTML();
        })
        .catch((e) => {
          console.error(e);
        });
    }

    fireChange(newCart) {
      document.dispatchEvent(
        new CustomEvent("theme:cart:change", {
          detail: {
            cart: newCart,
          },
          bubbles: true,
        })
      );
    }

    updateTotal() {
      if (this.cart && this.cart.total_price) {
        const price = themeCurrency.formatMoney(this.cart.total_price, theme.moneyFormat);
        this.finalPrice.innerHTML = price;
      }
      if (this.subtotal && this.cart) {
        window
          .fetch(`${window.theme.routes.root_url}?section_id=api-cart-subtotal`)
          .then(this.handleErrors)
          .then((response) => {
            return response.text();
          })
          .then((response) => {
            const fresh = document.createElement("div");
            fresh.innerHTML = response;
            this.subtotal.innerHTML = fresh.querySelector("[data-api-content]").innerHTML;
          })
          .finally(()=>{
          });
      }
    }

    updateCount() {
      if (this.cart && this.cart.items.length && this.itemCount) {
        // manual calculation of item count
        var item_count = this.cart.items.reduce(function (a, b) {
          return a + b.quantity;
        }, 0);
        this.itemCount.innerHTML = item_count > 1 ? `${item_count} Productos` : `${item_count} Producto`;
      }
    }

    updateCartPermalink() {
      if (!this.permalink) return;

      const shopUrl = this.permalink.dataset.shopUrl;
      var permalinkUrl = shopUrl + "/cart/";

      for (let i = 0; i < this.cart.items.length; i++) {
        let param = `${this.cart.items[i].variant_id}:${this.cart.items[i].quantity}`;
        if (i < this.cart.items.length - 1) {
          param += ",";
        }
        permalinkUrl += param;
      }

      //Go to cart page
      permalinkUrl = permalinkUrl + "?storefront=true"

      // Check if partner selected
      const currentWebsite = this.getCurrentPartnerSite();
      if (currentWebsite) {
        const partnerSite = currentWebsite.replace(/^[?&]*pws=/i, "").replace(/^[?&=]+/, "");
        if (partnerSite) {
          const url = new URL(permalinkUrl);
          url.searchParams.set(PARTNER_PARAM_KEY, partnerSite);
          permalinkUrl = url.toString();
        }
      }

      this.permalink.value = permalinkUrl;
    }

    getCurrentPartnerSite() {
      const urlSearchParam = new URLSearchParams(window.location.search);
      const urlWebsite = urlSearchParam.get(PARTNER_PARAM_KEY);
      const malformedWebsite = window.location.search.match(/p+ws=?([A-Za-z0-9_-]+)/i);

      return (
        urlWebsite ||
        (malformedWebsite ? malformedWebsite[1] : null) ||
        theme.storefront_partner?.siteName ||
        theme.partner_site ||
        localStorage.getItem(CURRENT_PARTNER_STORAGE_KEY)
      );
    }

    showError(message) {
      slideUp(this.errors);
      this.errors.innerHTML = message;
      window.setTimeout(() => {
        slideDown(this.errors);
      }, 600);
    }

    stockoutError(itemTitle) {
      let heading = `<p><strong>${window.theme.strings.stockout}</strong></p>`;
      let paragraph = `<p>${itemTitle}</p>`;
      this.showError(`${heading + paragraph}`);
    }

    maxAllowableQuantityError(itemTitle) {
      const foundItem = this.cart.items.find((item) => item.product_title === itemTitle);
      if (!foundItem) return;
      
      const errorTextElem = document.createElement("div");
      errorTextElem.innerHTML = window.theme.strings.maxAllowableQuantityErrorHtml;
      
      const maxAllowableQuantity = errorTextElem.querySelector("[data-max-allowable-quantity]");
      maxAllowableQuantity.textContent = foundItem.quantity;

      this.showError(errorTextElem.innerHTML);
    }

    loadForm() {
      document.querySelector("[data-line-items]").style.pointerEvents = 'none';
      document.querySelector("[data-line-items]").style.opacity = '0.5'
      if(window.location.pathname != "/cart"){
        const drawerWrapper = document?.querySelector(".upsell__sidebar__items") ?? [];
        const buttons = drawerWrapper.querySelectorAll("button");
    }
      window
        .fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`)
        .then(this.handleErrors)
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          const fresh = document.createElement("div");
          fresh.innerHTML = response;
          this.items.innerHTML = fresh.querySelector("[data-api-content]").innerHTML;
          this.showForm();
          this.initQuantity();
          this.initUpsell();
          let change = localStorage.getItem("changeItem")
          let ejecutado = localStorage.getItem("ejecutado")
          if(JSON.parse(change) && ejecutado == undefined){
            this.initCartRecommended();
            localStorage.setItem("ejecutado", true)
          } 
          if(JSON.parse(ejecutado)){
            localStorage.removeItem("ejecutado")
            localStorage.setItem("botonesDisable", true)
          }
          /*
          this.initCartContainsPromo();
          this.initCartPromo();
          this.initCartSubsToggles();
          this.initCartSubsInputs();
          // this.initCartWishlist();
          */
          this.initCartShareModal();
          this.initCartShareLink();
          this.updateTotal();
          this.updateCount();
          this.updateCartPermalink();
          document.dispatchEvent(new CustomEvent("swym:cart-loaded"));

        })
        .finally(()=>{
          if(JSON.parse(localStorage.getItem("botonesDisable"))){
            if(window.location.pathname != "/cart"){
              const drawerWrapper = document?.querySelector(".upsell__sidebar__items") ?? [];
              const buttons = drawerWrapper.querySelectorAll("button");
              buttons.forEach((ele)=>{
                ele.style.display = "block"
                ele.style.opacity = "1"
              })
            }
          }
        })



    }

    initUpsell() {
      const upsellProduct = this.items.querySelector(selectors$v.upsellProduct);
      const oldUpsellProduct = this.bottom.querySelector(selectors$v.upsellProduct);

      if (oldUpsellProduct) {
        oldUpsellProduct.remove();
      }

      if (this.cartPage && upsellProduct) {
        this.bottom.insertBefore(upsellProduct, this.bottom.firstChild);
      }
    }

    initCartUpsell() {
      /*
      if (!this.related.length || !this.cart.items.length) {
        return;
      }

      this.related.forEach((related) => {
        window
          .fetch(`${window.theme.routes.root_url}?section_id=api-cart-upsell`)
          .then(this.handleErrors)
          .then((response) => {
            return response.text();
          })
          .then((response) => {
            const fresh = document.createElement("div");
            fresh.innerHTML = response;
            related.innerHTML = fresh.querySelector("[data-api-content]").innerHTML;

            const upsell = related.querySelector(selectors$v.cartUpsell);
            if (upsell) {
              if (!related.classList.contains(classes$g.flickityDisabled)) {
                // last added product in cart has upsell metafield
                this.flkty = new Flickity(upsell, {
                  cellAlign: "left",
                  contain: true,
                  pageDots: true,
                  prevNextButtons: false,
                  lazyLoad: true,
                  adaptiveHeight: true,
                });
                this.flkty.resize();
              }
            } else {
              this.initCartRecommended();
            }
          });
        });
        */
    }

    initCartRecommended() {/*
      if (!this.related.length || !this.cart.items.length) {
        return;
      }
      this.related.forEach((related) => {
          const productId = this.cart.items[0].product_id;
          const limit = related.getAttribute("data-limit");
          const route = window.theme.routes.product_recommendations_url || "/recommendations/products/";
          const requestUrl = `${route}?section_id=header&limit=${limit}&product_id=${productId}`;
          axios
            .get(requestUrl)
            .then((response) => {
                const fresh = document.createElement("div");
                fresh.innerHTML = response.data;
                const inner = fresh.querySelector(selectors$v.related);
    
                const innerHtml = inner.innerHTML;
                related.innerHTML = innerHtml;
    
                const relatedItems = related.querySelector(selectors$v.recommended);
                if (relatedItems) {
                  if (!related.classList.contains(classes$g.flickityDisabled)) {
                    this.flkty = new Flickity(relatedItems, {
                      cellAlign: "left",
                      contain: true,
                      pageDots: true,
                      prevNextButtons: false,
                      lazyLoad: true,
                      adaptiveHeight: true,
                    });
                    this.flkty.resize();
                  }
                }

            }).
            finally(()=>{
            })
            .catch(function (error) {
              console.warn(error);
            });
      });
*/
    }

    initCartPromo() {
      if (!this.promo) return;

      window
        .fetch(`${window.theme.routes.root_url}?section_id=api-cart-promo`)
        .then(this.handleErrors)
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          const fresh = document.createElement("div");
          fresh.innerHTML = response;
          this.promo.innerHTML = fresh.querySelector("[data-api-content]").innerHTML;

          const promoWrap = this.promo.querySelector(selectors$v.promoWrap);
          if (promoWrap) {
            this.flkty = new Flickity(promoWrap, {
              cellAlign: "left",
              contain: true,
              pageDots: false,
              prevNextButtons: false,
              lazyLoad: true,
            });
            this.flkty.resize();
            this.initCartPromoInputs();
          }
        });
    }

    initCartPromoInputs() {
      const promoInputs = this.promo.querySelectorAll(selectors$v.promoInputs);

      promoInputs.forEach((input) => {
        if (input.disabled || input.checked) return;

        input.addEventListener(
          "change",
          function (e) {
            var id = parseFloat(e.target.value);
            var req = parseFloat(e.target.dataset.cartPromoReq);

            e.preventDefault();
            this.latestClick = this.items.querySelector(selectors$v.item);
            this.lockState();
            this.addCartPromo(id, 1, req);
          }.bind(this)
        );
      });
    }

    initCartContainsPromo() {
      const promosInCart = this.cart.items.filter(
        (item) => item.properties && item.properties._promo_type == "Free Gift"
      );
      if (!promosInCart.length) return;

      promosInCart.forEach((promo) => {
        var req = promo.properties._promo_req;
        if (this.cart.total_price < req) {
          this.latestClick = this.items.querySelector(selectors$v.item);
          this.lockState();
          this.updateCart(promo.key, 0);
        }
      });
    }

    initCartSubsToggles() {
      const toggles = this.container.querySelectorAll(selectors$v.subsToggle);

      toggles.forEach((toggle) => {
        toggle.addEventListener(
          "change",
          function (e) {
            const val = e.target.value.toString();
            const selected = this.container.querySelector(`[${selectors$v.subsChild}="${val}"]`);
            const groups = this.container.querySelectorAll(`[${selectors$v.subsChild}]`);

            if (selected) {
              selected.classList.remove(classes$g.hide);
              const first = selected.querySelector(`[name="selling_plan_cart"]`);
              first.checked = true;
            }
            groups.forEach((group) => {
              if (group !== selected) {
                group.classList.add(classes$g.hide);
                const plans = group.querySelectorAll(`[name="selling_plan_cart"]`);
                plans.forEach((plan) => {
                  plan.checked = false;
                });
              }
            });
          }.bind(this)
        );
      });
    }

    initCartSubsInputs() {
      const inputs = this.container.querySelectorAll(selectors$v.subsInputs);

      inputs.forEach((input) => {
        input.addEventListener(
          "change",
          function (e) {
            const val = e.target.value.toString();
            const lineElem = this.container.querySelector(selectors$v.subsLine);
            const keyElem = this.container.querySelector(selectors$v.subsKey);

            const id = parseInt(val);
            const line = parseInt(lineElem.dataset.subLine);
            const key = keyElem.dataset.subKey;

            e.preventDefault();
            this.latestClick = e.target.closest(selectors$v.item);
            this.lockState();
            this.updateSellingPlans(key, line, id);
          }.bind(this)
        );
      });
    }

    initCartWishlist() {
      const wishlistBtns = this.container.querySelectorAll(".swym-cart");

      wishlistBtns.forEach((btn) => {
        btn.addEventListener(
          "click",
          function (e) {
            const productId = parseFloat(e.target.dataset.productId);
            const variantId = parseFloat(e.target.dataset.variantId);
            const key = e.target.dataset.lineItemKey;
            var isInWishlist;

            window._swat.fetch(
              function (response) {
                isInWishlist = response.find(function (item) {
                  return item.empi == productId && item.epi == variantId;
                });
                if (!isInWishlist) {
                  e.preventDefault();
                  this.latestClick = e.target.closest(selectors$v.item);
                  this.lockState();
                  this.updateCart(key, 0);
                }
              }.bind(this)
            );
          }.bind(this)
        );
      });
    }

    initCartShareModal() {
      if (!this.openShareModal || !this.closeShareModal || !this.shareModalContainer) return;

      
      this.openShareModal.addEventListener(
        "click",
        function (e) {
          this.shareModalContainer.classList.add(classes$g.isVisible);
        }.bind(this)
      );

      this.closeShareModal.addEventListener(
        "click",
        function (e) {
          this.shareModalContainer.classList.remove(classes$g.isVisible);
        }.bind(this)
      );

      // modal underlay
      document.addEventListener(
        "click",
        function (e) {
          if (!this.shareModalContainer.classList.contains(classes$g.isVisible)) return;

          if (!this.openShareModal.contains(e.target) && !this.shareModal.contains(e.target)) {
            this.shareModalContainer.classList.remove(classes$g.isVisible);
          }
        }.bind(this)
      );
    }

    initCartShareLink() {
      if (!this.share) return;

      this.share.addEventListener(
        "click",
        function (e) {
          if (this.cart) this.updateCartPermalink();
          navigator.clipboard.writeText(this.permalink.value);
          this.share.disabled = true;
          this.share.classList.add("has-success");
          setTimeout(() => {
            this.share.classList.remove("has-success");
            this.share.disabled = false;
          }, 1500);
        }.bind(this)
      );
    }

    initQuantity() {
      initQtySection(this.container);
      this.initInputs();
      this.initRemove();
      this.validateInputs();
    }

    showForm() {
      if (this.bar) {
        this.bar.classList.remove(classes$g.hidden);
      }
      if (this.ship) {
        this.ship.classList.remove(classes$g.hidden);
      }
      if (this.progress) {
        this.progress.classList.remove(classes$g.hidden);
      }
      if (this.related.length) {
        this.related.forEach((related) => {
          related.classList.remove(classes$g.hidden);
        });
      }
      if (this.relatedOuter.length) {
        this.relatedOuter.forEach((outer) => {
          outer.classList.remove(classes$g.hidden);
        });
      }
      if (this.promoOuter) {
        this.promoOuter.classList.remove(classes$g.hidden);
      }
      if (this.shareOuter) {
        this.shareOuter.classList.remove(classes$g.hidden);
      }
      this.form.classList.remove(classes$g.hidden);
      this.bottom.classList.remove(classes$g.hidden);
      this.loader.classList.remove(classes$g.loading);
      this.emptystate.classList.add(classes$g.hidden);
    }

    showEmpty() {
      if (this.bar) {
        this.bar.classList.add(classes$g.hidden);
      }
      if (this.ship) {
        this.ship.classList.add(classes$g.hidden);
      }
      if (this.progress) {
        this.progress.classList.add(classes$g.hidden);
      }
      if (this.related.length) {
        this.related.forEach((related) => {
          related.classList.add(classes$g.hidden);
        });
      }
      if (this.relatedOuter.length) {
        this.relatedOuter.forEach((outer) => {
          outer.classList.add(classes$g.hidden);
        });
      }
      if (this.promoOuter) {
        this.promoOuter.classList.add(classes$g.hidden);
      }
      if (this.shareOuter) {
        this.shareOuter.classList.add(classes$g.hidden);
      }
      if (this.itemCount) {
        this.itemCount.innerHTML = "0 Items";
      }
      this.emptystate.classList.remove(classes$g.hidden);
      this.loader.classList.remove(classes$g.loading);
      this.form.classList.add(classes$g.hidden);
      this.bottom.classList.add(classes$g.hidden);
    }

    handleErrors(response) {
      if (!response.ok) {
        return response.json().then(function (json) {
          const e = new FetchError({
            status: response.statusText,
            headers: response.headers,
            json: json,
          });
          throw e;
        });
      }
      return response;
    }

    async cartDrawerupsell(product){
      try { 
          const product_ = await fetch(`/collections/all/products/${product.handle}.json`).then(res=> res.json());
            const tags = product_.product.tags.replace(",", "").split(" ");
            let enable = "disponible";
            let taggin = "";

            for (const tag of tags) {
              if (tag === "hiperoferta") {
                taggin = "aplica_hiperoferta";
                break;
              }
              if (tag === "megaoferta_3n") {
                taggin = "aplica_megaoferta_3n";
                break;
              }
              if (tag === "superprecio") {
                taggin = "aplica_superprecio";
                break;
              }
              if (tag === "2_o_mas") {
                taggin = "2_o_mas";
                break;
              }
              if (tag === "segundo-con-descuento") {
                taggin = "segundo-con-descuento";
                break;
              }
              if (tag.includes("ahorro_")) {
                taggin = "ahorro_";
                break;
              }
              if (tag === "nuevo") {
                taggin = "nuevo";
                break;
              }
              if (tag == "disponible_oferta"){
                taggin = "disponible_oferta";
                break;
              }
            }
            
            //determinate where we can find something in first time

            const list = await fetch(`/collections/${product.product_type}/products.json?limit=250`).then(res=> res.json());
            
            (!taggin || taggin == "") ? taggin = "disponible_oferta" : null;
            let filteredProducts = list.products.filter(product => product.tags.includes(taggin) && product.tags.includes(enable));
            let filteredProductsRandom = [];
            let notRepitProducts = [];

            if(filteredProducts.length > 2){
              let counter = 0
              let maxItems = Math.min(5, filteredProducts.length);
              while(counter < maxItems) {
                let randomIndex = Math.floor(Math.random() * filteredProducts.length);
                if(!notRepitProducts.includes(randomIndex)){
                  filteredProductsRandom.push(filteredProducts[randomIndex]);
                  notRepitProducts.push(randomIndex);
                  counter ++;
                }
              }
            }else{
              const list = await fetch(`/collections/ofertas/products.json?limit=250&tag=${taggin}`).then(res=> res.json());
              let filteredProductsAll = list.products.filter((product) => {
                if(product.tags.includes(enable)){
                  return product.tags.some(t => t.startsWith(taggin));
                }
              });
              let counter = 0
              let maxItems = Math.min(5, filteredProductsAll.length);
              while(counter < maxItems) {
                let randomIndex = Math.floor(Math.random() * filteredProductsAll.length);
                if(!notRepitProducts.includes(randomIndex)){
                  filteredProductsRandom.push(filteredProductsAll[randomIndex]);
                  notRepitProducts.push(randomIndex);
                  counter ++;
                }
              } 
              if(filteredProductsRandom.length < 5){
                const list2 = await fetch(`/collections/ofertas/products.json?limit=250`).then(res=> res.json());
                let filteredProducts2 = list2.products.filter(product => product.tags.includes("disponible_oferta") && product.tags.includes(enable));
                let counter2 = 0
                let maxItems2 = Math.min(5 - filteredProductsRandom.length, filteredProducts2.length);
                while(counter2 < maxItems2) {
                  let randomIndex2 = Math.floor(Math.random() * filteredProducts2.length); 
                  if(!notRepitProducts.includes(randomIndex2)){
                    filteredProductsRandom.push(filteredProducts2[randomIndex2]);
                    notRepitProducts.push(randomIndex2);
                    counter2 ++;
                  }
                }
              }
            }
            
            
            document.querySelectorAll("[data-cart-recommended]")?.forEach(e => e.remove());

            this.related.forEach((related) => {

              //Creating container
              const cartRecommended = document.createElement("div");
              cartRecommended.classList.add("cart__items");
              cartRecommended.setAttribute("data-cart-recommended", "");
  
              /*Relaated products by dicount application */
              const productsHtml = document.createElement("div");

                filteredProductsRandom.forEach((prod) => {
                  let Badge = prod.tags?.filter((tag) => tag?.includes("Badge:") || tag?.includes("nuevo"));
                  Badge = Badge?.map((badge) => badge?.replace(" ","_").replace("Badge:", ""));
                  let Badges_images = '';
                  Badge?.map((badge)=>{
                    (badge == "Lleva_2 o mas a precio rojo") ? badge = "Lleva_2_o_mas_a_precio_rojo" : badge;
                    badge.includes("nuevo") ? Badges_images += 
                    `<div class="product__image__badge__wrapper--left-wide">
                      <div class="product__image__badge">
                        <img src="//betterware.com.mx/cdn/shop/files/badge_${badge.replace("n", "N")}.svg?v=1709670831&amp;width=50" alt=""
                          class="fade-in lazyloaded">
                      </div>
                    </div>`
                    : Badges_images += 
                    `
                    <div class="product__image__badge__wrapper">
                      <div class="product__image__badge porcent">
                        <img src="//betterware.com.mx/cdn/shop/files/badge_${badge.replace(" ", "_")}.svg?v=1709670887&amp;width=50" alt=""
                          class="fade-in lazyloaded">
                      </div>
                    </div>
                    `
                  })

                  productsHtml.innerHTML += `
                    <div class="cart__upsell__item" data-cart-item="">
                      <div class="cart__items__grid--upsell" data-item="">
                        <div class="cart__items__image">
                          <a href="/products/${prod.handle}">
                          ${Badges_images}
                          <img class="cart__items__img" src="${prod.images[0].src}" alt="" height="180" width="180"></a>
                        </div>
                        <div class="cart__items__title">
                          <p><a href="">${prod.title}</a></p>
                        </div>
                        <div class="cart__items__price">
                          <p class="line__price"><span class="price">${new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(prod.variants[0].price)}</span></p>
                        </div>
                      </div><div class="cart__items__buttons--upsell">
                        <button style="opacity: 1; display: block;" data-upsell-add-to-cart="" data-add-to-cart-variant="${prod.variants[0].id}"
                          onclick="handleQuickAdd(this)" class="btn btn--primary btn--icon btn--upsell" type="button">
                          <span class="btn-state-ready">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cart" viewBox="0 0 25 25"><path d="M5.058 23a2 2 0 104.001-.001A2 2 0 005.058 23zm12.079 0c0 1.104.896 2 2 2s1.942-.896 1.942-2-.838-2-1.942-2-2 .896-2 2zM0 1a1 1 0 001 1h1.078l.894 3.341L5.058 13c0 .072.034.134.042.204l-1.018 4.58A.997.997 0 005.058 19h16.71a1 1 0 000-2H6.306l.458-2.061c.1.017.19.061.294.061h12.31c1.104 0 1.712-.218 2.244-1.5l3.248-6.964C25.423 4.75 24.186 4 23.079 4H5.058c-.157 0-.292.054-.438.088L3.844.772A1 1 0 002.87 0H1a1 1 0 00-1 1zm5.098 5H22.93l-3.192 6.798c-.038.086-.07.147-.094.19-.067.006-.113.012-.277.012H7.058v-.198l-.038-.195L5.098 6z"></path></svg>
                          </span>

                          <span class="btn-state-loading">
                            <svg height="18" width="18" class="svg-loader">
                              <circle r="7" cx="9" cy="9"></circle>
                              <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
                            </svg>
                          </span>

                          <span class="btn-state-complete" style="--primary: #fff;">&nbsp;</span>
                        </button>
                      </div>
                    </div>
                  `
                })
                
                //contenedor a hijos
                //cartRecommended.appendChild(productsHtml);
                cartRecommended.innerHTML = productsHtml.innerHTML;
                related.appendChild(cartRecommended);

                //related.innerHTML = cartRecommended;

                //cntenedor 
                const relatedItems = related.querySelector(selectors$v.recommended);

                if (relatedItems) {
                  if (!related.classList.contains(classes$g.flickityDisabled)) {
                    this.flkty = new Flickity(relatedItems, {
                      cellAlign: "left",
                      contain: true,
                      pageDots: true,
                      prevNextButtons: true,
                      lazyLoad: true,
                      adaptiveHeight: true,
                    });
                    this.flkty.resize();
                  }
                }
      });
    }
    catch (error) {
        console.log("related drawer products: ", error);
      }
  }
}

  const cartDrawer = {
    onLoad() {
      const isDrawerCart = this.container.querySelector(selectors$v.drawer);
      if (isDrawerCart) {
        this.cart = new CartItems(this);
      }

      const hasShipping = this.container.querySelector(selectors$v.shipping);
      if (hasShipping) {
        new ShippingCalculator(this);
      }
    },
    onUnload: function () {
      if (this.cart && typeof this.cart.unload === "function") {
        this.cart.unload();
      }
    },
  };

  const selectors$u = {
    accordionGroup: "[data-accordion-group]",
    accordionToggle: "data-accordion-trigger",
    accordionBody: "[data-accordion-body]",
    accordionBodyMobile: "data-accordion-body-mobile",
    rangeSlider: "data-range-holder",
    section: "[data-section-id]",
  };

  const classes$f = {
    open: "accordion-is-open",
  };

  let sections$c = {};

  class Accordion {
    constructor(el) {
      this.body = el;
      this.key = this.body.id;
      const btnSelector = `[${selectors$u.accordionToggle}='${this.key}']`;
      this.trigger = document.querySelector(btnSelector);

      this.toggleEvent = (e) => this.clickEvents(e);
      this.keyboardEvent = (e) => this.keyboardEvents(e);
      this.hideEvent = () => this.hideEvents();

      this.syncBodies = this.getSiblings();

      if (this.body.hasAttribute(selectors$u.accordionBodyMobile)) {
        this.mobileAccordions();
      } else {
        this.init();
      }
    }

    mobileAccordions() {
      if (window.innerWidth < window.theme.sizes.medium) {
        this.init();
        this.setDefaultState();
      } else {
        this.resetMobileAccordions();
        this.body.removeAttribute("style");
      }

      document.addEventListener("theme:resize", () => {
        if (window.innerWidth < window.theme.sizes.medium) {
          this.init();
          this.setDefaultState();
        } else {
          this.resetMobileAccordions();
          this.body.removeAttribute("style");
        }
      });
    }

    init() {
      this.trigger.setAttribute("aria-haspopup", true);
      this.trigger.setAttribute("aria-expanded", false);
      this.trigger.setAttribute("aria-controls", this.key);

      this.setDefaultState();

      this.trigger.addEventListener("click", this.toggleEvent);
      this.body.addEventListener("keyup", this.keyboardEvent);
      this.body.addEventListener("theme:accordion:close", this.hideEvent);
    }

    hideEvents() {
      this.hideAccordion();
    }

    clickEvents(e) {
      e.preventDefault();
      this.toggleState();
    }

    keyboardEvents(e) {
      if (e.which !== window.theme.keyboardKeys.ESCAPE) {
        return;
      }
      this.hideAccordion();
      this.trigger.focus();
    }

    resetMobileAccordions() {
      this.trigger.removeEventListener("click", this.toggleEvent);
      this.body.removeEventListener("keyup", this.keyboardEvent);
      this.body.removeEventListener("theme:accordion:close", this.hideEvent);
    }

    setDefaultState() {
      if (this.trigger.classList.contains(classes$f.open)) {
        showElement(this.body);
      } else {
        this.hideAccordion();
      }
    }

    getSiblings() {
      const section = this.body.closest(selectors$u.section);
      const groupsArray = [...section.querySelectorAll(selectors$u.accordionGroup)];
      const syncWrapper = groupsArray.filter((el) => el.contains(this.body)).shift();
      if (syncWrapper) {
        const allChilden = [...syncWrapper.querySelectorAll(selectors$u.accordionBody)];
        const onlySiblings = allChilden.filter((el) => !el.contains(this.body));
        return onlySiblings;
      } else return [];
    }

    closeSiblings() {
      this.syncBodies.forEach((accordionBody) => {
        accordionBody.dispatchEvent(new CustomEvent("theme:accordion:close", { bubbles: false }));
      });
    }

    toggleState() {
      if (this.trigger.classList.contains(classes$f.open)) {
        this.hideAccordion();
      } else {
        this.showAccordion();
        this.closeSiblings();

        // Collection filters
        // Accordion with range slider custom event to reload
        if (this.body.hasAttribute(selectors$u.rangeSlider)) {
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent("theme:reset-price-range", { bubbles: false }));
          }, 400);
        }
      }
    }

    hideAccordion() {
      this.trigger.classList.remove(classes$f.open);
      slideUp(this.body);
    }

    showAccordion() {
      this.trigger.classList.add(classes$f.open);
      slideDown(this.body);

      setTimeout(() => {
        this.checkInViewportAndScrollTo();
      }, 600);
    }

    checkInViewportAndScrollTo() {
      const rect = this.trigger.getBoundingClientRect();
      const windowScrollY =
        (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
      const inViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth);

      if (!inViewport) {
        window.scrollTo({
          top: windowScrollY + rect.top,
          left: 0,
          behavior: "smooth",
        });
      }
    }

    onBlockSelect(evt) {
      if (this.body.contains(evt.target)) {
        this.showAccordion();
      }
    }

    onBlockDeselect(evt) {
      if (this.body.contains(evt.target)) {
        this.hideAccordion();
      }
    }
  }

  const accordion = {
    onLoad() {
      sections$c[this.id] = [];
      const els = this.container.querySelectorAll(selectors$u.accordionBody);
      els.forEach((el) => {
        sections$c[this.id].push(new Accordion(el));
      });
    },
    onUnload: function () {
      sections$c[this.id].forEach((el) => {
        if (typeof el.unload === "function") {
          el.unload();
        }
      });
    },
    onSelect: function () {
      if (this.type === "accordion-single") {
        this.container.querySelector(`[${selectors$u.accordionToggle}]`).click();
      }
    },
    onDeselect: function () {
      if (this.type === "accordion-single") {
        this.container.querySelector(`[${selectors$u.accordionToggle}]`).click();
      }
    },
    onBlockSelect(evt) {
      sections$c[this.id].forEach((el) => {
        if (typeof el.onBlockSelect === "function") {
          el.onBlockSelect(evt);
        }
      });
    },
    onBlockDeselect(evt) {
      sections$c[this.id].forEach((el) => {
        if (typeof el.onBlockSelect === "function") {
          el.onBlockDeselect(evt);
        }
      });
    },
  };

  const selectors$t = {
    saleClass: "on-sale",
    soldClass: "sold-out",
  };

  function formatPrices(product) {
    // Apprend classes for on sale and sold out
    const on_sale = product.price < product.compare_at_price_min;
    let classes = on_sale ? selectors$t.saleClass : "";
    classes += product.available ? "" : selectors$t.soldClass;
    // Add 'from' before min prive if price varies
    product.price = themeCurrency.formatMoney(product.price, theme.moneyFormat);
    if (product.prive_varies) {
      let min = themeCurrency.formatMoney(product.price_min, theme.moneyFormat);
      product.price = `${window.theme.strings.from} ${min}`;
    }

    const formatted = {
      ...product,
      classes,
      on_sale,
      sold_out: !product.available,
      sold_out_translation: window.theme.strings.soldOut,
      compare_at_price: themeCurrency.formatMoney(product.compare_at_price_min, theme.moneyFormat),
      compare_at_price_max: themeCurrency.formatMoney(product.compare_at_price_max, theme.moneyFormat),
      compare_at_price_min: themeCurrency.formatMoney(product.compare_at_price_min, theme.moneyFormat),
      price_max: themeCurrency.formatMoney(product.price_max, theme.moneyFormat),
      price_min: themeCurrency.formatMoney(product.price_min, theme.moneyFormat),
    };
    return formatted;
  }

  const selectors$s = {
    wrapper: "[data-search-popdown-wrap]",
    results: "[data-predictive-search-results]",
    input: "[data-predictive-search-input]",
    productTemplate: "[data-search-product-template]",
    otherTemplate: "[data-search-other-template]",
    titleTemplate: "[data-predictive-search-title-template]",
    ariaTemplate: "[data-predictive-search-aria-template]",
    productTitleWrapper: "[data-product-title-wrap]",
    productWrapper: "[data-product-wrap]",
    collectionWrapper: "[data-collection-wrap]",
    articleWrapper: "[data-article-wrap]",
    pageWrapper: "[data-page-wrap]",
    ariaWrapper: "[data-predictive-search-aria]",
    outerWrapper: "[data-popdown-outer]",
    loader: "[data-loading-indicator]",
    dirtyClass: "dirty",
    noResults: "search--empty",
  };

  let sections$b = {};

  Sqrl__namespace.filters.define("animationDelay", function (index) {
    return index * 90 + 10;
  });

  class SearchPredictive {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.input = this.wrapper.querySelector(selectors$s.input);
      this.loader = this.wrapper.querySelector(selectors$s.loader);
      this.results = this.wrapper.querySelector(selectors$s.results);
      this.outer = this.input.closest(selectors$s.outerWrapper);

      this.productTemplate = this.wrapper.querySelector(selectors$s.productTemplate).innerHTML;
      this.otherTemplate = this.wrapper.querySelector(selectors$s.otherTemplate).innerHTML;
      this.titleTemplate = this.wrapper.querySelector(selectors$s.titleTemplate).innerHTML;
      this.ariaTemplate = this.wrapper.querySelector(selectors$s.ariaTemplate).innerHTML;

      this.productTitleWrapper = this.results.querySelector(selectors$s.productTitleWrapper);
      this.productWrapper = this.results.querySelector(selectors$s.productWrapper);
      this.collectionWrapper = this.results.querySelector(selectors$s.collectionWrapper);
      this.articleWrapper = this.results.querySelector(selectors$s.articleWrapper);
      this.pageWrapper = this.results.querySelector(selectors$s.pageWrapper);
      this.ariaWrapper = this.results.querySelector(selectors$s.ariaWrapper);

      this.initSearch();
    }

    initSearch() {
      this.input.addEventListener(
        "input",
        debounce(
          function (event) {
            const val = event.target.value;
            if (val && val.length > 1) {
              this.loader.style.display = "block";
              this.render(val);
            } else {
              this.resetTemplates();
              this.outer.classList.remove(selectors$s.dirtyClass);
            }
          }.bind(this),
          300
        )
      );
      this.input.addEventListener("clear", this.reset.bind(this));
    }

    render(terms) {
      let resources = "";
      resources += window.theme.settings.search_products ? "product," : "";
      resources += window.theme.settings.search_collections ? "collection," : "";
      resources += window.theme.settings.search_articles ? "article," : "";
      resources += window.theme.settings.search_pages ? "page," : "";
      resources = resources.slice(0, -1);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'InternalSearch',
        terms: terms
      });

      
      const serialized = `/search/suggest.json?q=${terms}&resources[type]=${resources}&resources[options][unavailable_products]=last`;
      fetch(serialized)
        .then(this.handleErrors)
        .then((response) => response.json())
        .then((response) => {
          this.resetTemplates();
          this.outer.classList.add(selectors$s.dirtyClass);
          const results = response.resources.results;
          const combined = [];
          for (const key in results) {
            if ({}.hasOwnProperty.call(results, key)) {
              combined.push(...results[key]);
            }
          }
          if (combined.length) {
            this.outer.classList.remove(selectors$s.noResults);
            this.injectOther(results);
            this.injectProduct(results.products);
          } else {
            this.noResults(terms);
          }
          this.injectAria(terms, combined);
          trapFocus(this.outer, { elementToFocus: this.input });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loader.style.display = "none";
        });
    }

    injectAria(terms, combined) {
      let title = window.theme.strings.noResultsFor;
      let count = null;
      if (combined.length) {
        count = combined.length;
        title = window.theme.strings.resultsFor;
      }
      this.ariaWrapper.innerHTML = Sqrl__namespace.render(this.ariaTemplate, {
        count: count,
        title: title,
        query: terms,
      });
    }

    noResults() {
      this.resetTemplates();
      this.outer.classList.add(selectors$s.dirtyClass);
      this.outer.classList.add(selectors$s.noResults);
    }

    resetTemplates() {
      this.productTitleWrapper.innerHTML = "";
      this.collectionWrapper.innerHTML = "";
      this.articleWrapper.innerHTML = "";
      this.productWrapper.innerHTML = "";
      this.pageWrapper.innerHTML = "";
      this.ariaWrapper.innerHTML = "";
    }

    reset() {
      this.resetTemplates();
      this.outer.classList.remove(selectors$s.dirtyClass);
      this.outer.classList.remove(selectors$s.noResults);
      this.input.val = "";
    }

    injectOther(results) {
      this.productTitleWrapper.innerHTML += Sqrl__namespace.render(this.titleTemplate, {
        title: window.theme.strings.products,
        count: results.products.length,
      });
      if (results.collections && results.collections.length) {
        this.collectionWrapper.innerHTML += Sqrl__namespace.render(this.titleTemplate, {
          title: window.theme.strings.collections,
          count: results.collections.length,
        });
        this.collectionWrapper.innerHTML += Sqrl__namespace.render(this.otherTemplate, results.collections);
      }
      if (results.pages && results.pages.length) {
        this.pageWrapper.innerHTML += Sqrl__namespace.render(this.titleTemplate, {
          title: window.theme.strings.pages,
          count: results.pages.length,
        });
        this.pageWrapper.innerHTML += Sqrl__namespace.render(this.otherTemplate, results.pages);
      }
      if (results.articles && results.articles.length) {
        this.articleWrapper.innerHTML += Sqrl__namespace.render(this.titleTemplate, {
          title: window.theme.strings.articles,
          count: results.articles.length,
        });
        this.articleWrapper.innerHTML += Sqrl__namespace.render(this.otherTemplate, results.articles);
      }
    }

    injectProduct(products) {
      let formatted = [];
      products.forEach((p) => {
        let product = p;
        product = formatPrices(product);
        product.image = null;
        if (product.featured_image) {
          product.thumb = getSizedImageUrl(product.featured_image.url, "360x360");
        }
        formatted.push(product);
      });
      const productHTML = Sqrl__namespace.render(this.productTemplate, formatted);
      this.productWrapper.innerHTML += productHTML;
    }

    handleErrors(response) {
      if (!response.ok) {
        return response.json().then(function (json) {
          const e = new FetchError({
            status: response.statusText,
            headers: response.headers,
            json: json,
          });
          throw e;
        });
      }
      return response;
    }
  }

  const searchResultsGlobal = {
    onLoad() {
      sections$b[this.id] = [];
      const els = document.querySelectorAll(selectors$s.wrapper);
      els.forEach((el) => {
        sections$b[this.id].push(new SearchPredictive(el));
      });
    },
    onUnload: function () {
      sections$b[this.id].forEach((el) => {
        if (typeof el.unload === "function") {
          el.unload();
        }
      });
    },
  };

  const selectors$r = {
    outer: "[data-drawer-search]",
    wrapper: "[data-search-popdown-wrap]",
    input: "[data-predictive-search-input]",
    clear: "[data-clear-input]",
  };

  class SearchDrawer {
    constructor(section) {
      this.outer = section.container.querySelector(selectors$r.outer);
      if (this.outer) {
        this.clear = document.querySelectorAll(selectors$r.clear);
        this.init();
      }
    }

    init() {
      this.clear.forEach((clear) => {
        clear.addEventListener(
          "click",
          function (evt) {
            evt.preventDefault();
            this.clearInput(evt);
          }.bind(this)
        );
      });
    }

    clearInput(evt) {
      const wrapper = evt.target.closest(selectors$r.wrapper);
      const input = wrapper.querySelector(selectors$r.input);

      input.value = "";
      input.dispatchEvent(new CustomEvent("clear", { bubbles: false }));
      input.focus();
    }
  }

  const searchDrawer = {
    onLoad() {
      this.searchDrawer = new SearchDrawer(this);
    },
    onUnload: function () {
      if (this.searchDrawer && typeof this.searchDrawer.unload === "function") {
        this.searchDrawer.unload();
      }
    },
  };

  const selectors$q = {
    slideruleOpen: "data-sliderule-open",
    slideruleClose: "data-sliderule-close",
    sliderulePane: "data-sliderule-pane",
    slideruleWrappper: "[data-sliderule]",
    focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    dataAnimates: "data-animates",
    children: `:scope > [data-animates], 
             :scope > * > [data-animates], 
             :scope > * > * >[data-animates],
             :scope .sliderule-grid  > *`,
  };

  const classes$e = {
    isVisible: "is-visible",
    isHiding: "is-hiding",
    isHidden: "is-hidden",
  };

  let sections$a = {};

  class HeaderMobileSliderule {
    constructor(el) {
      this.sliderule = el;
      this.wrapper = el.closest(selectors$q.wrapper);
      this.key = this.sliderule.id;
      const btnSelector = `[${selectors$q.slideruleOpen}='${this.key}']`;
      const exitSelector = `[${selectors$q.slideruleClose}='${this.key}']`;
      this.trigger = document.querySelector(btnSelector);
      this.exit = document.querySelectorAll(exitSelector);
      this.pane = document.querySelector(`[${selectors$q.sliderulePane}]`);
      this.children = this.sliderule.querySelectorAll(selectors$q.children);

      this.trigger.setAttribute("aria-haspopup", true);
      this.trigger.setAttribute("aria-expanded", false);
      this.trigger.setAttribute("aria-controls", this.key);

      this.clickEvents();
      this.staggerChildAnimations();

      document.addEventListener("theme:sliderule:close", this.closeSliderule.bind(this));
    }

    clickEvents() {
      this.trigger.addEventListener(
        "click",
        function () {
          this.showSliderule();
        }.bind(this)
      );
      this.exit.forEach((element) => {
        element.addEventListener(
          "click",
          function () {
            this.hideSliderule();
          }.bind(this)
        );
      });
    }

    keyboardEvents() {
      this.trigger.addEventListener(
        "keyup",
        function (evt) {
          if (evt.which !== window.theme.keyboardKeys.SPACE) {
            return;
          }
          this.showSliderule();
        }.bind(this)
      );
      this.sliderule.addEventListener(
        "keyup",
        function (evt) {
          if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
            return;
          }
          this.hideSliderule();
          this.buttons[0].focus();
        }.bind(this)
      );
    }

    staggerChildAnimations(reverse = false) {
      const childrenArr = reverse ? Array.prototype.slice.call(this.children).slice().reverse() : this.children;

      childrenArr.forEach((child, index) => {
        child.style.transitionDelay = index * 50 + 10 + "ms";
      });
    }

    hideSliderule(close = false) {
      const paneStyle = window.getComputedStyle(this.pane);
      const paneTransitionDuration = parseFloat(paneStyle.getPropertyValue("transition-duration")) * 1000;
      const children = close ? this.pane.querySelectorAll(`.${classes$e.isVisible}`) : this.children;
      this.pane.style.setProperty("--sliderule-height", "auto");
      this.staggerChildAnimations(true);
      this.pane.classList.add(classes$e.isHiding);
      this.sliderule.classList.add(classes$e.isHiding);
      this.sliderule.classList.remove(classes$e.isVisible);
      children.forEach((el) => {
        el.classList.remove(classes$e.isVisible);
      });
      const newPosition = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
      this.pane.setAttribute(selectors$q.sliderulePane, newPosition);
      const hidedSelector = close
        ? `[${selectors$q.dataAnimates}].${classes$e.isHidden}`
        : `[${selectors$q.dataAnimates}="${newPosition}"].${classes$e.isHidden}`;
      const hidedItems = this.pane.querySelectorAll(hidedSelector);
      if (hidedItems.length) {
        hidedItems.forEach((element) => {
          element.classList.remove(classes$e.isHidden);
        });
      }

      setTimeout(() => {
        this.pane.classList.remove(classes$e.isHiding);
        this.sliderule.classList.remove(classes$e.isHiding);
        this.staggerChildAnimations();
      }, paneTransitionDuration);
    }

    showSliderule() {
      this.pane.style.setProperty("--sliderule-height", "auto");
      this.sliderule.classList.add(classes$e.isVisible);
      this.children.forEach((el) => {
        el.classList.add(classes$e.isVisible);
      });
      const oldPosition = parseInt(this.pane.dataset.sliderulePane, 10);
      const newPosition = oldPosition + 1;
      this.pane.setAttribute(selectors$q.sliderulePane, newPosition);
      const hidedItems = this.pane.querySelectorAll(`[${selectors$q.dataAnimates}="${oldPosition}"]`);
      if (hidedItems.length) {
        const hidedItemsTransition =
          parseFloat(window.getComputedStyle(hidedItems[0]).getPropertyValue("transition-duration")) * 1000;
        setTimeout(() => {
          hidedItems.forEach((element) => {
            element.classList.add(classes$e.isHidden);
          });
        }, hidedItemsTransition);
      }

      const newHeight = parseInt(this.trigger.nextElementSibling.offsetHeight);
      this.pane.style.setProperty("--sliderule-height", `${newHeight}px`);
    }

    closeSliderule() {
      if (
        this.pane &&
        this.pane.hasAttribute(selectors$q.sliderulePane) &&
        parseInt(this.pane.getAttribute(selectors$q.sliderulePane)) > 0
      ) {
        this.hideSliderule(true);
        if (parseInt(this.pane.getAttribute(selectors$q.sliderulePane)) > 0) {
          this.pane.setAttribute(selectors$q.sliderulePane, 0);
        }
      }
    }
  }

  const headerMobileSliderule = {
    onLoad() {
      sections$a[this.id] = [];
      const els = this.container.querySelectorAll(selectors$q.slideruleWrappper);
      els.forEach((el) => {
        sections$a[this.id].push(new HeaderMobileSliderule(el));
      });
    },
  };

  const selectors$p = {
    wrapper: "[data-product-add-popdown-wrapper]",
    closeDrawer: "[data-close-popdown]",
    apiContent: "[data-api-content]",
    cartSectionAjax: '[data-ajax-disable="false"]',
    ajaxDisabled: '[data-ajax-disable="true"]',
  };

  var globalTimer;

  class CartPopdown {
    constructor() {
      this.drawer = document.querySelector(selectors$p.wrapper);
      this.cartSectionAjax = document.querySelector(selectors$p.cartSectionAjax);
      this.ajaxDisabled = document.querySelector(selectors$p.ajaxDisabled);
      document.addEventListener("theme:cart:popdown", (e) => {
        if (this.cartSectionAjax) {
          // if we are on the cart page, refresh the cart without popdown
          this.cartSectionAjax.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: true }));
        } else if (this.ajaxDisabled) {
          // ajax is disabled, refresh the whole page
          window.location.reload();
        } else {
          this.renderPopdown(e);
        }
      });
    }

    renderPopdown(event) {
      const variant = event.detail.variant;
      const url = `${window.theme.routes.root_url}variants/${variant.id}/?section_id=api-product-popdown`;
      const instance = this;
      axios
        .get(url)
        .then(function (response) {
          // handle success
          const fresh = document.createElement("div");
          fresh.innerHTML = response.data;
          instance.drawer.innerHTML = fresh.querySelector("[data-api-content]").innerHTML;
          instance.connectCartButton();
          instance.connectCloseButton();
        })
        .catch(function (error) {
          console.warn(error);
        });
    }

    connectCloseButton() {
      // Enable close button
      this.drawer.classList.add("is-visible");
      const closer = this.drawer.querySelector(selectors$p.closeDrawer);
      closer.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          this.drawer.classList.remove("is-visible");
        }.bind(this)
      );
      this.popdownTimer();
    }

    connectCartButton() {
      // Hook into cart drawer
      const cartButton = this.drawer.querySelector('[data-drawer-toggle="drawer-cart"]');
      const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');

      if (cartDrawer) {
        cartButton.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            this.drawer.classList.remove("is-visible");
            cartDrawer.dispatchEvent(
              new CustomEvent("theme:drawer:open", {
                bubbles: false,
              })
            );
          }.bind(this)
        );
      }
    }

    popdownTimer() {
      clearTimeout(globalTimer);
      globalTimer = setTimeout(() => {
        this.drawer.classList.remove("is-visible");
      }, 5000);
    }
  }

  const cartPopdown = {
    onLoad() {
      new CartPopdown(this);
    },
  };

  const selectors$o = {
    wrapper: "[data-header-wrapper]",
    style: "data-header-style",
    widthContent: "[data-takes-space]",
    desktop: "[data-header-desktop]",
    cloneClass: "js__header__clone",
    showMobileClass: "js__show__mobile",
    backfill: "[data-header-backfill]",
    transparent: "data-header-transparent",
    overrideBorder: "header-override-border",
    firstSectionHasImage: ".main-content > .shopify-section:first-child [data-overlay-header]",
    preventTransparentHeader: ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
    deadLink: '.navlink[href="#"]',
  };

  let sections$9 = {};

  const CURRENT_PARTNER_STORAGE_KEY = "CURRENT_PARTNER_STORAGE_KEY";
  const PARTNER_PARAM_KEY = "pws";
  const OVERRIDE_PARTNER_STORAGE_KEY = "OVERRIDE_PARTNER_STORAGE_KEY";
  class Header {
    constructor(el) {
      this.wrapper = el;
      this.style = this.wrapper.dataset.style;
      this.desktop = this.wrapper.querySelector(selectors$o.desktop);
      this.transparent = this.wrapper.getAttribute(selectors$o.transparent) !== "false";
      this.overlayedImages = document.querySelectorAll(selectors$o.firstSectionHasImage);
      this.deadLinks = document.querySelectorAll(selectors$o.deadLink);

      this.killDeadLinks();
      if (this.style !== "drawer" && this.desktop) {
        this.minWidth = this.getMinWidth();
        this.listenWidth();
      }
      this.checkForImage();
      window.dispatchEvent(new Event("resize"));
      document.addEventListener("header:check", this.checkForImage.bind(this));
    }

    unload() {
      document.removeEventListener("theme:resize", this.checkWidth);
    }

    checkForImage() {
      this.overlayedImages = document.querySelectorAll(selectors$o.firstSectionHasImage);
      let preventTransparentHeader = document.querySelectorAll(selectors$o.preventTransparentHeader).length;

      if (this.overlayedImages.length && !preventTransparentHeader && this.transparent) {
        // is transparent and has image, overlay the image
        document.querySelector(selectors$o.backfill).style.display = "none";
        this.listenOverlay();
      } else {
        this.wrapper.setAttribute(selectors$o.transparent, false);
      }

      if (this.overlayedImages.length && !preventTransparentHeader && !this.transparent) {
        // Have image but not transparent, remove border bottom
        this.wrapper.classList.add(selectors$o.overrideBorder);
        this.subtractHeaderHeight();
      }
    }

    listenOverlay() {
      document.addEventListener("theme:resize", this.checkWidth.bind(this));
      this.subtractAnnouncementHeight();
    }

    listenWidth() {
      document.addEventListener("theme:resize", this.checkWidth.bind(this));
      this.checkWidth();
    }

    killDeadLinks() {
      this.deadLinks.forEach((el) => {
        el.onclick = (e) => {
          e.preventDefault();
        };
      });
    }

    subtractAnnouncementHeight() {
      const { windowHeight, announcementHeight } = readHeights();
      this.overlayedImages.forEach((el) => {
        el.style.setProperty("--full-screen", `${windowHeight - announcementHeight}px`);
        el.classList.add("has-overlay");
      });
    }

    subtractHeaderHeight() {
      const { windowHeight, headerHeight } = readHeights();
      this.overlayedImages.forEach((el) => {
        el.style.setProperty("--full-screen", `${windowHeight - headerHeight}px`);
      });
    }

    checkWidth() {
      if (document.body.clientWidth < this.minWidth) {
        this.wrapper.classList.add(selectors$o.showMobileClass);
      } else {
        this.wrapper.classList.remove(selectors$o.showMobileClass);
      }
    }

    getMinWidth() {
      const comparitor = this.wrapper.cloneNode(true);
      comparitor.classList.add(selectors$o.cloneClass);
      document.body.appendChild(comparitor);
      const wideElements = comparitor.querySelectorAll(selectors$o.widthContent);
      let minWidth = 0;
      if (wideElements.length === 3) {
        minWidth = _sumSplitWidths(wideElements);
      } else {
        minWidth = _sumWidths(wideElements);
      }
      document.body.removeChild(comparitor);
      return minWidth + wideElements.length * 20;
    }
  }

  function _sumSplitWidths(nodes) {
    let arr = [];
    nodes.forEach((el) => {
      arr.push(el.clientWidth);
    });
    if (arr[0] > arr[2]) {
      arr[2] = arr[0];
    } else {
      arr[0] = arr[2];
    }
    const width = arr.reduce((a, b) => a + b);
    return width;
  }
  function _sumWidths(nodes) {
    let width = 0;
    nodes.forEach((el) => {
      width += el.clientWidth;
    });
    return width;
  }

  const header = {
    onLoad() {
      sections$9 = new Header(this.container);
    },
    onUnload: function () {
      if (typeof sections$9.unload === "function") {
        sections$9.unload();
      }
    },
  };

  const partnerSelect = {
    onLoad() {
      new PartnerSelect(this.container);
    },
  };

  class PartnerSelect {
    static selectors = {
      partner_name: "[data-partner-name]",
      hidden_when_has_partner: "[data-hideon-partner]",
      show_when_has_partner: "[data-showon-partner]",
      show_when_no_partner: "[data-showon-no-partner]",
    };

    constructor(container) {
      this.wrapper = container;
      this.partner_names = this.wrapper.querySelectorAll(PartnerSelect.selectors.partner_name);

      this.repository = new Repository();

      this.init();
    }

    async init() {
      const partner = await this.loadPartnerFromSources();

      if (partner) {
        // const isPrefPartnerSet = !theme.partner_site && partner.siteName && theme.customer;
        // if (isPrefPartnerSet) await this.repository.setPrefPartner(theme.customer_id, partner.siteName);

        this.setPrefPartner(partner);
      } else {
        this.setNoPartner();
      }

      document.addEventListener("theme:partner:update", (event) => {
        const partner = event.detail.partner;
        this.setPrefPartner(partner);
      });
    }

    async loadPartnerFromSources() {
      // Prefer URL the customer arrived on (while persisting the preferred website)
      const urlWebsite = this.getUrlPartnerSite();

      if (theme.customer && urlWebsite) sessionStorage.setItem(OVERRIDE_PARTNER_STORAGE_KEY, urlWebsite);
      else if (!theme.customer) sessionStorage.removeItem(OVERRIDE_PARTNER_STORAGE_KEY);
      
      const customerWebsite = theme.partner_site;
      const overrideWebsite = sessionStorage.getItem(OVERRIDE_PARTNER_STORAGE_KEY);
      const storageCurrentWebsite = localStorage.getItem(CURRENT_PARTNER_STORAGE_KEY);
      
      const partnerSite = overrideWebsite || customerWebsite || urlWebsite || storageCurrentWebsite;
      if (!partnerSite) return;
      const partner = await this.repository.getPartner(partnerSite);
      return partner;
    }

    getUrlPartnerSite() {
      const urlSearchParam = new URLSearchParams(window.location.search);
      const urlWebsite = urlSearchParam.get(PARTNER_PARAM_KEY);
      if (urlWebsite) return urlWebsite;

      const malformedWebsite = window.location.search.match(/p+ws=?([A-Za-z0-9_-]+)/i);
      return malformedWebsite ? malformedWebsite[1] : null;
    }

    setPrefPartner(partner) {
      localStorage.setItem(CURRENT_PARTNER_STORAGE_KEY, partner.siteName);
      this.current_partner = partner;
      theme.storefront_partner = partner;
      document.dispatchEvent(new CustomEvent("theme:partner:set", { detail: { partner } }));

      this.updateUrlWithDesignerSite(partner.siteName);
      this.updateHeader(partner.displayName);
      this.updatePartnerElems();
    }

    setNoPartner() {
      this.show_when_no_partner = document.querySelectorAll(PartnerSelect.selectors.show_when_no_partner);
      this.show_when_no_partner.forEach((elem) => elem.classList.remove("d-none"));

      const currentURL = new URL(window.location);
      currentURL.searchParams.delete(PARTNER_PARAM_KEY);
      window.history.replaceState(null, "nopartnerfound", currentURL);
    }

    displayMyWebsite() {
      //console.log("TODO");
    }

    updateUrlWithDesignerSite(siteName) {
      const currentURL = new URL(window.location);
      currentURL.searchParams.set(PARTNER_PARAM_KEY, siteName);
      window.history.replaceState(null, "withpartner", currentURL);
    }

    updateHeader(displayName) {
      this.partner_names.forEach((elem) => (elem.innerHTML = displayName));
    }

    updatePartnerElems() {
      this.elems_to_hide = document.querySelectorAll(PartnerSelect.selectors.hidden_when_has_partner);
      this.elems_to_show = document.querySelectorAll(PartnerSelect.selectors.show_when_has_partner);
      this.elems_to_hide.forEach((elem) => elem.classList.add("d-none"));
      this.elems_to_show.forEach((elem) => elem.classList.remove("d-none"));

      document.dispatchEvent(new CustomEvent("theme:partner:render"));
      AOS.refresh();
    }
  }

  const partnerModal = {
    onLoad() {
      new PartnerModal(this.container);
    },
  };

  class PartnerUtil {
    constructor() {
      this.repository = new Repository();
    }

    async removePartner() {
      if (theme.customer_id) await this.repository.removePrefPartner(theme.customer_id);
      localStorage.removeItem(CURRENT_PARTNER_STORAGE_KEY);
      sessionStorage.removeItem(OVERRIDE_PARTNER_STORAGE_KEY);
    }
  }

  class PartnerModal {
    static selectors = {
      trigger: "[data-popup-partner]",
      name: "[data-partner-name]",
      aboutYou: "[data-partner-about-you]",
      address: "[data-partner-address]",
      phone: "[data-partner-phone]",
      facebook: "[data-partner-facebook]",
      instagram: "[data-partner-instagram]",
      tiktok: "[data-partner-tiktok]",
      twitter: "[data-partner-twitter]",
      youtube: "[data-partner-youtube]",
      email: "[data-partner-email]",
      collection: "[data-partner-collection]",
      image: "[data-partner-image]",
      change_consultant: "[data-change-consultant]",
      remove_consultant: "[data-remove-consultant]",
    };

    constructor(container) {
      this.wrapper = container;
      this.triggers = this.wrapper.querySelectorAll(PartnerModal.selectors.trigger);
      this.name = this.wrapper.querySelector(PartnerModal.selectors.name);
      this.aboutYou = this.wrapper.querySelector(PartnerModal.selectors.aboutYou);
      this.address = this.wrapper.querySelector(PartnerModal.selectors.address);
      this.phone = this.wrapper.querySelector(PartnerModal.selectors.phone);
      this.facebook = this.wrapper.querySelector(PartnerModal.selectors.facebook);
      this.instagram = this.wrapper.querySelector(PartnerModal.selectors.instagram);
      this.tiktok = this.wrapper.querySelector(PartnerModal.selectors.tiktok);
      this.twitter = this.wrapper.querySelector(PartnerModal.selectors.twitter);
      this.youtube = this.wrapper.querySelector(PartnerModal.selectors.youtube);
      this.email = this.wrapper.querySelector(PartnerModal.selectors.email);
      this.collection = this.wrapper.querySelector(PartnerModal.selectors.collection);
      this.image = this.wrapper.querySelector(PartnerModal.selectors.image);
      this.change_consultant = this.wrapper.querySelector(PartnerModal.selectors.change_consultant);
      this.remove_consultant = this.wrapper.querySelector(PartnerModal.selectors.remove_consultant);

      this.partner_util = new PartnerUtil();

      this.init();
    }

    init() {
      modal("info-partner");
      document.addEventListener("theme:partner:set", (event) => {
        const partner = event.detail.partner;
        this.renderPartner(partner);
      });

      if (this.change_consultant) {
        this.change_consultant.addEventListener("click", () => {
          MicroModal.close("info-partner");
          MicroModal.show("find-your-consultant", {
            disableScroll: true,
            disableFocus: true,
          });
        });
      }

      if (this.remove_consultant) {
        this.remove_consultant.addEventListener("click", async () => {
          await this.partner_util.removePartner();

          const currentURL = new URL(window.location);
          currentURL.searchParams.delete(PARTNER_PARAM_KEY);
          location.replace(currentURL);
        });
      }
    }

    /**
     * Render the partner info in the modal
     * @param {Partner} partner
     */
    renderPartner(partner) {
      this.name.innerHTML = partner.displayName;

      if (partner.email) {
        this.email.parentElement.classList.remove("d-none");
        this.email.innerHTML = partner.email;
        this.email.href = `mailto:${partner.email}`;
      } else this.email.parentElement.classList.add("d-none");

      if (partner.phone) {
        this.phone.parentElement.classList.remove("d-none");
        this.phone.innerHTML = partner.phone;
        this.phone.href = `tel:${partner.phone}`;
      } else this.phone.parentElement.classList.add("d-none");

      if (partner.aboutYou) {
        this.aboutYou.parentElement.classList.remove("d-none");
        this.aboutYou.innerHTML = partner.aboutYou;
      } else this.aboutYou.parentElement.classList.add("d-none");

      if (partner.facebook) {
        this.facebook.parentElement.classList.remove("d-none");
        this.facebook.innerHTML = partner.facebook;
      } else this.facebook.parentElement.classList.add("d-none");

      if (partner.instagram) {
        this.instagram.parentElement.classList.remove("d-none");
        this.instagram.innerHTML = partner.instagram;
      } else this.instagram.parentElement.classList.add("d-none");

      if (partner.tiktok) {
        this.tiktok.parentElement.classList.remove("d-none");
        this.tiktok.innerHTML = partner.tiktok;
      } else this.tiktok.parentElement.classList.add("d-none");

      if (partner.twitter) {
        this.twitter.parentElement.classList.remove("d-none");
        this.twitter.innerHTML = partner.twitter;
      } else this.twitter.parentElement.classList.add("d-none");

      if (partner.youtube) {
        this.youtube.parentElement.classList.remove("d-none");
        this.youtube.innerHTML = partner.youtube;
      } else this.youtube.parentElement.classList.add("d-none");

      if (partner.provinceCode && partner.city) {
        this.address.classList.remove("d-none");
        this.address.innerHTML = `${partner.city}, ${partner.provinceCode}`;
      } else this.address.classList.add("d-none");

      if (partner.myCollectionHandle) {
        this.collection.classList.remove("d-none");
        this.collection.href = "/collections/" + partner.myCollectionHandle;
      } else this.collection.classList.add("d-none");

      if (partner.profileImage) this.image.src = partner.profileImage;
      else this.image.src = this.image.dataset.defaultImage;
    }
  }

  const findYourConsultant = {
    onLoad() {
      const modals = document.querySelectorAll(FindYourConsultant.selectors.modal);
      modals.forEach((modal) => new FindYourConsultant(modal));
    },
  };

  class FindYourConsultant {
    static selectors = {
      modal: "[data-find-your-consultant]",
      sections: "[data-fyc-section]",
      show_btns: "[data-fyc-show]",
      search_result_template: "[data-partner-result-template]",
      name_input: "#search-by-name",
      website_input: "#search-by-website",
      zip_input: "#search-by-zip",
      name_submit: '[data-submit-type="NAME"]',
      website_submit: '[data-submit-type="WEBSITE"]',
      zip_submit: '[data-submit-type="ZIP"]',
      search_result: "[data-search-result]",
      zip_search_result: "[data-zip-search-result]",
      errors: "[data-error-type]",
      partner_inputs: '[name="partner-radio"]',
      footer: "[data-fyc-footer]",
      select: "[data-fyc-select]",
      close: "[data-close-modal]",
      hideon_search: "[data-hideon-search]",
    };

    static SEARCH_TYPE = {
      NAME: "NAME",
      ZIP: "ZIP",
      WEBSITE: "WEBSITE",
    };

    constructor(modal) {
      this.modal = modal;
      this.sections = this.modal.querySelectorAll(FindYourConsultant.selectors.sections);
      this.show_btns = this.modal.querySelectorAll(FindYourConsultant.selectors.show_btns);
      this.name_input = this.modal.querySelector(FindYourConsultant.selectors.name_input);
      this.website_input = this.modal.querySelector(FindYourConsultant.selectors.website_input);
      this.zip_input = this.modal.querySelector(FindYourConsultant.selectors.zip_input);
      this.name_submit = this.modal.querySelector(FindYourConsultant.selectors.name_submit);
      this.website_submit = this.modal.querySelector(FindYourConsultant.selectors.website_submit);
      this.zip_submit = this.modal.querySelector(FindYourConsultant.selectors.zip_submit);
      this.search_result = this.modal.querySelector(FindYourConsultant.selectors.search_result);
      this.zip_search_result = this.modal.querySelector(FindYourConsultant.selectors.zip_search_result);
      this.errors = this.modal.querySelectorAll(FindYourConsultant.selectors.errors);
      this.footers = this.modal.querySelectorAll(FindYourConsultant.selectors.footer);
      this.selects = this.modal.querySelectorAll(FindYourConsultant.selectors.select);
      this.closeElems = this.modal.querySelectorAll(FindYourConsultant.selectors.close);
      this.hideon_search = this.modal.querySelectorAll(FindYourConsultant.selectors.hideon_search);

      this.search_result_template = this.modal.querySelector(
        FindYourConsultant.selectors.search_result_template
      ).innerHTML;

      this.selected_partner = null;

      this.repository = new Repository();

      this.init();
    }

    init() {
      modal("partner");
      this.initModalEventListener();
    }

    async initModalEventListener() {
      var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
      var eventer = window[eventMethod];
      var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

      // Listen to message from child window
      //console.log("create postmessage listener");

      eventer(
        messageEvent,
        async function (e) {
          //console.log("listenting for postmessage");
          var key = e.message ? "message" : "data";
          var data = e[key];
           //console.log("postmessage: ", data)

          switch (data.type) {
            case "setPrefPartner":
              // Set pref partner
              const partner = data.data;
              //console.log(data.data);
              const partnerWebsite = partner.siteName;
              if (!this.repository) {
                this.repository = new Repository();
              }
              if (theme.customer_id) await this.repository.setPrefPartner(theme.customer_id, partnerWebsite);
              sessionStorage.setItem(OVERRIDE_PARTNER_STORAGE_KEY, partnerWebsite);
              document.dispatchEvent(new CustomEvent("theme:partner:update", { detail: { partner } }));
              postMessage("showConfirmation", "*"); //  `*` on any domain
              break;
            case "closeModal":
              //console.log("switch Close modal");
              const modalName = "find-your-consultant";
              MicroModal.close(modalName);
              // FIX: Hack to fix the modal trigger breaking
              if (modalName === "find-your-consultant") MicroModal.close("info-partner");
              break;
            default:
              break;
          }
        },
        false
      );
    }

    resetError() {
      this.errors.forEach((error) => error.classList.add("d-none"));
    }

    resetResult() {
      this.selected_partner = null;
      this.updateFooter();
      this.search_result.innerHTML = "";
      this.zip_search_result.innerHTML = "";
      this.hideon_search.forEach((elem) => elem.classList.remove("d-none"));
    }

    onNameInput() {
      this.website_input.value = "";
      this.resetError();
    }

    onWebsiteInput() {
      this.name_input.value = "";
      this.resetError();
    }

    onClose(modalName) {
      this.resetResult();
      this.showSection("landing");

      MicroModal.close(modalName);
      // FIX: Hack to fix the modal trigger breaking
      if (modalName === "find-your-consultant") MicroModal.close("info-partner");
    }

    async onNameSubmit() {
      this.resetResult();

      const name = this.name_input.value;
      if (!name || name.length === 0) {
        this.showError(this.name_input, "empty");
        return;
      }

      this.hideon_search.forEach((elem) => elem.classList.add("d-none"));

      this.disableInputs();
      this.name_input.classList.add("loading");

      try {
        const data = await this.repository.searchPartner({
          searchType: FindYourConsultant.SEARCH_TYPE.NAME,
          name,
        });
        if (!data.partners || data.partners.length === 0) throw new Error("no-result");
        this.showSearchResult(data.partners, this.search_result);
      } catch (e) {
        this.showError(this.name_input, "no-result");
      } finally {
        this.enableInputs();
        this.name_input.classList.remove("loading");
      }
    }

    async onWebsiteSubmit() {
      this.resetResult();

      const website = this.website_input.value;
      if (!website || website.length === 0) {
        this.showError(this.website_input, "empty");
        return;
      }

      this.hideon_search.forEach((elem) => elem.classList.add("d-none"));

      this.disableInputs();
      this.website_input.classList.add("loading");

      try {
        const data = await this.repository.searchPartner({
          searchType: FindYourConsultant.SEARCH_TYPE.WEBSITE,
          website,
        });
        if (!data.partners || data.partners.length === 0) throw new Error("no-result");
        this.showSearchResult(data.partners, this.search_result);
      } catch (e) {
        this.showError(this.website_input, "no-result");
      } finally {
        this.enableInputs();
        this.website_input.classList.remove("loading");
      }
    }

    async onZipSubmit() {
      this.resetResult();

      const zip = this.zip_input.value;

      if (!zip || zip.length === 0) {
        this.showError(this.zip_input, "empty");
        return;
      }

      this.hideon_search.forEach((elem) => elem.classList.add("d-none"));

      this.disableInputs();
      this.zip_input.classList.add("loading");

      try {
        const data = await this.repository.searchPartner({
          searchType: FindYourConsultant.SEARCH_TYPE.ZIP,
          zip,
        });
        if (!data.partners || data.partners.length === 0) throw new Error("no-result");
        this.showSearchResult(data.partners, this.zip_search_result);
      } catch (e) {
        console.error(e);
        this.showError(this.zip_input, "no-result");
      } finally {
        this.enableInputs();
        this.zip_input.classList.remove("loading");
      }
    }

    showSearchResult(partners, searchResultElem) {
      this.partners = partners;

      const resultTemplate = Sqrl__namespace.render(this.search_result_template, { partners });
      searchResultElem.innerHTML = resultTemplate;

      this.attachEventListeners(searchResultElem);
    }

    attachEventListeners(searchResultElem) {
      this.partner_inputs = searchResultElem.querySelectorAll(FindYourConsultant.selectors.partner_inputs);

      this.partner_inputs.forEach((input) => {
        input.addEventListener("change", (event) => this.onPartnerInputChange(event));
        input.addEventListener("click", (event) => this.onPartnerInputClick(event));
      });
    }

    async onSelect() {
      if (!this.selected_partner) return;

      const partner = this.partners && this.partners.find((partner) => partner.siteName === this.selected_partner);
      const partnerWebsite = partner && partner.siteName;
      if (!partner) return;

      this.selects.forEach((select) => select.classList.add("loading"));

      // Set pref partner
      if (theme.customer_id) await this.repository.setPrefPartner(theme.customer_id, partnerWebsite);
      sessionStorage.setItem(OVERRIDE_PARTNER_STORAGE_KEY, partnerWebsite);
      document.dispatchEvent(new CustomEvent("theme:partner:update", { detail: { partner } }));

      this.selects.forEach((select) => select.classList.remove("loading"));

      this.showSection("confirmation");
    }

    onPartnerInputChange(e) {
      this.selected_partner = e.target.value;
      this.updateFooter();
    }

    onPartnerInputClick(e) {
      const elem = e.target;
      if (elem.dataset.waschecked === "true") {
        elem.checked = false;

        this.selected_partner = null;
        this.updateFooter();

        elem.dataset.waschecked = "false";
      } else {
        elem.dataset.waschecked = "true";
      }

      this.partner_inputs.forEach((input) => {
        if (input !== elem) input.dataset.waschecked = "false";
      });
    }

    updateFooter() {
      if (this.selected_partner) this.footers.forEach((footer) => footer.classList.remove("d-none"));
      else this.footers.forEach((footer) => footer.classList.add("d-none"));
    }

    disableInputs() {
      this.name_input.disabled = true;
      this.website_input.disabled = true;
      this.name_submit.disabled = true;
      this.website_submit.disabled = true;
      this.zip_input.disabled = true;
      this.zip_submit.disabled = true;
    }

    enableInputs() {
      this.name_input.disabled = false;
      this.website_input.disabled = false;
      this.name_submit.disabled = false;
      this.website_submit.disabled = false;
      this.zip_input.disabled = false;
      this.zip_submit.disabled = false;
    }

    showError(input, type) {
      const parentElem = input.parentElement;
      const errors = parentElem.querySelectorAll(FindYourConsultant.selectors.errors);
      errors.forEach((error) => {
        if (error.dataset.errorType === type) error.classList.remove("d-none");
        else error.classList.add("d-none");
      });
    }

    showSection(section_id) {
      this.resetResult();

      this.sections.forEach((section) => {
        if (section.dataset.fycSection === section_id) section.classList.remove("d-none");
        else section.classList.add("d-none");
      });
    }
  }

  const sections$o = [];

  /**
   * TTD / PWS — claves opcionales en la respuesta GET /partners?website=...
   *
   * Plano o dentro de partner.ttdLayout:
   * - selectedHeaderColor | ttdBarColor | barColor → azul / naranja / amarillo (o inglés)
   * - selectedBanners | ttdSelectedBanners → "1,1,1,0" (1=mostrar slide, 0=ocultar; índice = orden en metaobject/blocks)
   * - ttdDoubleBannerHandle | doubleBannerHandle → handle del metaobjeto (tipo ttd_promo_doble)
   * - ttdHiddenSectionTypes | hiddenSectionTypes → valores de data-section-type a ocultar
   *   ej. ["image-hotspot","V2-tiktok-carrusel","collection-carousel","V2-sliderBanner","section-collection-images"]
   */
  function parseSelectedBannersFlags(raw) {
    if (raw == null || raw === "") return null;
    const s = String(raw).trim();
    if (!s) return null;
    return s.split(",").map((x) => x.trim());
  }

  function extractTtdPartnerConfig(partner) {
    const empty = {
      barColor: null,
      doubleBannerHandle: null,
      hiddenSectionTypes: [],
      selectedBanners: null,
    };
    if (!partner || typeof partner !== "object") return empty;
    const L =
      partner.ttdLayout && typeof partner.ttdLayout === "object"
        ? partner.ttdLayout
        : {};
    const hiddenRaw =
      partner.ttdHiddenSectionTypes ??
      L.hiddenSectionTypes ??
      partner.hiddenSectionTypes ??
      [];
    const hidden = Array.isArray(hiddenRaw)
      ? hiddenRaw
      : typeof hiddenRaw === "string"
        ? hiddenRaw.split(",").map((s) => s.trim())
        : [];
    return {
      barColor:
        partner.selectedHeaderColor ??
        L.selectedHeaderColor ??
        partner.ttdBarColor ??
        L.barColor ??
        partner.storefrontBarColor ??
        partner.barColor ??
        partner.headerTheme ??
        null,
      doubleBannerHandle:
        partner.ttdDoubleBannerHandle ??
        L.doubleBannerHandle ??
        partner.doubleBannerHandle ??
        null,
      hiddenSectionTypes: hidden.filter(Boolean),
      selectedBanners:
        partner.selectedBanners ??
        L.selectedBanners ??
        partner.ttdSelectedBanners ??
        null,
    };
  }

  /**
   * Oculta slides del banner principal (V2-sliderBanner) según selectedBanners del API.
   * Los slides en Liquid llevan data-ttd-slide-index 0..n alineados con el orden del metaobject o blocks.
   */
  function applyTtdSliderBannerVisibility(partner) {
    const cfg = extractTtdPartnerConfig(partner);
    const flags = parseSelectedBannersFlags(cfg.selectedBanners);

    document
      .querySelectorAll('[data-section-type="V2-sliderBanner"]')
      .forEach((sectionEl) => {
        const slides = sectionEl.querySelectorAll(
          ".sp-slide[data-ttd-slide-index]"
        );
        if (!slides.length) return;

        slides.forEach((slide) => {
          const idx = parseInt(
            slide.getAttribute("data-ttd-slide-index"),
            10
          );
          if (Number.isNaN(idx)) return;

          let hide = false;
          if (flags && flags.length) {
            const raw = flags[idx];
            if (raw !== undefined && raw !== null && raw !== "") {
              hide =
                raw === "0" ||
                raw === 0 ||
                String(raw).toLowerCase() === "false";
            }
          }

          slide.classList.toggle("d-none", hide);
          if (hide) slide.setAttribute("data-ttd-api-banner-slide-hidden", "1");
          else slide.removeAttribute("data-ttd-api-banner-slide-hidden");
        });

        sectionEl.querySelectorAll(".sp-dot").forEach((dot) => {
          const di = parseInt(dot.dataset.index, 10);
          if (Number.isNaN(di)) return;
          const slide = sectionEl.querySelector(
            `.sp-slide[data-ttd-slide-index="${di}"]`
          );
          const hideDot = slide && slide.classList.contains("d-none");
          dot.classList.toggle("d-none", !!hideDot);
        });

        const sec = sectionEl.closest(".shopify-section");
        const visibleCount = sectionEl.querySelectorAll(
          ".sp-slide[data-ttd-slide-index]:not(.d-none)"
        ).length;
        if (sec) {
          if (visibleCount === 0) {
            sec.classList.add("d-none");
            sec.setAttribute("data-ttd-api-banner-empty", "1");
          } else {
            sec.classList.remove("d-none");
            sec.removeAttribute("data-ttd-api-banner-empty");
          }
        }
      });
  }

  function resetTtdApiSectionHides() {
    document
      .querySelectorAll('.shopify-section[data-ttd-api-hidden="1"]')
      .forEach((sec) => {
        sec.classList.remove("d-none");
        sec.removeAttribute("data-ttd-api-hidden");
      });
  }

  function applyTtdSectionVisibilityFromPartner(partner) {
    resetTtdApiSectionHides();
    const cfg = extractTtdPartnerConfig(partner);
    const hidden = cfg.hiddenSectionTypes;
    if (!hidden.length) return;
    hidden.forEach((type) => {
      const t = String(type).trim();
      if (!t) return;
      document.querySelectorAll("[data-section-type]").forEach((el) => {
        if (el.getAttribute("data-section-type") !== t) return;
        const sec = el.closest(".shopify-section");
        if (sec) {
          sec.classList.add("d-none");
          sec.setAttribute("data-ttd-api-hidden", "1");
        }
      });
    });
  }

  document.addEventListener("theme:partner:set", (e) => {
    const partner = e.detail?.partner;
    applyTtdSectionVisibilityFromPartner(partner);
    applyTtdSliderBannerVisibility(partner);
    document.dispatchEvent(
      new CustomEvent("theme:ttd:layout", {
        detail: {
          partner,
          config: extractTtdPartnerConfig(partner),
        },
      })
    );
  });
  document.addEventListener("theme:partner:update", (e) => {
    const partner = e.detail?.partner;
    applyTtdSectionVisibilityFromPartner(partner);
    applyTtdSliderBannerVisibility(partner);
    document.dispatchEvent(
      new CustomEvent("theme:ttd:layout", {
        detail: {
          partner,
          config: extractTtdPartnerConfig(partner),
        },
      })
    );
  });

  function runTtdSliderBannerIfPartnerAlreadyLoaded() {
    if (typeof theme === "undefined" || !theme.storefront_partner) return;
    applyTtdSliderBannerVisibility(theme.storefront_partner);
    document.dispatchEvent(
      new CustomEvent("theme:ttd:layout", {
        detail: {
          partner: theme.storefront_partner,
          config: extractTtdPartnerConfig(theme.storefront_partner),
        },
      })
    );
  }
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      runTtdSliderBannerIfPartnerAlreadyLoaded
    );
  } else {
    runTtdSliderBannerIfPartnerAlreadyLoaded();
  }

  class TtdDoubleBannerController {
    constructor(container) {
      this.container = container;
      this.onLayout = this.onLayout.bind(this);
      document.addEventListener("theme:ttd:layout", this.onLayout);
      if (typeof theme !== "undefined" && theme.storefront_partner) {
        this.onLayout({
          detail: {
            partner: theme.storefront_partner,
            config: extractTtdPartnerConfig(theme.storefront_partner),
          },
        });
      }
    }

    onLayout(event) {
      const partner = event.detail?.partner;
      const cfg =
        event.detail?.config ?? extractTtdPartnerConfig(partner);
      const root = this.container.querySelector(
        "[data-ttd-double-banner-dynamic]"
      );
      if (!root) return;
      const manual = this.container.querySelector(
        "[data-ttd-double-banner-manual]"
      );
      const rows = root.querySelectorAll("[data-ttd-double-banner-row]");
      const want = (cfg.doubleBannerHandle || "").toString().trim().toLowerCase();
      let anyShown = false;
      rows.forEach((row) => {
        const h = (
          row.getAttribute("data-ttd-double-banner-handle") || ""
        ).toLowerCase();
        let show = false;
        if (want) show = h === want;
        else if (row.hasAttribute("data-ttd-double-banner-fallback")) show = true;
        row.classList.toggle("d-none", !show);
        if (show) anyShown = true;
      });
      if (!anyShown && rows.length) {
        rows[0].classList.remove("d-none");
        anyShown = true;
      }
      if (manual) {
        if (anyShown) manual.classList.add("d-none");
        else manual.classList.remove("d-none");
      }
    }
  }

  const ttdDoubleBannerSection = {
    onLoad() {
      new TtdDoubleBannerController(this.container);
    },
  };

  class PartnerStorefront {
    static selectors = {
      outer: "[data-partner-storefront]",
      name: "[data-partner-name]",
      phone: "[data-partner-phone]",
      email: "[data-partner-email]",
      zip: "[data-partner-zip]",
      about: "[data-partner-about]",
      profileImage: "[data-partner-profile-image]",
      whatsapp: "[data-partner-whatsapp]",
      facebook: "[data-partner-facebook]",
      instagram: "[data-partner-instagram]",
      tiktok: "[data-partner-tiktok]",
      twitter: "[data-partner-twitter]",
      youtube: "[data-partner-youtube]",
      clearMatch: "[data-clear-match]",
    };

    /** Modificadores CSS: partner-storefront-bar--{blue|orange|yellow} */
    static BAR_THEME_PREFIX = "partner-storefront-bar--";
    static BAR_THEMES = ["blue", "orange", "yellow"];

    /**
     * Color de barra TTD desde API (ttdBarColor u otros alias).
     * Acepta: blue|orange|yellow o azul|naranja|amarillo|dorado|gold (case insensitive).
     */
    static normalizeBarTheme(value) {
      if (value == null || value === "") return "orange";
      const v = String(value).trim().toLowerCase();
      if (v === "blue" || v === "azul") return "blue";
      if (v === "orange" || v === "naranja") return "orange";
      if (v === "yellow" || v === "amarillo" || v === "gold" || v === "dorado")
        return "yellow";
      return "orange";
    }

    /** URL + texto para @ en UI; acepta URL completa, @handle, /ruta o handle */
    static normalizeYoutubePartnerValue(raw) {
      if (raw == null || raw === "") return null;
      let s = String(raw).trim();
      if (!s) return null;
      if (/^https?:\/\//i.test(s)) {
        let label = s.replace(/^https?:\/\/(www\.)?youtube\.com\//i, "");
        label = label.replace(/^@/, "").split("/")[0] || "YouTube";
        return { href: s.split("?")[0], label };
      }
      if (s.startsWith("/")) {
        const path = s.replace(/\?.*$/, "");
        const label = path.replace(/^\//, "").split("/").pop() || "YouTube";
        return { href: `https://www.youtube.com${path}`, label };
      }
      s = s.replace(/^@+/, "");
      return {
        href: `https://www.youtube.com/@${s}`,
        label: s,
      };
    }

    static parseContactMethodPref(raw) {
      if (raw == null || raw === "") return [];
      if (Array.isArray(raw)) {
        return raw
          .map((v) => String(v).trim().toLowerCase())
          .filter(Boolean);
      }
      return String(raw)
        .split(",")
        .map((v) => v.trim().toLowerCase())
        .filter(Boolean);
    }

    constructor(holder) {
      this.outer = holder;
      this.name = this.outer.querySelector(PartnerStorefront.selectors.name);
      this.phone = this.outer.querySelector(PartnerStorefront.selectors.phone);
      this.email = this.outer.querySelector(PartnerStorefront.selectors.email);
      this.zip = this.outer.querySelector(PartnerStorefront.selectors.zip);
      this.about = this.outer.querySelector(PartnerStorefront.selectors.about);
      this.profileImage = this.outer.querySelector(PartnerStorefront.selectors.profileImage);
      this.whatsapp = this.outer.querySelector(PartnerStorefront.selectors.whatsapp);
      this.facebook = this.outer.querySelector(PartnerStorefront.selectors.facebook);
      this.instagram = this.outer.querySelector(PartnerStorefront.selectors.instagram);
      this.tiktok = this.outer.querySelector(PartnerStorefront.selectors.tiktok);
      this.youtube = this.outer.querySelector(PartnerStorefront.selectors.youtube);
      this.twitter = this.outer.querySelector(PartnerStorefront.selectors.twitter);

      this.partner = null;
      this.prefContactMethods = [];
      this.position = null;

      this.clearMatchEl = this.outer.querySelector("[data-clear-match]");

      if (this.outer) this.init();
    }

    async init() {
      document.addEventListener("theme:partner:set", (event) => {
        this.partner = event.detail.partner;
        this.setStorefront();
      });

      document.addEventListener("theme:partner:update", (event) => {
        this.partner = event.detail.partner;
        this.setStorefront();
      });

      this.clearMatchEl?.addEventListener("click", (event) => {
        if (localStorage.getItem("ZIP_CODE_STORAGE_KEY") === null) {
          event.preventDefault();
          this.clearMatch();
        }
        else{
          window.location.href = '/pages/compra-con-un-distribuidor';
        }
      });
    }

    applyBarTheme() {
      if (!this.outer.classList.contains("partner-storefront-bar")) return;
      const cfg = extractTtdPartnerConfig(this.partner);
      const raw =
        cfg.barColor ??
        this.outer.dataset.partnerBarFallback;
      const theme = PartnerStorefront.normalizeBarTheme(raw);
      const p = PartnerStorefront.BAR_THEME_PREFIX;
      PartnerStorefront.BAR_THEMES.forEach((t) => {
        this.outer.classList.remove(`${p}${t}`);
      });
      this.outer.classList.add(`${p}${theme}`);
    }

    async setStorefront() {
      if (!this.partner) return;

      this.prefContactMethods = PartnerStorefront.parseContactMethodPref(
        this.partner.contactMethodPref
      );

      this.applyBarTheme();

      this.renderName();
      this.renderAbout();
      this.renderProfileImage();
      this.renderZip();
      this.renderPhone();
      this.renderEmail();
      this.renderWhatsapp();
      this.renderFacebook();
      this.renderInstagram();
      this.renderTiktok();
      this.renderYoutube()
      this.renderTwitter()
    }

    hasPreferredMethod(method) {
      if (!this.prefContactMethods.length) return true;
      return this.prefContactMethods.includes(String(method).toLowerCase());
    }

    indexOfPreferredMethod(method) {
      this.position = this.prefContactMethods.indexOf(method);
      return this.position
    }

    renderName() {
      if (this.name && this.partner.displayName) {
        if(this.partner.nickname !== null ) {
          this.name.textContent = this.partner.nickname;
        }else{
          this.name.textContent = this.partner.displayName;
        }
      }
    }

    renderAbout() {
      if (this.about && this.partner.aboutYou) {
        this.about.textContent = this.partner.aboutYou;
      }
    }

    renderProfileImage() {
      if (this.profileImage && this.partner.profileImage) {
        this.profileImage.src = this.partner.profileImage;
        this.profileImage.parentElement.classList.remove("d-none");
      }
    }

    renderZip() {
      if (this.zip && window.zipLocator.zip) {
        this.zip.textContent = window.zipLocator.zip;
        this.zip.parentElement.classList.remove("d-none");
      }
    }

    renderPhone() {
      if (this.phone && this.partner.phone) {
        if (this.partner.hidePhone) return;
        if (!this.hasPreferredMethod("phone")) return;

        var auxPosition = this.indexOfPreferredMethod("phone");
        this.phone.textContent = this.partner.phone;
        this.phone.closest("a").href = `tel:${this.partner.phone}`;
        this.phone.parentElement.classList.remove("d-none");
        this.phone.parentElement.classList.add(`method-${auxPosition}`);
      }
    }

    renderEmail() {
      if (this.email && this.partner.email) {
        if (this.partner.hideEmail) return;
        if (!this.hasPreferredMethod("email")) return;

        var auxPosition = this.indexOfPreferredMethod("email");
        this.email.textContent = this.partner.email;
        this.email.closest("a").href = `mailto:${this.partner.email}`;
        this.email.parentElement.classList.remove("d-none");
        this.email.parentElement.classList.add(`method-${auxPosition}`);
      }
    }

    renderWhatsapp() {
      if (this.whatsapp && this.partner.phone) {
        this.isJoinPage = window.location.href.includes("unete");
        if (!this.hasPreferredMethod("whatsapp") && !this.isJoinPage) return;

        this.whatsapp.textContent = this.partner.phone;
        var auxPosition = this.indexOfPreferredMethod("whatsapp");
        this.whatsapp.closest("a").href = this.isJoinPage
          ? `https://wa.me/${this.partner.phone}?text=Hola, me gustaría unirme a Betterware.`
          : `https://wa.me/${this.partner.phone}?text=Hola, quiero comprar en Betterware`;
        this.whatsapp.parentElement.classList.remove("d-none");
        this.whatsapp.parentElement.classList.add(`method-${auxPosition}`);
      }
    }

    renderFacebook() {
      if (this.facebook && this.partner.facebook) {
        if (!this.hasPreferredMethod("facebook")) return;

         var auxPosition = this.indexOfPreferredMethod("facebook");
        this.facebook.textContent = this.partner.facebook;
        this.facebook.closest("a").href = `https://www.facebook.com/${this.partner.facebook}`;
        this.facebook.parentElement.classList.remove("d-none");
        this.facebook.parentElement.classList.add(`method-${auxPosition}`);
      }
    }

    renderInstagram() {
      if (this.instagram && this.partner.instagram) {
        if (!this.hasPreferredMethod("instagram")) return;

        var auxPosition = this.indexOfPreferredMethod("instagram");
        const ig = String(this.partner.instagram).replace(/^@+/, "").trim();
        this.instagram.textContent = ig;
        this.instagram.closest("a").href = `https://www.instagram.com/${ig}`;
        this.instagram.parentElement.classList.remove("d-none");
        this.instagram.parentElement.classList.add(`method-${auxPosition}`);
      }
    }

    renderTiktok() {
      if (this.tiktok && this.partner.tiktok) {
        if (!this.hasPreferredMethod("tiktok")) return;

        var auxPosition = this.indexOfPreferredMethod("tiktok");
        this.tiktok.textContent = this.partner.tiktok;
        this.tiktok.closest("a").href = `https://tiktok.com/@${this.partner.tiktok}`;
        this.tiktok.parentElement.classList.remove("d-none");
        this.tiktok.parentElement.classList.add(`method-${auxPosition}`);
      }
    }

    renderYoutube() {
      if (this.youtube) {
        if (!this.hasPreferredMethod("youtube")) return;

        const ytSource = this.partner.youtube || this.partner.url_video;
        if (!ytSource) return;
        const yt = PartnerStorefront.normalizeYoutubePartnerValue(ytSource);
        if (!yt) return;
        this.youtube.textContent = yt.label;
        const link = this.youtube.closest("a");
        if (link) {
          link.href = yt.href;
          link.classList.remove("d-none");
        }
      }
    }

    renderTwitter() {
      if (this.twitter && this.partner.twitter) {
        if (!this.hasPreferredMethod("twitter")) return;

        this.twitter.textContent = this.partner.twitter;
        this.twitter.closest("a").href = `https://x.com/@${this.partner.twitter}`;
        this.twitter.parentElement.classList.remove("d-none");
      }
    }

    clearMatch() {
      for (const key in sessionStorage) {
        if (key.startsWith("PARTNER-")) {
          sessionStorage.removeItem(key);
        }
      }
      if (sessionStorage.getItem('OVERRIDE_PARTNER_STORAGE_KEY')) {
          sessionStorage.removeItem('OVERRIDE_PARTNER_STORAGE_KEY');
      } 
      localStorage.removeItem("ZIP_LOCATOR_VIEWED_STORAGE_KEY");
      localStorage.removeItem("CONSULTANT_PREFERENCE_STORAGE_KEY");
      localStorage.removeItem("CURRENT_PARTNER_STORAGE_KEY");
      localStorage.removeItem("CONSULTANT_MATCH_STORAGE_KEY");
      localStorage.removeItem("ZIP_CODE_STORAGE_KEY");
      window.location.href = "/";
    }
  }

  const partnerStorefront = {
    onLoad() {
      sections$o[this.id] = [];
      const holders = this.container.querySelectorAll(PartnerStorefront.selectors.outer);
      holders.forEach((holder) => {
        sections$o[this.id].push(new PartnerStorefront(holder));
      });
    },
  };

  const pfpSelectors = {
    section: "partner-featured-products",
    slides: ".product-grid-slide",
    template: "[data-product-item-template]",
    messageTemplate: "[data-product-item-message-template]",
    defaultSection: `[data-section-type="featured-collection"]`,
    partnerName: "[data-partner-name]",
    productCount: "[data-product-count]",
    messageWrapper: "[data-message-wrapper]",
    locale: "data-locale",
  };

  const partnerFeaturedProducts = {
    onLoad() {
      // Init Slider
      const slider = this.container.querySelector(selectors$l.slider);
      const flktySlider = new Slider(this.container, slider);

      // Enable SliderMessage if it exists
      const messageElem = this.container.querySelector(selectors$l.message_wrapper);
      if (messageElem) new SliderMessage(messageElem, flktySlider.flkty);

      // Enable Featured Products if it exists
      if (this.container.id === pfpSelectors.section) new PartnerFeaturedProducts(this.container, flktySlider);
    },
  };

  class PartnerFeaturedProducts {
    constructor(section, flktySlider) {
      this.section = section;
      this.defaultSection = document.querySelector(pfpSelectors.defaultSection);
      this.repository = new Repository();
      this.partner = null;
      this.flktySlider = flktySlider;
      this.flkty = this.flktySlider.flkty;
      this.currentSlides = this.section.querySelectorAll(pfpSelectors.slides);
      this.template = this.section.querySelector(pfpSelectors.template).innerHTML;
      this.messageTemplate = this.section.querySelector(pfpSelectors.messageTemplate).innerHTML;
      this.messageWrapper = this.section.querySelector(pfpSelectors.messageWrapper);
      this.partnerName = this.section.querySelector(pfpSelectors.partnerName);
      this.productCount = this.section.querySelector(pfpSelectors.productCount);
      this.locale = this.section.querySelector(`[${pfpSelectors.locale}]`);

      this.init();
    }

    init() {
      document.addEventListener("theme:partner:set", (event) => {
        this.partner = event.detail.partner;
        this.showFeaturedProducts();
      });
    }

    async showFeaturedProducts() {
      const data = await this.repository.getProducts(this.partner.siteName);
      if (data.products && data.products.length > 0) {
        const products = data.products;
        const products_enable = products.filter(
          (product) =>
            !(
              product.tags &&
              Array.isArray(product.tags) &&
              product.tags.includes("no_disponible")
            )
        );
        if (!products_enable.length) {
          this.showDefaultSection();
          return;
        }
        this.updateSlider(products_enable);
        this.updateInfo(products_enable);
      } else {
        this.showDefaultSection();
      }
    }

    updateInfo(products) {
      if (this.partnerName) {
        this.partnerName.textContent = this.partner.displayName;
        this.partnerName.parentElement.classList.remove(classes$5.hide);
      }
      if (this.productCount) {
        this.productCount.innerHTML = products.length;
      }

      const messageTemplate = Sqrl__namespace.render(this.messageTemplate, {
        products,
      });
      this.messageWrapper.innerHTML = messageTemplate;
    }

    /**
     * Update the slider with the products
     * @param {Array} products
     */
    updateSlider(products) {
      this.currentSlides = this.section.querySelectorAll(pfpSelectors.slides);
      this.flkty.remove(this.currentSlides);

      products.forEach((product) => {
        const productTemplate = Sqrl__namespace.render(this.template, {
          title: product.title,
          rating: product.rating,
          price: product.price,
          variant: product.variantID,
          image: product.featuredImage.url,
          tagline: product.tagline,
          tags: product.tags,
          isAvailable: product.isAvailable,
          href: `/products/${product.handle}`,
          review: product.review,
          reviewLoop: [1, 2, 3, 4, 5],
          locale: this.locale ? this.locale.getAttribute(pfpSelectors.locale) : "",
        });
        const template = document.createElement("template");
        template.innerHTML = productTemplate.trim();
        this.flkty.append(template.content.firstChild);
      });

      // Re-init Slider
      this.flktySlider.refreshFlktyScroll();
      this.flkty.selectCell(0);

      // Attach click handler
      document.dispatchEvent(new CustomEvent("theme:item:loaded"));
    }

    showDefaultSection() {
      // this.defaultSection.classList.remove("d-none");
      this.section.classList.add("d-none");

      document.dispatchEvent(new CustomEvent("theme:partner:render"));
    }
  }

  const selectors$W = {
    trigger: "[data-popup-zip-locator]",
    closeTrigger: "[data-micromodal-close]",
    modal: "[data-zip-locator-modal]",
    content: "data-zip-locator-modal-content",
    form: "[data-zip-locator-form]",
    formStorefront: "[data-zip-locator-form-with-storefront]",
    formError: "[data-zip-locator-form-error]",
    input: "data-zip-locator-input",
    inputStorefront: "data-zip-locator-input-with-storefront",
    submit: "[data-zip-locator-submit]",
    submitStorefront: "[data-zip-locator-submit-with-storefront]",
    return: "[data-zip-locator-return]",
    continue: "[data-zip-locator-continue]",
    toast: "[data-zip-locator-toast]",
    drawer: "[data-drawer]",

    matchNameEl: "[data-zip-locator-match-name]",
    matchNameElStorefront: "[data-zip-locator-match-name-with-storefront]",
    matchPhoneEl: "[data-zip-locator-match-phone]",
    matchZipEl: "[data-zip-locator-match-zip]",
    matchZipElStorefront: "[data-zip-locator-match-zip-with-storefront]",
    matchImageEl: "[data-zip-locator-match-image]",

  };

  const ZIP_CODE_STORAGE_KEY = "ZIP_CODE_STORAGE_KEY";
  const CONSULTANT_MATCH_STORAGE_KEY = "CONSULTANT_MATCH_STORAGE_KEY";
  const ZIP_LOCATOR_VIEWED_STORAGE_KEY = "ZIP_LOCATOR_VIEWED_STORAGE_KEY";
  const CHECKOUT_REDIRECT_ZIP_LOCATOR_STORAGE_KEY = "CHECKOUT_REDIRECT_ZIP_LOCATOR_STORAGE_KEY";

  class ZipLocator {
    constructor(wrapper) {
      this.baseURL = `https://${HOST_AWS_URL}/Prod`;
      
      if(!wrapper) return;

      modal("zip-locator");

      this.modal = wrapper;
      this.triggers = document.querySelectorAll(selectors$W.trigger);
      this.closeTriggers = this.modal.querySelectorAll(selectors$W.closeTrigger);
      this.content = this.modal.querySelector(`[${selectors$W.content}]`);
      this.input = this.modal.querySelector(`[${selectors$W.input}]`);
      this.inputStorefront = this.modal.querySelector(`[${selectors$W.inputStorefront}]`);
      this.submit = this.modal.querySelector(selectors$W.submit);
      this.submitStorefront = this.modal.querySelector(selectors$W.submitStorefront);
      this.return = this.modal.querySelector(selectors$W.return);
      this.continue = this.modal.querySelector(selectors$W.continue);
      this.openTrigger = document.querySelector(selectors$W.trigger);
      this.closeTrigger = this.modal.querySelector(selectors$W.closeTrigger);
      this.toast = document.querySelector(selectors$W.toast);
      this.drawers = document.querySelectorAll(selectors$W.drawer);

      this.matchNameEl = this.modal.querySelector(selectors$W.matchNameEl);
      this.matchNameElStorefront = this.modal.querySelector(selectors$W.matchNameElStorefront);
      this.matchPhoneEl = this.modal.querySelector(selectors$W.matchPhoneEl);
      this.matchZipEl = this.modal.querySelector(selectors$W.matchZipEl);
      this.matchZipElStorefront = this.modal.querySelector(selectors$W.matchZipElStorefront);
      this.matchImageEl = this.modal.querySelector(selectors$W.matchImageEl);

      this.openShareModal = this.modal.querySelector(selectors$v.openShareModal);

      this.zipCode = "";
      this.location = {
        lat: null,
        long: null,
        city: null,
        state: null,
      };

      this.redirected = false;

      this.listen();
      this.init();
    }

    listen() {
      document.addEventListener("theme:partner:set", this.handlePartnerSet.bind(this));

      this.triggers.forEach((trigger) => {
        trigger.addEventListener("click", this.closeDrawer.bind(this));
      });

      this.closeTriggers.forEach((trigger) => {
        trigger.addEventListener("click", this.storeZipLocatorViewed.bind(this));
        trigger.addEventListener("touchend", this.storeZipLocatorViewed.bind(this));
      });

      this.initModal();
    }

    conditionShowModalWithPWS() {

    document.addEventListener("theme:partner:set", (event) => {
      document.getElementById("modal-content").classList.add("miniModal"); 
    });

    /*
      window.addEventListener('load', () => {
        setTimeout(()=>{
            const urlParams = new URLSearchParams(window.location.search);
            if(urlParams.has('pws') == false){
              // Cancel default open
              //if (!window.zipLocator.viewed || this.redirected) this.openModal();
            }else{
              document.getElementById("modal-content").classList.add("miniModal");
            }
        }, 2000)
      })
      */
    }

    init() {
      this.getStoredZipLocatorData();
      this.getCheckoutRedirectZipLocatorData();
      // openModal canceled
      //if (!window.zipLocator.viewed || this.redirected) this.openModal();   
      this.renderMatchedConsultant();
      this.conditionShowModalWithPWS(); 
    }

    initModal() {
      this.submit.addEventListener("click", () => {
        this.handleZipCodeSubmit();
      });

      this.submitStorefront.addEventListener("click",() => {
        this.handleZipCodeSubmitWithStorefront();
      });

      this.return.addEventListener("click", () => {
        if(window.theme.storefront_partner){
          this.renderState("no-match", "default-storefront");
        }else{
          this.renderState("no-match", "default");
        }
      });

      if (this.input && window.zipLocator.zip) {
        this.input.value = window.zipLocator.zip;
      }
      const state = this.content.getAttribute(selectors$W.content);
      if (state === "no-match" && this.return) this.return.click();
      //PWS or normal popup

      this.renderState("no-match", "default");
      document.addEventListener("theme:partner:set", (event) => {
        this.renderState("default", "default-storefront");
      });
      
    }

    async reload() {
      const data = await this.getConsultants(window.zipLocator.zip);
      const resultsData = this.getConsultantsResults(data.nodes);
      const matchData = await this.getConsultantMatch(resultsData);

      if (matchData) {
        this.storeZipLocatorData(window.zipLocator.zip, matchData);
      }
    }

    async handlePartnerSet() {
      // match with selected partner as long as user zip matches with any distributor
      if (!window.zipLocator.zip) return;

      const data = await this.getConsultants(window.zipLocator.zip);
      const resultsData = this.getConsultantsResults(data.nodes);
      const matchData = await this.getConsultantMatch(resultsData);

      if (matchData) {
        this.storeZipLocatorData(window.zipLocator.zip, matchData);
      }
    }

    async handleZipCodeSubmit() {
      const form = this.submit.closest(selectors$W.form);
      const input = form.querySelector(`[${selectors$W.input}]`);

      const zipValid = this.validateZipCode(input, form);
      if (!zipValid) return;

      this.zipCode = input.value;
      form.classList.remove("has-error");
      this.submit.classList.add("loading");

      const data = await this.getConsultants(this.zipCode);
      const resultsData = this.getConsultantsResults(data.nodes);
      const matchData = await this.getConsultantMatch(resultsData);

      if (matchData) {
        this.storeZipLocatorViewed();
        this.storeZipLocatorData(this.zipCode, matchData);
        this.renderMatchedConsultant();

        this.submit.classList.remove("loading");
        this.submit.classList.add("has-success");

        this.renderState("loading", "matched");

        if (window.zipLocator.match.storefront) {
          setTimeout(() => (window.location.href = `/${window.zipLocator.match.storefront}`), 1000);
        }

        // this.closeModal();
        // this.renderToast();
      } else {
        this.storeZipLocatorData(this.zipCode, null);
        this.submit.classList.remove("loading");
        this.renderState("loading", "no-match");
      }
    }

    async handleZipCodeSubmitWithStorefront() {
      const form = this.submitStorefront.closest(selectors$W.formStorefront);
      const input = form.querySelector(`[${selectors$W.inputStorefront}]`);

      const zipValid = this.validateZipCode(input, form);
      if (!zipValid) return;

      this.zipCode = input.value;
      form.classList.remove("has-error");
      this.submitStorefront.classList.add("loading");

      const data = await this.getConsultants(this.zipCode);
      const resultsData = this.getConsultantsResults(data.nodes);
      const matchData = await this.getConsultantMatch(resultsData);

      if (matchData) {
        this.storeZipLocatorViewed();
        this.storeZipLocatorData(this.zipCode, matchData);
        this.renderMatchedConsultant();

        this.submitStorefront.classList.remove("loading");
        this.submitStorefront.classList.add("has-success");

        this.renderState("loading", "matched-with-storefront");

        /*
        if (window.zipLocator.match.storefront) {
          setTimeout(() => (window.location.href = `/${window.zipLocator.match.storefront}`), 1000);
        }
        */

        // this.closeModal();
        // this.renderToast();
      } else {
        this.storeZipLocatorData(this.zipCode, null);
        this.submitStorefront.classList.remove("loading");
        this.renderState("loading", "no-match");
      }
    }

    validateZipCode(input, formElem) {
      var valid = false;
      // const zipRegex = /^(\d{5})$/;
      // valid = zipRegex.test(zipCode);
      valid = input.checkValidity();

      if (!valid) this.showMissingZipError(formElem);
      return valid;
    }

    showMissingZipError(formElem) {
      let errorMessage = "Please enter a valid ZIP Code";
      const formError = formElem.querySelector(selectors$W.formError);
      formError.textContent = errorMessage;
      formElem.classList.add("has-error");
    }

    async getConsultants(zipCode) {
      const url = `${this.baseURL}/enrollment/locator?key=zip_codes&zipCode=${zipCode}`;
      return await fetch(url).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        const data = await res.json();
        return data;
      });
    }

    async getConsultantStatus(usercode) {
      const url = `${this.baseURL}/distributors/delivery-program?code=${usercode}`;
      return await fetch(url).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        const data = await res.json();
        return data;
      });
    }

    getConsultantsResults(data) {
      // map all distributors from raw data
      const resultsData = data.map((item) => {
        
        const id = parseFloat(item.id.replace("gid://shopify/Metaobject/", ""));
        const zipField = item.fields.find((field) => field.key === "zipcode");
        const zip = zipField?.value;

        // get relevant entries from item
        const keys = [
          "usercode_list",
          "phone_number_list",
          "delivery_list",
          "type_list",
          "last_name_1_list",
          "distributor_storefront_list",
          "delivery_guarantee_day"
        ];
        const lists = keys.map((key) => {
          let field = item.fields.find((field) => field.key === key);
          let list = JSON.parse(field?.value);
          return list;
        });

        // construct list data object
        const listDataCols = ["usercode", "phone", "delivery", "type", "name", "storefront", "delivery_guarantee_day"];
        const listDataRows = [];
        for (var i = 0; i < lists[0].length; i++) {
          listDataRows.push(lists.map((item) => item[i]));
        }
        const listData = listDataRows.map(function (row) {
          return row.reduce(function (res, field, index) {
            res["id"] = id;
            res["zip"] = zip;
            res[listDataCols[index]] = field;
            return res;
          }, {});
        });

        return listData;
      })
      .flat();

      return resultsData;
    }

    async getConsultantMatch(results) {
      let matchData = null;

      if (!results.length) return matchData;

      // filter out distributors who cannot deliver
      let resultsDataFiltered = [];
      const resultsDataFirstFilter = results.filter((item) => item.delivery === "1");
      if (resultsDataFirstFilter.length) {
        resultsDataFiltered = resultsDataFirstFilter;

        // filter out distributors who cannot deliver - second check
        const deliveryStatusesPromises = resultsDataFiltered.map((item) => {
          return this.getConsultantStatus(item.usercode);
        })
        const resultsDataSecondFilter = await Promise
          .all(deliveryStatusesPromises)
          .then((deliveryStatuses) => {
            return resultsDataFiltered.filter((result, index) => {
              if (deliveryStatuses[index]?.status) return result;
            });
          })
          .catch((error) => {
            console.warn(error);
          });

        resultsDataFiltered = resultsDataSecondFilter;

        // match with referral partner only if referral partner has coverage
        if (theme.referral_partner) {
          const foundPrefPartner = resultsDataFiltered.find(
            (item) => item.usercode === theme.referral_partner?.betterwarePlusId
          );
          if (foundPrefPartner) {
            matchData = {
              coverage: true,
              ...foundPrefPartner,
            };
          }
          return matchData;
        }
        // match with storefront partner regardless of coverage
        else if (theme.storefront_partner) {
          const foundPrefPartner = resultsDataFiltered.find(
            (item) => item.usercode === theme.storefront_partner.betterwarePlusId
          );
          const storefrontPartner = {
            usercode: theme.storefront_partner.betterwarePlusId,
            phone: theme.storefront_partner.phone,
            name: theme.storefront_partner.displayName,
            storefront: theme.storefront_partner.siteName,
            delivery_guarantee_day: theme.storefront_partner.deliveryGuaranteeDay
          };

          matchData = {
            id: null,
            zip: theme.storefront_partner.zip,
            coverage: foundPrefPartner ? true : false,
            ...storefrontPartner,
          };
          return matchData;
        }

        if (resultsDataFiltered.length) {
          // prioritize distributors with storefronts
          const resultsDataThirdFilter = resultsDataFiltered.filter((item) => item.distributor_storefront !== "null");
          if (resultsDataThirdFilter.length) {
            resultsDataFiltered = resultsDataThirdFilter;
          }
        }
      }

      // randomly pick from filtered distributors
      if (resultsDataFiltered.length) {
        const randomIndex = Math.floor(Math.random() * resultsDataFiltered.length);
        const match = resultsDataFiltered[randomIndex];

        matchData = {
          coverage: true,
          ...match,
        };
      }

      return matchData;
    }

    getStoredZipLocatorData() {
      const storedZip = localStorage.getItem(ZIP_CODE_STORAGE_KEY);
      const storedMatch = localStorage.getItem(CONSULTANT_MATCH_STORAGE_KEY);
      const storedViewed = localStorage.getItem(ZIP_LOCATOR_VIEWED_STORAGE_KEY);
      const zipCode = JSON.parse(storedZip);
      const match = JSON.parse(storedMatch);
      const viewed = JSON.parse(storedViewed);

      window.zipLocator.zip = zipCode;
      window.zipLocator.match = match;
      window.zipLocator.viewed = viewed;

      document.dispatchEvent(new CustomEvent("theme:locator:update"));
    }

    storeZipLocatorData(zip, matchData) {
      const zipCode = zip ? parseFloat(zip) : null;
      var match = null;
      // construct match storage object
      if (matchData) {
        match = {
          id: matchData.id,
          zip: matchData.zip,
          coverage: matchData.coverage,
          usercode: matchData.usercode,
          phone: matchData.phone,
          name: matchData.name,
          image: null,
          delivery: matchData.delivery,
          type: matchData.type,
          storefront: matchData.storefront !== "null" ? matchData.storefront : null,
          delivery_guarantee_day: matchData.delivery_guarantee_day
        };
      }

      localStorage.setItem(ZIP_CODE_STORAGE_KEY, zipCode);
      localStorage.setItem(CONSULTANT_MATCH_STORAGE_KEY, JSON.stringify(match));
      window.zipLocator.zip = zipCode;
      window.zipLocator.match = match;

      document.dispatchEvent(new CustomEvent("theme:locator:update"));
    }

    storeZipLocatorViewed() {
      const viewed = true;

      localStorage.setItem(ZIP_LOCATOR_VIEWED_STORAGE_KEY, viewed);
      window.zipLocator.viewed = viewed;

      document.dispatchEvent(new CustomEvent("theme:locator:update"));
    }

    getCheckoutRedirectZipLocatorData() {
      const extensionStorage = localStorage.getItem("extensionStorage");
      if (extensionStorage) {
        const extensionStorageObj = JSON.parse(extensionStorage);
        const key = Object.keys(extensionStorageObj).find((key) =>
          key.includes(CHECKOUT_REDIRECT_ZIP_LOCATOR_STORAGE_KEY)
        );
        if (key) {
          this.redirected = true;

          localStorage.setItem(ZIP_CODE_STORAGE_KEY, extensionStorageObj[key]);
          localStorage.setItem(CONSULTANT_MATCH_STORAGE_KEY, null);
          window.zipLocator.zip = extensionStorageObj[key];
          window.zipLocator.match = null;

          document.dispatchEvent(new CustomEvent("theme:locator:update"));

          delete extensionStorageObj[key];
          window.localStorage.setItem("extensionStorage", JSON.stringify(extensionStorageObj));
        }
      }
    }

    async locationLookup(zipCode) {
      const url = `${this.geocodeBaseURL}address=${zipCode}&components=country:MX&sensor=true&key=${this.key}`;

      await axios
        .get(url)
        .then((response) => {
          var results = response.data.results;
          if (results.length) {
            this.location.lat = results[0].geometry?.location?.lat;
            this.location.long = results[0].geometry?.location?.lng;

            var addressComponents = results[0].address_components;
            addressComponents.forEach((addressComponent) => {
              if (!location.city && addressComponent.types.includes("locality")) {
                this.location.city = addressComponent.long_name;
              }
              if (!location.state & addressComponent.types.includes("administrative_area_level_1")) {
                this.location.state = addressComponent.short_name;
              }
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    renderMatchedConsultant() {
      const match = window.zipLocator.match;
      if (!match) return;

      if (match.name) {
        if(window.theme.storefront_partner){
          this.matchNameElStorefront.textContent = match.name;
          this.matchNameElStorefront.classList.remove(classes$5.hide);
          if (window.zipLocator.zip) {
            this.matchZipElStorefront.textContent = window.zipLocator.zip;
            this.matchZipElStorefront.parentElement.classList.remove(classes$5.hide);
          }
        }
        else{
          this.matchNameEl.textContent = match.name;
          this.matchNameEl.classList.remove(classes$5.hide);
          if (window.zipLocator.zip) {
            this.matchZipEl.textContent = window.zipLocator.zip;
            this.matchZipEl.parentElement.classList.remove(classes$5.hide);
          }
        }
      }
      if (match.image) {
        this.matchImageEl.src = match.image;
      }
    }

    renderState(prev, curr) {
      this.content.classList.remove(prev);
      this.content.classList.add(curr);
      this.content.setAttribute(selectors$W.content, curr);
    }

    renderToast() {
      // success state
      if (this.toast) {
        setTimeout(() => {
          this.toast.classList.add("is-visible");
        }, times.loadingDelay);
        setTimeout(() => {
          this.toast.classList.remove("is-visible");
        }, 5000);
      }
    }

    openModal() {
      if (this.openTrigger) {
        setTimeout(() => {
          this.openTrigger.click();
        }, times.loadingDelay);
      }
    }

    closeModal() {
      if (this.closeTrigger) {
        setTimeout(() => {
          this.closeTrigger.click();
        }, times.loadingDelay);
      }
    }

    closeDrawer() {
      this.drawers.forEach((drawer) => {
        if (drawer.classList.contains(classes$n.isVisible)) {
          drawer.dispatchEvent(
            new CustomEvent("theme:drawer:close", {
              bubbles: false,
            })
          );
        }
      });
    }
  }

  const zipLocator = {
    onLoad() {
      const wrappers = document.querySelectorAll(selectors$W.modal);
      wrappers.forEach((wrapper) => {
        new ZipLocator(wrapper);
      });
    },
  };

  const CONSULTANT_REFERRAL_STORAGE_KEY = "CONSULTANT_REFERRAL_STORAGE_KEY";

  class PartnerReferral {
    constructor() {
      this.referral = {
        usercode: null,
        name: null
      }

      this.init();
      this.listen();
    }

    init() {
      this.getStoredReferralPartnerData();
      this.setReferralVariable();
    }

    listen() {
      document.addEventListener("theme:locator:update", this.storeReferralPartner.bind(this));
      document.addEventListener("theme:partner:set", this.storeReferralPartner.bind(this));
    }

    storeReferralPartner() {
      if (theme.referral_partner) {
        // if pref partner does not have coverage
        if (window.zipLocator.match?.usercode !== theme.referral_partner?.betterwarePlusId) {
          this.referral.usercode = theme.referral_partner?.betterwarePlusId;
          this.referral.name = theme.referral_partner?.displayName;
        } else {
          this.referral.usercode = null;
          this.referral.name = null;
        }
      }
      // clear referral partner if on storefront
      if (theme.storefront_partner) {
        this.referral.usercode = null;
        this.referral.name = null;
      }

      this.storeReferralPartnerData(this.referral);
    }

    getStoredReferralPartnerData() {
      const storedReferral = localStorage.getItem(CONSULTANT_REFERRAL_STORAGE_KEY);
      const referral = JSON.parse(storedReferral);

      window.zipLocator.referral = referral;
    }

    storeReferralPartnerData(referral) {
      localStorage.setItem(CONSULTANT_REFERRAL_STORAGE_KEY, JSON.stringify(referral));

      window.zipLocator.referral = referral;
    }

    setReferralVariable() {
      this.referral.usercode = window.zipLocator.referral?.usercode || null;
      this.referral.name = window.zipLocator.referral?.name || null;
    }
  }

  const partnerReferral = {
    onLoad() {
      new PartnerReferral();
    },
  };

  const sections$p = [];

  class PartnerSearch {
    static selectors = {
      outer: "[data-distributor-search-holder]",
      form: "[data-distributor-search-form]",
      radio: "[data-distributor-search-radio]",
      input: "[data-distributor-search-input]",
      submit: "[data-distributor-search-submit]",
      error: "[data-error-type]",
      success: "[data-success-type]",
      referralName: "[data-referral-name]"
    };

    constructor(holder) {
      this.outer = holder;
      this.form = this.outer.querySelector(PartnerSearch.selectors.form);
      this.radios = this.outer.querySelectorAll(PartnerSearch.selectors.radio);
      this.input = this.form.querySelector(PartnerSearch.selectors.input);
      this.submit = this.form.querySelector(PartnerSearch.selectors.submit);
      this.errors = this.form.querySelectorAll(PartnerSearch.selectors.error);
      this.successes = this.form.querySelectorAll(PartnerSearch.selectors.success);

      this.repository = new Repository();
      this.zipLocator = new ZipLocator();
      this.partnerReferral = new PartnerReferral();

      this.init();
    }

    init() {
      this.initFormInput();

      this.submit.addEventListener("click", this.onFormSubmit.bind(this));

      if (!this.radios.length) return;
      this.initFormRadios();
    }

    initFormInput() {
      if (window.zipLocator.referral?.usercode) {
        this.input.value = window.zipLocator.referral?.usercode;
      }
    }

    initFormRadios() {
      if (window.zipLocator.referral?.usercode) {
        this.checkRadio("true");
        this.input.parentElement.classList.remove(classes$5.hide);
      } else {
        this.checkRadio("false");
        this.input.parentElement.classList.add(classes$5.hide);
      }

      this.radios.forEach((radio) => {
        radio.addEventListener("change", this.onRadioChange.bind(this));
      });
    }

    onRadioChange(evt) {
      const target = evt.currentTarget;
      if (target.value === "true") {
        this.input.parentElement.classList.remove(classes$5.hide);
      } else {
        this.input.parentElement.classList.add(classes$5.hide);
      }
    }

    async onFormSubmit() {
      this.hideErrors();
      this.hideSuccess();

      let value = this.input.value;
      if (!value || value === "") return;

      this.submit.classList.add(classes$i.loading);

      try {
        const partner = await this.repository.getPartnerByID(value);
        if (!partner) throw new Error("no-result");

        theme.referral_partner = partner;
        await this.zipLocator.reload();

        if (window.zipLocator.match?.usercode === theme.referral_partner?.betterwarePlusId) {
          this.submit.classList.remove(classes$i.loading);
          this.submit.classList.add(classes$i.success);

          setTimeout(() => {
            this.submit.classList.remove(classes$i.success);
          }, 1500);

          this.showSuccess("rd-has-coverage");

          if (window.zipLocator.match.storefront) {
            setTimeout(() => (window.location.href = `/${window.zipLocator.match.storefront}`), 1000);
          }
        } else {
          this.partnerReferral.storeReferralPartner();

          this.submit.classList.remove(classes$i.loading);
          this.submit.classList.add(classes$i.success);

          setTimeout(() => {
            this.submit.classList.remove(classes$i.success);
          }, 1500);

          this.showSuccess("rd-no-coverage");

          const partnerHasStorefront = partner.tags.find((tag) => tag === "PersonalWebsite") && partner.siteName;
          if (partnerHasStorefront) {
            setTimeout(() => (window.location.href = `/${partner.siteName}`), 1000);
          }
        }
      } catch (e) {
        this.showError("no-result");
        this.submit.classList.remove(classes$i.loading);
      }
    }

    showError(type) {
      this.errors.forEach((error) => {
        if (error.dataset.errorType === type) error.classList.remove("d-none");
        else error.classList.add("d-none");
      });
    }

    showSuccess(type) {
      const referralName = this.getReferralName(type);

      this.successes.forEach((success) => {
        const referralNameElem = success.querySelector(PartnerSearch.selectors.referralName);
        if (referralNameElem && referralName) referralNameElem.textContent = referralName;

        if (success.dataset.successType === type) success.classList.remove("d-none"); 
        else success.classList.add("d-none");
      });
    }

    hideErrors() {
      this.errors.forEach((error) => { error.classList.add("d-none"); });
    }

    hideSuccess() {
      this.successes.forEach((success) => { success.classList.add("d-none"); });
    }

    getReferralName(type) {
      let referralName = null;
      if (type === "rd-no-coverage" && window.zipLocator.referral?.usercode) {
        referralName = window.zipLocator.referral?.usercode; 
      }
      if (type === "rd-has-coverage" && window.zipLocator.match?.usercode) {
        referralName = window.zipLocator.match?.usercode; 
      }

      return referralName;
    }

    checkRadio(value) {
      this.radios.forEach((radio) => {
        if (radio.value === value) radio.checked = true;
        else radio.checked = false;
      });
    }
  }

  const partnerSearch = {
    onLoad() {
      sections$p[this.id] = [];
      const holders = this.container.querySelectorAll(PartnerSearch.selectors.outer);
      holders.forEach((holder) => {
        sections$p[this.id].push(new PartnerSearch(holder));
      });
    },
  };

  register("header", [
    header,
    drawer,
    headerMobileSliderule,
    stickyHeader,
    hoverDisclosure,
    hoverUnderline,
    headerTotals,
    searchPopdown,
    searchResultsGlobal,
    searchDrawer,
    swatchGridSection,
    cartDrawer,
    cartPopdown,
    accordion,
    findYourConsultant,
    partnerSelect,
    partnerReferral,
    partnerSearch,
    zipLocator,
  ]);

  if (!customElements.get("popout-select")) {
    customElements.define("popout-select", PopoutSelect);
  }

  if (!customElements.get("upsell-product")) {
    customElements.define("upsell-product", UpsellProduct);
  }

  if (!customElements.get("radio-swatch")) {
    customElements.define("radio-swatch", RadioSwatch);
  }

  register("sidebar", [drawer]);

  const PARTNER_KEY = `PARTNER-`;

  class Repository {
    constructor() {
      this.baseURL = `https://${HOST_AWS_URL}/Prod`;
      this.accessToken = window?.customer?.accessToken ?? "";
    }

    async setPrefPartner(customerID, partnerSite) {
      const url = `${this.baseURL}/customers/${customerID}/partner`;
      await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ partnerSite }),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
      });
    }

    async removePrefPartner(customerID) {
      const url = `${this.baseURL}/customers/${customerID}/partner`;
      await fetch(url, { method: "DELETE" }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
      });
    }

    async getPartner(partnerSite) {
      const key = `${PARTNER_KEY}${partnerSite}`;
      const cachedPartner = sessionStorage.getItem(key);
      //if (cachedPartner) return JSON.parse(cachedPartner);

      const url = `${this.baseURL}/partners?website=${partnerSite}`;
      return await fetch(url).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        const data = await res.json();
        if (data) sessionStorage.setItem(key, JSON.stringify(data));
        return data;
      });
    }

    async getPartnerByID(partnerId) {
      const url = `${this.baseURL}/partners?plusId=${partnerId}`;
      return await fetch(url).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        const data = await res.json();
        return data;
      });
    }

    async searchPartner(params) {
      const url = new URL(`${this.baseURL}/partners/partner-search`);
      Object.entries(params).forEach(([key, value]) => url.searchParams.append(key, value));
      return await fetch(url).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        const data = await res.json();
        return data;
      });
    }

    async addFeaturedProduct(productID, customerID, feedback) {
      const url = `${this.baseURL}/partners/${customerID}/featured_product`;
      await fetch(url, {
        method: "POST",
        body: JSON.stringify({ productID, feedback }),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
      });
    }

    async getProductFeedback(productID, partnerSite) {
      const url = `${this.baseURL}/partners/feedback?productID=${productID}&website=${partnerSite}`;
      return await fetch(url).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
        return res.json();
      });
    }

    async getProducts(partnerSite) {
      const url = `${this.baseURL}/partners/featured_products?website=${partnerSite}`;
      return await fetch(url).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
        return res.json();
      });
    }

    async deleteFeaturedProduct(metafieldKey, customerID) {
      const url = `${this.baseURL}/partners/${customerID}/featured_product`;
      await fetch(url, {
        method: "DELETE",
        body: JSON.stringify({ metafieldKey }),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
      });
    }

    async editFeaturedProduct(metafieldKey, customerID, feedback) {
      const url = `${this.baseURL}/partners/${customerID}/featured_product`;
      await fetch(url, {
        method: "PUT",
        body: JSON.stringify({ metafieldKey, feedback }),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
      });
    }

    async reorderFeaturedProduct(customerID, newOrder) {
      const url = `${this.baseURL}/partners/${customerID}/featured_product_reorder`;
      await fetch(url, {
        method: "PUT",
        body: JSON.stringify({ newOrder }),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
      });
    }

    /**
     * Get URL to upload image to S3
     * @param {File} file
     */
    async getImageUploadURL(file) {
      const url = new URL(`${this.baseURL}/partners/image_upload`);
      url.searchParams.append("size", file.size);
      url.searchParams.append("type", file.type);

      return await fetch(url).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
        return res.json();
      });
    }

    async setImageAsProfile(customerID, imageURL) {
      const url = `${this.baseURL}/partners/${customerID}/profile_image`;
      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify({ imageURL }),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setPassword(customerID, password, confirmPassword) {
      const url = `${this.baseURL}/customers/${customerID}/password`;
      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify({ password, confirmPassword }),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setPassword(customerID, password, confirmPassword) {
      const url = `${this.baseURL}/customers/${customerID}/password`;
      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify({ password, confirmPassword }),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setName(customerID, firstName, lastName) {
      const url = `${this.baseURL}/partners/${customerID}/name`;
      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify({ customerID, firstName, lastName }),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setNickname(customerID, nickname) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;
      let data = {
        namespace: "partner",
        key: "nickname",
        value: nickname,
        type: "single_line_text_field",
      };
      return await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            console.log(text);
            throw new Error(text);
          });
        return res.json();
      });
    }

    async setPhone(customerID, phone) {
      const url = `${this.baseURL}/partners/${customerID}/phone`;
      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify({ customerID, phone }),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setSiteInfo(customerID, data) {
      const url = `${this.baseURL}/partners/${customerID}/siteinfo`;
      return await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    //set bettershiping to DS
    async setPersonalDeliveredInfo(customerID, bettershipingValue) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;
      let data = {
        namespace: "partner",
        key: "personal_delivery",
        value: bettershipingValue,
        type: "boolean",
      };
      return await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
        return res.json();
      });
    }

    //set cashOnDelivery to DS
    async setCashOnDeliveryInfo(customerID, cashOnDeliveryValue) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;
      let data = {
        namespace: "partner",
        key: "use_cash_on_delivery",
        value: cashOnDeliveryValue,
        type: "boolean",
      };
      return await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error("error de COD ", text);
          });
        return res.json();
      });
    }

    async setFacebook(customerID, facebook) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;

      let data = {
        namespace: "partner",
        key: "facebook",
        value: facebook,
        type: "single_line_text_field",
      };

      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setLastUpdateDelivery(customerID, time) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;

      let data = {
        namespace: "partner",
        key: "last_update_delivery",
        value: time,
        type: "single_line_text_field",
      };

      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setInstagram(customerID, instagram) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;

      let data = {
        namespace: "partner",
        key: "instagram",
        value: instagram,
        type: "single_line_text_field",
      };

      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setTiktok(customerID, tiktok) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;

      let data = {
        namespace: "partner",
        key: "tiktok",
        value: tiktok,
        type: "single_line_text_field",
      };

      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setTwitter(customerID, twitter) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;

      let data = {
        namespace: "partner",
        key: "twitter",
        value: twitter,
        type: "single_line_text_field",
      };

      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setYoutube(customerID, youtube) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;

      let data = {
        namespace: "partner",
        key: "youtube",
        value: youtube,
        type: "single_line_text_field",
      };

      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setUrlVideo(customerID, url_video) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;

      let data = {
        namespace: "partner",
        key: "url_video",
        value: url_video,
        type: "single_line_text_field",
      };

      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setContactMethodPref(customerID, contact_method) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;

      let data = {
        namespace: "partner",
        key: "preferred_contact_method",
        value: contact_method,
        type: "single_line_text_field",
      };

      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setSelectedBanners(customerID, selected_banners) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;

      let data = {
        namespace: "partner",
        key: "selected_banners",
        value: selected_banners,
        type: "single_line_text_field",
      };

      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async setSelectedHeaderColor(customerID, selectedHeaderColor) {
      const url = `${this.baseURL}/partners/${customerID}/metafield`;

      let data = {
        namespace: "partner",
        key: "selected_header_color",
        value: selectedHeaderColor,
        type: "single_line_text_field",
      };

      return await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        return res.json();
      });
    }

    async getProductSearch(searchTerm) {
      return await fetch(
        `/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=30&section_id=dashboard-predictive-search&_t=${Date.now()}`
      ).then((res) => {
        if (!res.ok) {
          return res.text().then((text) => {
            throw new Error(text);
          });
        }

        return res.text();
      });
    }
  }

  const footerSection = {
    onLoad() {
      // Lighthouse fires security warning for the Shopify link.
      var shopifyLink = document.querySelector("[data-powered-link] a");
      if (shopifyLink) {
        shopifyLink.setAttribute("rel", "noopener");
      }
    },
  };

  register("footer", [footerSection, accordion]);

  if (!customElements.get("popout-select")) {
    customElements.define("popout-select", PopoutSelect);
  }

  function isTouch() {
    const isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

    document.documentElement.classList.toggle("supports-touch", isTouch);

    return isTouch;
  }

  isTouch();

  const defaultOptions$1 = {
    cc_load_policy: 1,
    iv_load_policy: 3,
    modestbranding: 1,
    playsinline: 1,
    controls: 1,
    showinfo: 0,
    ecver: 2,
    fs: 1,
    rel: 0,
  };

  function embedYoutube(uniqueKey, options) {
    const playerOptions = {
      ...defaultOptions$1,
      ...options,
    };
    const playerWrapper = document.querySelector(`[data-player="${uniqueKey}"]`);
    const playerElement = playerWrapper.querySelector("iframe, [data-replace]");
    const youtubeKey = playerWrapper.querySelector("[data-video-id]").getAttribute("data-video-id");
    loadScript({ url: "https://www.youtube.com/iframe_api" });
    const playerPromise = window.youtubeLoaderPromise
      .then(function () {
        let player = new window.YT.Player(playerElement, {
          videoId: youtubeKey,
          playerVars: {
            ...playerOptions,
          },
        });
        playerWrapper.addEventListener("pause", function () {
          try {
            if (player.pauseVideo) {
              player.pauseVideo();
            }
          } catch (e) {
            console.warn(e);
          }
        });
        playerWrapper.addEventListener("play-desktop", function () {
          if (!isTouch()) {
            playerWrapper.dispatchEvent(new Event("play"));
          }
        });
        playerWrapper.addEventListener("play", function () {
          try {
            if (player.playVideo) {
              player.playVideo();
            } else {
              player.addEventListener("onReady", function (event) {
                event.target.playVideo();
              });
            }
          } catch (e) {
            console.warn(e);
          }
        });
        playerWrapper.addEventListener("destroy", function () {
          try {
            if (player.destroy) {
              player.destroy();
            }
          } catch (e) {
            console.warn(e);
          }
        });
        return player;
      })
      .catch(function (err) {
        console.error(err);
      });
    return playerPromise;
  }

  window.youtubeLoaderPromise = new Promise((resolve) => {
    window.onYouTubeIframeAPIReady = function () {
      resolve();
    };
  });

  const defaultOptions = {
    autoplay: true,
    loop: true,
    controls: true,
    muted: false,
    playsinline: true,
  };

  function embedVimeo(uniqueKey, options) {
    const playerOptions = {
      ...defaultOptions,
      ...options,
    };
    const playerWrapper = document.querySelector(`[data-player="${uniqueKey}"]`);
    const playerElement = playerWrapper.querySelector("iframe, [data-replace]");
    const vimeoKey = playerWrapper.querySelector("[data-video-id]").getAttribute("data-video-id");
    const loadedPromise = loadScript({
      url: "https://player.vimeo.com/api/player.js",
    });
    const vimeoSelector = `select-${uniqueKey}`;
    playerElement.setAttribute("id", vimeoSelector);
    const returnPlayer = loadedPromise
      .then(function () {
        const player = new window.Vimeo.Player(vimeoSelector, {
          ...playerOptions,
          id: vimeoKey,
        });
        playerWrapper.addEventListener("pause", function () {
          try {
            if (player.pause) {
              player.pause();
            }
          } catch (e) {
            console.warn(e);
          }
        });
        playerWrapper.addEventListener("play-desktop", function () {
          if (!isTouch()) {
            playerWrapper.dispatchEvent(new Event("play"));
          }
        });
        playerWrapper.addEventListener("play", function () {
          if (player.play) {
            player.play();
          }
        });
        playerWrapper.addEventListener("destroy", function () {
          try {
            if (player.destroy) {
              player.destroy();
            }
          } catch (e) {
            //console.log(e);
          }
        });
        return player;
      })
      .catch(function (err) {
        console.error(err);
      });
    return returnPlayer;
  }

  const selectors$n = {
    videoPopup: "[data-video-popup]",
    videoAutoplay: "[data-video-autoplay]",
    attrUnique: "data-unique",
    attrVideoId: "data-video-id",
    attrVideoType: "data-video-type",
    attrPlayer: "data-player",
    urlHash: "data-popup-url-hash",
  };

  class PopupVideo {
    constructor(section) {
      this.container = section.container;
      this.triggers = this.container.querySelectorAll(selectors$n.videoPopup);
      this.backgroundVideo = this.container.querySelector(selectors$n.videoAutoplay);

      this.init();
    }

    init() {
      this.triggers.forEach((trigger) => {
        const unique = trigger.getAttribute(selectors$n.attrUnique);
        const video = trigger.getAttribute(selectors$n.attrVideoId);
        const type = trigger.getAttribute(selectors$n.attrVideoType);
        const urlHash = trigger.getAttribute(selectors$n.urlHash);

        // Find the modal body, which has been moved to the document root
        // and append a unique ID for youtube and vimeo to init players.
        const uniqueKey = `${video}-${unique}`;
        const player = document.querySelector(`[${selectors$n.attrPlayer}="${uniqueKey}"]`);

        // Modal Event Logic:
        // When a modal opens it creates and plays the video
        // When a modal opens it pauses background videos in this section
        // --
        // When a modal closes it destroys the player
        // When a modal closes it plays background videos anywhere on the page
        MicroModal.init({
          onShow: () => {
            if (this.backgroundVideo && typeof this.backgroundVideo.pause === "function") {
              this.backgroundVideo.pause();
            }
            let playerPromise = {};
            if (type === "youtube") {
              playerPromise = embedYoutube(uniqueKey);
            } else if (type === "vimeo") {
              playerPromise = embedVimeo(uniqueKey);
            }
            playerPromise.then(() => {
              player.dispatchEvent(new CustomEvent("play"));
            });
          },
          onClose: (modal, el, event) => {
            event && event.preventDefault();
            player.dispatchEvent(new CustomEvent("destroy"));
            if (this.backgroundVideo && typeof this.backgroundVideo.play === "function") {
              this.backgroundVideo.play();
            }
          },
          openTrigger: `data-trigger-${video}-${unique}`,
        });

        // Auto play if a url hash is set in theme customizer
        const hash = window.location.hash;
        if (hash === urlHash) {
          setTimeout(() => trigger.click(), 1000);
        }
      });
    }
  }

  const popupVideoSection = {
    onLoad() {
      new PopupVideo(this);
    },
  };

  const selectors$m = {
    button: "[data-scroll-down]",
  };

  class ScrollButton {
    constructor(el) {
      this.wrapper = el;
      this.init();
    }

    init() {
      const buttons = this.wrapper.querySelectorAll(selectors$m.button);
      if (buttons) {
        buttons.forEach((btn) => {
          btn.addEventListener("click", this.scroll.bind(this));
        });
      }
    }

    scroll() {
      const bottom = this.wrapper.offsetTop + this.wrapper.clientHeight;
      window.scroll({
        top: bottom,
        left: 0,
        behavior: "smooth",
      });
    }
  }

  const scrollButton = {
    onLoad() {
      this.scrollButton = new ScrollButton(this.container);
    },
    onUnload: function () {
      delete this.scrollButton;
    },
  };

  register("video", [parallaxImage, scrollButton, popupVideoSection]);

  register("page-faq", accordion);

  register("hero", [parallaxImage, scrollButton]);

  const selectors$l = {
    slider: "[data-slider]",
    photo: "[data-grid-slide]",
    scroll: "[data-grid-scrollbar]",
    scroll_handle: ".flickity-grid-slider__handle",
    dot: ".dot",
    prevnext_btn: ".flickity-prev-next-button",
    message_wrapper: "[data-message-wrapper]",
    messages: "[data-product-message]",
  };

  const attributes = {
    showDots: "data-show-dots",
    singleCell: "data-single-cell",
    scrollByOne: "data-scroll-by-one",
    excessScroll: "data-excess-scroll",
    messageIndex: "data-product-message",
    hideArrow: "data-hide-arrow",
    cellAlign: "data-cell-align",
    wrapAround: "data-wrap-around",
    autoplay: "data-autoplay",
    selectOnClick: "data-select-on-click",
    gridLarge: "data-grid-large",
  };

  const sections$8 = {};

  class SliderMessage {
    constructor(el, flkty) {
      this.messageWrapper = el;
      this.flkty = flkty;

      this.flkty.on("change", (index) => this.showByIndex(index));
    }

    showByIndex(index) {
      this.messages = this.messageWrapper.querySelectorAll(selectors$l.messages);
      this.messages.forEach((message) => {
        const messageIndex = parseInt(message.getAttribute(attributes.messageIndex));
        if (messageIndex === index) {
          message.classList.add("active");
          setTimeout(() => message.classList.add("fade"), 0);
        } else {
          message.classList.remove("fade");
          message.classList.remove("active");
        }
      });
    }
  }

  class FlickityScroll {
    constructor(el, flkty) {
      this.slideshow = el;
      this.flickityElem = this.slideshow.querySelector(".flickity-enabled");
      this.flkty = flkty;
      this.scrollBar = this.slideshow.querySelector(selectors$l.scroll);
      this.scrollBarHandle = this.scrollBar.querySelector(selectors$l.scroll_handle);
      this.dots = this.slideshow.querySelectorAll(selectors$l.dot);
      this.prevNextBtns = this.slideshow.querySelectorAll(selectors$l.prevnext_btn);

      this.excessScroll = this.flickityElem.getAttribute(attributes.excessScroll) === "true";

      this.renderedSlides = this.flickityElem.getAttribute(attributes.gridLarge) || 4;

      this.isDragged = false;

      this.initScrollHandle();
      this.initEventHandlers();
    }

    refresh() {
      this.dots = this.slideshow.querySelectorAll(selectors$l.dot);
      this.prevNextBtns = this.slideshow.querySelectorAll(selectors$l.prevnext_btn);

      this.excessScroll = this.flickityElem.getAttribute(attributes.excessScroll) === "true";

      this.isDragged = false;

      this.initScrollHandle();
    }

    updateByProgress(progress) {
      const barWidth = this.scrollBar.getBoundingClientRect().width;
      const handleWidth = this.scrollBarHandle.getBoundingClientRect().width;
      const offset = barWidth - handleWidth;
      let xCoord = offset * progress;

      xCoord = Math.min(offset, xCoord);

      if (!this.isDragged) this.scrollBarHandle.style.left = `${xCoord}px`;
    }

    initEventHandlers() {
      document.addEventListener("theme:tab:change", () => this.refresh());
      document.addEventListener("theme:resize", () => this.refresh());
      this.flkty.on("scroll", (progress) => this.updateByProgress(progress));
    }

    initScrollHandle() {
      // Verify if all elements exists and the slider is visible
      const isAllElemExists = this.dots && this.slideshow && this.scrollBar;
      const isRendered = this.flickityElem && this.flickityElem.offsetWidth > 0;
      if (!isAllElemExists || !isRendered) return;

      const isMobile = window.matchMedia(`(max-width: ${window.theme.sizes.medium - 1}px)`).matches;
      const dotWidth = this.dots[0].offsetWidth;
      const handleWidth = dotWidth * (isMobile || this.excessScroll ? 1 : this.renderedSlides);
      this.scrollBarHandle.style.width = `${handleWidth}px`;

      // Hide if there are not enough slides
      const isOnePage = handleWidth >= this.scrollBar.getBoundingClientRect().width;
      if (isOnePage) {
        this.scrollBar.style.display = "none";
        this.dots.forEach((dot) => (dot.style.display = "none"));
        return;
      }

      this.scrollBarHandle.onmousedown = (event) => {
        this.isDragged = true;

        // Instances
        const scrollbar = this.scrollBar;
        const handle = this.scrollBarHandle;
        const totalSlides = this.dots.length;
        const flkty = this.flkty;
        const excessScroll = this.excessScroll;

        // Offsets
        const max = scrollbar.getBoundingClientRect().width - handle.getBoundingClientRect().width;
        const clickShiftX = event.clientX - handle.getBoundingClientRect().left;
        let shiftX = scrollbar.getBoundingClientRect().left + clickShiftX;

        moveAt(event.pageX);

        // moves the scrollbar at pageX coordinates
        // taking initial shifts into account
        function moveAt(pageX) {
          let xCoord = pageX - shiftX;
          xCoord = Math.max(0, xCoord);
          xCoord = Math.min(max, xCoord);
          handle.style.left = `${xCoord}px`;
        }

        function onMouseMove(event) {
          moveAt(event.pageX);

          const handleCoord = handle.getBoundingClientRect().left - scrollbar.getBoundingClientRect().left;
          const barWidth = scrollbar.getBoundingClientRect().width;

          // Select slide at the correct index
          const rawIndex = (totalSlides * handleCoord) / barWidth;
          const index = Math.floor(Math.round(rawIndex * 100) / 100);
          flkty.select(index);
        }

        // move the scrollBar on mousemove
        document.addEventListener("mousemove", onMouseMove);

        // drop the scrollBar, remove unneeded handlers
        document.onmouseup = () => {
          document.removeEventListener("mousemove", onMouseMove);
          document.onmouseup = null;
          setTimeout(() => (this.isDragged = false), 1000);
        };
      };
    }
  }

  class Slider {
    constructor(container, el) {
      this.container = container;
      this.slideshow = el;

      this.pageDots = this.slideshow.getAttribute(attributes.showDots) === "true";
      this.singleCell = this.slideshow.getAttribute(attributes.singleCell) === "true";
      this.scrollByOne = this.slideshow.getAttribute(attributes.scrollByOne) === "true";
      this.excessScroll = this.slideshow.getAttribute(attributes.excessScroll) === "true";
      this.hideArrow = this.slideshow.getAttribute(attributes.hideArrow) === "true";
      this.cellAlign = this.slideshow.getAttribute(attributes.cellAlign) || "left";
      this.wrapAround = this.slideshow.getAttribute(attributes.wrapAround) === "true";
      this.autoplay = parseInt(this.slideshow.getAttribute(attributes.autoplay)) || false;
      this.selectOnClick = this.slideshow.getAttribute(attributes.selectOnClick) === "true";
      this.firstPhoto = this.container.querySelector(selectors$l.photo);
      if (this.firstPhoto) {
        const buttonOffset = this.firstPhoto.offsetHeight / 2;
        this.slideshow.style.setProperty("--buttons-top", `${buttonOffset}px`);
      }

      if (!this.slideshow) return;

      this.flkty = null;
      this.flktyScroll = null;

      this.init();
    }

    init() {
      const instance = this;
      const sliderOptions = {
        initialIndex: 0,
        accessibility: true,
        autoPlay: this.autoplay,
        pauseAutoPlayOnHover: true,
        contain: !this.excessScroll,
        pageDots: this.pageDots,
        adaptiveHeight: false,
        wrapAround: this.wrapAround,
        groupCells: !this.singleCell,
        cellAlign: this.cellAlign,
        freeScroll: !this.scrollByOne,
        prevNextButtons: !this.hideArrow,
        draggable: true,
        rightToLeft: window.isRTL,
        dragThreshold: 20,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 65,
          y2: 45,
          x3: 20,
        },
        on: {
          ready: function () {
            instance.removeIncorrectAria();
          },
        },
      };

      this.flkty = new Flickity(this.slideshow, sliderOptions);

      this.container.addEventListener("theme:tab:change", () => this.flkty.resize());
      document.addEventListener("theme:resize", () => this.flkty.resize());
      document.addEventListener("theme:partner:render", () => this.flkty.resize());

      if (this.selectOnClick) this.flkty.on("staticClick", (_, __, ___, cellIndex) => this.flkty.select(cellIndex));

      const isScrollbarExist = this.container.querySelector(selectors$l.scroll);
      if (isScrollbarExist) this.flktyScroll = new FlickityScroll(this.slideshow.parentElement, this.flkty);
    }

    refreshFlktyScroll() {
      this.flktyScroll && this.flktyScroll.refresh();
    }

    removeIncorrectAria() {
      const slidesHidden = this.slideshow.querySelectorAll('[aria-hidden="true"]');
      slidesHidden.forEach((el) => el.removeAttribute("aria-hidden"));
    }

    onUnload() {
      if (this.slideshow && this.flkty) {
        this.flkty.options.watchCSS = false;
        this.flkty.destroy();
      }
    }
  }

  const productSliderSection = {
    onLoad() {
      sections$8[this.id] = [];
      const els = this.container.querySelectorAll(selectors$l.slider);
      els.forEach((el) => {
        sections$8[this.id].push(new Slider(this.container, el));
      });
    },
    onUnload(e) {
      sections$8[this.id].forEach((el) => {
        if (typeof el.onUnload === "function") {
          el.onUnload(e);
        }
      });
    },
  };

  register("custom-content", [parallaxImage, popupVideoSection, swatchGridSection, productSliderSection]);

  if (!customElements.get("radio-swatch")) {
    customElements.define("radio-swatch", RadioSwatch);
  }

  const sections$7 = [];
  const selectors$k = {
    wrapper: "[data-slideshow-wrapper]",
    speed: "data-slideshow-speed",
    autoplay: "data-slideshow-autoplay",
    slideCount: "data-slideshow-slides",
    prevButton: "[data-slide-custom-prev]",
    nextButton: "[data-slide-custom-next]",
  };

  const classes$d = {
    isEnable: "flickity-enabled",
  };

  class Slideshow {
    constructor(section) {
      this.container = section.container;
      this.wrapper = section.container.querySelector(selectors$k.wrapper);
      if (!this.wrapper) return;
      this.speed = this.wrapper.getAttribute(selectors$k.speed);
      this.autoplay = this.wrapper.getAttribute(selectors$k.autoplay) === "true";
      this.slideCount = parseInt(this.wrapper.getAttribute(selectors$k.slideCount), 10);
      this.prevButtons = this.wrapper.querySelectorAll(selectors$k.prevButton);
      this.nextButtons = this.wrapper.querySelectorAll(selectors$k.nextButton);
      this.flkty = null;
      this.init();
      this.listen();
    }

    listen() {
      this.wrapper.addEventListener("theme:slideshow:resize", () => {
        this.flkty.resize();
      });
    }

    init() {
      const settings = {
        autoPlay: this.autoplay && this.speed ? parseInt(this.speed) : false,
        contain: true,
        pageDots: false,
        adaptiveHeight: true,
        accessibility: true,
        wrapAround: true,
        prevNextButtons: true,
        draggable: true,
        fade: true,
        rightToLeft: window.isRTL,
      };
      this.flkty = new FlickityFade(this.wrapper, settings);

      if (this.prevButtons.length) {
        this.prevButtons.forEach((e) => {
          e.onclick = () => {
            this.flkty.previous(true, false);
          };
        });
      }
      if (this.nextButtons.length) {
        this.nextButtons.forEach((e) => {
          e.onclick = () => {
            this.flkty.next(true, false);
          };
        });
      }

      this.reload();
    }

    unload() {
      if (this.flkty && this.wrapper && this.wrapper.classList.contains(classes$d.isEnable)) {
        this.flkty.destroy();
      }
    }

    onBlockSelect(evt) {
      const indexEl = evt.target.closest("[data-slideshow-index]");
      const slideIndex = indexEl.getAttribute("data-slideshow-index");
      const select = parseInt(slideIndex);
      this.flkty.selectCell(select);
      this.flkty.stopPlayer();
    }

    onBlockDeselect() {
      if (this.autoplay) {
        this.flkty.playPlayer();
      }
    }

    reload() {
      this.wrapper.addEventListener("theme:slideshow:reload", () => {
        this.unload();
        this.init();
      });
    }
  }

  const slideshowSection = {
    onLoad() {
      sections$7[this.id] = new Slideshow(this);
    },
    onSelect(e) {
      preventOverflow(e.target);
    },
    onUnload() {
      if (typeof sections$7[this.id].unload === "function") {
        sections$7[this.id].unload();
      }
    },
    onBlockSelect(evt) {
      if (typeof sections$7[this.id].onBlockSelect === "function") {
        sections$7[this.id].onBlockSelect(evt);
      }
    },
    onBlockDeselect(evt) {
      if (typeof sections$7[this.id].onBlockSelect === "function") {
        sections$7[this.id].onBlockDeselect(evt);
      }
    },
  };

  register("slideshow", [slideshowSection, parallaxImage, scrollButton]);

  register("testimonials", [slideshowSection, popupVideoSection]);

  const bentoSection = {
    onLoad() {
      document.addEventListener("theme:partner:render", () => {
        const slideshow = this.container.querySelector(selectors$k.wrapper);
        slideshow?.dispatchEvent(new CustomEvent("theme:slideshow:resize"));
      });
    },
  };

  const selectors$j = {
    rangeSlider: "[data-range-slider]",
    rangeDotLeft: "[data-range-left]",
    rangeDotRight: "[data-range-right]",
    rangeLine: "[data-range-line]",
    rangeHolder: "[data-range-holder]",
    dataMin: "data-se-min",
    dataMax: "data-se-max",
    dataMinValue: "data-se-min-value",
    dataMaxValue: "data-se-max-value",
    dataStep: "data-se-step",
    dataFilterUpdate: "data-range-filter-update",
    priceMin: "[data-field-price-min]",
    priceMax: "[data-field-price-max]",
  };

  const classes$c = {
    classInitialized: "is-initialized",
  };

  class RangeSlider {
    constructor(section) {
      this.container = section.container;
      this.slider = section.querySelector(selectors$j.rangeSlider);

      if (this.slider) {
        this.onMoveEvent = (event) => this.onMove(event);
        this.onStopEvent = (event) => this.onStop(event);
        this.onStartEvent = (event) => this.onStart(event);
        this.startX = 0;
        this.x = 0;

        // retrieve touch button
        this.touchLeft = this.slider.querySelector(selectors$j.rangeDotLeft);
        this.touchRight = this.slider.querySelector(selectors$j.rangeDotRight);
        this.lineSpan = this.slider.querySelector(selectors$j.rangeLine);

        // get some properties
        this.min = parseFloat(this.slider.getAttribute(selectors$j.dataMin));
        this.max = parseFloat(this.slider.getAttribute(selectors$j.dataMax));

        this.step = 0.0;

        // normalize flag
        this.normalizeFact = 26;

        this.init();

        document.addEventListener("theme:reset-price-range", () => {
          this.setDefaultValues();
        });
      }
    }

    init() {
      this.setDefaultValues();

      // link events
      this.touchLeft.addEventListener("mousedown", this.onStartEvent);
      this.touchRight.addEventListener("mousedown", this.onStartEvent);
      this.touchLeft.addEventListener("touchstart", this.onStartEvent);
      this.touchRight.addEventListener("touchstart", this.onStartEvent);

      // initialize
      this.slider.classList.add(classes$c.classInitialized);
    }

    setDefaultValues() {
      // retrieve default values
      let defaultMinValue = this.min;
      if (this.slider.hasAttribute(selectors$j.dataMinValue)) {
        defaultMinValue = parseFloat(this.slider.getAttribute(selectors$j.dataMinValue));
      }
      let defaultMaxValue = this.max;

      if (this.slider.hasAttribute(selectors$j.dataMaxValue)) {
        defaultMaxValue = parseFloat(this.slider.getAttribute(selectors$j.dataMaxValue));
      }

      // check values are correct
      if (defaultMinValue < this.min) {
        defaultMinValue = this.min;
      }

      if (defaultMaxValue > this.max) {
        defaultMaxValue = this.max;
      }

      if (defaultMinValue > defaultMaxValue) {
        defaultMinValue = defaultMaxValue;
      }

      if (this.slider.getAttribute(selectors$j.dataStep)) {
        this.step = Math.abs(parseFloat(this.slider.getAttribute(selectors$j.dataStep)));
      }

      // initial reset
      this.reset();

      // usefull values, min, max, normalize fact is the width of both touch buttons
      this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth;
      this.selectedTouch = null;
      this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact;

      // set defualt values
      this.setMinValue(defaultMinValue);
      this.setMaxValue(defaultMaxValue);
    }

    reset() {
      this.touchLeft.style.left = "0px";
      this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px";
      this.lineSpan.style.marginLeft = "0px";
      this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px";
      this.startX = 0;
      this.x = 0;
    }

    setMinValue(minValue) {
      const ratio = (minValue - this.min) / (this.max - this.min);
      this.touchLeft.style.left =
        Math.ceil(ratio * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px";
      this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px";
      this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px";
      this.slider.setAttribute(selectors$j.dataMinValue, minValue);
    }

    setMaxValue(maxValue) {
      const ratio = (maxValue - this.min) / (this.max - this.min);
      this.touchRight.style.left =
        Math.ceil(
          ratio * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact
        ) + "px";
      this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px";
      this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px";
      this.slider.setAttribute(selectors$j.dataMaxValue, maxValue);
    }

    onStart(event) {
      // Prevent default dragging of selected content
      event.preventDefault();
      let eventTouch = event;

      if (event.touches) {
        eventTouch = event.touches[0];
      }

      if (event.currentTarget === this.touchLeft) {
        this.x = this.touchLeft.offsetLeft;
      } else {
        this.x = this.touchRight.offsetLeft;
      }

      this.startX = eventTouch.pageX - this.x;
      this.selectedTouch = event.currentTarget;
      this.slider.addEventListener("mousemove", this.onMoveEvent);
      this.slider.addEventListener("mouseup", this.onStopEvent);
      this.slider.addEventListener("touchmove", this.onMoveEvent);
      this.slider.addEventListener("touchend", this.onStopEvent);
    }

    onMove(event) {
      let eventTouch = event;

      if (event.touches) {
        eventTouch = event.touches[0];
      }

      this.x = eventTouch.pageX - this.startX;

      if (this.selectedTouch === this.touchLeft) {
        if (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) {
          this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10;
        } else if (this.x < 0) {
          this.x = 0;
        }

        this.selectedTouch.style.left = this.x + "px";
      } else if (this.selectedTouch === this.touchRight) {
        if (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) {
          this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10;
        } else if (this.x > this.maxX) {
          this.x = this.maxX;
        }
        this.selectedTouch.style.left = this.x + "px";
      }

      // update line span
      this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px";
      this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px";

      // write new value
      this.calculateValue();

      // call on change
      if (this.slider.getAttribute("on-change")) {
        const fn = new Function("min, max", this.slider.getAttribute("on-change"));
        fn(this.slider.getAttribute(selectors$j.dataMinValue), this.slider.getAttribute(selectors$j.dataMaxValue));
      }

      this.onChange(
        this.slider.getAttribute(selectors$j.dataMinValue),
        this.slider.getAttribute(selectors$j.dataMaxValue)
      );
    }

    onStop(event) {
      this.slider.removeEventListener("mousemove", this.onMoveEvent);
      this.slider.removeEventListener("mouseup", this.onStopEvent);
      this.slider.removeEventListener("touchmove", this.onMoveEvent);
      this.slider.removeEventListener("touchend", this.onStopEvent);

      this.selectedTouch = null;

      // write new value
      this.calculateValue();

      // call did changed
      this.onChanged(
        this.slider.getAttribute(selectors$j.dataMinValue),
        this.slider.getAttribute(selectors$j.dataMaxValue)
      );
    }

    onChange(min, max) {
      const rangeHolder = this.slider.closest(selectors$j.rangeHolder);
      if (rangeHolder) {
        const priceMin = rangeHolder.querySelector(selectors$j.priceMin);
        const priceMax = rangeHolder.querySelector(selectors$j.priceMax);

        if (priceMin && priceMax) {
          priceMin.value = min;
          priceMax.value = max;
        }
      }
    }

    onChanged(min, max) {
      if (this.slider.hasAttribute(selectors$j.dataFilterUpdate)) {
        this.slider.dispatchEvent(new CustomEvent("range:filter:update", { bubbles: true }));
      }
    }

    calculateValue() {
      const newValue = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let minValue = this.lineSpan.offsetLeft / this.initialValue;
      let maxValue = minValue + newValue;

      minValue = minValue * (this.max - this.min) + this.min;
      maxValue = maxValue * (this.max - this.min) + this.min;

      if (this.step !== 0.0) {
        let multi = Math.floor(minValue / this.step);
        minValue = this.step * multi;

        multi = Math.floor(maxValue / this.step);
        maxValue = this.step * multi;
      }

      if (this.selectedTouch === this.touchLeft) {
        this.slider.setAttribute(selectors$j.dataMinValue, minValue);
      }

      if (this.selectedTouch === this.touchRight) {
        this.slider.setAttribute(selectors$j.dataMaxValue, maxValue);
      }
    }
  }

  const throttle = (fn, wait) => {
    let prev, next;
    return function invokeFn(...args) {
      const now = Date.now();
      next = clearTimeout(next);
      if (!prev || now - prev >= wait) {
        // eslint-disable-next-line prefer-spread
        fn.apply(null, args);
        prev = now;
      } else {
        next = setTimeout(invokeFn.bind(null, ...args), wait - (now - prev));
      }
    };
  };

  const selectors$i = {
    filtersWrappper: "[data-filters]",
    filtersWrappperAttr: "data-filters",
    underlay: "[data-filters-underlay]",
    filtersHideDesktop: "data-default-hide",
    filtersToggle: "data-filters-toggle",
    focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    groupHeading: "data-group-heading",
    showMore: "data-show-more",
  };

  const classes$b = {
    show: "drawer--visible",
    defaultVisible: "filters--default-visible",
    hide: "hidden",
    expand: "is-expanded",
    hidden: "is-hidden",
  };

  const sections$6 = {};

  class Filters {
    constructor(filters) {
      this.container = filters;
      this.underlay = this.container.querySelector(selectors$i.underlay);
      this.groupHeadings = this.container.querySelectorAll(`[${selectors$i.groupHeading}]`);
      this.showMoreButtons = this.container.querySelectorAll(`[${selectors$i.showMore}]`);
      const triggerKey = this.container.getAttribute(selectors$i.filtersWrappperAttr);
      const selector = `[${selectors$i.filtersToggle}='${triggerKey}']`;
      this.filtersToggleButtons = document.querySelectorAll(selector);

      this.connectToggleMemory = (evt) => this.connectToggleFunction(evt);
      this.connectShowHiddenOptions = (evt) => this.showHiddenOptions(evt);

      this.connectToggle();
      this.onFocusOut();
      this.expandingEvents();

      if (this.getShowOnLoad()) {
        this.showFilters();
      } else {
        this.hideFilters();
      }
    }

    unload() {
      if (this.filtersToggleButtons.length) {
        this.filtersToggleButtons.forEach((element) => {
          element.removeEventListener("click", this.connectToggleMemory);
        });
      }

      if (this.showMoreButtons.length) {
        this.showMoreButtons.forEach((button) => {
          button.removeEventListener("click", this.connectShowHiddenOptions);
        });
      }
    }

    expandingEvents() {
      if (this.showMoreButtons.length) {
        this.showMoreButtons.forEach((button) => {
          button.addEventListener("click", throttle(this.connectShowHiddenOptions, 500));
        });
      }
    }

    showHiddenOptions(evt) {
      const element = evt.target.hasAttribute(selectors$i.showMore)
        ? evt.target
        : evt.target.closest(`[${selectors$i.showMore}]`);

      element.classList.add(classes$b.hidden);

      element.previousElementSibling.querySelectorAll(`.${classes$b.hidden}`).forEach((option) => {
        option.classList.remove(classes$b.hidden);
      });
    }

    connectToggle() {
      this.filtersToggleButtons.forEach((button) => {
        button.addEventListener("click", this.connectToggleMemory.bind(this));
      });
    }

    connectToggleFunction(evt) {
      const ariaExpanded = evt.currentTarget.getAttribute("aria-expanded") === "true";
      if (ariaExpanded) {
        this.hideFilters();
      } else {
        this.showFilters();
      }
    }

    onFocusOut() {
      this.container.addEventListener(
        "focusout",
        function (evt) {
          if (window.innerWidth >= window.theme.sizes.medium) {
            return;
          }
          const childInFocus = evt.currentTarget.contains(evt.relatedTarget);
          const isVisible = this.container.classList.contains(classes$b.show);
          const isFocusEnabled = document.body.classList.contains("focus-enabled");
          if (isFocusEnabled && isVisible && !childInFocus) {
            this.hideFilters();
          }
        }.bind(this)
      );

      this.container.addEventListener(
        "keyup",
        function (evt) {
          if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
            return;
          }
          this.hideFilters();
          this.filtersToggleButtons[0].focus();
        }.bind(this)
      );

      this.underlay.addEventListener(
        "click",
        function () {
          this.hideFilters();
        }.bind(this)
      );
    }

    getShowOnLoad() {
      const selector = `[${selectors$i.filtersHideDesktop}='false']`;
      const showOnDesktop = document.querySelector(selector);
      const isDesktop = window.innerWidth >= window.theme.sizes.medium;
      if (showOnDesktop && isDesktop) {
        return true;
      } else {
        return false;
      }
    }

    showFilters() {
      this.container.classList.remove(classes$b.hide);
      // animates after display none is removed
      setTimeout(() => {
        this.filtersToggleButtons.forEach((btn) => btn.setAttribute("aria-expanded", true));
        this.filtersToggleButtons.forEach((btn) => btn.classList.add(classes$b.show));
        this.container.classList.add(classes$b.show);
        this.container.querySelector(selectors$i.focusable).focus();
      }, 1);
    }

    hideFilters() {
      this.filtersToggleButtons.forEach((btn) => btn.setAttribute("aria-expanded", false));
      this.container.classList.remove(classes$b.show);
      this.container.classList.remove(classes$b.defaultVisible);
      this.filtersToggleButtons.forEach((btn) => btn.classList.remove(classes$b.show));
      this.filtersToggleButtons.forEach((btn) => btn.classList.remove(classes$b.defaultVisible));
      // adds display none after animations
      setTimeout(() => {
        if (!this.container.classList.contains(classes$b.show)) {
          this.container.classList.add(classes$b.hide);
        }
      }, 800);
    }
  }

  const collectionFiltersSidebar = {
    onLoad() {
      sections$6[this.id] = [];
      const wrappers = this.container.querySelectorAll(selectors$i.filtersWrappper);
      wrappers.forEach((wrapper) => {
        sections$6[this.id].push(new Filters(wrapper));
      });
    },
    onUnload: function () {
      sections$6[this.id].forEach((filters) => {
        if (typeof filters.unload === "function") {
          filters.unload();
        }
      });
    },
  };

  const selectors$h = {
    collectionSidebar: "[data-collection-sidebar]",
    collectionCount: "[data-collection-count]",
    form: "[data-sidebar-filter-form]",
    inputs: "input, select, label, textarea",
    priceMin: "[data-field-price-min]",
    priceMax: "[data-field-price-max]",
    priceMinValue: "data-field-price-min",
    priceMaxValue: "data-field-price-max",
    rangeMin: "[data-se-min-value]",
    rangeMax: "[data-se-max-value]",
    rangeMinValue: "data-se-min-value",
    rangeMaxValue: "data-se-max-value",
    productsContainer: "[data-products-grid]",
    filterUpdateUrlButton: "[data-filter-update-url]",
    activeFiltersHolder: "[data-active-filters]",
    activeFiltersCount: "[data-active-filters-count]",
    dataSort: "data-sort-enabled",
    collectionTools: "[data-collection-tools]",
    swatch: "[data-swatch]",
    filtersWrappper: "[data-filters]",
    headerSticky: '[data-header-sticky="sticky"]',
    headerHeight: "[data-header-height]",
    gridLarge: "data-grid-large",
    gridSmall: "data-grid-small",
    showMore: "[data-show-more]",
    accordionBody: "[data-accordion-body]",
    checkedOption: "input:checked",
    siblingsInnerHolder: "[data-sibling-inner]",
    loaderImg : ".loaderCollectionsContainer img",
    loader : ".loaderCollections",
    grid : ".collection__products .js-grid",
    currentPagination: ".pagination-custom"
  };

  const classes$a = {
    classHidden: "is-hidden",
    classLoading: "is-loading",
  };

  const times = {
    loadingDelay: 1000,
    scrollTime: 1000,
  };

  class FiltersForm {
    constructor(section) {
      this.section = section;
      this.container = this.section.container;
      this.sidebar = this.container.querySelector(selectors$h.collectionSidebar);
      this.form = section.container.querySelector(selectors$h.form);
      this.sort = this.container.querySelector(`[${selectors$h.dataSort}]`);
      this.productsContainer = this.container.querySelector(selectors$h.productsContainer);
      this.activeFiltersHolder = this.container.querySelector(selectors$h.activeFiltersHolder);
      this.activeFiltersCount = this.container.querySelector(selectors$h.activeFiltersCount);
      this.collectionCount = this.container.querySelector(selectors$h.collectionCount);
      this.headerIsSticky = document.querySelector(selectors$h.headerSticky) !== null;
      this.layoutLarge = this.container.querySelector(`[${selectors$h.gridLarge}]`);
      this.layoutSmall = this.container.querySelector(`[${selectors$h.gridSmall}]`);
      this.loaderImg = this.container.querySelector(selectors$h.loaderImg);
      this.loader = this.container.querySelector(selectors$h.loader);
      this.grid = this.container.querySelector(selectors$h.grid);
      this.currentPagination = this.container.querySelector(selectors$h.currentPagination);

      if (this.productsContainer && this.sidebar) {
        this.init();
      }

      if (this.sort) {
        this.container.addEventListener("theme:filter:form", (e) => this.filtering(e));
      }

      if (this.sidebar || this.sort) {
        window.addEventListener("popstate", (e) => this.filtering(e));
      }
    }

    init() {
      this.showAllOptions();

      if (this.form) {
        new RangeSlider(this.form);

        this.sidebar.addEventListener(
          "input",
          debounce((e) => {
            const type = e.type;
            const target = e.target;

            if (!selectors$h.inputs.includes(type) || !this.form || typeof this.form.submit !== "function") {
              return;
            }

            const priceMin = this.form.querySelector(selectors$h.priceMin);
            const priceMax = this.form.querySelector(selectors$h.priceMax);

            if (priceMin && priceMax) {
              if (target.hasAttribute(selectors$h.priceMinValue) && !priceMax.value) {
                priceMax.value = priceMax.placeholder;
              }

              if (target.hasAttribute(selectors$h.priceMaxValue) && !priceMin.value) {
                priceMin.value = priceMin.placeholder;
              }
            }

            this.filtering(e);
          }, 1500)
        );

        this.form.addEventListener("range:filter:update", (e) => this.updateRange(e));
      }

      if (this.sidebar) {
        this.sidebar.addEventListener("click", (e) => this.updateFilterFromUrl(e));
      }

      if (this.activeFiltersHolder) {
        this.activeFiltersHolder.addEventListener("click", (e) => this.updateFilterFromUrl(e));
      }

      if (this.productsContainer) {
        this.productsContainer.addEventListener("click", (e) => this.updateFilterFromUrl(e));
      }

      document.addEventListener("scroll", () => {
        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 400){
          this.InfiniteScroll();
        }
      });

      // Color swatches tooltips
      new Swapper(this.sidebar);
    }

    /**
     * Update range slider (price money)
     * @param {Object} e
     */
    updateRange(e) {
      if (this.form && typeof this.form.submit === "function") {
        const rangeMin = this.form.querySelector(selectors$h.rangeMin);
        const rangeMax = this.form.querySelector(selectors$h.rangeMax);
        const priceMin = this.form.querySelector(selectors$h.priceMin);
        const priceMax = this.form.querySelector(selectors$h.priceMax);
        const checkElements = rangeMin && rangeMax && priceMin && priceMax;

        if (
          checkElements &&
          rangeMin.hasAttribute(selectors$h.rangeMinValue) &&
          rangeMax.hasAttribute(selectors$h.rangeMaxValue)
        ) {
          const priceMinValue = parseInt(priceMin.placeholder);
          const priceMaxValue = parseInt(priceMax.placeholder);
          const rangeMinValue = parseInt(rangeMin.getAttribute(selectors$h.rangeMinValue));
          const rangeMaxValue = parseInt(rangeMax.getAttribute(selectors$h.rangeMaxValue));

          if (priceMinValue !== rangeMinValue || priceMaxValue !== rangeMaxValue) {
            priceMin.value = rangeMinValue;
            priceMax.value = rangeMaxValue;

            this.filtering(e);
          }
        }
      }
    }

    /**
     * Update filter on last clicked element
     * @param {Object} e
     */
    updateFilterFromUrl(e) {
      const target = e.target;
      if (
        target.matches(selectors$h.filterUpdateUrlButton) ||
        (target.closest(selectors$h.filterUpdateUrlButton) && target)
      ) {
        e.preventDefault();
        const button = target.matches(selectors$h.filterUpdateUrlButton)
          ? target
          : target.closest(selectors$h.filterUpdateUrlButton);
        this.filtering(e, button.getAttribute("href"));
      }
    }

    /**
     * Add filters to history api
     *
     * @param {Object} e
     * @param {String} replaceHref
     */
    addToHistory(e, replaceHref = "") {
      const sortValue = this.sort ? this.sort.getAttribute(selectors$h.dataSort) : "";

      if (!e || (e && e.type !== "popstate")) {
        if (replaceHref === "") {
          const searchParams = new window.URL(window.location.href).searchParams;
          const filterUrlParams = Object.fromEntries(searchParams);
          const filterUrlRemoveString = searchParams.toString();

          if (
            filterUrlRemoveString.includes("filter.") ||
            filterUrlRemoveString.includes("sort_by") ||
            filterUrlRemoveString.includes("page")
          ) {
            for (const key in filterUrlParams) {
              if (key.includes("filter.") || key.includes("sort_by") || key.includes("page")) {
                searchParams.delete(key);
              }
            }
          }

          if (this.form) {
            const formParams = new URLSearchParams(new FormData(this.form));

            for (let [key, val] of formParams.entries()) {
              if (key.includes("filter.") && val) {
                searchParams.append(key, val);
              }
            }
          }

          if (sortValue || (e && e.detail && e.detail.href)) {
            const sortString = sortValue ? sortValue : e.detail.params;
            searchParams.set("sort_by", sortString);
          }

          const filterUrlString = searchParams.toString();
          const filterNewParams = filterUrlString ? `?${filterUrlString}` : location.pathname;
          window.history.pushState(null, "", filterNewParams);

          return;
        }

        window.history.pushState(null, "", replaceHref);
      }
    }
    
    displayLoader(loader, loaderImg){
      if (loader) loader.style.display = 'block';
      if (loaderImg) loaderImg.style.display = 'block';
    }

    hideLoader(loader, loaderImg){
      if (loader) loader.style.display = 'none';
      if (loaderImg) loaderImg.style.display = 'none';
    }


    InfiniteScroll() {
      //this.productsContainer.classList.add(classes$a.classLoading);
      //this.getGridValues();
      const nextPage = document.querySelector('#next-page a');
      if (!nextPage) {
        return;
      }
      try{
        //this.getGridValues();
        let loader = document.querySelector(".loaderCollections");
        let loaderImg = document.querySelector(".loaderCollectionsContainer img");
        this.displayLoader(loader, loaderImg);
        if(localStorage.getItem('loaderCollection') == null) {
          localStorage.setItem('loaderCollection', true)
          fetch(nextPage.href)
            .then((response) => response.text())
            .then((response) => {
              const doc = new DOMParser().parseFromString(response, 'text/html');
              //console.log("pagination", nextPage);
              //console.log("doc", doc.querySelectorAll('.product-grid-item'))
    
              const items = doc.querySelectorAll('.product-grid-item')
              const nextPagination = doc.querySelector('.pagination-custom');
              let currentPagination = document.querySelector('.pagination-custom');
              currentPagination.innerHTML = nextPagination.innerHTML;
              let newGrid = document.querySelector(".collection__products .js-grid");
              items.forEach(element => {
                newGrid.append(element)
              });
              this.refreshFunctionalities();
              this.hideLoader(loader, loaderImg);
          }).catch((error) => { 
            console.log("Error fetching next page:", error);
          }).
          finally(() => {
            localStorage.removeItem('loaderCollection');
          })
        }
    } catch (error) {  
        console.error("Error fetching next page:", error);
    } 
  }



    /**
     * Get filter result and append them to their holders
     */
    getFilterResult() {
      this.productsContainer.classList.add(classes$a.classLoading);
      this.getGridValues();

      fetch(`${window.location.pathname}${window.location.search}`)
        .then((response) => response.text())
        .then((response) => {
          const responseHolder = document.createElement("div");
          responseHolder.innerHTML = response;

          if (this.form) {
            this.form.innerHTML = responseHolder.querySelector(selectors$h.form).innerHTML;
          }

          if (this.activeFiltersCount) {
            this.activeFiltersCount.innerHTML = responseHolder.querySelector(selectors$h.activeFiltersCount).innerHTML;
          }

          if (this.collectionCount) {
            this.collectionCount.innerHTML = responseHolder.querySelector(selectors$h.collectionCount).innerHTML;
          }

          this.productsContainer.innerHTML = responseHolder.querySelector(selectors$h.productsContainer).innerHTML;

          // Show active filters holder
          // this.activeFiltersHolder.innerHTML = responseHolder.querySelector(selectors$h.activeFiltersHolder).innerHTML;
          // this.activeFiltersHolder.classList.toggle(classes$a.classHidden, this.activeFiltersHolder.innerHTML === "");

          this.setGridValues();
          this.refreshFunctionalities();

          setTimeout(() => {
            this.productsContainer.classList.remove(classes$a.classLoading);
          }, times.loadingDelay);
        });
    }

    /**
     * Refresh functionalities
     */
    refreshFunctionalities() {
      // Apply ProductAddButton class to Add to Cart buttons
      let sections$d = {};
      sections$d[this.id] = [];
      const els = this.container.querySelectorAll("[data-add-action-wrapper]");
      els.forEach((el) => {
        sections$d[this.id].push(new ProductAddButton(el));
      });

      // Init range slider
      this.form = this.container.querySelector(selectors$h.form);
      if (this.form) {
        new RangeSlider(this.form);
        this.form.addEventListener("range:filter:update", (e) => this.updateRange(e));
      }

      // Init accordions
      const accordions = this.container.querySelectorAll(selectors$h.accordionBody);
      accordions.forEach((accordion) => {
        new Accordion(accordion);
      });

      // Init siblings
      new Siblings(this.container);

      // Color swatches tooltips
      if (this.sidebar) {
        new Swapper(this.sidebar);
      }

      // Init product swatches
      makeGridSwatches(this.container);
      // Init grid forms
      makeGridForms(this.container);

      this.showAllOptions();
    }

    // Get grid values
    getGridValues() {
      if (this.layoutLarge) {
        this.layoutLargeValue = this.layoutLarge.getAttribute(selectors$h.gridLarge);
      }

      if (this.layoutSmall) {
        this.layoutSmallValue = this.layoutSmall.getAttribute(selectors$h.gridSmall);
      }
    }

    // Set grid values on AJAX
    setGridValues() {
      if (this.layoutLarge) {
        this.layoutLarge = this.container.querySelector(`[${selectors$h.gridLarge}]`);
        this.layoutLarge.setAttribute(selectors$h.gridLarge, this.layoutLargeValue);
      }

      if (this.layoutSmall) {
        this.layoutSmall = this.container.querySelector(`[${selectors$h.gridSmall}]`);
        this.layoutSmall.setAttribute(selectors$h.gridSmall, this.layoutSmallValue);
      }
    }

    // Show all options if in the filter have selected option but it is hidden
    showAllOptions() {
      const checkedOptions = this.container.querySelectorAll(selectors$h.checkedOption);

      checkedOptions.forEach((option) => {
        if (option.parentNode.classList.contains(classes$a.classHidden)) {
          const button = option.closest(selectors$h.accordionBody).nextElementSibling;

          if (!button.classList.contains(selectors$h.classHidden)) {
            button.dispatchEvent(new CustomEvent("click"));
          }
        }
      });
    }

    /**
     * Filtering method and scroll at the top on the section
     * @param {Object} e
     * @param {String} replaceHref
     */
    filtering(e, replaceHref = "") {
      // Scroll to filter tools
      const windowScrollY = window.scrollY || window.pageYOffset;
      const headerH = this.headerIsSticky
        ? document.querySelector(selectors$h.headerHeight).getBoundingClientRect().height
        : 0;
      const collectionTools = this.container.querySelector(selectors$h.collectionTools);
      const scrollToElement = collectionTools.offsetTop - headerH;
      const enableScrollTo =
        collectionTools.offsetTop + collectionTools.getBoundingClientRect().height < windowScrollY - headerH;

      if (enableScrollTo) {
        window.scrollTo({
          top: scrollToElement,
          left: 0,
          behavior: "smooth",
        });
      }

      setTimeout(
        () => {
          this.addToHistory(e, replaceHref);
          this.getFilterResult();
        },
        enableScrollTo ? times.scrollTime : 10
      );
    }
  }

  const collectionFiltersForm = {
    onLoad() {
      this.filterForm = new FiltersForm(this);
    },
    onUnload() {
      if (this.filterForm && typeof this.filterForm.unload === "function") {
        this.filterForm.unload();
      }
    },
  };

  register("search-page", [collectionFiltersSidebar, collectionFiltersForm, swatchGridSection, accordion]);

  if (!customElements.get("popout-select")) {
    customElements.define("popout-select", PopoutSelect);
  }

  if (!customElements.get("radio-swatch")) {
    customElements.define("radio-swatch", RadioSwatch);
  }

  const selectors$g = {
    zoomImage: "[data-image-zoom]",
    attrUnique: "data-unique",
  };

  class GalleryZoom {
    constructor(container) {
      this.triggers = container.querySelectorAll(selectors$g.zoomImage);
      this.init();
    }

    init() {
      this.triggers.forEach((trigger) => {
        const unique = trigger.getAttribute(selectors$g.attrUnique);

        MicroModal.init({
          disableScroll: true,
          openTrigger: `data-popup-${unique}`,
          onShow: (modal) => {
            var images = modal.querySelectorAll("[data-src]", modal);
            images.forEach((image) => {
              if (image.getAttribute("src") === null) {
                const bigImage = image.getAttribute("data-src");
                image.setAttribute("src", bigImage);
              }
            });
          },
          onClose: (modal, el, event) => {
            event && event.preventDefault();
          },
        });
      });
    }
  }

  const galleryZoomSection = {
    onLoad() {
      new GalleryZoom(this.container);
    },
  };

  register("gallery", [galleryZoomSection, popupVideoSection]);

  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  const selectors$f = {
    productMediaWrapper: "[data-product-single-media-wrapper]",
    productSlideshow: "[data-product-slideshow]",
    productXr: "[data-shopify-xr]",
    dataMediaId: "data-media-id",
    dataModelId: "data-model-id",
    modelViewer: "model-viewer",
    dataModel3d: "data-shopify-model3d-id",
    modelJson: "#ModelJson-",
  };

  function initSectionModels(modelViewerContainer, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false,
    };

    const mediaId = modelViewerContainer.getAttribute(selectors$f.dataMediaId);
    const modelViewerElement = modelViewerContainer.querySelector(selectors$f.modelViewer);
    const modelId = modelViewerElement.getAttribute(selectors$f.dataModelId);
    const xrButton = modelViewerContainer
      .closest(selectors$f.productSlideshow)
      .parentElement.querySelector(selectors$f.productXr);
    xrButtons[sectionId] = {
      $element: xrButton,
      defaultId: modelId,
    };

    models[mediaId] = {
      modelId: modelId,
      mediaId: mediaId,
      sectionId: sectionId,
      $container: modelViewerContainer,
      $element: modelViewerElement,
    };

    window.Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: setupShopifyXr,
      },
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: setupModelViewerUi,
      },
    ]);
  }

  function setupShopifyXr(errors) {
    if (errors) {
      console.warn(errors);
      return;
    }
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", function () {
        setupShopifyXr();
      });
      return;
    }

    for (const sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        const modelSection = modelJsonSections[sectionId];
        if (modelSection.loaded) continue;

        const modelJson = document.querySelector(`${selectors$f.modelJson}${sectionId}`);
        if (modelJson) {
          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) {
      console.warn(errors);
      return;
    }

    for (const key in models) {
      if (models.hasOwnProperty(key)) {
        const model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    const xrButton = xrButtons[model.sectionId];

    model.$container.addEventListener("pause", function () {
      if (model.modelViewerUi.pause) {
        model.modelViewerUi.pause();
      }
    });
    model.$container.addEventListener("play-desktop", function () {
      if (model.modelViewerUi.play && !isTouch()) {
        model.modelViewerUi.play();
      }
      if (xrButton && xrButton.$element && model && model.modelId && selectors$f.dataModel3d) {
        xrButton.$element.setAttribute(selectors$f.dataModel3d, model.modelId);
      }
    });
    model.$container.addEventListener("play", function () {
      if (model.modelViewerUi.play) {
        model.modelViewerUi.play();
      }
    });
  }

  async function productNativeVideo(uniqueKey) {
    const playerElement = document.querySelector(`[data-player="${uniqueKey}"]`);
    const videoElement = playerElement.querySelector("video");
    const videoLoad = {
      name: "video-ui",
      version: "1.0",
    };
    await loadScript(videoLoad);

    const player = new window.Shopify.Plyr(videoElement);
    playerElement.addEventListener("pause", function () {
      if (player.pause) {
        player.pause();
      }
    });
    playerElement.addEventListener("play-desktop", function () {
      if (player.play && !isTouch()) {
        playerElement.dispatchEvent(new CustomEvent("play"));
      }
    });
    playerElement.addEventListener("play", function () {
      try {
        if (player.play) {
          player.play();
        } else {
          player.addEventListener("onReady", function (event) {
            event.target.play();
          });
        }
      } catch (e) {
        console.warn(e);
      }
    });
    playerElement.addEventListener("destroy", function () {
      try {
        if (player.destroy) {
          player.destroy();
        }
      } catch (e) {
        console.warn(e);
      }
    });
    return player;
  }

  const selectors$e = {
    holderItems: "[data-custom-scrollbar-items]",
    scrollbar: "[data-custom-scrollbar]",
    scrollbarTrack: "[data-custom-scrollbar-track]",
  };

  const classes$9 = {
    hide: "hide",
  };

  class CustomScrollbar {
    constructor(holder) {
      this.holderItems = holder.querySelector(selectors$e.holderItems);
      this.scrollbar = holder.querySelector(selectors$e.scrollbar);
      this.scrollbarTrack = holder.querySelector(selectors$e.scrollbarTrack);
      this.trackWidth = 0;
      this.scrollWidth = 0;

      if (this.scrollbar && this.holderItems) {
        this.events();
        this.calculateTrackWidth();
      }
    }

    events() {
      this.holderItems.addEventListener("scroll", this.calculatePosition.bind(this));

      document.addEventListener("theme:resize:width", this.calculateTrackWidth.bind(this));
      document.addEventListener("theme:resize:width", this.calculatePosition.bind(this));
    }

    calculateTrackWidth() {
      this.scrollbarWidth =
        this.scrollbar.clientWidth === 0
          ? this.scrollbar.parentNode.getBoundingClientRect().width
          : this.scrollbar.clientWidth;
      setTimeout(() => {
        this.scrollWidth =
          this.holderItems.children.length *
          (this.holderItems.children[0].clientWidth +
            Number(getComputedStyle(this.holderItems.children[0]).marginRight.replace("px", "")) +
            Number(getComputedStyle(this.holderItems.children[0]).marginLeft.replace("px", "")));

        this.trackWidth = (this.scrollbarWidth / this.scrollWidth) * 100;
        this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth;
        this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}%`);
        const hideScrollbar = this.trackWidth >= 100;

        this.scrollbar.classList.toggle(classes$9.hide, hideScrollbar);
      }, 100);
    }

    calculatePosition() {
      let position = this.holderItems.scrollLeft / (this.holderItems.scrollWidth - this.holderItems.clientWidth);
      position *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth;
      position = position < 0 ? 0 : position;
      position = isNaN(position) ? 0 : position;

      this.scrollbar.style.setProperty("--position", `${Math.round(position)}px`);

      document.dispatchEvent(
        new CustomEvent("theme:scrollbar:scroll", {
          bubbles: true,
          detail: {
            holder: this.holderItems,
          },
        })
      );
    }
  }

  const selectors$d = {
    productSlideshow: "[data-product-slideshow]",
    productThumbs: "[data-product-thumbs]",
    productThumbsVertical: "[data-product-thumbs-vertical]",
    thumbsVerticalButtonDown: "[data-thumbs-vertical-button-down]",
    thumbsVerticalButtonUp: "[data-thumbs-vertical-button-up]",
    thumbImage: "[data-slideshow-thumbnail]",
    productImage: "[data-product-image]",
    mediaSlide: "[data-media-slide]",
    dataMediaId: "data-media-id",
    dataMediaSelect: "data-media-select",
    mediaType: "data-type",
    videoPlayerExternal: '[data-type="external_video"]',
    videoPlayerNative: '[data-type="video"]',
    modelViewer: '[data-type="model"]',
    allPlayers: "[data-player]",
    xrButton: "[data-shopify-xr]",
    xrButtonId: "data-shopify-model3d-id",
    loopVideo: "data-enable-video-looping",
    flickitylockHeight: "flickity-lock-height",
    alignment: "data-thumbs-align",
  };

  const classes$8 = {
    flickityDisableClass: "flickity-disabled-mobile",
    flickityEnabled: "flickity-enabled",
    selected: "is-selected",
    active: "is-activated",
  };

  class Media {
    constructor(section) {
      this.section = section;
      this.container = section.container;
      this.slideshow = this.container.querySelector(selectors$d.productSlideshow);
      this.thumbWrapper = this.container.querySelector(selectors$d.productThumbs);
      this.thumbWrapperVertical = this.container.querySelector(selectors$d.productThumbsVertical);
      this.thumbVerticalButtonDown = this.container.querySelector(selectors$d.thumbsVerticalButtonDown);
      this.thumbVerticalButtonUp = this.container.querySelector(selectors$d.thumbsVerticalButtonUp);
      this.thumbImages = this.container.querySelectorAll(selectors$d.thumbImage);
      this.loopVideo = this.container.getAttribute(selectors$d.loopVideo) === "true";
      this.centerAlign = this.container.getAttribute(selectors$d.alignment) === "center";

      this.flkty = null;
      this.flktyThumbs = null;
      this.currentSlide = null;
      this.enableScrollbar = false;

      this.init();
      this.listen();
    }

    init() {
      this.createSlider();
      this.detectVideo();
      this.detectYouTube();
      this.detect3d();
      this.stopSliderThumbs();

      document.addEventListener("theme:resize", () => {
        this.stopSliderThumbs();
      });

      if (this.thumbWrapperVertical) {
        this.setSliderThumbsVertical();
      }
    }

    listen() {
      document.addEventListener("theme:slideshow:init", () => {
        this.slideshow = this.container.querySelector(selectors$d.productSlideshow);
        this.thumbWrapper = this.container.querySelector(selectors$d.productThumbs);
        this.thumbWrapperVertical = this.container.querySelector(selectors$d.productThumbsVertical);
        this.thumbImages = this.container.querySelectorAll(selectors$d.thumbImage);
        this.loopVideo = this.container.getAttribute(selectors$d.loopVideo) === "true";
        this.centerAlign = this.container.getAttribute(selectors$d.alignment) === "center";

        this.flkty = null;
        this.flktyThumbs = null;
        this.currentSlide = null;
        this.enableScrollbar = false;
        this.init();
      });
    }

    setSliderThumbsVertical() {
      const focusImg = this.slideshow.querySelector(selectors$d.mediaSlide);
      this.thumbWrapperVertical.style.maxHeight = focusImg.offsetHeight + "px";

      document.addEventListener(
        "theme:resize",
        function () {
          this.thumbWrapperVertical.style.maxHeight = focusImg.offsetHeight + "px";

          if (this.thumbWrapperVertical.clientHeight < this.thumbWrapperVertical.scrollHeight) {
            this.thumbVerticalButtonDown.parentElement.classList.remove(classes$5.hide);
            this.thumbVerticalButtonUp.parentElement.classList.remove(classes$5.hide);
          } else {
            this.thumbVerticalButtonDown.parentElement.classList.add(classes$5.hide);
            this.thumbVerticalButtonUp.parentElement.classList.add(classes$5.hide);
          }
        }.bind(this)
      );

      // set auto scroll to focus
      this.thumbWrapperVertical.addEventListener(
        "click",
        function () {
          const selectedThumb = this.thumbWrapperVertical.querySelector(".is-activated");
          const scrollY =
            selectedThumb.offsetTop +
            this.thumbWrapperVertical.offsetTop -
            (this.thumbWrapperVertical.offsetHeight - selectedThumb.offsetHeight) / 2;
          this.thumbWrapperVertical.scrollTop = scrollY;
        }.bind(this)
      );

      // set up down arrows
      this.thumbVerticalButtonDown.addEventListener(
        "click",
        function () {
          const scrollY = this.thumbWrapperVertical.offsetHeight;
          this.thumbWrapperVertical.scrollTop = scrollY;
        }.bind(this)
      );

      this.thumbVerticalButtonUp.addEventListener(
        "click",
        function () {
          const scrollY = this.thumbWrapperVertical.offsetTop;
          this.thumbWrapperVertical.scrollTop = scrollY;
        }.bind(this)
      );
    }

    createSlider() {
      if (!this.slideshow) {
        return;
      }

      const instance = this;
      let flickityOptions = {
        autoPlay: false,
        prevNextButtons: false,
        contain: true,
        pageDots: true,
        adaptiveHeight: true,
        accessibility: true,
        wrapAround: true,
        fade: true,
        rightToLeft: window.isRTL,
        on: {
          ready: function () {
            instance.sliderThumbs();
          },
        },
      };

      this.flkty = new FlickityFade(this.slideshow, flickityOptions);
      this.flkty.resize();

      this.currentSlide = this.slideshow.querySelectorAll(selectors$d.mediaSlide)[0];
      this.setDraggable();

      this.flkty.on(
        "change",
        function (index) {
          this.currentSlide.dispatchEvent(new CustomEvent("pause"));
          this.currentSlide = this.flkty.cells[index].element;
          this.slideshow.classList.remove(selectors$d.flickitylockHeight);

          if (this.thumbWrapper === null) return;

          if (this.flktyThumbs !== null && this.thumbWrapper.classList.contains(classes$8.flickityEnabled)) {
            this.flktyThumbs.select(index);
          } else {
            const id = this.currentSlide.getAttribute(selectors$d.dataMediaId);
            const currentThumb = this.thumbWrapper.querySelector(`[${selectors$d.dataMediaSelect}="${id}"]`);

            this.thumbWrapper.querySelector(`.${classes$8.active}`).classList.remove(classes$8.active);
            currentThumb.classList.add(classes$8.active);
          }
        }.bind(this)
      );

      this.flkty.on(
        "settle",
        function (index) {
          this.currentSlide = this.flkty.cells[index].element;
          this.setDraggable();
          this.currentSlide.dispatchEvent(new CustomEvent("play-desktop"));
          const isFocusEnabled = document.body.classList.contains(selectors$d.focusEnabled);
          if (isFocusEnabled) this.currentSlide.dispatchEvent(new Event("focus"));
          this.confirmSync();
        }.bind(this)
      );

      this.eventListeners();
    }

    eventListeners() {
      this.slideshow.addEventListener(
        "theme:image:change",
        function (event) {
          var mediaId = event.detail.id;
          const mediaIdString = `[${selectors$d.dataMediaId}="${mediaId}"]`;
          const matchesMedia = (cell) => {
            return cell.element.matches(mediaIdString);
          };
          const index = this.flkty.cells.findIndex(matchesMedia);
          this.flkty.select(index);
        }.bind(this)
      );

      this.thumbImages.forEach((thumb) => {
        thumb.addEventListener(
          "click",
          function (event) {
            const thumb = event.currentTarget;
            const id = thumb.getAttribute(selectors$d.dataMediaSelect);

            const activedThumb = thumb.parentNode.querySelector(`.${classes$8.active}`);
            if (activedThumb) {
              activedThumb.classList.remove(classes$8.active);
            }
            thumb.classList.add(classes$8.active);
            this.slideshow.dispatchEvent(
              new CustomEvent("theme:image:change", {
                detail: {
                  id: id,
                },
              })
            );
          }.bind(this)
        );
      });
    }

    sliderThumbs() {
      let opts = {
        freeScroll: true,
        draggable: true,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        accessibility: true,
        cellAlign: this.centerAlign ? "center" : "left",
        watchCSS: true,
      };
      this.flktyThumbs = new FlickitySync(this.thumbWrapper, opts);
    }

    confirmSync() {
      if (this.flkty.selectedIndex !== this.flktyThumbs.selectedIndex) {
        this.flkty.resize();
      }
    }

    setDraggable() {
      if (this.currentSlide) {
        const mediaType = this.currentSlide.getAttribute(selectors$d.mediaType);

        if (mediaType === "model" || mediaType === "video" || mediaType === "external_video") {
          // fisrt boolean sets value, second option false to prevent refresh
          this.flkty.options.draggable = false;
          this.flkty.updateDraggable();
        } else {
          this.flkty.options.draggable = true;
          this.flkty.updateDraggable();
        }
      }
    }

    detect3d() {
      const modelViewerElements = this.container.querySelectorAll(selectors$d.modelViewer);
      if (modelViewerElements) {
        modelViewerElements.forEach((element) => {
          initSectionModels(element, this.section.id);
        });
        document.addEventListener(
          "shopify_xr_launch",
          function () {
            this.container.querySelectorAll(selectors$d.allPlayers).forEach((player) => {
              player.dispatchEvent(new CustomEvent("pause"));
            });
          }.bind(this)
        );
      }
    }

    detectVideo() {
      const playerElements = this.section.container.querySelectorAll(selectors$d.videoPlayerNative);
      for (var player of playerElements) {
        const uniqueKey = player.dataset.player;
        const nativePlayerPromise = productNativeVideo(uniqueKey);
        if (this.loopVideo === true) {
          nativePlayerPromise
            .then((nativePlayer) => {
              nativePlayer.loop = true;
              return nativePlayer;
            })
            .catch((err) => {
              console.error(err);
            });
        }
      }
    }

    detectYouTube() {
      const playerElements = this.section.container.querySelectorAll(selectors$d.videoPlayerExternal);
      for (var player of playerElements) {
        const uniqueKey = player.dataset.player;
        const youtubePlayerPromise = embedYoutube(uniqueKey);
        if (this.loopVideo === true) {
          youtubePlayerPromise
            .then((youtubePlayer) => {
              return _setToLoop(youtubePlayer);
            })
            .catch((err) => {
              console.error(err);
            });
        }
      }
    }

    stopSliderThumbs() {
      if (
        window.innerWidth < window.theme.sizes.medium &&
        this.thumbWrapper?.classList.contains(classes$8.flickityDisableClass) &&
        !this.enableScrollbar
      ) {
        new CustomScrollbar(this.container);
        this.enableScrollbar = true;
      } else {
        this.enableScrollbar = false;
      }
    }

    pauseAllMedia() {
      const all = this.container.querySelector(`[data-media-slide]`);
      all.dispatchEvent(new CustomEvent("pause"));
    }

    pauseOtherMedia(uniqueKey) {
      const otherMedia = this.container.querySelector(`[data-media-slide]:not([data-player="${uniqueKey}"])`);
      otherMedia.dispatchEvent(new CustomEvent("pause"));
    }

    destroy() {
      this.container.querySelectorAll(selectors$d.allPlayers).forEach((player) => {
        player.dispatchEvent(new CustomEvent("destroy"));
      });
    }
  }

  function _setToLoop(youtubePlayer) {
    youtubePlayer.addEventListener("onStateChange", function (event) {
      if (event.data === 0) {
        // video is over, replay
        event.target.playVideo();
      }
    });
    return youtubePlayer;
  }

  const selectors$c = {
    pickupContainer: "data-store-availability-container",
    shopifySection: "[data-api-content]",
    drawer: "[data-pickup-drawer]",
    drawerOpen: "[data-pickup-drawer-open]",
    drawerClose: "[data-pickup-drawer-close]",
    drawerBody: "[data-pickup-body]",
  };

  const classes$7 = {
    isVisible: "drawer--visible",
    isHidden: "hide",
  };

  let sections$5 = {};

  class PickupAvailability {
    constructor(section) {
      this.container = section.container;
      this.drawer = null;
      this.buttonDrawerOpen = null;
      this.buttonDrawerClose = null;
      this.drawerBody = null;

      this.fetchPickupAvailability();

      this.container.addEventListener("theme:variant:change", (event) => this.fetchPickupAvailability(event));
    }

    fetchPickupAvailability(event) {
      const container = this.container.querySelector(`[${selectors$c.pickupContainer}]`);
      if (!container) return;
      const variantID =
        event && event.detail.variant ? event.detail.variant.id : container.getAttribute(selectors$c.pickupContainer);
      if (event && !event.detail.variant) {
        container.classList.add(classes$7.isHidden);
        return;
      }

      if (variantID) {
        fetch(`${window.theme.routes.root_url}variants/${variantID}/?section_id=api-pickup-availability`)
          .then(this.handleErrors)
          .then((response) => response.text())
          .then((text) => {
            const pickupAvailabilityHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(selectors$c.shopifySection).innerHTML;
            container.innerHTML = pickupAvailabilityHTML;
            container.classList.remove(classes$7.isHidden);

            this.drawer = this.container.querySelector(selectors$c.drawer);
            this.buttonDrawerOpen = this.container.querySelector(selectors$c.drawerOpen);
            this.buttonDrawerClose = this.container.querySelectorAll(selectors$c.drawerClose);
            this.drawerBody = this.container.querySelector(selectors$c.drawerBody);

            if (this.buttonDrawerOpen) {
              this.buttonDrawerOpen.addEventListener("click", () => this.openDrawer());
            }

            if (this.buttonDrawerClose.length) {
              this.buttonDrawerClose.forEach((element) => {
                element.addEventListener("click", () => this.closeDrawer());
              });
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }

    openDrawer() {
      if (this.drawer) {
        this.drawer.classList.add(classes$7.isVisible);
        this.drawer.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
        this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
      }
    }

    closeDrawer() {
      if (this.drawer) {
        this.drawer.classList.remove(classes$7.isVisible);
        this.drawer.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
        this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
      }
    }

    handleErrors(response) {
      if (!response.ok) {
        return response.json().then(function (json) {
          const e = new FetchError({
            status: response.statusText,
            headers: response.headers,
            json: json,
          });
          throw e;
        });
      }
      return response;
    }
  }

  const pickupAvailability = {
    onLoad() {
      sections$5[this.id] = new PickupAvailability(this);
    },
  };

  const hideElement = (elem) => {
    if (elem) {
      elem.style.display = "none";
    }
  };

  const selectors$b = {
    form: "[data-product-form]",
    optionPosition: "data-option-position",
    optionInput: '[name^="options"], [data-popout-option]',
    selectOptionValue: "data-value",
  };

  const classes$6 = {
    soldOut: "sold-out",
    unavailable: "unavailable",
  };

  /**
   * Variant Sellout Precrime Click Preview
   * I think of this like the precrime machine in Minority report.  It gives a preview
   * of every possible click action, given the current form state.  The logic is:
   *
   * for each clickable name=options[] variant selection element
   * find the value of the form if the element were clicked
   * lookup the variant with those value in the product json
   * clear the classes, add .unavailable if it's not found,
   * and add .sold-out if it is out of stock
   *
   * Caveat: we rely on the option position so we don't need
   * to keep a complex map of keys and values.
   */

  class SelloutVariants {
    constructor(section, productJSON) {
      this.container = section;
      this.productJSON = productJSON;
      this.form = this.container.querySelector(selectors$b.form);
      this.formData = new FormData(this.form);
      this.optionElements = this.container.querySelectorAll(selectors$b.optionInput);

      if (this.productJSON && this.form) {
        this.init();
      }
    }

    init() {
      this.update();
    }

    update() {
      this.getCurrentState();

      this.optionElements.forEach((el) => {
        const val = el.value || el.getAttribute(selectors$b.selectOptionValue);
        const positionString = el.closest(`[${selectors$b.optionPosition}]`).getAttribute(selectors$b.optionPosition);
        // subtract one because option.position in liquid does not count form zero, but JS arrays do
        const position = parseInt(positionString, 10) - 1;

        let newVals = [...this.selections];
        newVals[position] = val;

        const found = this.productJSON.variants.find((element) => {
          // only return true if every option matches our hypothetical selection
          let perfectMatch = true;
          for (let index = 0; index < newVals.length; index++) {
            if (element.options[index] !== newVals[index]) {
              perfectMatch = false;
            }
          }
          return perfectMatch;
        });

        el.classList.remove(classes$6.soldOut, classes$6.unavailable);
        if (typeof found === "undefined") {
          el.classList.add(classes$6.unavailable);
        } else if (found && found.available === false) {
          el.classList.add(classes$6.soldOut);
        }
      });
    }

    getCurrentState() {
      this.formData = new FormData(this.form);
      this.selections = [];
      for (var value of this.formData.entries()) {
        if (value[0].includes("options[")) {
          // push the current state of the form, dont worry about the group name
          // we will be using the array position instead of the name to match values
          this.selections.push(value[1]);
        }
      }
    }
  }

  const selectors$a = {
    outerSection: "[data-section-id]",
    productForm: "[data-product-form]",
    productSlideshow: "[data-product-slideshow]",
    addToCart: "[data-add-to-cart]",
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    buttonsWrapper: "[data-buttons-wrapper]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    priceButton: "[data-button-price]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    unitPrice: "[data-product-unit-price]",
    unitBase: "[data-product-base]",
    unitWrapper: "[data-product-unit]",
    dataEnableHistoryState: "data-enable-history-state",
    optionPosition: "data-option-position",
    optionValue: "[data-option-value]",
    subPrices: "[data-subscription-watch-price]",
    subSelectors: "[data-subscription-selectors]",
    priceOffWrap: "[data-price-off]",
    priceOffType: "[data-price-off-type]",
    priceOffAmount: "[data-price-off-amount]",
    subsToggle: "[data-toggles-group]",
    subsChild: "data-group-toggle",
    subDescription: "[data-plan-description]",
    remainingCount: "[data-remaining-count]",
    remainingMax: "[data-remaining-max]",
    remainingMaxAttr: "data-remaining-max",
    remainingWrapper: "[data-remaining-wrapper]",
    remainingJSON: "[data-product-remaining-json]",
    preOrderTag: "_preorder",
    idInput: '[name="id"]',
    upsellModal: "[data-upsell-modal]",
  };

  const classes$5 = {
    hide: "hide",
    variantSoldOut: "variant--soldout",
    variantUnavailable: "variant--unavailable",
    productPriceSale: "product__price--sale",
    remainingLow: "count-is-low",
    remainingIn: "count-is-in",
    remainingOut: "count-is-out",
    remainingUnavailable: "count-is-unavailable",
  };

  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.container = this;
      this.outerSection = this.container.closest(selectors$a.outerSection);
      this.upsell = this.container.closest(selectors$a.upsellModal);
      this.outerWrapper = this.upsell ? this.upsell : this.outerSection || this.container;

      this.productForm = this.container.querySelector(selectors$a.productForm);
      this.slideshow = this.outerWrapper.querySelector(selectors$a.productSlideshow);
      this.enableHistoryState =
        this.outerSection && this.outerSection.hasAttribute(selectors$a.dataEnableHistoryState)
          ? this.outerSection.getAttribute(selectors$a.dataEnableHistoryState) === "true"
          : false;
      this.hasUnitPricing = this.outerWrapper.querySelector(selectors$a.unitWrapper);
      this.subSelectors = this.container.querySelector(selectors$a.subSelectors);
      this.subPrices = this.container.querySelector(selectors$a.subPrices);

      this.priceOffWrap = this.outerWrapper.querySelector(selectors$a.priceOffWrap);
      this.priceOffAmount = this.outerWrapper.querySelectorAll(selectors$a.priceOffAmount);
      this.priceOffType = this.outerWrapper.querySelector(selectors$a.priceOffType);
      this.planDecription = this.container.querySelector(selectors$a.subDescription);

      this.remainingWrapper = this.container.querySelector(selectors$a.remainingWrapper);
      const remainingMaxWrap = this.container.querySelector(selectors$a.remainingMax);

      this.sellout = null;

      if (this.remainingWrapper && remainingMaxWrap) {
        this.remainingMaxInt = parseInt(remainingMaxWrap.getAttribute(selectors$a.remainingMaxAttr), 10);
        this.remainingCount = this.container.querySelector(selectors$a.remainingCount);
        this.remainingJSONWrapper = this.container.querySelector(selectors$a.remainingJSON);
        this.remainingJSON = null;
        if (this.remainingJSONWrapper && this.remainingJSONWrapper.innerHTML !== "") {
          this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML);
        } else {
          console.warn("Missing product quantity JSON");
        }
      }

      initQtySection(this.container);

      this.init();
    }

    init() {
      let productJSONText = null;
      this.productJSON = null;
      const productElemJSON = this.container.querySelector(selectors$a.productJson);

      if (productElemJSON) {
        productJSONText = productElemJSON.innerHTML;
      }
      if (productJSONText && this.productForm) {
        this.productJSON = JSON.parse(productJSONText);
        this.sellout = new SelloutVariants(this.container, this.productJSON);
        this.linkForm();
      } else {
        console.warn("Missing product form or product JSON");
      }

      // Add cookie for recent products
      if (this.productJSON) {
        new RecordRecentlyViewed(this.productJSON.handle);
      }
    }

    destroy() {
      this.productForm.destroy();
    }

    linkForm() {
      this.productForm = new ProductFormReader(this.productForm, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
        onPlanChange: this.onPlanChange.bind(this),
        onQuantityChange: this.onQuantityChange.bind(this),
      });
      this.pushState(this.productForm.getFormState());
      this.subsToggleListeners();
    }

    onOptionChange(evt) {
      this.pushState(evt.dataset);
    }

    onPlanChange(evt) {
      if (this.subPrices) {
        this.pushState(evt.dataset);
      }
    }

    onQuantityChange(evt) {
      const formState = evt.dataset;
      this.productState = this.setProductState(formState);
      this.updateButtonPrices(formState);
    }

    pushState(formState) {
      this.productState = this.setProductState(formState);
      this.updateProductImage(formState);
      this.updateAddToCartState(formState);
      this.updateProductPrices(formState);
      this.updateSaleText(formState);
      this.updateSubscriptionText(formState);
      this.updateLegend(formState);
      this.updateRemaining(formState);
      this.fireHookEvent(formState);
      if (this.sellout) {
        this.sellout.update(formState);
      }
      if (this.enableHistoryState) {
        this.updateHistoryState(formState);
      }
    }

    updateAddToCartState(formState) {
      const variant = formState.variant;
      let addText = theme.strings.addToCart;
      const priceWrapper = this.outerWrapper.querySelectorAll(selectors$a.priceWrapper);
      const buttonsWrapper = this.container.querySelector(selectors$a.buttonsWrapper);
      const addToCart = buttonsWrapper.querySelectorAll(selectors$a.addToCart);
      const addToCartText = buttonsWrapper.querySelectorAll(selectors$a.addToCartText);

      if (this.productJSON.tags.includes(selectors$a.preOrderTag)) {
        addText = theme.strings.preOrder;
      }

      if (priceWrapper.length && variant) {
        priceWrapper.forEach((element) => {
          element.classList.remove(classes$5.hide);
        });
      }

      if (addToCart.length) {
        addToCart.forEach((element) => {
          if (variant) {
            if (variant.available) {
              element.disabled = false;
            } else {
              element.disabled = true;
            }
          } else {
            element.disabled = true;
          }
        });
      }

      if (addToCartText.length) {
        addToCartText.forEach((element) => {
          if (variant) {
            if (variant.available) {
              element.innerHTML = addText;
            } else {
              element.innerHTML = theme.strings.soldOut;
            }
          } else {
            element.innerHTML = theme.strings.unavailable;
          }
        });
      }

      if (buttonsWrapper) {
        if (variant) {
          if (variant.available) {
            buttonsWrapper.classList.remove(classes$5.variantSoldOut, classes$5.variantUnavailable);
          } else {
            buttonsWrapper.classList.add(classes$5.variantSoldOut);
            buttonsWrapper.classList.remove(classes$5.variantUnavailable);
          }
          const formSelect = buttonsWrapper.querySelector(selectors$a.originalSelectorId);
          if (formSelect) {
            formSelect.value = variant.id;
          }
        } else {
          buttonsWrapper.classList.add(classes$5.variantUnavailable);
          buttonsWrapper.classList.remove(classes$5.variantSoldOut);
        }
      }
    }

    updateLegend(formState) {
      const variant = formState.variant;
      if (variant) {
        const vals = this.container.querySelectorAll(selectors$a.optionValue);
        vals.forEach((val) => {
          const wrapper = val.closest(`[${selectors$a.optionPosition}]`);
          if (wrapper) {
            const position = wrapper.getAttribute(selectors$a.optionPosition);
            const index = parseInt(position, 10) - 1;
            this.newValue = variant.options[index];
            val.innerHTML = this.newValue;
          }
        });
      }
    }

    updateHistoryState(formState) {
      const variant = formState.variant;
      const plan = formState.plan;
      const location = window.location.href;
      if (variant && location.includes("/product")) {
        const url = new window.URL(location);
        const params = url.searchParams;
        params.set("variant", variant.id);
        if (plan && plan.detail && plan.detail.id && this.productState.hasPlan) {
          params.set("selling_plan", plan.detail.id);
        } else {
          params.delete("selling_plan");
        }
        url.search = params.toString();
        const urlString = url.toString();
        window.history.replaceState({ path: urlString }, "", urlString);
      }
    }

    updateRemaining(formState) {
      const variant = formState.variant;
      if (variant && this.remainingWrapper && this.remainingJSON && this.remainingCount) {
        const newQuantity = this.remainingJSON[variant.id];
        if (newQuantity && newQuantity <= this.remainingMaxInt && newQuantity > 0) {
          this.remainingWrapper.classList.remove(
            classes$5.remainingIn,
            classes$5.remainingOut,
            classes$5.remainingUnavailable
          );
          this.remainingWrapper.classList.add(classes$5.remainingLow);
          this.remainingCount.innerHTML = newQuantity;
        } else if (this.productState.soldOut) {
          this.remainingWrapper.classList.remove(
            classes$5.remainingLow,
            classes$5.remainingIn,
            classes$5.remainingUnavailable
          );
          this.remainingWrapper.classList.add(classes$5.remainingOut);
        } else if (this.productState.available) {
          this.remainingWrapper.classList.remove(
            classes$5.remainingLow,
            classes$5.remainingOut,
            classes$5.remainingUnavailable
          );
          this.remainingWrapper.classList.add(classes$5.remainingIn);
        }
      } else if (this.remainingWrapper) {
        this.remainingWrapper.classList.remove(classes$5.remainingIn, classes$5.remainingOut, classes$5.remainingLow);
        this.remainingWrapper.classList.add(classes$5.remainingUnavailable);
      }
    }

    getBaseUnit(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    }

    subsToggleListeners() {
      const toggles = this.container.querySelectorAll(selectors$a.subsToggle);

      toggles.forEach((toggle) => {
        toggle.addEventListener(
          "change",
          function (e) {
            const val = e.target.value.toString();
            const selected = this.container.querySelector(`[${selectors$a.subsChild}="${val}"]`);
            const groups = this.container.querySelectorAll(`[${selectors$a.subsChild}]`);
            if (selected) {
              selected.classList.remove(classes$5.hide);
              const first = selected.querySelector(`[name="selling_plan"]`);
              first.checked = true;
              first.dispatchEvent(new Event("change"));
            }
            groups.forEach((group) => {
              if (group !== selected) {
                group.classList.add(classes$5.hide);
                const plans = group.querySelectorAll(`[name="selling_plan"]`);
                plans.forEach((plan) => {
                  plan.checked = false;
                  plan.dispatchEvent(new Event("change"));
                });
              }
            });
          }.bind(this)
        );
      });
    }

    updateSaleText(formState) {
      if (this.productState.planSale) {
        this.updateSaleTextSubscription(formState);
      } else if (this.productState.onSale) {
        this.updateSaleTextStandard(formState);
      } else if (this.priceOffWrap) {
        this.priceOffWrap.classList.add(classes$5.hide);
      }
    }

    updateSaleTextStandard(formState) {
      if (!this.priceOffType) return;
      this.priceOffType.innerHTML = window.theme.strings.sale || "sale";
      const variant = formState.variant;
      if (window.theme.settings.badge_sale_type && window.theme.settings.badge_sale_type === "percentage") {
        const discountFloat = (variant.compare_at_price - variant.price) / variant.compare_at_price;
        const discountInt = Math.floor(discountFloat * 100);
        this.priceOffAmount.forEach((priceOffAmount) => {
          priceOffAmount.innerHTML = `${discountInt}%`;
        });
      } else {
        const discount = variant.compare_at_price - variant.price;
        this.priceOffAmount.forEach((priceOffAmount) => {
          priceOffAmount.innerHTML = themeCurrency.formatMoney(discount, theme.moneyFormat);
        });
      }
      this.priceOffWrap.classList.remove(classes$5.hide);
    }

    updateSaleTextSubscription(formState) {
      this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton";
      const variant = formState.variant;
      const adjustment = formState.plan.detail.price_adjustments[0];
      const discount = adjustment.value;
      if (adjustment && adjustment.value_type === "percentage") {
        this.priceOffAmount.forEach((priceOffAmount) => {
          priceOffAmount.innerHTML = `${discount}%`;
        });
      } else if (adjustment && adjustment.value_type === "price") {
        this.priceOffAmount.forEach((priceOffAmount) => {
          priceOffAmount.innerHTML = themeCurrency.formatMoney(variant.price - adjustment.value, theme.moneyFormat);
        });
      } else {
        this.priceOffAmount.forEach((priceOffAmount) => {
          priceOffAmount.innerHTML = themeCurrency.formatMoney(discount, theme.moneyFormat);
        });
      }
      this.priceOffWrap.classList.remove(classes$5.hide);
    }

    updateSubscriptionText(formState) {
      if (formState.plan && this.planDecription && formState.plan.detail.description !== null) {
        this.planDecription.innerHTML = formState.plan.detail.description;
        this.planDecription.classList.remove(classes$5.hide);
      } else if (this.planDecription) {
        this.planDecription.classList.add(classes$5.hide);
      }
    }

    getPrices(formState) {
      const variant = formState.variant;
      const plan = formState.plan;
      let comparePrice = "";
      let price = "";

      if (this.productState.available) {
        comparePrice = variant.compare_at_price;
        price = variant.price;
      }

      if (this.productState.hasPlan) {
        price = plan.allocation.price;
      }

      if (this.productState.planSale) {
        comparePrice = plan.allocation.compare_at_price;
        price = plan.allocation.price;
      }
      return {
        price: price,
        comparePrice: comparePrice,
      };
    }

    updateButtonPrices(formState) {
      const priceButtons = this.container.querySelectorAll(selectors$a.priceButton);
      const { price } = this.getPrices(formState);

      if (priceButtons.length) {
        priceButtons.forEach((btn) => {
          const btnPrice = formState.quantity * price;
          btn.innerHTML = themeCurrency.formatMoney(btnPrice, theme.moneyFormat);
        });
      }
    }

    updateProductPrices(formState) {
      const variant = formState.variant;
      const priceWrappers = this.outerWrapper.querySelectorAll(selectors$a.priceWrapper);
      const priceButtons = this.container.querySelectorAll(selectors$a.priceButton);

      const { price, comparePrice } = this.getPrices(formState);

      priceWrappers.forEach((wrap) => {
        const comparePriceEl = wrap.querySelector(selectors$a.comparePrice);
        const productPriceEl = wrap.querySelector(selectors$a.productPrice);
        const comparePriceText = wrap.querySelector(selectors$a.comparePriceText);

        if (comparePriceEl) {
          if (this.productState.onSale || this.productState.planSale) {
            comparePriceEl.classList.remove(classes$5.hide);
            // comparePriceText.classList.remove(classes$5.hide);
            productPriceEl.classList.add(classes$5.productPriceSale);
          } else {
            comparePriceEl.classList.add(classes$5.hide);
            // comparePriceText.classList.add(classes$5.hide);
            productPriceEl.classList.remove(classes$5.productPriceSale);
          }
          comparePriceEl.innerHTML = themeCurrency.formatMoney(comparePrice, theme.moneyFormat);
        }
        if (productPriceEl) {
          if (variant) {
            productPriceEl.innerHTML = themeCurrency.formatMoney(price, theme.moneyFormat);
          } else {
            productPriceEl.innerHTML = "&nbsp;";
          }
        }
      });

      if (priceButtons.length) {
        priceButtons.forEach((btn) => {
          const btnPrice = formState.quantity * price;
          btn.innerHTML = themeCurrency.formatMoney(btnPrice, theme.moneyFormat);
        });
      }

      if (this.hasUnitPricing) {
        this.updateProductUnits(formState);
      }
    }

    updateProductUnits(formState) {
      const variant = formState.variant;
      const plan = formState.plan;
      let unitPrice = null;

      if (variant && variant.unit_price) {
        unitPrice = variant.unit_price;
      }
      if (plan && plan.allocation && plan.allocation.unit_price) {
        unitPrice = plan.allocation.unit_price;
      }

      if (unitPrice) {
        const base = this.getBaseUnit(variant);
        const formattedPrice = themeCurrency.formatMoney(unitPrice, theme.moneyFormat);
        this.outerWrapper.querySelector(selectors$a.unitPrice).innerHTML = formattedPrice;
        this.outerWrapper.querySelector(selectors$a.unitBase).innerHTML = base;
        showElement(this.outerWrapper.querySelector(selectors$a.unitWrapper));
      } else {
        hideElement(this.outerWrapper.querySelector(selectors$a.unitWrapper));
      }
    }

    fireHookEvent(formState) {
      const variant = formState.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: {
            variant: variant,
          },
          bubbles: true,
        })
      );
    }

    /**
     * Tracks aspects of the product state that are relevant to UI updates
     * @param {object} evt - variant change event
     * @return {object} productState - represents state of variant + plans
     *  productState.available - current variant and selling plan options result in valid offer
     *  productState.soldOut - variant is sold out
     *  productState.onSale - variant is on sale
     *  productState.showUnitPrice - variant has unit price
     *  productState.requiresPlan - all the product variants requires a selling plan
     *  productState.hasPlan - there is a valid selling plan
     *  productState.planSale - plan has a discount to show next to price
     *  productState.planPerDelivery - plan price does not equal per_delivery_price - a prepaid subscribtion
     */
    setProductState(dataset) {
      const variant = dataset.variant;
      const plan = dataset.plan;

      const productState = {
        available: true,
        soldOut: false,
        onSale: false,
        showUnitPrice: false,
        requiresPlan: false,
        hasPlan: false,
        planPerDelivery: false,
        planSale: false,
      };

      if (!variant || (variant.requires_selling_plan && !plan)) {
        productState.available = false;
      } else {
        if (!variant.available) {
          productState.soldOut = true;
        }

        if (variant.compare_at_price > variant.price) {
          productState.onSale = true;
        }

        if (variant.unit_price) {
          productState.showUnitPrice = true;
        }

        if (this.productJSON && this.productJSON.requires_selling_plan) {
          productState.requiresPlan = true;
        }

        if (plan && this.subPrices) {
          productState.hasPlan = true;
          if (plan.allocation.per_delivery_price !== plan.allocation.price) {
            productState.planPerDelivery = true;
          }
          if (variant.price > plan.allocation.price) {
            productState.planSale = true;
          }
        }
      }
      return productState;
    }

    updateProductImage(formState) {
      const variant = formState.variant;
      if (
        this.slideshow &&
        !this.slideshow.hasAttribute("data-variants-slideshow") &&
        variant &&
        variant.featured_media &&
        variant.featured_media.id
      ) {
        // Update variant image, if one is set
        this.slideshow.dispatchEvent(
          new CustomEvent("theme:image:change", {
            detail: {
              id: variant.featured_media.id,
            },
          })
        );
      }
    }
  }

  const selectors$9 = {
    slideshow: "[data-product-slideshow]",
    singeImage: "[data-product-image]",
    zoomButton: "[data-zoom-button]",
    zoomWrapper: "[data-zoom-wrapper]",
    mediaId: "[data-media-id]",
    mediaIdAttr: "data-media-id",
  };

  function productPhotoswipeZoom(container, json) {
    const loadedPromise = loadScript({ url: window.theme.assets.photoswipe });
    const returnZoom = loadedPromise
      .then(() => {
        const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
        const PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;

        const triggers = container.querySelectorAll(selectors$9.zoomButton);
        triggers.forEach((trigger) => {
          trigger.addEventListener("click", (event) => {
            const el = container.querySelector(selectors$9.zoomWrapper);
            const dataId = event.target.closest(selectors$9.mediaId).getAttribute(selectors$9.mediaIdAttr).toString();
            const items = [];
            for (let i = 0; i < json.media.length; i++) {
              if (json.media[i].media_type === "image") {
                items[items.length] = {
                  src: json.media[i].src,
                  w: json.media[i].width,
                  h: json.media[i].height,
                  id: json.media[i].id,
                };
              }
            }
            const findImage = (element) => element.id.toString() === dataId;
            const index = items.findIndex(findImage);
            const options = {
              index,
              showHideOpacity: true,
              showAnimationDuration: 150,
              hideAnimationDuration: 250,
              bgOpacity: 1,
              spacing: 0,
              allowPanToNext: false,
              maxSpreadZoom: 3,
              history: false,
              loop: true,
              pinchToClose: false,
              modal: false,
              closeOnScroll: false,
              closeOnVerticalDrag: true,
              getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
                if (isMouseClick) {
                  return 1.67;
                } else {
                  return item.initialZoomLevel < 0.7 ? 1 : 1.3;
                }
              },
              getThumbBoundsFn: function getThumbBoundsFn() {
                let imageLocation = container.querySelector(selectors$9.slideshow);
                if (!imageLocation) {
                  imageLocation = container.querySelector(selectors$9.singeImage);
                }
                const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                const rect = imageLocation.getBoundingClientRect();
                return {
                  x: rect.left,
                  y: rect.top + pageYScroll,
                  w: rect.width,
                };
              },
            };
            el.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
            // Initializes and opens PhotoSwipe
            const gallery = new PhotoSwipe(el, PhotoSwipeUI, items, options);
            gallery.init();
            gallery.listen("close", function () {
              document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
            });
          });
        });
      })
      .catch((e) => console.error(e));
    return returnZoom;
  }

  const selectors$8 = {
    body: "body",
    dataRelatedSectionElem: "[data-related-section]",
    dataTabsHolder: "[data-tabs-holder]",
    dataTab: "data-tab",
    dataTabIndex: "data-tab-index",
    blockId: "data-block-id",
    tabsLi: ".tabs > button",
    tabLink: ".tab-link",
    tabLinkRecent: ".tab-link__recent",
    tabContent: ".tab-content",
    scrollbarHolder: "[data-scrollbar]",
    scrollbarArrowPrev: "[data-scrollbar-arrow-prev]",
    scrollbarArrowNext: "[data-scrollbar-arrow-next]",
    dataGridItem: "[data-grid-item]",
  };

  const classes$4 = {
    classCurrent: "current",
    classHide: "hide",
    classAlt: "alt",
  };

  const sections$4 = {};

  class GlobalTabs {
    constructor(holder) {
      this.container = holder;
      this.body = document.querySelector(selectors$8.body);
      this.accessibility = window.accessibility;

      if (this.container) {
        this.scrollbarHolder = this.container.querySelectorAll(selectors$8.scrollbarHolder);

        this.init();

        // Init native scrollbar
        this.initNativeScrollbar();
      }
    }

    init() {
      const ctx = this.container;
      const tabsNavList = ctx.querySelectorAll(selectors$8.tabsLi);
      const firstTabLink = ctx.querySelector(`${selectors$8.tabLink}-0`);
      const firstTabContent = ctx.querySelector(`${selectors$8.tabContent}-0`);

      const gridItems = ctx.querySelectorAll(selectors$8.dataGridItem);
      gridItems.forEach((gridItem) => {
        new ProductAddButton(gridItem);
      });

      if (firstTabContent) {
        firstTabContent.classList.add(classes$4.classCurrent);
      }

      if (firstTabLink) {
        firstTabLink.classList.add(classes$4.classCurrent);
      }

      this.checkVisibleTabLinks();
      this.container.addEventListener("tabs:checkRecentTab", () => this.checkRecentTab());
      this.container.addEventListener("tabs:hideRelatedTab", () => this.hideRelatedTab());

      if (tabsNavList.length) {
        tabsNavList.forEach((element) => {
          const tabId = parseInt(element.getAttribute(selectors$8.dataTab));
          const tab = ctx.querySelector(`${selectors$8.tabContent}-${tabId}`);

          element.addEventListener("click", () => {
            this.tabChange(element, tab);
          });

          element.addEventListener("keyup", (event) => {
            if (
              (event.which === window.theme.keyboardKeys.SPACE || event.which === window.theme.keyboardKeys.ENTER) &&
              this.body.classList.contains("is-focused")
            ) {
              this.tabChange(element, tab);

              if (tab.querySelector("a, input")) {
                this.accessibility.lastFocused = element;

                this.accessibility.a11y.trapFocus(tab, {
                  elementToFocus: tab.querySelector("a:first-child, input:first-child"),
                });
              }
            }
          });
        });
      }
    }

    tabChange(element, tab) {
      this.container
        .querySelector(`${selectors$8.tabsLi}.${classes$4.classCurrent}`)
        .classList.remove(classes$4.classCurrent);
      this.container
        .querySelector(`${selectors$8.tabContent}.${classes$4.classCurrent}`)
        .classList.remove(classes$4.classCurrent);

      element.classList.add(classes$4.classCurrent);
      tab.classList.add(classes$4.classCurrent);

      if (element.classList.contains(classes$4.classHide)) {
        tab.classList.add(classes$4.classHide);
      }

      this.checkVisibleTabLinks();

      this.container.dispatchEvent(new CustomEvent("theme:tab:change"));
    }

    initNativeScrollbar() {
      if (this.scrollbarHolder.length) {
        this.scrollbarHolder.forEach((scrollbar) => {
          new NativeScrollbar(scrollbar);
        });
      }
    }

    checkVisibleTabLinks() {
      const tabsNavList = this.container.querySelectorAll(selectors$8.tabsLi);
      const tabsNavListHided = this.container.querySelectorAll(`${selectors$8.tabLink}.${classes$4.classHide}`);
      const difference = tabsNavList.length - tabsNavListHided.length;

      if (difference < 2) {
        this.container.classList.add(classes$4.classAlt);
      } else {
        this.container.classList.remove(classes$4.classAlt);
      }
    }

    checkRecentTab() {
      const tabLink = this.container.querySelector(selectors$8.tabLinkRecent);

      if (tabLink) {
        tabLink.classList.remove(classes$4.classHide);
        const tabLinkIdx = parseInt(tabLink.getAttribute(selectors$8.dataTab));
        const tabContent = this.container.querySelector(
          `${selectors$8.tabContent}[${selectors$8.dataTabIndex}="${tabLinkIdx}"]`
        );

        if (tabContent) {
          tabContent.classList.remove(classes$4.classHide);
        }

        this.checkVisibleTabLinks();

        this.initNativeScrollbar();
      }
    }

    hideRelatedTab() {
      const relatedSection = this.container.querySelector(selectors$8.dataRelatedSectionElem);
      if (!relatedSection) {
        return;
      }

      const parentTabContent = relatedSection.closest(`${selectors$8.tabContent}.${classes$4.classCurrent}`);
      if (!parentTabContent) {
        return;
      }
      const parentTabContentIdx = parseInt(parentTabContent.getAttribute(selectors$8.dataTabIndex));
      const tabsNavList = this.container.querySelectorAll(selectors$8.tabsLi);

      if (tabsNavList.length > parentTabContentIdx) {
        const nextTabsNavLink = tabsNavList[parentTabContentIdx].nextSibling;

        if (nextTabsNavLink) {
          tabsNavList[parentTabContentIdx].classList.add(classes$4.classHide);
          nextTabsNavLink.dispatchEvent(new Event("click"));
          this.initNativeScrollbar();
        }
      }
    }

    onBlockSelect(evt) {
      const element = this.container.querySelector(
        `${selectors$8.tabLink}[${selectors$8.blockId}="${evt.detail.blockId}"]`
      );
      if (element) {
        element.dispatchEvent(new Event("click"));

        element.parentNode.scrollTo({
          top: 0,
          left: element.offsetLeft - element.clientWidth,
          behavior: "smooth",
        });
      }
    }
  }

  const tabs = {
    onLoad() {
      sections$4[this.id] = [];
      const tabHolders = this.container.querySelectorAll(selectors$8.dataTabsHolder);

      tabHolders.forEach((holder) => {
        sections$4[this.id].push(new GlobalTabs(holder));
      });
    },
    onBlockSelect(e) {
      sections$4[this.id].forEach((el) => {
        if (typeof el.onBlockSelect === "function") {
          el.onBlockSelect(e);
        }
      });
    },
  };

  register("social-widget", [partnerStorefront]);

  register("partner-header", [partnerStorefront]);

  register("partner-featured-products", [partnerFeaturedProducts]);

  register("ttd-partner-profile-card", [partnerStorefront]);

  register("ttd-double-banner", [ttdDoubleBannerSection]);

  register("bento", [partnerStorefront, partnerSearch, bentoSection, slideshowSection, accordion, tabs]);

  const selectors$7 = {
    productForm: "[data-product-form]",
    productJson: "[data-product-json]",
    popupButton: "[data-toggle-product-modal]",
    zoomButton: "[data-zoom-button]",
    toggleTruncateHolder: "[data-truncated-holder]",
    toggleTruncateButton: "[data-truncated-button]",
    toggleTruncateContent: "[data-truncated-content]",
    toggleTruncateContentAttr: "data-truncated-content",
  };

  const classes$3 = {
    classExpanded: "is-expanded",
    classVisible: "is-visible",
  };

  const sections$3 = [];

  class ProductTemplate {
    constructor(section) {
      this.section = section;
      this.id = section.id;
      this.container = section.container;
      this.settings = section.settings;
      this.productFormElement = this.container.querySelector(selectors$7.productForm);

      modal(this.id);
      this.media = new Media(section);

      const productJSON = this.container.querySelector(selectors$7.productJson);
      if (productJSON && productJSON.innerHTML !== "") {
        this.product = JSON.parse(productJSON.innerHTML);
      } else {
        console.error("Missing product JSON");
        return;
      }

      this.truncateElementHolder = this.container.querySelector(selectors$7.toggleTruncateHolder);
      this.truncateElement = this.container.querySelector(selectors$7.toggleTruncateContent);
      this.resizeEventTruncate = () => this.truncateText();

      this.init();
    }

    init() {
      this.zoomEnabled = this.container.querySelector(selectors$7.zoomButton) !== null;
      if (this.zoomEnabled) {
        productPhotoswipeZoom(this.container, this.product);
      }

      if (this.truncateElementHolder && this.truncateElement) {
        setTimeout(this.resizeEventTruncate, 50);
        document.addEventListener("theme:resize", this.resizeEventTruncate);
      }
    }

    truncateText() {
      if (this.truncateElementHolder.classList.contains(classes$3.classVisible)) return;
      const truncateRows = 5;
      const truncateElementCloned = this.truncateElement.cloneNode(true);
      const truncateElementClass = this.truncateElement.getAttribute(selectors$7.toggleTruncateContentAttr);
      const truncateNextElement = this.truncateElement.nextElementSibling;
      if (truncateNextElement) {
        truncateNextElement.remove();
      }

      this.truncateElement.parentElement.append(truncateElementCloned);

      const truncateAppendedElement = this.truncateElement.nextElementSibling;
      truncateAppendedElement.classList.add(truncateElementClass);
      truncateAppendedElement.removeAttribute(selectors$7.toggleTruncateContentAttr);

      showElement(truncateAppendedElement);

      ellipsed.ellipsis(truncateAppendedElement, truncateRows, {
        replaceStr: "",
      });

      hideElement(truncateAppendedElement);

      if (this.truncateElement.innerHTML !== truncateAppendedElement.innerHTML) {
        this.truncateElementHolder.classList.add(classes$3.classExpanded);
      } else {
        truncateAppendedElement.remove();
        this.truncateElementHolder.classList.remove(classes$3.classExpanded);
      }

      this.toggleTruncatedContent(this.truncateElementHolder);
    }

    toggleTruncatedContent(holder) {
      const toggleButton = holder.querySelector(selectors$7.toggleTruncateButton);
      if (toggleButton) {
        toggleButton.addEventListener("click", (e) => {
          e.preventDefault();
          holder.classList.remove(classes$3.classExpanded);
          holder.classList.add(classes$3.classVisible);
        });
      }
    }

    onBlockSelect(event) {
      const block = this.container.querySelector(`[data-block-id="${event.detail.blockId}"]`);
      if (block) {
        block.dispatchEvent(new Event("click"));
      }
    }

    onBlockDeselect(event) {
      const block = this.container.querySelector(`[data-block-id="${event.detail.blockId}"]`);
      if (block) {
        block.dispatchEvent(new Event("click"));
      }
    }

    onUnload() {
      this.media.destroy();
      if (this.truncateElementHolder && this.truncateElement) {
        document.removeEventListener("theme:resize", this.resizeEventTruncate);
      }
    }
  }

  const productSection = {
    onLoad() {
      sections$3[this.id] = new ProductTemplate(this);
    },
    onUnload() {
      if (typeof sections$3[this.id].unload === "function") {
        sections$3[this.id].unload();
      }
    },
    onBlockSelect(evt) {
      if (typeof sections$3[this.id].onBlockSelect === "function") {
        sections$3[this.id].onBlockSelect(evt);
      }
    },
    onBlockDeselect(evt) {
      if (typeof sections$3[this.id].onBlockDeselect === "function") {
        sections$3[this.id].onBlockDeselect(evt);
      }
    },
  };

  register("product", [
    productSection,
    pickupAvailability,
    productAddSection,
    accordion,
    tabs,
    swapperSection,
    productSliderSection,
  ]);

  if (!customElements.get("product-form")) {
    customElements.define("product-form", ProductForm);
  }

  if (!customElements.get("radio-swatch")) {
    customElements.define("radio-swatch", RadioSwatch);
  }

  if (!customElements.get("popout-select")) {
    customElements.define("popout-select", PopoutSelect);
  }

  if (!customElements.get("upsell-product")) {
    customElements.define("upsell-product", UpsellProduct);
  }

  const selectors$6 = {
    toggle: "data-toggle-grid",
    large: "data-grid-large",
    small: "data-grid-small",
  };

  const options = {
    breakpoint: window.theme.sizes.small,
  };

  var sections$2 = {};

  class Toggle {
    constructor(toggle) {
      this.toggle = toggle;
      this.value = this.toggle.getAttribute(selectors$6.toggle);
      this.toggleClickFunction = (evt) => this.toggleClick(evt);

      this.init();
    }

    init() {
      this.toggle.addEventListener("click", this.toggleClickFunction);
    }

    unload() {
      this.toggle.removeEventListener("click", this.toggleClickFunction);
    }

    toggleClick() {
      const isLarge = window.innerWidth >= options.breakpoint;
      const selector = isLarge ? selectors$6.large : selectors$6.small;
      document.querySelector(`[${selector}]`).setAttribute(selector, this.value);
      if (window.lazySizes) {
        window.lazySizes.autoSizer.checkElems();
      }
    }
  }

  const toggleSection = {
    onLoad() {
      sections$2[this.id] = [];
      const buttons = this.container.querySelectorAll(`[${selectors$6.toggle}]`);
      buttons.forEach((button) => {
        sections$2[this.id].push(new Toggle(button));
      });
    },
    onUnload: function () {
      sections$2[this.id].forEach((toggle) => {
        if (typeof toggle.unload === "function") {
          toggle.unload();
        }
      });
    },
  };

  const selectors$5 = {
    sort: "data-sort-enabled",
    sortLinks: "[data-sort-link]",
    sortButtonText: "[data-sort-button-text]",
    sortValue: "data-value",
  };

  const classes$2 = {
    active: "popout-list__item--current",
  };

  class Sort {
    constructor(section) {
      this.container = section.container;
      this.sort = this.container.querySelector(`[${selectors$5.sort}]`);
      this.sortLinks = this.container.querySelectorAll(selectors$5.sortLinks);
      this.sortButtonText = this.container.querySelector(selectors$5.sortButtonText);

      if (this.sort) {
        this.init();
      }
    }

    init() {
      this.sortLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          this.sortingResults(e);
        });
      });
    }

    sortingResults(e) {
      const link = e.currentTarget;
      const sort = link.getAttribute(selectors$5.sortValue);
      const text = link.innerText;

      this.sortButtonText.innerText = text;
      this.sortButtonText.parentNode.dispatchEvent(new Event("click"));

      this.sort.querySelector(`.${classes$2.active}`).classList.remove(classes$2.active);
      link.parentNode.classList.add(classes$2.active);

      this.sort.setAttribute(selectors$5.sort, sort);

      this.container.dispatchEvent(
        new CustomEvent("theme:filter:form", {
          bubbles: true,
          detail: {
            params: sort,
          },
        })
      );
    }
  }

  var selectors$4 = {
    collectionNavGrouped: "[data-tag-group]",
    linkAdd: ".link--add",
    linkRemove: ".link--remove",
    swatch: "data-swatch",
  };

  class Collection {
    constructor(section) {
      this.section = section;
      this.container = this.section.container;
      this.swatches = this.container.querySelectorAll(`[${selectors$4.swatch}]`);
      this.init();
    }

    init() {
      new Sort(this.section);
      this.removeUnusableFilters();
    }

    removeUnusableFilters() {
      // temp tag filters
      const collectionNavGrouped = this.container.querySelectorAll(selectors$4.collectionNavGrouped);
      if (collectionNavGrouped.length > 0) {
        collectionNavGrouped.forEach((element) => {
          const linkAdd = element.querySelector(selectors$4.linkAdd);
          const linkRemove = element.querySelector(selectors$4.linkRemove);

          if (!linkAdd && !linkRemove) {
            hideElement(element);
          }
        });
      }
    }
  }

  const collectionSection = {
    onLoad() {
      this.collection = new Collection(this);
    },
  };

  register("collection", [
    collectionSection,
    collectionFiltersSidebar,
    collectionFiltersForm,
    productAddSection,
    toggleSection,
    swatchGridSection,
    formGridSection,
    accordion,
    siblings,
  ]);

  if (!customElements.get("popout-select")) {
    customElements.define("popout-select", PopoutSelect);
  }

  if (!customElements.get("radio-swatch")) {
    customElements.define("radio-swatch", RadioSwatch);
  }

  register("collection-row", [swatchGridSection, siblings]);

  if (!customElements.get("radio-swatch")) {
    customElements.define("radio-swatch", RadioSwatch);
  }

  register("collection-tabs", [tabs, productSliderSection, swatchGridSection, formGridSection, productAddSection]);

  if (!customElements.get("radio-swatch")) {
    customElements.define("radio-swatch", RadioSwatch);
  }

  register("collection-carousel", [productAddSection, productSliderSection, swatchGridSection, formGridSection]);

  var styles = {};
  styles.basic = [];
  /* eslint-disable */
  styles.light = [
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [{ visibility: "on" }, { lightness: "64" }, { hue: "#ff0000" }],
    },
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    {
      featureType: "administrative",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
    },
    {
      featureType: "landscape.natural.landcover",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "landscape.natural.terrain",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "geometry.fill",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "labels",
      stylers: [{ lightness: "100" }],
    },
    {
      featureType: "poi.park",
      elementType: "all",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [{ saturation: "-100" }],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [{ visibility: "simplified" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [{ gamma: "10.00" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.stroke",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.fill",
      stylers: [{ weight: "0.8" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.local",
      elementType: "geometry.fill",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.local",
      elementType: "geometry.stroke",
      stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
    },
    {
      featureType: "road.local",
      elementType: "labels",
      stylers: [{ visibility: "simplified" }, { weight: "0.01" }, { lightness: "39" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.stroke",
      stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
    },
  ];

  styles.light_blank = [
    {
      featureType: "all",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [{ visibility: "off" }, { lightness: "64" }, { hue: "#ff0000" }],
    },
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [{ color: "#bdbdbd" }],
    },
    {
      featureType: "administrative",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
    },
    {
      featureType: "landscape.natural.landcover",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "landscape.natural.terrain",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "geometry.fill",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "labels",
      stylers: [{ lightness: "100" }],
    },
    {
      featureType: "poi.park",
      elementType: "all",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [{ saturation: "-100" }],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }, { visibility: "off" }],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [{ visibility: "simplified" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [{ gamma: "10.00" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.stroke",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.fill",
      stylers: [{ weight: "0.8" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.local",
      elementType: "geometry.fill",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.local",
      elementType: "geometry.stroke",
      stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
    },
    {
      featureType: "road.local",
      elementType: "labels",
      stylers: [{ visibility: "off" }, { weight: "0.01" }, { lightness: "39" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.stroke",
      stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
    },
  ];

  styles.white_blank = [
    {
      featureType: "all",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [{ color: "#444444" }],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [{ color: "#f2f2f2" }],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [{ saturation: -100 }, { lightness: 45 }],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [{ visibility: "simplified" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [{ weight: "0.8" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0.8" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ weight: "0.8" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.stroke",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.local",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
    },
  ];

  styles.white_label = [
    {
      featureType: "all",
      elementType: "all",
      stylers: [{ visibility: "simplified" }],
    },
    {
      featureType: "all",
      elementType: "labels",
      stylers: [{ visibility: "simplified" }],
    },
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [{ gamma: "3.86" }, { lightness: "100" }],
    },
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [{ color: "#cccccc" }],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [{ color: "#f2f2f2" }],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [{ saturation: -100 }, { lightness: 45 }],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [{ visibility: "simplified" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [{ weight: "0.8" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0.8" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ weight: "0.8" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.stroke",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.local",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
    },
  ];

  styles.dark_blank = [
    {
      featureType: "all",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "all",
      elementType: "labels.text.fill",
      stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
    },
    {
      featureType: "all",
      elementType: "labels.text.stroke",
      stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }],
    },
    {
      featureType: "all",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [{ color: "#000000" }, { lightness: 20 }],
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
    },
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [{ color: "#000000" }, { lightness: 20 }],
    },
    {
      featureType: "landscape",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#000000" }, { lightness: 21 }],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [{ color: "#000000" }, { lightness: 18 }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [{ color: "#000000" }, { lightness: 16 }],
    },
    {
      featureType: "road.local",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#000000" }, { lightness: 19 }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#000000" }, { lightness: 17 }],
    },
  ];

  styles.dark_label = [
    {
      featureType: "all",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "all",
      elementType: "labels.text.fill",
      stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
    },
    {
      featureType: "all",
      elementType: "labels.text.stroke",
      stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }],
    },
    {
      featureType: "all",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [{ color: "#000000" }, { lightness: 20 }],
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
    },
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [{ visibility: "simplified" }, { lightness: "-82" }],
    },
    {
      featureType: "administrative",
      elementType: "labels.text.stroke",
      stylers: [{ invert_lightness: true }, { weight: "7.15" }],
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [{ color: "#000000" }, { lightness: 20 }],
    },
    {
      featureType: "landscape",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#000000" }, { lightness: 21 }],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [{ visibility: "simplified" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [{ color: "#000000" }, { lightness: 18 }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [{ color: "#000000" }, { lightness: 16 }],
    },
    {
      featureType: "road.local",
      elementType: "geometry.stroke",
      stylers: [{ weight: "0.01" }],
    },
    {
      featureType: "road.local",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#000000" }, { lightness: 19 }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#000000" }, { lightness: 17 }],
    },
  ];
  /* eslint-enable */

  function mapStyle(key) {
    return styles[key];
  }

  window.theme.allMaps = window.theme.allMaps || {};
  let allMaps = window.theme.allMaps;

  class Map {
    constructor(section) {
      this.container = section.container;
      this.mapWrap = this.container.querySelector("[data-map-container]");
      this.styleString = this.container.getAttribute("data-style") || "";
      this.key = this.container.getAttribute("data-api-key");
      this.zoomString = this.container.getAttribute("data-zoom") || 14;
      this.address = this.container.getAttribute("data-address");
      this.enableCorrection = this.container.getAttribute("data-latlong-correction");
      this.lat = this.container.getAttribute("data-lat");
      this.long = this.container.getAttribute("data-long");
      if (this.key) {
        this.initMaps();
      }
    }

    initMaps() {
      const urlKey = `https://maps.googleapis.com/maps/api/js?key=${this.key}`;
      loadScript({ url: urlKey })
        .then(() => {
          return this.enableCorrection === "true" && this.lat !== "" && this.long !== ""
            ? new window.google.maps.LatLng(this.lat, this.long)
            : geocodeAddressPromise(this.address);
        })
        .then((center) => {
          var zoom = parseInt(this.zoomString, 10);
          const styles = mapStyle(this.styleString);
          var mapOptions = {
            zoom,
            styles,
            center,
            draggable: true,
            clickableIcons: false,
            scrollwheel: false,
            zoomControl: false,
            disableDefaultUI: true,
          };
          const map = createMap(this.mapWrap, mapOptions);
          return map;
        })
        .then((map) => {
          this.map = map;
          allMaps[this.id] = map;
        })
        .catch((e) => {
          //console.log("Failed to load Google Map");
          //console.log(e);
        });
    }

    onUnload() {
      if (typeof window.google !== "undefined") {
        window.google.maps.event.clearListeners(this.map, "resize");
      }
    }
  }

  function createMap(container, options) {
    var map = new window.google.maps.Map(container, options);
    var center = map.getCenter();

    new window.google.maps.Marker({
      map: map,
      position: center,
    });

    window.google.maps.event.addDomListener(window, "resize", function () {
      window.google.maps.event.trigger(map, "resize");
      map.setCenter(center);
    });
    return map;
  }

  function geocodeAddressPromise(address) {
    return new Promise((resolve, reject) => {
      var geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: address }, function (results, status) {
        if (status == "OK") {
          var latLong = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
          };
          resolve(latLong);
        } else {
          reject(status);
        }
      });
    });
  }

  const mapSection = {
    onLoad() {
      allMaps[this.id] = new Map(this);
    },
    onUnload() {
      if (typeof allMaps[this.id].unload === "function") {
        allMaps[this.id].unload();
      }
    },
  };

  register("section-map", mapSection);

  register("section-columns", popupVideoSection);

  const selectors$3 = {
    dataRelatedSectionElem: "[data-related-section]",
    dataRelatedProduct: "[data-grid-item]",
    dataLimit: "data-limit",
    dataMinimum: "data-minimum",
    recentlyViewed: "[data-recent-wrapper]",
    recentlyViewedWrapper: "[data-recently-viewed-wrapper]",
    recentlyProduct: "[data-recently-viewed-products]",
    slider: "[data-slider]",
    gridLarge: "data-grid-large",
    dataLayout: "data-layout",
  };

  class Related {
    constructor(section) {
      this.section = section;
      this.container = section.container;

      this.init();
      this.listen();
    }

    listen() {
      this.container.addEventListener("recent-products:added", () => {
        this.recent();
      });
    }

    init() {
      const relatedSection = this.container.querySelector(selectors$3.dataRelatedSectionElem);

      if (!relatedSection) {
        return;
      }

      const numberSlides = relatedSection.getAttribute(selectors$3.dataLayout);
      const productId = relatedSection.getAttribute("data-product-id");
      const limit = relatedSection.getAttribute("data-limit");
      const route = window.theme.routes.product_recommendations_url || "/recommendations/products/";
      const requestUrl = `${route}?section_id=related&limit=${limit}&product_id=${productId}`;

      axios
        .get(requestUrl)
        .then((response) => {
          const fresh = document.createElement("div");
          fresh.innerHTML = response.data;

          const inner = fresh.querySelector(selectors$3.dataRelatedSectionElem);

          if (inner.querySelector(selectors$3.dataRelatedProduct)) {
            const innerHtml = inner.innerHTML;
            hideElement(relatedSection);
            relatedSection.innerHTML = innerHtml;
            slideDown(relatedSection);

            makeGridSwatches(relatedSection.parentElement);

            const outerGridWrappers = relatedSection.querySelectorAll(selectors$3.dataRelatedProduct);
            outerGridWrappers.forEach((wrap) => {
              new ProductAddButton(wrap);
            });

            if (relatedSection.querySelector(selectors$3.slider)) {
              relatedSection.querySelector(selectors$3.slider).setAttribute(selectors$3.gridLarge, numberSlides);
              new Slider(relatedSection, relatedSection.querySelector(selectors$3.slider));
            }
          } else {
            relatedSection.dispatchEvent(
              new CustomEvent("tabs:hideRelatedTab", {
                bubbles: true,
              })
            );
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    }

    recent() {
      const recentlyViewedHolder = this.container.querySelector(selectors$3.recentlyViewed);
      const recentlyViewedWrapper = this.container.querySelector(selectors$3.recentlyViewedWrapper);
      const recentProducts = this.container.querySelectorAll(selectors$3.dataRelatedProduct);

      const minimumNumberProducts = recentlyViewedHolder.hasAttribute(selectors$3.dataMinimum)
        ? parseInt(recentlyViewedHolder.getAttribute(selectors$3.dataMinimum))
        : 4;
      const checkRecentInRelated = !recentlyViewedWrapper && recentProducts.length > 0;
      const checkRecentOutsideRelated = recentlyViewedWrapper && recentProducts.length >= minimumNumberProducts;

      if (checkRecentInRelated || checkRecentOutsideRelated) {
        recentlyViewedHolder.dispatchEvent(
          new CustomEvent("tabs:checkRecentTab", {
            bubbles: true,
          })
        );

        makeGridSwatches(this.container);

        if (recentlyViewedHolder.querySelector(selectors$3.slider)) {
          new Slider(recentlyViewedHolder, recentlyViewedHolder.querySelector(selectors$3.slider));
        }
      }
    }
  }

  const relatedSection = {
    onLoad() {
      this.section = new Related(this);
    },
  };

  register("related", [relatedSection, tabs, recentProducts]);

  if (!customElements.get("radio-swatch")) {
    customElements.define("radio-swatch", RadioSwatch);
  }

  const selectors$2 = {
    ajaxDisable: "data-ajax-disable",
    shipping: "[data-shipping-estimate-form]",
    input: "[data-update-cart]",
    update: "[data-update-button]",
    bottom: "[data-cart-bottom]",
    upsellProduct: "[data-upsell-holder]",
    upsellButton: "[data-add-action-wrapper]",
  };

  const cartSection = {
    onLoad() {
      const hasShipping = this.container.querySelector(selectors$2.shipping);
      if (hasShipping) {
        new ShippingCalculator(this);
      }

      this.disabled = this.container.getAttribute(selectors$2.ajaxDisable) == "true";
      if (this.disabled) {
        this.cart = new DisabledCart(this);
        return;
      }

      this.cart = new CartItems(this);
      const initPromise = this.cart.init();
      initPromise.then(() => {
        this.cart.loadHTML();
      });
    },
  };

  class DisabledCart {
    constructor(section) {
      this.section = section;
      this.container = section.container;
      this.inputs = this.container.querySelectorAll(selectors$2.input);
      this.quantityWrappers = this.container.querySelectorAll(selectors$2.qty);
      this.updateBtn = this.container.querySelector(selectors$2.update);
      this.upsellProduct = this.container.querySelector(selectors$2.upsellProduct);
      this.initQuantity();
      this.initInputs();
      if (this.upsellProduct) {
        this.moveUpsell();
      }
    }

    initQuantity() {
      initQtySection(this.container);
    }

    moveUpsell() {
      const bottom = this.container.querySelector(selectors$2.bottom);
      bottom.insertBefore(this.upsellProduct, bottom.firstChild);
    }

    initInputs() {
      this.inputs.forEach((input) => {
        input.addEventListener(
          "change",
          function () {
            this.updateBtn.classList.add("cart--dirty");
            this.updateBtn.classList.add("heartBeat");
            setTimeout(
              function () {
                this.updateBtn.classList.remove("heartBeat");
              }.bind(this),
              1300
            );
          }.bind(this)
        );
      });
    }
  }

  register("cart", [cartSection, accordion]);

  if (!customElements.get("upsell-product")) {
    customElements.define("upsell-product", UpsellProduct);
  }

  register("accordion-single", accordion);

  const fadeIn = (el, display, callback = null) => {
    el.style.opacity = 0;
    el.style.display = display || "block";

    (function fade() {
      let val = parseFloat(el.style.opacity);
      if (!((val += 0.1) > 1)) {
        el.style.opacity = val;
        requestAnimationFrame(fade);
      }

      if (val === 1 && typeof callback === "function") {
        callback();
      }
    })();
  };

  const fadeOut = (el, callback = null) => {
    el.style.opacity = 1;

    (function fade() {
      if ((el.style.opacity -= 0.1) < 0) {
        el.style.display = "none";
      } else {
        requestAnimationFrame(fade);
      }

      if (parseFloat(el.style.opacity) === 0 && typeof callback === "function") {
        callback();
      }
    })();
  };

  const selectors$1 = {
    newsletterForm: "[data-newsletter-form]",
  };

  const classes$1 = {
    success: "has-success",
    error: "has-error",
  };

  const sections$1 = {};

  class NewsletterCheckForResult {
    constructor(newsletter) {
      this.sessionStorage = window.sessionStorage;
      this.newsletter = newsletter;

      this.stopSubmit = true;
      this.isChallengePage = false;
      this.formID = null;

      this.checkForChallengePage();

      this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e);

      if (!this.isChallengePage) {
        this.init();
      }
    }

    init() {
      this.newsletter.addEventListener("submit", this.newsletterSubmit);

      this.showMessage();
    }

    newsletterSubmitEvent(e) {
      if (this.stopSubmit) {
        e.preventDefault();

        this.removeStorage();
        this.writeStorage();
        this.stopSubmit = false;
        this.newsletter.submit();
      }
    }

    checkForChallengePage() {
      this.isChallengePage = window.location.pathname === "/challenge";
    }

    writeStorage() {
      if (this.sessionStorage !== undefined) {
        this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
      }
    }

    readStorage() {
      this.formID = this.sessionStorage.getItem("newsletter_form_id");
    }

    removeStorage() {
      this.sessionStorage.removeItem("newsletter_form_id");
    }

    showMessage() {
      this.readStorage();

      if (this.newsletter.id === this.formID) {
        const newsletter = document.getElementById(this.formID);

        if (window.location.search.indexOf("?customer_posted=true") !== -1) {
          newsletter.classList.remove(classes$1.error);
          newsletter.classList.add(classes$1.success);
        } else if (window.location.search.indexOf("accepts_marketing") !== -1) {
          newsletter.classList.remove(classes$1.success);
          newsletter.classList.add(classes$1.error);
        }

        this.scrollToForm(newsletter);
      }
    }

    scrollToForm(newsletter) {
      const rect = newsletter.getBoundingClientRect();
      const isVisible =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth);

      if (!isVisible) {
        setTimeout(() => {
          window.scroll({
            top: rect.top,
            left: 0,
            behavior: "smooth",
          });
        }, 400);
      }
    }

    unload() {
      this.newsletter.removeEventListener("submit", this.newsletterSubmit);
    }
  }

  const newsletterCheckForResultSection = {
    onLoad() {
      sections$1[this.id] = [];
      const newsletters = this.container.querySelectorAll(selectors$1.newsletterForm);
      newsletters.forEach((form) => {
        sections$1[this.id].push(new NewsletterCheckForResult(form));
      });
    },
    onUnload() {
      sections$1[this.id].forEach((form) => {
        if (typeof form.unload === "function") {
          form.unload();
        }
      });
    },
  };

  const selectors = {
    tracking: "[data-tracking-consent]",
    trackingAccept: "[data-confirm-cookies]",
    close: "[data-close-modal]",
    popupInner: "[data-popup-inner]",
    newsletterPopup: "[data-newsletter]",
    newsletterPopupHolder: "[data-newsletter-holder]",
    newsletterField: "[data-newsletter-field]",
    newsletterForm: "[data-newsletter-form]",
    promoPopup: "[data-promo-text]",
    delayAttribite: "data-popup-delay",
    cookieNameAttribute: "data-cookie-name",
    dataTargetReferrer: "data-target-referrer",
  };

  const classes = {
    hide: "hide",
    hasValue: "has-value",
    success: "has-success",
    desktop: "desktop",
    mobile: "mobile",
  };

  let sections = {};

  class PopupCookie {
    constructor(name, value) {
      this.configuration = {
        expires: null, // session cookie
        path: "/",
        domain: window.location.hostname,
      };
      this.name = name;
      this.value = value;
    }

    write() {
      const hasCookie =
        document.cookie.indexOf("; ") !== -1 && !document.cookie.split("; ").find((row) => row.startsWith(this.name));
      if (hasCookie || document.cookie.indexOf("; ") === -1) {
        document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
      }
    }

    read() {
      if (
        document.cookie.indexOf("; ") !== -1 &&
        document.cookie.split("; ").find((row) => row.startsWith(this.name))
      ) {
        const returnCookie = document.cookie
          .split("; ")
          .find((row) => row.startsWith(this.name))
          .split("=")[1];

        return returnCookie;
      } else return false;
    }

    destroy() {
      if (document.cookie.split("; ").find((row) => row.startsWith(this.name))) {
        document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
      }
    }
  }

  class DelayShow {
    constructor(holder, element) {
      this.element = element;
      this.delay = holder.getAttribute(selectors.delayAttribite);

      if (this.delay === "always") {
        this.always();
      }

      if (this.delay === "delayed") {
        this.delayed();
      }

      if (this.delay === "bottom") {
        this.bottom();
      }

      if (this.delay === "idle") {
        this.idle();
      }
    }

    always() {
      fadeIn(this.element);
    }

    delayed() {
      // Show popup after 10s
      setTimeout(() => {
        fadeIn(this.element);
      }, 10000);
    }

    // Scroll to the bottom of the page
    bottom() {
      window.addEventListener("scroll", () => {
        if (window.scrollY + window.innerHeight >= document.body.clientHeight) {
          fadeIn(this.element);
        }
      });
    }

    // Idle for 1 min
    idle() {
      let timer = 0;
      let idleTime = 60000;
      const documentEvents = [
        "mousemove",
        "mousedown",
        "click",
        "touchmove",
        "touchstart",
        "touchend",
        "keydown",
        "keypress",
      ];
      const windowEvents = ["load", "resize", "scroll"];

      const startTimer = () => {
        timer = setTimeout(() => {
          timer = 0;
          fadeIn(this.element);
        }, idleTime);

        documentEvents.forEach((eventType) => {
          document.addEventListener(eventType, resetTimer);
        });

        windowEvents.forEach((eventType) => {
          window.addEventListener(eventType, resetTimer);
        });
      };

      const resetTimer = () => {
        if (timer) {
          clearTimeout(timer);
        }

        documentEvents.forEach((eventType) => {
          document.removeEventListener(eventType, resetTimer);
        });

        windowEvents.forEach((eventType) => {
          window.removeEventListener(eventType, resetTimer);
        });

        startTimer();
      };

      startTimer();
    }
  }

  class TargetReferrer {
    constructor(el) {
      this.el = el;
      this.locationPath = location.href;

      if (!this.el.hasAttribute(selectors.dataTargetReferrer)) {
        return;
      }

      this.init();
    }

    init() {
      if (
        this.locationPath.indexOf(this.el.getAttribute(selectors.dataTargetReferrer)) === -1 &&
        !window.Shopify.designMode
      ) {
        this.el.parentNode.removeChild(this.el);
      }
    }
  }

  class Tracking {
    constructor(el) {
      this.popup = el;
      this.modal = document.querySelector(selectors.tracking);
      this.modalInner = this.popup.querySelector(selectors.popupInner);
      this.close = this.modal.querySelector(selectors.close);
      this.acceptButton = this.modal.querySelector(selectors.trackingAccept);
      this.enable = this.modal.getAttribute("data-enable") === "true";
      this.showPopup = false;

      window.Shopify.loadFeatures(
        [
          {
            name: "consent-tracking-api",
            version: "0.1",
          },
        ],
        (error) => {
          if (error) {
            throw error;
          }

          const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
          const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

          this.showPopup = !userCanBeTracked && userTrackingConsent === "no_interaction" && this.enable;

          if (window.Shopify.designMode) {
            this.showPopup = true;
          }

          this.init();
        }
      );
    }

    init() {
      if (this.showPopup) {
        fadeIn(this.modalInner);
      }

      this.clickEvents();
    }

    clickEvents() {
      this.close.addEventListener("click", (event) => {
        event.preventDefault();

        window.Shopify.customerPrivacy.setTrackingConsent(false, () => fadeOut(this.modalInner));
      });

      this.acceptButton.addEventListener("click", (event) => {
        event.preventDefault();

        window.Shopify.customerPrivacy.setTrackingConsent(true, () => fadeOut(this.modalInner));
      });

      document.addEventListener("trackingConsentAccepted", function () {
        //console.log("trackingConsentAccepted event fired");
      });
    }

    onBlockSelect(evt) {
      if (this.popup.contains(evt.target) && this.showPopup) {
        fadeIn(this.modalInner);
      }
    }

    onBlockDeselect(evt) {
      if (this.popup.contains(evt.target)) {
        fadeOut(this.modalInner);
      }
    }
  }

  class PromoText {
    constructor(el) {
      this.popup = el;
      this.popupInner = this.popup.querySelector(selectors.popupInner);
      this.close = this.popup.querySelector(selectors.close);
      this.cookie = new PopupCookie(this.popup.getAttribute(selectors.cookieNameAttribute), "user_has_closed");
      this.isTargeted = new TargetReferrer(this.popup);
      this.hasDeviceClass = "";

      this.init();
    }

    init() {
      const cookieExists = this.cookie.read() !== false;

      if (!cookieExists || window.Shopify.designMode) {
        if (!window.Shopify.designMode) {
          new DelayShow(this.popup, this.popupInner);
        } else {
          fadeIn(this.popupInner);
        }

        this.clickEvents();
      }
    }

    clickEvents() {
      this.close.addEventListener("click", (event) => {
        event.preventDefault();

        fadeOut(this.popupInner);
        this.cookie.write();
      });
    }

    onBlockSelect(evt) {
      if (this.popup.classList.contains(classes.mobile)) {
        this.hasDeviceClass = classes.mobile;
      }

      if (this.popup.classList.contains(classes.desktop)) {
        this.hasDeviceClass = classes.desktop;
      }

      if (this.hasDeviceClass !== "") {
        this.popup.classList.remove(this.hasDeviceClass);
      }

      if (this.popup.contains(evt.target)) {
        fadeIn(this.popupInner);
      }
    }

    onBlockDeselect(evt) {
      if (this.popup.contains(evt.target)) {
        fadeOut(this.popupInner);
      }

      if (this.hasDeviceClass !== "") {
        this.popup.classList.add(this.hasDeviceClass);
      }
    }
  }

  class NewsletterPopup {
    constructor(el) {
      this.popup = el;
      this.popupInner = this.popup.querySelector(selectors.popupInner);
      this.holder = this.popup.querySelector(selectors.newsletterPopupHolder);
      this.close = this.popup.querySelector(selectors.close);
      this.newsletterField = this.popup.querySelector(selectors.newsletterField);
      this.cookie = new PopupCookie(this.popup.getAttribute(selectors.cookieNameAttribute), "newsletter_is_closed");
      this.form = this.popup.querySelector(selectors.newsletterForm);
      this.isTargeted = new TargetReferrer(this.popup);

      this.init();
    }

    init() {
      const cookieExists = this.cookie.read() !== false;

      if (!cookieExists || window.Shopify.designMode) {
        this.show();

        if (this.form.classList.contains(classes.success)) {
          this.checkForSuccess();
        }
      }
    }

    show() {
      if (!window.Shopify.designMode) {
        new DelayShow(this.popup, this.popupInner);
      } else {
        fadeIn(this.popupInner);
      }

      this.inputField();
      this.closePopup();
    }

    checkForSuccess() {
      fadeIn(this.popupInner);
      this.cookie.write();
    }

    closePopup() {
      this.close.addEventListener("click", (event) => {
        event.preventDefault();

        fadeOut(this.popupInner);
        this.cookie.write();
      });
    }

    inputField() {
      this.newsletterField.addEventListener("input", () => {
        if (this.newsletterField.value !== "") {
          this.holder.classList.add(classes.hasValue, this.newsletterField.value !== "");
        }
      });

      this.newsletterField.addEventListener("focus", () => {
        if (this.newsletterField.value !== "") {
          this.holder.classList.add(classes.hasValue, this.newsletterField.value !== "");
        }
      });

      this.newsletterField.addEventListener("focusout", () => {
        setTimeout(() => {
          this.holder.classList.remove(classes.hasValue);
        }, 2000);
      });
    }

    onBlockSelect(evt) {
      if (this.popup.contains(evt.target)) {
        fadeIn(this.popupInner);
      }
    }

    onBlockDeselect(evt) {
      if (this.popup.contains(evt.target)) {
        fadeOut(this.popupInner);
      }
    }
  }

  const popupSection = {
    onLoad() {
      sections[this.id] = [];

      const tracking = this.container.querySelectorAll(selectors.tracking);
      tracking.forEach((el) => {
        sections[this.id].push(new Tracking(el));
      });

      const newsletterPopup = this.container.querySelectorAll(selectors.newsletterPopup);
      newsletterPopup.forEach((el) => {
        sections[this.id].push(new NewsletterPopup(el));
      });

      const promoPopup = this.container.querySelectorAll(selectors.promoPopup);
      promoPopup.forEach((el) => {
        sections[this.id].push(new PromoText(el));
      });
    },
    onBlockSelect(evt) {
      sections[this.id].forEach((el) => {
        if (typeof el.onBlockSelect === "function") {
          el.onBlockSelect(evt);
        }
      });
    },
    onBlockDeselect(evt) {
      sections[this.id].forEach((el) => {
        if (typeof el.onBlockDeselect === "function") {
          el.onBlockDeselect(evt);
        }
      });
    },
  };

  register("popups", [popupSection, newsletterCheckForResultSection]);

  register("tabs", tabs);

  const selectors$V = {
    modal: "[data-enrollment-locator-modal]",
    content: "data-enrollment-locator-modal-content",
    form: "[data-enrollment-locator-form]",
    formError: "[data-enrollment-locator-form-error]",
    input: "data-enrollment-locator-input",
    zipSubmit: '[data-enrollment-locator-submit="zip"]',
    zipReset: "[data-enrollment-locator-zip-reset]",
    contactSubmit: '[data-enrollment-locator-submit="contact"]',
    findMyLocation: "[data-enrollment-locator-find-my-location]",

    matchNameEl: "[data-enrollment-locator-match-name]",
    matchPhoneEl: "[data-enrollment-locator-match-phone]",
    matchZipEl: "[data-enrollment-locator-match-zip]",
    matchQrEl: "[data-enrollment-locator-match-qr]",
    matchWhatsappEl: "[data-enrollment-locator-match-whatsapp]",
    formEnrollment: "[enrollment-locator-form]"
  };

  class EnrollmentLocator {
    constructor(wrapper) {
      modal("enrollment-locator");
      modal("enrollment-info");

      this.modal = wrapper;
      this.content = this.modal.querySelector(`[${selectors$V.content}]`);
      this.zipSubmit = this.modal.querySelector(selectors$V.zipSubmit);
      this.zipReset = this.modal.querySelector(selectors$V.zipReset);
      this.contactSubmits = this.modal.querySelectorAll(selectors$V.contactSubmit);
      this.findMyLocation = this.modal.querySelectorAll(selectors$V.findMyLocation);

      this.matchNameEl = this.modal.querySelector(selectors$V.matchNameEl);
      this.matchPhoneEl = this.modal.querySelector(selectors$V.matchPhoneEl);
      this.matchZipEl = this.modal.querySelector(selectors$V.matchZipEl);
      this.matchQrEl = this.modal.querySelector(selectors$V.matchQrEl);
      this.matchWhatsappEl = this.modal.querySelectorAll(selectors$V.matchWhatsappEl);

      this.zipCode = "";
      this.consultant = {
        usercode: null,
        name: null,
        phone: null,
        zip: null,
      };
      this.tags = [];

      this.baseURL = `https://${HOST_AWS_URL}/Prod`;
      this.geocodeBaseURL = "https://maps.googleapis.com/maps/api/geocode/json?";
      this.key = "AIzaSyC-to9oGgxoraWdZJPckgKVIsxSg9oj9m8";
      this.forms = this.modal.querySelectorAll(selectors$V.formEnrollment);

      this.init();
    }

    async init() {
      document.addEventListener("theme:partner:set", (event) => {
        this.partner = event.detail.partner;
        if (this.partner) this.handleEnrollWithExistingConsultant();
      });

      document.addEventListener("theme:partner:update", (event) => {
        this.partner = event.detail.partner;
        if (this.partner) this.handleEnrollWithExistingConsultant();
      });

      this.zipReset.addEventListener("click", this.handleZipCodeReset.bind(this));

      this.zipSubmit.addEventListener("click", this.handleZipCodeSubmit.bind(this));

      this.contactSubmits.forEach((submit) => {
        submit.addEventListener("click", this.handleContactInfoSubmit.bind(this));
      });


      this.findMyLocation.forEach((elem) => {
        elem.addEventListener("click", this.handleFindMyLocation.bind(this));
      });
    }

    async handleEnrollWithExistingConsultant() {
      this.setExistingConsultant();
      this.renderState("default", "matched");
    }

    //get Dsitributor & Associate
    async handleZipCodeSubmit() {
      const form = this.zipSubmit.closest(selectors$V.form);
      const input = form.querySelector(`[${selectors$V.input}]`);

      const zipValid = this.validateZipCode(input, form);
      if (!zipValid) return;

      this.zipCode = input.value;
      form.classList.remove("has-error");
      this.renderState("default", "loading");

      const data = await this.getConsultants(this.zipCode);
      const matchData = this.getConsultantMatch(data.nodes);
      //Match Distributor or Associate
      console.log(matchData)

      if (matchData) {
        this.renderMatchedConsultant(matchData);
        this.renderState("loading", "matched");
      } else {
        this.renderState("loading", "no-match");
      }
    }

    handleZipCodeReset() {
      this.zipCode = "";
      this.renderState("no-match", "default");
    }

    validateZipCode(input, formElem) {
      var valid = false;
      // const zipRegex = /^(\d{5})$/;
      // valid = zipRegex.test(zipCode);
      valid = input.checkValidity();

      if (!valid) this.showMissingInputsError("zip", formElem);
      return valid;
    }

    renderState(prev, curr) {
      this.content.classList.remove(prev);
      this.content.classList.add(curr);
      this.content.setAttribute(selectors$V.content, curr);
    }

    async getConsultants(zipCode) {
      const url = `${this.baseURL}/enrollment/locator?key=zip_codes&zipCode=${zipCode}`;
      return await fetch(url).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });

        const data = await res.json();
        return data;
      });
    }

    getConsultantMatch(results) {
      let matchData = null;
      if (!results.length) return matchData;

      // randomly pick from results
      const randomIndex = Math.floor(Math.random() * results.length);
      const target = results[randomIndex];

      // get relevant entries from target result
      const targetKeys = ["usercode_list", "phone_number_list", "new_prospect_list", "type_list", "last_name_1_list"];
      const targetLists = targetKeys.map((key) => {
        let field = target.fields.find((field) => field.key === key);
        let list = JSON.parse(field?.value);
        return list;
      });

      // construct list data object
      const targetListDataCols = ["usercode", "phone", "new_prospect", "type", "name"];
      const targetListDataRows = [];
      for (var i = 0; i < targetLists[0].length; i++) {
        targetListDataRows.push(targetLists.map((item) => item[i]));
      }
      const targetListData = targetListDataRows.map(function (row) {
        return row.reduce(function (result, field, index) {
          result[targetListDataCols[index]] = field;
          return result;
        }, {});
      });

      // filter out distributors who opted out of enrollment process
      let targetListDataFiltered = [];
      const targetListDataFirstFilter = targetListData.filter((item) => item.new_prospect === "1");
      if (targetListDataFirstFilter.length) {
        targetListDataFiltered = targetListDataFirstFilter;

        let targetListDataSecondFilter = [];
        // if enrollment type is distributor, prioritize advisers over distributors
        if (this.modal.id === "join-distributor") {
          targetListDataSecondFilter = targetListDataFirstFilter.filter((item) => item.type === "Asesor");
        }
        // if enrollment type is associate, prioritize distributors over advisers
        if (this.modal.id === "join-associate") {
          targetListDataSecondFilter = targetListDataFirstFilter.filter((item) => item.type === "Distrib");
        }

        if (targetListDataSecondFilter.length) {
          targetListDataFiltered = targetListDataSecondFilter;
        }
      }

      // randomly pick from filtered distributors
      if (targetListDataFiltered.length) {
        const randomIndex = Math.floor(Math.random() * targetListDataFiltered.length);
        const match = targetListDataFiltered[randomIndex];
        const targetId = parseFloat(target.id.replace("gid://shopify/Metaobject/", ""));
        const targetZipField = target.fields.find((field) => field.key === "zipcode");
        const targetZip = targetZipField?.value;

        matchData = {
          id: targetId,
          zip: targetZip,
          ...match,
        };
      }
      return matchData;
    }

    renderMatchedConsultant(matchData) {
      this.consultant.usercode = matchData.usercode;
      this.consultant.name = matchData.name;
      this.consultant.phone = matchData.phone;
      this.consultant.zip = matchData.zip;

      this.renderConsultant();
    }

    setExistingConsultant() {
      this.consultant.usercode = this.partner.betterwarePlusId;
      this.consultant.name = this.partner.displayName;
      this.consultant.phone = this.partner.phone;
      this.consultant.zip = this.partner.zip;

      this.renderConsultant();
    }

    renderConsultant() {
      this.matchNameEl.textContent = this.consultant.name;
      this.matchZipEl.textContent = this.consultant.zip;

      if (this.consultant.phone) {
        const phoneNumber = this.consultant.phone.replace(/[^0-9]/g, "");
        this.matchPhoneEl.textContent = this.consultant.phone;

        this.matchQrLink = `https://wa.me/${phoneNumber}?text=Hola, me gustaría unirme a Betterware, mi nombre es name-placeholder`;
        this.matchQrEl.src = `https://quickchart.io/qr?text=${this.matchQrLink}&size=144`;
        this.matchQrEl.classList.remove("hide");
        this.matchWhatsappEl[0].href = this.matchQrLink;
        this.matchWhatsappEl[1].href = this.matchQrLink;
        this.matchWhatsappEl[1].classList.remove("hide");
      } else {
        this.matchPhoneEl.parentElement.classList.add("hide");
        this.matchQrEl.parentElement.classList.add("hide");
        this.matchWhatsappEl.parentElement.classList.add("hide");
      }
    }

    //Associate submit
    async handleContactInfoSubmit(evt) {
      const state = this.content.getAttribute(selectors$V.content);
      const target = evt.currentTarget;
      const form = target.closest(selectors$V.form);
      const inputs = form.querySelectorAll(`[${selectors$V.input}]`);
      const inputsArr = Array.from(inputs);

      const formValid = this.validateEnrollmentForm(inputs, form);
      if (!formValid) return;

      const formData = inputsArr.reduce((prev, curr) => ({ ...prev, [curr.getAttribute("name")]: curr.value }), {});
      this.customerName = `${formData.firstName} ${formData.lastName}`;
      this.matchQrEl.src = this.matchQrEl.src.replace("name-placeholder", this.customerName);
      this.matchWhatsappEl[0].href = this.matchWhatsappEl[0].href.replace("name-placeholder", this.customerName);
      this.matchWhatsappEl[1].href = this.matchWhatsappEl[1].href.replace("name-placeholder", this.customerName);

      this.configureEnrollmentCustomerTags(state);

      target.disabled = true;
      target.classList.add("loading");

      const dataConsultant = {"DistriutorCode":this.consultant.usercode,"name": this.consultant.name, "phone": this.consultant.phone, "zip": this.consultant.zip}

      const leadBy = window.theme.storefront_partner
      ? window.theme.storefront_partner.siteName + " - " + this.consultant.usercode
      : "betterware";


      try {
       await this.createEnrollmentCustomer(
         formData.firstName,
         formData.lastName,
         formData.email,
         formData.phone,
         this.zipCode ? this.zipCode : formData.zip,
         this.tags,
         this.consultant.usercode,
         this.consultant.phone,
         leadBy
       );
       //Notification WA
       this.notificationToAssociate(formData, dataConsultant)
       this.notificationToDistributor(formData, dataConsultant)

        target.classList.remove("loading");
        target.classList.add("has-success");


        setTimeout(() => {
          target.classList.remove("has-success");
          target.disabled = false;
          if (state === "matched") {
            this.renderState("matched", "post-matched");
          } else if (state === "no-match") {
            this.renderState("no-match", "post-no-match");
          }
        }, 1500);
      } catch (e) {
        this.showError(e, form, target);
        console.error(e);
        return
      }
    }

    async notificationToAssociate(dataProspect, dataConsultant) {
      const url = `https://${HOST_AWS_URL}/Prod/notifications`;
      const dataNotification = {
        "phone": `52${dataProspect.phone.toString().trim()}`,
        "template": "distribuidor_asignado", //this notification indicates to AS her distributor
        "parametersBody": [
          {
            "text": dataConsultant.name.toString(),
            "parameter_name": "nombre_distribuidor",
            "type": "text"
          },
          {
            "text": dataConsultant.phone.toString(),
            "parameter_name": "numero_distribuidor",
            "type": "text"
          }
        ],
        "parametersHeader": [
          {
            "text": dataProspect.firstName.toString(),
            "parameter_name": "nombre_prospecto",
            "type": "text"
          }
        ]
      }

      try {
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataNotification),
        });
      } catch (error) {
        console.error("Error en la solicitud:", error.message);
        throw error; 
      }
    }

    async notificationToDistributor(dataProspect, dataConsultant) {
      const url = `https://${HOST_AWS_URL}/Prod/notifications`;
      const dataNotification = {
        "phone": `52${dataConsultant.phone.toString().trim()}`,
        "template": "prospecto_asignado", //this notification indicates to DS her Associate
        "parametersBody": [
          {
            "text": dataProspect.firstName.toString(),
            "parameter_name": "nombre_prospecto",
            "type": "text"
          },
          {
            "text": dataProspect.phone.toString(),
            "parameter_name": "numero_prospecto",
            "type": "text"
          }
        ]
      }

      try {
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataNotification),
        });
      } catch (error) {
        console.error("Error en la solicitud:", error.message);
        throw error; 
      }
    }

    validateEnrollmentForm(inputs, formElem) {
      var valid = false;

      Array.from(inputs).every((input) => {
        valid = input.checkValidity();
        return valid;
      });

      if (!valid) this.showMissingInputsError("contact", formElem);
      return valid;
    }

    configureEnrollmentCustomerTags(state) {
      if (this.modal.id === "join-associate") {
        this.tags.push("UserType_Associate");
      } else if (this.modal.id === "join-distributor") {
        this.tags.push("UserType_Distributor");
      }

      if (state === "matched") {
        this.tags.push(`matched:${this.consultant.name}`);
      } else if (state === "no-match") {
        this.tags.push("no_match");
      }
    }

    async createEnrollmentCustomer(firstName, lastName, email, phone, zip, tags, matchUsercode, matchPhone, leadBy) {
      const url = `${this.baseURL}/enrollment/customer`;
      const data = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: `+52${phone}`,
        zip: zip,
        tags: tags,
        matchedDistributorName: matchUsercode,
        matchedDistributorNumber: matchPhone,
        leadBy: leadBy,
      };

      
      await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (!res.ok)
          return res.text().then((text) => {
            throw new Error(text);
          });
      });
    
    }

    showMissingInputsError(type, formElem) {
      let errorMessage = "";
      if (type === "zip") {
        errorMessage = theme.strings.enrollmentLocator.invalidZipError;
      } else {
        errorMessage = theme.strings.enrollmentLocator.missingFieldsError;
      }

      const formError = formElem.querySelector(selectors$V.formError);
      formError.textContent = errorMessage;
      formElem.classList.add("has-error");
    }

    showError(error, formElem, target) {
      let data = null;
      try {
        data = JSON.parse(error.message);
      } catch {}

      let errorMessage = "";
      let errorField = "";
      if (data && data.error && data.error.length > 0) {
        errorMessage = data.error[0].message;
        errorField = data.error[0].field[0];
      }

      const inputError = formElem.querySelector(`[${selectors$V.input}][name="${errorField}"]`);
      const formError = formElem.querySelector(selectors$V.formError);
      if (inputError) inputError.classList.add("has-error");
      formError.textContent =
        errorMessage === "Email is invalid"
          ? theme.strings.enrollmentLocator.invalidEmailError
          : errorMessage === "Email has already been taken"
          ? theme.strings.enrollmentLocator.emailInUseError
          : errorMessage === "Enter a valid phone number"
          ? theme.strings.enrollmentLocator.invalidPhoneError
          : errorMessage === "Phone has already been taken"
          ? theme.strings.enrollmentLocator.phoneInUseError
          : "";
      formElem.classList.add("has-error");

      target.classList.remove("loading");
      target.disabled = false;
    }

    handleFindMyLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.zipCodeLookup.bind(this),
          this.showFindMyLocationError.bind(this)
        );
      } else {
        alert(theme.strings.enrollmentLocator.geolocationNotSupported);
      }
    }

    showFindMyLocationError() {
      alert(theme.strings.enrollmentLocator.geolocationNotPermitted);
    }

    zipCodeLookup(position) {
      const lat = position.coords.latitude;
      const long = position.coords.longitude;
      const url = `${this.geocodeBaseURL}latlng=${lat},${long}&key=${this.key}`;

      axios
        .get(url)
        .then((response) => {
          var results = response.data.results;
          if (results.length) {
            var zipIndex = results[0].address_components.length - 1;
            var zip = results[0].address_components[zipIndex]?.long_name;
            if (zip) this.autofillZipCode(zip);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    autofillZipCode(zip) {
      const form = this.zipSubmit.closest(selectors$V.form);
      const input = form.querySelector(`[${selectors$V.input}]`);
      input.value = zip;
    }
  }

  const enrollmentLocator = {
    onLoad() {
      const wrappers = document.querySelectorAll(selectors$V.modal);
      wrappers.forEach((wrapper) => {
        new EnrollmentLocator(wrapper);
      });
    },
  };

  register("join", [enrollmentLocator, popupVideoSection]);

  class Dashboard {
    static selectors = {
      addBtn: "[data-add-product]",
      navs: ".dashboard-nav__item",
      sections: ".dashboard__section",
      idInput: "#pick_product_input",
      feedbackInput: "[data-pick-feedback]",
      edit: "[data-edit-pick]",
      delete: "[data-delete-pick]",
      aside: ".dashboard__aside",
      go_back: "[data-go-back]",
    };

    static DEFAULT_SECTION = "profile";

    constructor(container) {
      this.wrapper = container;
      this.navs = this.wrapper.querySelectorAll(Dashboard.selectors.navs);
      this.sections = this.wrapper.querySelectorAll(Dashboard.selectors.sections);
      this.links = this.wrapper.querySelectorAll("a");
      this.aside = this.wrapper.querySelector(Dashboard.selectors.aside);
      this.go_back_btns = this.wrapper.querySelectorAll(Dashboard.selectors.go_back);
      this.init();

      modal("dashboard-error");

      new DashboardProfile(this.wrapper);
      new DashboardAddress(this.wrapper);
      new DashboardPersonalize(this.wrapper);
      new PartnerPicks(this.wrapper);
    }

    init() {
      this.navs.forEach((nav) => nav.addEventListener("click", this.onNavClick.bind(this)));
      this.go_back_btns.forEach((btn) => btn.addEventListener("click", this.unselectSection.bind(this)));

      const urlSection = window.location.hash.substring(1);
      const defaultSection = urlSection || Dashboard.DEFAULT_SECTION;
      if (this.isMobile() && urlSection) this.showSection(urlSection);
      else this.showSection(defaultSection);
    }

    isMobile() {
      return window.innerWidth < 989;
    }

    onNavClick(event) {
      const section = event.target.dataset.navFor;
      this.showSection(section);
    }

    /**
     * Show section by id
     * @param {string} sectionName
     */
    showSection(sectionName) {
      const sectionToShow = [...this.sections].find((section) => section.dataset.dashboardSection === sectionName);
      const navToShow = [...this.navs].find((nav) => nav.dataset.navFor === sectionName);
      if (!sectionToShow || !navToShow) return;

      // Show section
      this.sections.forEach((section) => section.classList.remove("active", "visible"));
      sectionToShow.classList.add("active");
      setTimeout(() => sectionToShow.classList.add("visible"), 100);

      // Highlight nav
      this.navs.forEach((nav) => nav.classList.remove("active"));
      navToShow.classList.add("active");

      // Hide on mobile
      this.aside.classList.remove("visible");

      // Set hash
      window.location.hash = sectionName;
    }

    /**
     * Mobile specific action to go to nav
     */
    unselectSection() {
      this.sections.forEach((section) => section.classList.remove("visible"));
      setTimeout(() => this.sections.forEach((section) => section.classList.remove("active")), 500);
      this.navs.forEach((nav) => nav.classList.remove("active"));
      this.aside.classList.add("visible");
    }
  }

  const BUTTON_TRANSITION_DURATION = 2000;

  class DashboardErrorModal {
    static selectors = {
      modal: "#dashboard-error",
      title: "[data-error-modal-title]",
      subtitle: "[data-error-modal-subtitle]",
    };

    static message_map = {
      "Enter a valid phone number": "Ingresa un número de teléfono válido",	
      "Email is invalid": "Ingresa un correo electrónico válido",
      "Email has already been taken": "Este correo electrónico ya está registrado en nuestro sistema",
      "Enter a valid phone number to use this delivery method": "Ingresa un número de teléfono válido para usar este método de entrega",
      "Phone has already been taken": "Por favor ingresa un número de teléfono diferente, este ya está registrado en nuestro sistema.",
      "Site name contains bad words": "Esta palabra no puede ser utilizada en tu tienda digital, por favor elige un término diferente.",
    };

    constructor(customMessage) {
      this.modal = document.querySelector(DashboardErrorModal.selectors.modal);
      this.modal_title = this.modal.querySelector(DashboardErrorModal.selectors.title);
      this.modal_subtitle = this.modal.querySelector(DashboardErrorModal.selectors.subtitle);
      this.error_message = customMessage;
    }

    showError(error) {
      let data = null;
      try {
        data = JSON.parse(error.message);
      } catch {}

      let errorMessage = "";
      if (data && data.error && data.error.length > 0) {
        errorMessage = data.error[0].message;
      }

      if (DashboardErrorModal.message_map[errorMessage]) errorMessage = DashboardErrorModal.message_map[errorMessage];

      MicroModal.show("dashboard-error", {
        disableScroll: true,
        disableFocus: true,
      });
      
      if (errorMessage) this.modal_subtitle.innerHTML = this.error_message || errorMessage;
    }
  }

  class DashboardFormHelper {
    static updateDOM({ data, elem, attr = "innerHTML" }) {
      if (!elem) return;
      elem[attr] = data;
    }

    static preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    static debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    constructor({ btnElem, inputElems = null, modalName = null }) {
      this.btnElem = btnElem;
      this.inputElems = inputElems;
      this.modalName = modalName;
    }

    setLoading() {
      if (!this.btnElem) return;
      this.btnElem.classList.add("loading");

      if (!this.inputElems) return;
      this.inputElems.forEach((elem) => elem.setAttribute("disabled", "disabled"));
    }

    setCompleted(transitionDelay = BUTTON_TRANSITION_DURATION) {
      if (!this.btnElem) return;
      this.btnElem.classList.remove("loading");
      this.btnElem.classList.add("has-success");
      setTimeout(() => {
        this.btnElem.classList.remove("has-success");
        if (this.modalName) MicroModal.close(this.modalName);
      }, transitionDelay);

      if (!this.inputElems) return;
      this.inputElems.forEach((elem) => elem.removeAttribute("disabled"));
    }

    setReady() {
      if (!this.btnElem) return;
      this.btnElem.classList.remove("loading");
      this.btnElem.classList.remove("has-success");

      if (!this.inputElems) return;
      this.inputElems.forEach((elem) => elem.removeAttribute("disabled"));
    }

    toggleButton(isValid) {
      if (!this.btnElem) return;

      if (!isValid) this.btnElem.setAttribute("disabled", "disabled");
      else this.btnElem.removeAttribute("disabled");
    }
  }

  class DashboardProfileName {
    static selectors = {
      first_name: "#profile-first-name",
      last_name: "#profile-last-name",
      name_submit: "[data-name-submit]",
      profile_name: "[data-profile-name]",
      aside_profile_name: "[data-panel-name]",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;

      // Edit name form elems
      this.first_name_input = this.wrapper.querySelector(DashboardProfileName.selectors.first_name);
      this.last_name_input = this.wrapper.querySelector(DashboardProfileName.selectors.last_name);
      this.name_submit = this.wrapper.querySelector(DashboardProfileName.selectors.name_submit);

      // Edit name data elems
      this.profile_name = this.wrapper.querySelector(DashboardProfileName.selectors.profile_name);
      this.aside_profile_name = document.querySelector(DashboardProfileName.selectors.aside_profile_name);

      // Edit name states
      this.initialFirstName = this.first_name_input.value;
      this.initialLastName = this.last_name_input.value;
      this.firstName = this.initialFirstName;
      this.lastName = this.initialLastName;

      this.form_helper = new DashboardFormHelper({
        btnElem: this.name_submit,
        inputElems: [this.first_name_input, this.last_name_input],
        modalName: "profile-name",
      });
      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();
    }

    init() {
      this.first_name_input.addEventListener("input", this.onNameChange.bind(this));
      this.last_name_input.addEventListener("input", this.onNameChange.bind(this));
      this.name_submit.addEventListener("click", this.onNameSubmit.bind(this));
    }

    onNameChange() {
      // Update name
      this.firstName = this.first_name_input.value;
      this.lastName = this.last_name_input.value;

      // Disable if name is empty
      const isValid = this.first_name_input.checkValidity() && this.last_name_input.checkValidity();
      this.form_helper.toggleButton(isValid);
    }

    async onNameSubmit() {
      try {
        this.form_helper.setLoading();

        // Update name
        const data = await this.repository.setName(theme.customer_id, this.firstName, this.lastName);

        // Update name in UI
        const name = `${data.customer.firstName} ${data.customer.lastName}`;
        DashboardFormHelper.updateDOM({ data: name, elem: this.profile_name });
        DashboardFormHelper.updateDOM({
          data: name,
          elem: this.aside_profile_name,
        });

        // Update button state
        this.form_helper.setCompleted();
      } catch (e) {
        this.form_helper.setReady();
        this.error_modal.showError(e);
        console.error(e);
      }
    }
  }

  class DashboardProfilePassword {
    static selectors = {
      password: "#profile-password-input",
      confirm_password: "#profile-confirm-password-input",
      password_submit: "[data-password-submit]",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;

      // Edit password form elems
      this.password_input = this.wrapper.querySelector(DashboardProfilePassword.selectors.password);
      this.confirm_password_input = this.wrapper.querySelector(DashboardProfilePassword.selectors.confirm_password);
      this.password_submit = this.wrapper.querySelector(DashboardProfilePassword.selectors.password_submit);

      // Edit password states
      this.password = "";
      this.confirm_password = "";

      this.repository = new Repository();

      this.form_helper = new DashboardFormHelper({
        btnElem: this.password_submit,
        inputElems: [this.password_input, this.confirm_password_input],
      });
      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();
      
    }

    init() {
      // Attach event listeners to edit password form
      this.password_input.addEventListener("input", this.onPasswordChange.bind(this));
      this.confirm_password_input.addEventListener("input", this.onPasswordChange.bind(this));
      this.password_submit.addEventListener("click", this.onPasswordSubmit.bind(this));
    }

    onPasswordChange() {
      // Update password
      this.password = this.password_input.value;
      this.confirm_password = this.confirm_password_input.value;

      // Check password mismatch
      if (this.password !== this.confirm_password)
        this.confirm_password_input.setCustomValidity("Password does not match");
      else this.confirm_password_input.setCustomValidity("");

      const isPasswordValid = this.password_input.checkValidity() && this.confirm_password_input.checkValidity();
      this.form_helper.toggleButton(isPasswordValid);
    }

    async onPasswordSubmit() {
      try {
        this.form_helper.setLoading();

        // Update password
        await this.repository.setPassword(theme.customer_id, this.password, this.confirm_password);

        // Update button state
        this.form_helper.setCompleted(5000);

        // Trigger re-login
        location.reload();
      } catch (e) {
        this.form_helper.setReady();
        this.error_modal.showError(e);
      }
    }
  }

  class DashboardProfileNickname {
    static selectors = {
      nickname: "#profile-nickname-input",
      nickname_submit: "[data-nickname-submit]",
      profile_nickname: "[data-profile-nickname]",
      error_message_modal: "[data-error-modal-subtitle]"
    };

    constructor(wrapper) {
      this.wrapper = wrapper;

      // Edit nickname form elems
      this.nickname_input = this.wrapper.querySelector(DashboardProfileNickname.selectors.nickname);
      this.nickname_submit = this.wrapper.querySelector(DashboardProfileNickname.selectors.nickname_submit);

      // Edit nickname data elems
      this.profile_nickname = this.wrapper.querySelector(DashboardProfileNickname.selectors.profile_nickname);
      this.error_message_modal = document.querySelector(DashboardProfileNickname.selectors.error_message_modal);

      // Edit nickname states
      this.initialnickname = this.nickname_input.value;
      this.nickname = this.initialnickname;

      this.form_helper = new DashboardFormHelper({
        btnElem: this.nickname_submit,
        inputElems: [this.nickname_input],
        modalName: "profile-nickname",
      });
      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();

      this.init();
    }

    init() {
      this.nickname_input.addEventListener("input", this.onnicknameChange.bind(this));
      this.nickname_submit.addEventListener("click", this.onnicknameSubmit.bind(this));
    }

    onnicknameChange() {
      // Update nickname
      this.nickname = this.nickname_input.value;
      // Disable if nickname is empty
      //
      const isValid = this.nickname_input.checkValidity();
      this.form_helper.toggleButton(isValid);
    }

    async onnicknameSubmit() {
      try {
        this.form_helper.setLoading();

        // Update nickname
        const data = await this.repository.setNickname(theme.customer_id, this.nickname);
        // Update nickname in UI
        DashboardFormHelper.updateDOM({
          data: data.customer[0].value,
          elem: this.profile_nickname,
        });

        // Update button state
        this.form_helper.setCompleted();
      } catch (e) {
        let messageError = (e.toString().includes("Apodo contains bad words")) ? "El apodo de tu tienda digital incluye palabras no permitidas. Por favor, revisa y modifica tu nombre antes de continuar." : e;
        this.error_message_modal.innerHTML = messageError;
        this.form_helper.setReady();
        this.error_modal.showError(e);
      }
    }
  }

  class DashboardProfilePhone {
    static selectors = {
      phone: "#profile-phone-input",
      phone_submit: "[data-phone-submit]",
      profile_phone: "[data-profile-phone]",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;

      // Edit phone form elems
      this.phone_input = this.wrapper.querySelector(DashboardProfilePhone.selectors.phone);
      this.phone_submit = this.wrapper.querySelector(DashboardProfilePhone.selectors.phone_submit);

      // Edit phone data elems
      this.profile_phone = this.wrapper.querySelector(DashboardProfilePhone.selectors.profile_phone);

      // Edit phone states
      this.initialPhone = this.phone_input.value;
      this.phone = this.initialPhone;

      this.form_helper = new DashboardFormHelper({
        btnElem: this.phone_submit,
        inputElems: [this.phone_input],
        modalName: "profile-phone",
      });
      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();

      this.init();
    }

    init() {
      this.phone_input.addEventListener("input", this.onPhoneChange.bind(this));
      this.phone_submit.addEventListener("click", this.onPhoneSubmit.bind(this));
    }

    onPhoneChange() {
      // Update phone
      this.phone = this.phone_input.value;

      // Disable if phone is empty
      const isValid = this.phone_input.checkValidity();
      this.form_helper.toggleButton(isValid);
    }

    async onPhoneSubmit() {
      try {
        this.form_helper.setLoading();

        // Update phone
        const data = await this.repository.setPhone(theme.customer_id, this.phone);

        // Update phone in UI
        DashboardFormHelper.updateDOM({
          data: data.customer.phone,
          elem: this.profile_phone,
        });

        // Update button state
        this.form_helper.setCompleted();
      } catch (e) {
        this.form_helper.setReady();
        this.error_modal.showError(e);
        console.error(e);
      }
    }
  }

  class DashboardProfileFacebook {
    static selectors = {
      facebook: "#profile-facebook-input",
      facebook_submit: "[data-facebook-submit]",
      profile_facebook: "[data-profile-facebook]",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;

      // Edit facebook form elems
      this.facebook_input = this.wrapper.querySelector(DashboardProfileFacebook.selectors.facebook);
      this.facebook_submit = this.wrapper.querySelector(DashboardProfileFacebook.selectors.facebook_submit);

      // Edit facebook data elems
      this.profile_facebook = this.wrapper.querySelector(DashboardProfileFacebook.selectors.profile_facebook);

      // Edit facebook states
      this.initialFacebook = this.facebook_input.value;
      this.facebook = this.initialFacebook;

      this.form_helper = new DashboardFormHelper({
        btnElem: this.facebook_submit,
        inputElems: [this.facebook_input],
        modalName: "profile-facebook",
      });
      this.form_validator = new DashboardFormValidator();
      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();

      this.init();
    }

    init() {
      this.facebook_input.addEventListener("input", this.onFacebookChange.bind(this));
      this.facebook_submit.addEventListener("click", this.onFacebookSubmit.bind(this));
    }

    onFacebookChange() {
      // Update facebook
      this.facebook = this.facebook_input.value;

      // Disable if facebook is empty
      const isValid = this.facebook_input.checkValidity() && this.form_validator.validateTextInput(this.facebook, true);
      this.form_helper.toggleButton(isValid);
    }

    async onFacebookSubmit() {
      try {
        this.form_helper.setLoading();

        this.facebook = this.facebook.replace(/.*facebook\.com\//, '').replace(/\s+/g, '').trim();
        
        // Update facebook
        const data = await this.repository.setFacebook(theme.customer_id, this.facebook);

        // Update facebook in UI
        DashboardFormHelper.updateDOM({
          data: data.customer[0].value,
          elem: this.profile_facebook,
        });

        // Update button state
        this.form_helper.setCompleted();
      } catch (e) {
        this.form_helper.setReady();
        this.error_modal.showError(e);
        console.error(e);
      }
    }
  }

  class DashboardProfileInstagram {
    static selectors = {
      instagram: "#profile-instagram-input",
      instagram_submit: "[data-instagram-submit]",
      profile_instagram: "[data-profile-instagram]",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;

      // Edit instagram form elems
      this.instagram_input = this.wrapper.querySelector(DashboardProfileInstagram.selectors.instagram);
      this.instagram_submit = this.wrapper.querySelector(DashboardProfileInstagram.selectors.instagram_submit);

      // Edit instagram data elems
      this.profile_instagram = this.wrapper.querySelector(DashboardProfileInstagram.selectors.profile_instagram);

      // Edit instagram states
      this.initialInstagram = this.instagram_input.value;
      this.instagram = this.initialInstagram;

      this.form_helper = new DashboardFormHelper({
        btnElem: this.instagram_submit,
        inputElems: [this.instagram_input],
        modalName: "profile-instagram",
      });
      this.form_validator = new DashboardFormValidator();
      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();

      this.init();
    }

    init() {
      this.instagram_input.addEventListener("input", this.onInstagramChange.bind(this));
      this.instagram_submit.addEventListener("click", this.onInstagramSubmit.bind(this));
    }

    onInstagramChange() {
      // Update instagram
      this.instagram = this.instagram_input.value;

    // Disable if instagram is empty
    const isValid = this.instagram_input.checkValidity() && this.form_validator.validateTextInput(this.instagram, true);
    this.form_helper.toggleButton(isValid);
    }

    async onInstagramSubmit() {
      try {
        this.form_helper.setLoading();

        this.instagram = this.instagram.replace(/.*instagram\.com\//, '').replace(/\s+/g, '').trim();
        
        // Update instagram
        const data = await this.repository.setInstagram(theme.customer_id, this.instagram);

        // Update instagram in UI
        DashboardFormHelper.updateDOM({
          data: data.customer[0].value,
          elem: this.profile_instagram,
        });

        // Update button state
        this.form_helper.setCompleted();
      } catch (e) {
        this.form_helper.setReady();
        this.error_modal.showError(e);
        console.error(e);
      }
    }
  }

  class DashboardProfileTiktok {
    static selectors = {
      tiktok: "#profile-tiktok-input",
      tiktok_submit: "[data-tiktok-submit]",
      profile_tiktok: "[data-profile-tiktok]",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;

      // Edit tiktok form elems
      this.tiktok_input = this.wrapper.querySelector(DashboardProfileTiktok.selectors.tiktok);
      this.tiktok_submit = this.wrapper.querySelector(DashboardProfileTiktok.selectors.tiktok_submit);

      // Edit tiktok data elems
      this.profile_tiktok = this.wrapper.querySelector(DashboardProfileTiktok.selectors.profile_tiktok);

      // Edit tiktok states
      this.initialTiktok = this.tiktok_input.value;
      this.tiktok = this.initialTiktok;

      this.form_helper = new DashboardFormHelper({
        btnElem: this.tiktok_submit,
        inputElems: [this.tiktok_input],
        modalName: "profile-tiktok",
      });
      this.form_validator = new DashboardFormValidator();
      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();

      this.init();
    }

    init() {
      this.tiktok_input.addEventListener("input", this.onTiktokChange.bind(this));
      this.tiktok_submit.addEventListener("click", this.onTiktokSubmit.bind(this));
    }

    onTiktokChange() {
      // Update tiktok
      this.tiktok = this.tiktok_input.value;

      // Disable if tiktok is empty
      const isValid = this.tiktok_input.checkValidity() && this.form_validator.validateTextInput(this.tiktok, true);
      this.form_helper.toggleButton(isValid);
    }

    async onTiktokSubmit() {
      try {
        this.form_helper.setLoading();

        this.tiktok = this.tiktok.replace(/.*tiktok\.com\//, '').replace(/\s+/g, '').trim();

        // Update tiktok
        const data = await this.repository.setTiktok(theme.customer_id, this.tiktok);

        // Update tiktok in UI
        DashboardFormHelper.updateDOM({
          data: data.customer[0].value,
          elem: this.profile_tiktok,
        });

        // Update button state
        this.form_helper.setCompleted();
      } catch (e) {
        this.form_helper.setReady();
        this.error_modal.showError(e);
        console.error(e);
      }
    }
  }

  class DashboardProfileTwitter {
    static selectors = {
      twitter: "#profile-twitter-input",
      twitter_submit: "[data-twitter-submit]",
      profile_twitter: "[data-profile-twitter]",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;

      // Edit twitter form elems
      this.twitter_input = this.wrapper.querySelector(DashboardProfileTwitter.selectors.twitter);
      this.twitter_submit = this.wrapper.querySelector(DashboardProfileTwitter.selectors.twitter_submit);

      // Edit twitter data elems
      this.profile_twitter = this.wrapper.querySelector(DashboardProfileTwitter.selectors.profile_twitter);

      // Edit twitter states
      this.initialTwitter = this.twitter_input.value;
      this.twitter = this.initialTwitter;

      this.form_helper = new DashboardFormHelper({
        btnElem: this.twitter_submit,
        inputElems: [this.twitter_input],
        modalName: "profile-twitter",
      });
      this.form_validator = new DashboardFormValidator();
      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();

      this.init();
    }

    init() {
      this.twitter_input.addEventListener("input", this.onTwitterChange.bind(this));
      this.twitter_submit.addEventListener("click", this.onTwitterSubmit.bind(this));
    }

    onTwitterChange() {
      // Update twitter
      this.twitter = this.twitter_input.value;

      // Disable if twitter is empty
      const isValid = this.twitter_input.checkValidity() && this.form_validator.validateTextInput(this.twitter, true);
      this.form_helper.toggleButton(isValid);
    }

    async onTwitterSubmit() {
      try {
        this.form_helper.setLoading();

        this.twitter = this.twitter.replace(/.*x\.com\//, '').replace(/.*twitter\.com\//, '').replace(/\s+/g, '').trim();
        
        // Update twitter
        const data = await this.repository.setTwitter(theme.customer_id, this.twitter);

        // Update twitter in UI
        DashboardFormHelper.updateDOM({
          data: data.customer[0].value,
          elem: this.profile_twitter,
        });

        // Update button state
        this.form_helper.setCompleted();
      } catch (e) {
        this.form_helper.setReady();
        this.error_modal.showError(e);
        console.error(e);
      }
    }
  }

  class DashboardProfileYoutube {
    static selectors = {
      youtube: "#profile-youtube-input",
      youtube_submit: "[data-youtube-submit]",
      profile_youtube: "[data-profile-youtube]",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;

      // Edit youtube form elems
      this.youtube_input = this.wrapper.querySelector(DashboardProfileYoutube.selectors.youtube);
      this.youtube_submit = this.wrapper.querySelector(DashboardProfileYoutube.selectors.youtube_submit);

      // Edit youtube data elems
      this.profile_youtube = this.wrapper.querySelector(DashboardProfileYoutube.selectors.profile_youtube);

      // Edit youtube states
      this.initialyoutube = this.youtube_input.value;
      this.youtube = this.initialyoutube;

      this.form_helper = new DashboardFormHelper({
        btnElem: this.youtube_submit,
        inputElems: [this.youtube_input],
        modalName: "profile-youtube",
      });
      this.form_validator = new DashboardFormValidator();
      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();

      this.init();
    }

    init() {
      this.youtube_input.addEventListener("input", this.onyoutubeChange.bind(this));
      this.youtube_submit.addEventListener("click", this.onyoutubeSubmit.bind(this));
    }

    onyoutubeChange() {
      // Update youtube
      this.youtube = this.youtube_input.value;

      // Disable if youtube is empty
      const isValid = this.youtube_input.checkValidity() && this.form_validator.validateTextInput(this.youtube, true);
      this.form_helper.toggleButton(isValid);
    }

    async onyoutubeSubmit() {
      try {
        this.form_helper.setLoading();

        this.youtube = this.youtube.replace(/.*youtube\.com\//, '').replace(/\s+/g, '').trim();
        
        // Update youtube
        const data = await this.repository.setYoutube(theme.customer_id, this.youtube);

        // Update youtube in UI
        DashboardFormHelper.updateDOM({
          data: data.customer[0].value,
          elem: this.profile_youtube,
        });

        // Update button state
        this.form_helper.setCompleted();
      } catch (e) {
        this.form_helper.setReady();
        this.error_modal.showError(e);
        console.error(e);
      }
    }
  }

  class DashboardProfileUrlVideo {
    static selectors = {
      url_video: "#profile-url_video-input",
      url_video_submit: "[data-url_video-submit]",
      profile_url_video: "[data-profile-url_video]",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;

      // Edit url_video form elems
      this.url_video_input = this.wrapper.querySelector(DashboardProfileUrlVideo.selectors.url_video);
      this.url_video_submit = this.wrapper.querySelector(DashboardProfileUrlVideo.selectors.url_video_submit);

      // Edit url_video data elems
      this.profile_url_video = this.wrapper.querySelector(DashboardProfileUrlVideo.selectors.profile_url_video);

      // Si no existe el input, salimos silenciosamente
      if (!this.url_video_input || !this.url_video_submit || !this.profile_url_video) {
        console.warn('[DashboardProfileUrlVideo] Elementos necesarios no encontrados, clase no se inicializa.');
        return;
      }

      // Edit url_video states
      this.initialurl_video = this.url_video_input.value;
      this.url_video = this.initialurl_video;

      this.form_helper = new DashboardFormHelper({
        btnElem: this.url_video_submit,
        inputElems: [this.url_video_input],
        modalName: "profile-url_video__modal",
      });
      this.form_validator = new DashboardFormValidator();
      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();

      this.init();
    }

    init() {
      this.url_video_input.addEventListener("input", this.onurl_videoChange.bind(this));
      this.url_video_submit.addEventListener("click", this.onurl_videoSubmit.bind(this));
    }

    onurl_videoChange() {
      // Update url_video
      this.url_video = this.url_video_input.value;

      // Disable if url_video is empty
      const isValid = this.url_video_input.checkValidity() && this.form_validator.validateTextInput(this.url_video, true);
      this.form_helper.toggleButton(isValid);
    }

    async onurl_videoSubmit() {

      try{
        new URL(this.url_video);
      }
      catch(e){
        const error = { message: JSON.stringify({ error: [{ message: "Ingresa una URL" }] }) };
        this.error_modal.showError(error);
        return
      }
      const urlObj = new URL(this.url_video);
      const host = urlObj.hostname;
      const searchParams = urlObj.searchParams;
      console.log(searchParams)

      const validHosts = ["www.facebook.com", "facebook.com", "www.youtu.be", "youtu.be", "www.youtube.com", "youtube.com"];

      if (!validHosts.some(validHost => host.includes(validHost))) {
        const error = { message: JSON.stringify({ error: [{ message: `Tu URL contiene un dominio no válido: '${host}'`   }] }) };
        this.error_modal.showError(error); 
        return 
      }

      //Youtube Model
      const regex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

      //Facebook Model
      const videoRegex = /^https?:\/\/(www\.)?facebook\.com\/[^\/]+\/videos\/\d+\/?$/; // https://www.facebook.com/{usuario}/videos/{id}
      const postRegex = /^https?:\/\/(www\.)?facebook\.com\/[^\/]+\/posts\/\d+\/?$/; // https://www.facebook.com/{usuario}/posts/{id}
      const watchRegex = /^https?:\/\/(www\.)?facebook\.com\/watch\/\?v=\d+$/; // Formato watch con ?v=ID

      if(regex.test(this.url_video) || videoRegex.test(this.url_video) || postRegex.test(this.url_video) || (watchRegex.test(this.url_video) && searchParams.has("v"))){
        try {
          
          this.form_helper.setLoading();          
          // Update url_video
          const data = await this.repository.setUrlVideo(theme.customer_id, this.url_video);
  
          // Update url_video in UI
          DashboardFormHelper.updateDOM({
            data: data.customer[0].value,
            elem: this.profile_url_video,
          });
  
          // Update button state
          this.form_helper.setCompleted();
          
        } catch (e) {
          this.form_helper.setReady();
          this.error_modal.showError(e);
          console.error(e);
        }
      }else{
        const error = { message: JSON.stringify({ error: [{ message: `Verifica la estructura de la liga`}] }) };
        this.error_modal.showError(error);
      }
    }
  }

  class DashboardProfileImage {
    static selectors = {
      image_upload: "#profile-upload",
      image_submit: "[data-image-submit]",
      image_remove: "[data-image-remove]",
      image_drop: "[data-profile-drop]",
      image_preview: "[data-profile-preview]",
      inputgroup: ".inputgroup",
      profile_image: "[data-profile-image]",
    };

    static MAX_IMAGE_SIZE = 5242880;

    constructor(wrapper) {
      this.wrapper = wrapper;

      // Image upload form elems
      this.image_input = this.wrapper.querySelector(DashboardProfileImage.selectors.image_upload);
      this.image_submit = this.wrapper.querySelector(DashboardProfileImage.selectors.image_submit);
      this.image_remove = this.wrapper.querySelector(DashboardProfileImage.selectors.image_remove);
      this.image_drop = this.wrapper.querySelector(DashboardProfileImage.selectors.image_drop);
      this.image_preview = this.wrapper.querySelector(DashboardProfileImage.selectors.image_preview);
      this.inputgroup = this.wrapper.querySelector(DashboardProfileImage.selectors.inputgroup);
      this.profile_images = document.querySelectorAll(DashboardProfileImage.selectors.profile_image);

      // Image upload states
      this.profile_image = null;

      this.repository = new Repository();
      this.form_helper = new DashboardFormHelper({
        btnElem: this.image_submit,
        inputElems: [this.image_input],
        modalName: "profile-image",
      });
      this.error_modal = new DashboardErrorModal();
      this.reader = new FileReader();
    }

    init() {
      this.image_input.addEventListener("change", this.onImageChange.bind(this));
      this.image_submit.addEventListener("click", this.onImageSubmit.bind(this));
      this.image_remove.addEventListener("click", this.onImageRemove.bind(this));
      ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
        this.image_drop.addEventListener(eventName, DashboardFormHelper.preventDefaults, false);
      });
      ["dragenter", "dragover"].forEach((eventName) =>
        this.image_drop.addEventListener(eventName, () => this.image_drop.classList.add("highlight"), false)
      );
      ["dragleave", "drop"].forEach((eventName) =>
        this.image_drop.addEventListener(eventName, () => this.image_drop.classList.remove("highlight"), false)
      );
      this.image_drop.addEventListener("drop", this.onImageDrop.bind(this), false);
    }

    /**
     * On image change
     */
    onImageChange(event) {
      const files = event.target.files;
      const file = files[0];
      this.profile_image = file;

      this.update();
    }

    /**
     * On image mouse drop
     * @param {Event} event
     */
    onImageDrop(event) {
      const dt = event.dataTransfer;
      const file = dt && dt.files && dt.files[0];
      this.profile_image = file;

      this.update();
    }

    /**
     * On image remove click
     */
    onImageRemove() {
      this.profile_image = null;
      this.update();
    }

    /**
     * Update UI on image change
     */
    update() {
      const isNotImage = this.profile_image && !this.profile_image.type.includes("image");
      if (isNotImage) {
        this.profile_image = null;
        this.error_modal.showError({
          message: JSON.stringify({
            error: [{ message: "You can only upload an image file" }],
          }),
        });
      }

      const isSizeExceed = this.profile_image && this.profile_image.size > DashboardProfileImage.MAX_IMAGE_SIZE;
      if (isSizeExceed) {
        this.profile_image = null;
        this.error_modal.showError({
          message: JSON.stringify({
            error: [{ message: "You can only upload up to 5MB" }],
          }),
        });
      }

      this.form_helper.toggleButton(!!this.profile_image);
      this.updatePreview();
    }

    /**
     * Update preview image
     */
    updatePreview() {
      if (this.profile_image) {
        this.reader.readAsDataURL(this.profile_image);
        this.reader.onloadend = () => {
          DashboardFormHelper.updateDOM({
            data: this.reader.result,
            elem: this.image_preview,
            attr: "src",
          });
          this.image_preview.classList.remove("d-none");
          this.image_remove.classList.remove("d-none");
          this.inputgroup.classList.add("d-none");
        };
      } else {
        DashboardFormHelper.updateDOM({
          data: "",
          elem: this.image_preview,
          attr: "src",
        });
        this.image_preview.classList.add("d-none");
        this.image_remove.classList.add("d-none");
        this.inputgroup.classList.remove("d-none");
      }
    }

    async onImageSubmit() {
      try {
        this.form_helper.setLoading();

        // Update image
        await this.setImageAsProfile(this.profile_image);
        this.reader.readAsDataURL(this.profile_image);
        this.reader.onloadend = () => {
          this.profile_images.forEach((elem) =>
            DashboardFormHelper.updateDOM({
              data: this.reader.result,
              elem,
              attr: "src",
            })
          );
        };

        // Update button state
        this.form_helper.setCompleted();
      } catch (e) {
        this.form_helper.setReady();
        this.error_modal.showError(e);
      }
    }

    async setImageAsProfile(image) {
      // Get S3 bucket to upload
      const data = await this.repository.getImageUploadURL(image);

      // Upload image to S3 bucket
      await fetch(data.url, { method: "PUT", body: image });

      // Set uploaded image as profile image
      const customerID = theme.customer_id;
      await this.repository.setImageAsProfile(customerID, data.resourceUrl);
    }
  }

  class DashboardAboutYou {
    static selectors = {
      about_you: "#personalize-aboutyou",
      about_you_submit: "[data-aboutyou-submit]",
      personalize_about: "[data-personalize-about]",
      text_length: "[data-text-length]",
      error_message_modal: "[data-error-modal-subtitle]"
    };

    constructor(wrapper, modal) {
      this.wrapper = wrapper;
      this.modal = modal;

      if (!this.modal) return;

      this.about_you_input = this.modal.querySelector(DashboardAboutYou.selectors.about_you);
      this.about_you_submit = this.modal.querySelector(DashboardAboutYou.selectors.about_you_submit);
      this.text_length = this.modal.querySelector(DashboardAboutYou.selectors.text_length);
      this.personalize_about = this.wrapper.querySelector(DashboardAboutYou.selectors.personalize_about);
      this.error_message_modal = document.querySelector(DashboardAboutYou.selectors.error_message_modal);

      // About you state
      this.initialAboutYou = this.about_you_input.value;
      this.aboutYou = this.initialAboutYou;

      // Helpers
      this.form_helper = new DashboardFormHelper({
        btnElem: this.about_you_submit,
        inputElems: [this.about_you_input],
        modalName: "about-you",
      });
      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();

      this.init();
    }

    init() {
      this.about_you_input.addEventListener("input", this.onAboutYouChange.bind(this));
      this.about_you_submit.addEventListener("click", this.onAboutYouSubmit.bind(this));
      this.onAboutYouChange();
    }

    onAboutYouChange() {
      this.aboutYou = this.about_you_input.value;

      const isValid = this.about_you_input.checkValidity();
      this.form_helper.toggleButton(isValid);
    }

    async onAboutYouSubmit() {
      try {
        this.form_helper.setLoading();

        // Update about you
        const customerID = theme.customer_id;
        await this.repository.setSiteInfo(customerID, {
          aboutYou: this.aboutYou,
        });

        // Update data in DOM
        DashboardFormHelper.updateDOM({
          data: this.aboutYou.replaceAll("\n", "<br/>"),
          elem: this.personalize_about,
        });

        this.form_helper.setCompleted();
      } catch (e) {
        let messageError = (e.toString().includes("Error: About you contains bad words")) ? "Tu descripción contiene palabras no permitidas. Por favor, revisa y modifica tu texto antes de continuar." : e;
        this.error_message_modal.innerHTML = messageError;

        this.form_helper.setReady();
        this.error_modal.showError(e);
      }
    }
  }

  class DashboardSiteName {
    static selectors = {
      site_name: "#personalize-sitename",
      site_name_submit: "[data-sitename-submit]",
      personalize_sitename: "[data-personalize-sitename]",
      text_length: "[data-text-length]",
      error_message: "#personalize-error-message",
      error_message_modal: "[data-error-modal-subtitle]"
    };

    constructor(wrapper, modal) {
      this.wrapper = wrapper;
      this.modal = modal;

      this.site_name_input = this.modal.querySelector(DashboardSiteName.selectors.site_name);
      this.site_name_submit = this.modal.querySelector(DashboardSiteName.selectors.site_name_submit);
      this.text_length = this.modal.querySelector(DashboardSiteName.selectors.text_length);
      this.personalize_sitename = this.wrapper.querySelector(DashboardSiteName.selectors.personalize_sitename);
      this.error_message = document.querySelector(DashboardSiteName.selectors.error_message);
      this.error_message_modal = document.querySelector(DashboardSiteName.selectors.error_message_modal);

      // Site name state
      this.initialSiteName = this.site_name_input.value;
      this.siteName = this.initialSiteName;

      // Helpers
      this.form_helper = new DashboardFormHelper({
        btnElem: this.site_name_submit,
        inputElems: [this.site_name_input],
        modalName: "site-name",
      });
      this.form_validator = new DashboardFormValidator();
      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();

      this.init();
    }

    init() {
      this.site_name_input.addEventListener("input", this.onSiteNameChange.bind(this));
      this.site_name_submit.addEventListener("click", this.onSiteNameSubmit.bind(this));
      this.onSiteNameChange();
    }

    onSiteNameChange() {
      this.siteName = this.site_name_input.value;

      const isValid = this.site_name_input.checkValidity();
      this.form_helper.toggleButton(isValid);
    }

    async onSiteNameSubmit() {
      try {
        this.form_helper.setLoading();

        // Update site name
        const customerID = theme.customer_id;
        // validate input
        var validator_data = await this.form_validator.validateSiteName(this.siteName);
        if (validator_data.isValid) {
          let res = await this.repository.setSiteInfo(customerID, {
            siteName: this.siteName,
          });
          let status = res.status;
          if (status === 200) {
            // Update data in DOM
            DashboardFormHelper.updateDOM({
              data: this.siteName.replaceAll("\n", "<br/>"),
              elem: this.personalize_sitename,
            });
            this.form_helper.setCompleted();
            this.error_message.innerText = "";
          } else if (status === 400) {
            this.error_message.innerText = res.message === 'That site name is already in use, please try another one.' ? 'Este nombre ya se encuentra en uso, por favor intenta con uno diferente.' : res.message.includes("Site name already set") ?  "El nombre de tu tienda ha sido configurado con éxito." : res.message;
            this.form_helper.setReady();
          } else if (status === 500) {
            this.error_message.innerText = res.message;
            this.form_helper.setReady();
          }
        } else {
          let error_message_inner = "El nombre de tu tienda digital incluye palabras no permitidas, por favor elige un nombre diferente.";
          if (validator_data.hasBannedWords) {
            // small hack to decode HTML entities
            var txt = document.createElement("textarea");
            txt.innerHTML = theme.strings.errors.bannedWords;
            error_message_inner = txt.value;
          }
          this.error_message.innerHTML = error_message_inner;
          this.form_helper.setReady();
        }
      } catch (e) {
        let messageError = (e.toString().includes("Site name contains bad words")) ? "El nombre de tu tienda digital incluye palabras no permitidas, Por favor, revisa y modifica tu nombre antes de continuar." : e;
        this.error_message_modal.innerHTML = messageError;

        this.form_helper.setReady();
        this.error_modal.showError(e);
      }
    }
  }

  class DashboardReorder {
    static selectors = {
      modal: "[data-reorder-modal]",
      close_box_btn: "[data-close-box]",
      box: "[data-modal-box]",
      save_reorder_btn: "[data-save-order]",
      reorder_list: "[data-reorder-list]",
      featured_product_list: "[data-featured-product-list]",
      reorder_item: "[data-reorder-item]",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;
      this.modal = document.querySelector(DashboardReorder.selectors.modal);

      if (!this.modal) return;

      this.close_box_btn = this.modal.querySelector(DashboardReorder.selectors.close_box_btn);
      this.box = this.modal.querySelector(DashboardReorder.selectors.box);
      this.save_reorder_btn = this.modal.querySelector(DashboardReorder.selectors.save_reorder_btn);
      this.reorder_list = this.modal.querySelector(DashboardReorder.selectors.reorder_list);
      this.featured_product_list = this.wrapper.querySelector(DashboardReorder.selectors.featured_product_list);
      this.reorder_items = this.wrapper.querySelectorAll(DashboardReorder.selectors.reorder_item);

      this.sortable = new Sortable(this.reorder_list, { animation: 150 });
      this.product_order = this.sortable.toArray();

      this.repository = new Repository();
      this.error_modal = new DashboardErrorModal();
      this.form_helper = new DashboardFormHelper({
        btnElem: this.save_reorder_btn,
      });

      modal("personalize-reorder", this.onOpenModal.bind(this));

      this.init();
    }

    init() {
      this.close_box_btn.addEventListener("click", this.onCloseBox.bind(this));
      this.save_reorder_btn.addEventListener("click", this.onSaveReorder.bind(this));
    }

    onCloseBox() {
      this.box.classList.add("d-none");
    }

    async onSaveReorder() {
      try {
        this.form_helper.setLoading();

        // Save order state
        this.product_order = this.sortable.toArray();

        // Update order in Shopify
        const customerID = theme.customer_id;
        await this.repository.reorderFeaturedProduct(customerID, this.product_order);

        // Update button state
        this.form_helper.setCompleted();

        // Update order in DOM
        location.reload();
      } catch (e) {
        console.error(e);
        this.error_modal.showError(e);
      }
    }

    onOpenModal() {
      this.form_helper.setReady();
      this.sortable.sort(this.product_order);
    }
  }

  class DashboardProfile {
    constructor(wrapper) {
      this.wrapper = wrapper;

      this.dashboard_profile_name = new DashboardProfileName(this.wrapper);
      this.dashboard_profile_password = new DashboardProfilePassword(this.wrapper);
      this.dashboard_profile_nickname = new DashboardProfileNickname(this.wrapper);
      this.dashboard_profile_phone = new DashboardProfilePhone(this.wrapper);
      this.dashboard_profile_facebook = new DashboardProfileFacebook(this.wrapper);
      this.dashboard_profile_instagram = new DashboardProfileInstagram(this.wrapper);
      this.dashboard_profile_tiktok = new DashboardProfileTiktok(this.wrapper);
      this.dashboard_profile_twitter = new DashboardProfileTwitter(this.wrapper);
      this.dashboard_profile_youtube = new DashboardProfileYoutube(this.wrapper);
      this.dashboard_profile_youtube = new DashboardProfileUrlVideo(this.wrapper);
      this.dashboard_profile_image = new DashboardProfileImage(this.wrapper);

      modal("profile");

      this.init();
    }

    init() {
      this.dashboard_profile_name.init();
      this.dashboard_profile_password.init();
      this.dashboard_profile_image.init();
    }
  }

  class DashboardAddress {
    static selectors = {
      order_history: "[data-dashboard-section='order-history']",
      dashboard_links: ".dashboard-link > a",
      page_links: ".pagination a",
      save: "[data-order-save]",
      print: "[data-order-print]",
      cells: ".dashboard-row > td",
    };

    static HASH = "#order-history";

    constructor(wrapper) {
      this.wrapper = wrapper;
      this.block = this.wrapper.querySelector(DashboardAddress.selectors.order_history);
      this.dashboard_links = this.block.querySelectorAll(DashboardAddress.selectors.dashboard_links);
      this.page_links = this.block.querySelectorAll(DashboardAddress.selectors.page_links);
      this.save_btn = this.block.querySelector(DashboardAddress.selectors.save);
      this.print_btn = this.block.querySelector(DashboardAddress.selectors.print);
      this.cells = this.block.querySelectorAll(DashboardAddress.selectors.cells);

      this.init();
      this.updateLinks();
    }

    init() {
      if (this.save_btn) this.save_btn.addEventListener("click", this.onSave.bind(this));
      if (this.print_btn) this.print_btn.addEventListener("click", this.onPrint.bind(this));
    }

    removePseudoCell() {
      this.cells.forEach((elem) => elem.classList.add("no-before"));
    }

    addPseudoCell() {
      this.cells.forEach((elem) => elem.classList.remove("no-before"));
    }

    getOption(orderNumber) {
      const fileName = `Order #${orderNumber}`;
      const option = {
        filename: fileName,
        image: { type: "pdf" },
        html2canvas: {
          windowWidth: 800,
          scrollX: 0,
          scrollY: 0,
          x: 0,
          y: 0,
        },
      };

      return option;
    }

    async onSave(e) {
      // Set loading state
      this.save_btn.classList.add("loading");
      this.removePseudoCell();

      // Save order pdf
      const option = this.getOption(e.currentTarget.dataset.orderNumber);
      await html2pdf().set(option).from(this.block).save();

      // Revert loading state
      this.save_btn.classList.remove("loading");
      this.addPseudoCell();
    }

    async onPrint(e) {
      // Set loading state
      this.print_btn.classList.add("loading");
      this.removePseudoCell();

      // Generate order pdf
      const option = this.getOption(e.target.dataset.orderNumber);
      const pdf = await html2pdf().set(option).from(this.block).toPdf().get("pdf");

      // Print pdf
      pdf.autoPrint();
      window.open(pdf.output("bloburl"), "_blank");

      // Revert loading state
      this.print_btn.classList.remove("loading");
      this.addPseudoCell();
    }

    updateLinks() {
      this.dashboard_links.forEach((elem) => {
        const url = new URL(elem.href);
        elem.href = url.pathname + DashboardAddress.HASH;
      });

      this.page_links.forEach((elem) => {
        const url = new URL(elem.href);
        elem.href = url.pathname + url.search + DashboardAddress.HASH;
      });
    }
  }

  class DashboardFeaturedProductDeleteModal {
    static selectors = {
      delete_btn: "[data-delete-submit]",
    };

    constructor(section, modal) {
      this.section = section;
      this.modal = modal;

      this.delete_btn = this.modal.querySelector(DashboardFeaturedProductDeleteModal.selectors.delete_btn);

      this.metafieldKey = this.modal.dataset.metafieldKey;
      this.productID = this.modal.dataset.productId;

      this.featuredItemRow = this.section.querySelector(`[data-featured-product-id="${this.productID}"]`);

      // Helpers
      this.repository = new Repository();
      this.form_helper = new DashboardFormHelper({ btnElem: this.delete_btn });
      this.error_modal = new DashboardErrorModal();

      this.init();
    }

    init() {
      this.delete_btn.addEventListener("click", this.onDelete.bind(this));
    }

    async onDelete() {
      try {
        this.form_helper.setLoading();

        // Remove featured product
        const customerID = theme.customer_id;
        await this.repository.deleteFeaturedProduct(this.metafieldKey, customerID);

        this.form_helper.setCompleted();

        // Remove from DOM
        location.reload();
      } catch (e) {
        this.form_helper.setReady();
        this.error_modal.showError(e);
        console.error(e);
      }
    }
  }

  class DashboardFeaturedProductEditModal {
    static selectors = {
      edit_textarea: "[data-featured-edit]",
      edit_submit: "[data-edit-submit]",
      feedback_text: "[data-featured-product-feedback]",
      text_length: "[data-text-length]",
    };

    constructor(section, modal) {
      this.section = section;
      this.modal = modal;

      this.edit_textarea = this.modal.querySelector(DashboardFeaturedProductEditModal.selectors.edit_textarea);
      this.edit_submit = this.modal.querySelector(DashboardFeaturedProductEditModal.selectors.edit_submit);
      this.text_length = this.modal.querySelector(DashboardFeaturedProductEditModal.selectors.text_length);

      // State
      this.feedback = this.edit_textarea.value;

      this.metafield_key = this.modal.dataset.metafieldKey;
      this.productID = this.modal.dataset.productId;

      this.featured_item_row = this.section.querySelector(`[data-featured-product-id="${this.productID}"]`);
      this.feedback_text = this.featured_item_row.querySelector(
        DashboardFeaturedProductEditModal.selectors.feedback_text
      );

      // Helpers
      this.repository = new Repository();
      this.form_helper = new DashboardFormHelper({
        btnElem: this.edit_submit,
        inputElems: [this.edit_textarea],
        modalName: `edit_${this.productID}`,
      });
      this.error_modal = new DashboardErrorModal();

      this.init();
    }

    init() {
      this.edit_submit.addEventListener("click", this.onEdit.bind(this));
      this.edit_textarea.addEventListener("input", this.onInput.bind(this));
    }

    onInput() {
      this.feedback = this.edit_textarea.value;

      const isValid = this.edit_textarea.checkValidity();
      this.form_helper.toggleButton(isValid);

      this.text_length.innerHTML = `(${this.feedback.length}/${DashboardFeaturedProductAddModal.MAX_FEEDBACK})`;
    }

    async onEdit() {
      try {
        this.form_helper.setLoading();

        // Update featured product
        const customerID = theme.customer_id;
        await this.repository.editFeaturedProduct(this.metafield_key, customerID, this.feedback);

        // Update DOM
        DashboardFormHelper.updateDOM({
          data: this.feedback.replaceAll("\n", "<br/>"),
          elem: this.feedback_text,
        });

        this.form_helper.setCompleted();
      } catch (e) {
        this.form_helper.setReady();
        this.error_modal.showError(e);
        console.error(e);
      }
    }
  }

  class DashboardFeaturedProductAddModal {
    static selectors = {
      search_page: "[data-search-page]",
      edit_page: "[data-edit-page]",
      show_feedback: "[data-show-feedback-page]",
      back_btn: "[data-go-back-modal]",
      search_hinttext: "[data-search-hinttext]",
      search_result: "[data-search-result]",
      search_input: "[data-search-input]",
      feedback_textarea: "[data-featured-edit]",
      feedback_submit: "[data-feedback-submit]",
      text_length: "[data-text-length]",
      product_radio: "input[name='personalize_search_product']",
    };

    static MAX_FEEDBACK = 140;

    constructor(section, modal) {
      this.section = section;
      this.modal = modal;

      if (!this.modal) return;

      this.search_page = this.modal.querySelector(DashboardFeaturedProductAddModal.selectors.search_page);
      this.edit_page = this.modal.querySelector(DashboardFeaturedProductAddModal.selectors.edit_page);
      this.search_hinttext = this.modal.querySelector(DashboardFeaturedProductAddModal.selectors.search_hinttext);
      this.search_result = this.modal.querySelector(DashboardFeaturedProductAddModal.selectors.search_result);
      this.search_input = this.modal.querySelector(DashboardFeaturedProductAddModal.selectors.search_input);
      this.show_feedback = this.modal.querySelector(DashboardFeaturedProductAddModal.selectors.show_feedback);
      this.feedback_textarea = this.modal.querySelector(DashboardFeaturedProductAddModal.selectors.feedback_textarea);
      this.feedback_submit = this.modal.querySelector(DashboardFeaturedProductAddModal.selectors.feedback_submit);
      this.back_btn = this.modal.querySelector(DashboardFeaturedProductAddModal.selectors.back_btn);
      this.text_length = this.modal.querySelector(DashboardFeaturedProductAddModal.selectors.text_length);

      this.product_id = null;
      this.hinttext = this.search_hinttext.dataset.searchHinttext;
      this.feedback = this.feedback_textarea.value;

      // Helpers
      this.form_helper = new DashboardFormHelper({
        btnElem: this.feedback_submit,
        inputElems: [this.feedback_textarea],
      });
      this.repository = new Repository();
      this.error_modal = new DashboardErrorModal();

      this.init();
    }

    init() {
      this.search_input.addEventListener(
        "input",
        DashboardFormHelper.debounce((event) => this.onChange(event), 300).bind(this)
      );

      this.show_feedback.addEventListener("click", this.showEditPage.bind(this));

      this.back_btn.addEventListener("click", this.showSearchPage.bind(this));

      this.feedback_textarea.addEventListener("input", this.onFeedbackChange.bind(this));
      this.onFeedbackChange();

      this.feedback_submit.addEventListener("click", this.onFeedbackSubmit.bind(this));
    }

    onFeedbackChange() {
      this.feedback = this.feedback_textarea.value;

      const isValid = this.feedback_textarea.checkValidity();
      this.form_helper.toggleButton(isValid);

      this.text_length.innerHTML = `(${this.feedback.length}/${DashboardFeaturedProductAddModal.MAX_FEEDBACK})`;
    }

    async onFeedbackSubmit() {
      try {
        this.form_helper.setLoading();

        // Update featured product
        const customerID = theme.customer_id;
        await this.repository.addFeaturedProduct(this.product_id, customerID, this.feedback);

        this.form_helper.setCompleted();

        // Update order in DOM
        location.reload();
      } catch (e) {
        this.form_helper.setReady();
        this.error_modal.showError(e);
        console.error(e);
      }
    }

    reset() {
      // Reset state
      this.product_id = null;

      // Reset DOM
      this.search_result.innerHTML = "";
      this.search_hinttext.innerHTML = this.hinttext;
      this.search_input.value = "";
      this.feedback_textarea.value = "";
      this.showSearchPage();
      this.hideLoading();
      this.updateFooter();
    }

    setLoading() {
      this.search_result.classList.add("loading");
    }

    hideLoading() {
      this.search_result.classList.remove("loading");
    }

    onChange() {
      this.product_id = null;
      this.updateFooter();

      const searchTerm = this.search_input.value.trim();
      if (!searchTerm.length) {
        this.reset();
        return;
      }

      this.getSearchResults(searchTerm);
    }

    async getSearchResults(searchTerm) {
      try {
        this.setLoading();

        const searchResult = await this.repository.getProductSearch(searchTerm);

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = searchResult;

        const searchSection = tempDiv.querySelector("#shopify-section-dashboard-predictive-search");
        if (searchSection) {
          const items = searchSection.querySelectorAll('li[data-search-item]');
          items.forEach(item => {
            console.log('>', item)
            const label = item.querySelector('label[style="display:none"]');
            if (label && label.textContent.includes('no_disponible')) {
              item.remove();
            }
          });
        };
        
        // const resultMarkup = new DOMParser()
        //   .parseFromString(searchResult, "text/html")
        //   .querySelector("#shopify-section-dashboard-predictive-search").innerHTML;

        this.search_result.innerHTML = searchSection.innerHTML;
        this.updateMessage();
        this.attachEventListeners();

        this.hideLoading();
      } catch (e) {
        console.error(e);
        this.error_modal.showError(e);
      }
    }

    updateMessage() {
      const resultCount = this.search_result.querySelectorAll("li").length;
      const searchTerm = this.search_input.value.trim();
      const message = `${resultCount} Productos encontrados para “${searchTerm}" `;

      this.search_hinttext.innerHTML = message;
    }

    attachEventListeners() {
      this.product_inputs = this.search_result.querySelectorAll(
        DashboardFeaturedProductAddModal.selectors.product_radio
      );
      this.product_inputs.forEach((input) => {
        input.addEventListener("change", (event) => this.onProductChange(event));
        input.addEventListener("click", (event) => this.onProductClick(event));
      });
    }

    onProductChange(e) {
      this.product_id = e.target.value;
      this.updateFooter();
    }

    onProductClick(e) {
      const elem = e.target;
      if (elem.dataset.waschecked === "true") {
        elem.checked = false;

        this.product_id = null;
        this.updateFooter();

        elem.dataset.waschecked = "false";
      } else {
        elem.dataset.waschecked = "true";
      }

      this.product_inputs.forEach((input) => {
        if (input !== elem) input.dataset.waschecked = "false";
      });
    }

    updateFooter() {
      if (this.product_id) this.search_result.classList.add("footer-visible");
      else this.search_result.classList.remove("footer-visible");
    }

    showEditPage() {
      this.search_page.classList.add("d-none");
      this.edit_page.classList.remove("d-none");

      this.feedback_textarea.focus();
    }

    showSearchPage() {
      this.search_page.classList.remove("d-none");
      this.edit_page.classList.add("d-none");
    }
  }

  class DashboardHidePartnerInfo {
    static selectors = {
      bettershiping_checkbox: "[data-bettershiping]",
      cashOnDelivery_checkbox: "[data-cashOnDelivery]",
      email_checkbox: "[data-email-pref]",
      phone_checkbox: "[data-phone-pref]",
      pws_checkbox: "[data-pws-pref]",
      bettershiping_label: "[data-bettershiping-label]",
      cashOnDelivery_label: "[data-cashOnDelivery-label]",
      email_label: "[data-email-pref-label]",
      phone_label: "[data-phone-pref-label]",
      pws_label: "[data-pws-pref-label]",
      containerPerosnalDelivered: "#warningPersonalDelivered",
      containerCOD: "#warningCOD",
      spiners: ".spinner"
    };

    constructor(wrapper) {
      this.wrapper = wrapper;
      this.bettershiping_checkbox = this.wrapper.querySelector(DashboardHidePartnerInfo.selectors.bettershiping_checkbox);
      this.cashOnDelivery_checkbox = this.wrapper.querySelector(DashboardHidePartnerInfo.selectors.cashOnDelivery_checkbox);
      this.email_checkbox = this.wrapper.querySelector(DashboardHidePartnerInfo.selectors.email_checkbox);
      this.phone_checkbox = this.wrapper.querySelector(DashboardHidePartnerInfo.selectors.phone_checkbox);
      this.pws_checkbox = this.wrapper.querySelector(DashboardHidePartnerInfo.selectors.pws_checkbox);

      this.bettershiping_label = this.wrapper.querySelector(DashboardHidePartnerInfo.selectors.bettershiping_label);
      this.cashOnDelivery_label = this.wrapper.querySelector(DashboardHidePartnerInfo.selectors.cashOnDelivery_label);
      this.email_label = this.wrapper.querySelector(DashboardHidePartnerInfo.selectors.email_label);
      this.phone_label = this.wrapper.querySelector(DashboardHidePartnerInfo.selectors.phone_label);
      this.pws_label = this.wrapper.querySelector(DashboardHidePartnerInfo.selectors.pws_label);

      this.containerPerosnalDelivered = this.wrapper.querySelector(DashboardHidePartnerInfo.selectors.containerPerosnalDelivered);
      this.containerCOD = this.wrapper.querySelector(DashboardHidePartnerInfo.selectors.containerCOD);

      this.spiners = this.wrapper.querySelectorAll(DashboardHidePartnerInfo.selectors.spiners);

      this.repository = new Repository();

      this.value = null;
      this.valueCash = null;

      this.init();
    }

    init() {
      const btnClose = document.getElementById('closeAd')
      const btnAccept = document.getElementById('acceptarAd')
      const btnCloseCashOndelivery = document.getElementById('closeAdCashOndelivery')
      const btnAcceptCashOndelivery = document.getElementById('acceptarAdCashOndelivery')

      if(btnClose){
        btnClose.addEventListener("click", this.closeAd.bind(this));
      }

      if(btnAccept){
        btnAccept.addEventListener("click", this.acceptAd.bind(this));
      }
      if(btnCloseCashOndelivery){
        btnCloseCashOndelivery.addEventListener("click", this.closeAdCashOndelivery.bind(this));
      }

      if(btnAcceptCashOndelivery){
        btnAcceptCashOndelivery.addEventListener("click", this.acceptAdCashOndelivery.bind(this));
      }

      if (this.bettershiping_checkbox) {
        this.bettershiping_checkbox.addEventListener("change", (e)=>{
          this.advertisinOpen();
          this.value = e.target.checked.toString();
          ///this.onPersonalDeliveredChange.bind(this)
        });
      }
      if (this.cashOnDelivery_checkbox) {
        this.cashOnDelivery_checkbox.addEventListener("change", (e)=>{
          this.advertisinOpenCashOndelivery();
          this.valueCash = e.target.checked.toString();
          //this.onCashOnDeliveryChange.bind(this)
        });
      }
      if (this.email_checkbox) {
        this.email_checkbox.addEventListener("change", this.onEmailChange.bind(this));
      }
      if (this.phone_checkbox) {
        this.phone_checkbox.addEventListener("change", this.onPhoneChange.bind(this));
      }
      if (this.pws_checkbox) {
        this.pws_checkbox.addEventListener("change", this.onPwsChange.bind(this));
      }
      
      this.WarningTexts();
      this.hideSpinners();

    }

    WarningTexts() {
      if(this.bettershiping_checkbox.checked == true){
        this.containerPerosnalDelivered.innerHTML = window?.translations?.onPersonalDelivering
      }
      else{
        this.containerPerosnalDelivered.innerHTML = window?.translations?.offPersonalDelivering
      }
      if(this.cashOnDelivery_checkbox.checked == true){
        this.containerCOD.innerHTML = window?.translations?.onCod
      }
      else{
        this.containerCOD.innerHTML = window?.translations?.offCod
      }
    }
    disableButtons(){
      this.bettershiping_checkbox.disabled = true;
      this.cashOnDelivery_checkbox.disabled = true;
    } 
    enableButtons(){
      this.bettershiping_checkbox.disabled = false;
      this.cashOnDelivery_checkbox.disabled = false;
    }

    hideSpinners (){
      this.spiners.forEach((ele)=>{
        ele.style.display = 'none';
      })
    }

    showSpinners (){
      this.spiners.forEach((ele)=>{
        ele.style.display = 'block';
      })
    }

  async validateDateTime() {
  const div = document.querySelector('#dateTime');
  const customerID = theme.customer_id;
  this.showSpinners();
  if (!div) {
    console.warn("No se encontró el div con atributo dateTime");
    return false;
  }
  
  const dt1 = div.getAttribute('dateTime');

  if (!dt1 || isNaN(new Date(dt1).getTime())) {
    div.setAttribute('dateTime', new Date().toISOString());
    await this.repository.setLastUpdateDelivery(customerID, new Date().toISOString())
      .catch((e)=>console.log(e))
    console.warn("El atributo dateTime está vacío o no es una fecha válida");
    this.hideSpinners();
    return true;
  }

  const fecha1 = new Date(dt1);
  const fecha2 = new Date(); // Fecha actual

  const diffMs = Math.abs(fecha2 - fecha1);
  const unaHora = 1000 * 60 * 5;
  const unDia = 1000 * 60 * 60 * 24;

  if (diffMs <= unaHora) {
    console.log("Acción ejecutada: diferencia <= 1h");
    this.hideSpinners();
    return true;
  } else if (diffMs >= unDia) {

    div.setAttribute('dateTime', new Date().toISOString());
    await this.repository.setLastUpdateDelivery(customerID, new Date().toISOString())
      .catch((e)=>console.log(e))
    console.log("Acción ejecutada: diferencia >= 1d");
    this.hideSpinners();
    return true;

  } else {
    console.log("No se ejecuta: diferencia entre 1h y 1d");
    this.hideSpinners();
    return false;
  }
}

  calculateDateTime() {
    const div = document.querySelector('#dateTime');
    const dt1 = div.getAttribute('dateTime');
    const text = document.getElementById('timeDenied');

    const fechaBase = new Date(dt1);
    const fechaLimite = new Date(fechaBase.getTime() + 24 * 60 * 60 * 1000);
    const diffMs = fechaLimite - new Date();

    if (diffMs <= 0) {
      text.innerHTML = "¡Ya han pasado las 24 horas!";
    } else {
      const totalMin = Math.floor(diffMs / (1000 * 60));
      const horas = Math.floor(totalMin / 60);
      const minutos = totalMin % 60;

      if (horas > 0) {
        text.innerHTML = `${horas}h ${minutos}m restantes`;
      } else {
        text.innerHTML = `${minutos}m restantes`;
      }
    }

  }

    advertisinOpen(e){
      const btnAbrir = document.getElementById('advertising')
      btnAbrir.showPopover(e)
    }

    async acceptAd(e){
      const btnAbrir = document.getElementById('advertising')
      btnAbrir.hidePopover()
      const isValid = await this.validateDateTime();
      if (isValid) {
        this.onPersonalDeliveredChange(e)
      }
      else{
        const denied = document.getElementById('advertisingDenied')
        //this.calculateDateTime();
        this.bettershiping_checkbox.checked = !this.bettershiping_checkbox.checked
        denied.showPopover(e);
      }
    }

    closeAd(){
      const btnClose = document.getElementById('advertising')
      btnClose.hidePopover()
      if(this.bettershiping_checkbox.checked == true){
        this.bettershiping_checkbox.checked = false;
        this.bettershiping_label.classList.add("unchecked");
        this.WarningTexts();
        this.enableButtons();
        this.hideSpinners();
      }
      else{
        this.bettershiping_checkbox.checked = true;
        this.bettershiping_label.classList.add("checked");
        this.WarningTexts();
        this.enableButtons();
        this.hideSpinners();
      }
    }

    //cash
    advertisinOpenCashOndelivery(e){
      const btnAbrir = document.getElementById('advertisingCashOndelivery')
      btnAbrir.showPopover(e)
    }

    async acceptAdCashOndelivery(e){
      const btnAbrir = document.getElementById('advertisingCashOndelivery')
      btnAbrir.hidePopover()
      console.log(e)
      const isValid = await this.validateDateTime();
      if (isValid) {
        this.onCashOnDeliveryChange(e)
      }
      else{
        const denied = document.getElementById('advertisingDenied')
        //this.calculateDateTime();
        this.cashOnDelivery_checkbox.checked = !this.cashOnDelivery_checkbox.checked
        denied.showPopover(e);
      }
    }

    closeAdCashOndelivery(){
      const btnClose = document.getElementById('advertisingCashOndelivery')
      btnClose.hidePopover()
      if(this.cashOnDelivery_checkbox.checked == true){
        this.cashOnDelivery_checkbox.checked = false;
        this.cashOnDelivery_label.classList.add("unchecked");
        this.WarningTexts();
        this.enableButtons();
        this.hideSpinners();
      }
      else{
        this.cashOnDelivery_checkbox.checked = true;
        this.cashOnDelivery_label.classList.add("checked");
        this.WarningTexts();
        this.enableButtons();
        this.hideSpinners();
      }
    }

    async onPersonalDeliveredChange(e) {
      if(this.bettershiping_checkbox.checked == false && this.cashOnDelivery_checkbox.checked == true){
        const customerID = theme.customer_id;
        
        this.disableButtons();
        this.showSpinners();
        await this.repository.setPersonalDeliveredInfo(customerID, this.value)
        .catch(()=>{
          this.bettershiping_checkbox.checked = !this.bettershiping_checkbox.checked;
          return
        })
        .finally( async ()=>{
          await this.repository.setCashOnDeliveryInfo(customerID, "false")
          .catch(()=>{
            this.cashOnDelivery_checkbox.checked = true
            return
          })
          .finally(()=>{
            this.cashOnDelivery_checkbox.checked = false
            this.cashOnDelivery_label.classList.add("unchecked");
            this.bettershiping_label.classList.add("unchecked");
            this.WarningTexts();
            this.enableButtons();
            this.hideSpinners();
          })
        })

      }else{
        try {
          this.disableButtons();
          this.showSpinners();
          const customerID = theme.customer_id;
          await this.repository.setPersonalDeliveredInfo(customerID, this.value);
        } catch (e) {
          this.bettershiping_checkbox.checked = !this.bettershiping_checkbox.checked;
        } finally {
          this.bettershiping_checkbox.disabled = false;
          let boolValue = (this.value === "true");
          if (!boolValue) this.bettershiping_label.classList.add("unchecked");
          else this.bettershiping_label.classList.remove("unchecked");
          this.WarningTexts();
          this.enableButtons();
          this.hideSpinners();
        }
      }
    }

    async onCashOnDeliveryChange(e) {
      if(this.bettershiping_checkbox.checked == false && this.cashOnDelivery_checkbox.checked == true){
        const customerID = theme.customer_id;
        this.disableButtons();
        this.showSpinners();
        await this.repository.setPersonalDeliveredInfo(customerID, "true")
        .then((res)=>console.log(res))
        .catch((err)=>{
          this.bettershiping_checkbox.checked = false
          console.log(err)
        })
        .finally(async ()=>{
          await this.repository.setCashOnDeliveryInfo(customerID, this.valueCash)
          .catch((err)=> {
            console.log(err)
            this.cashOnDelivery_checkbox.checked = !this.cashOnDelivery_checkbox.checked;
          })
          .finally(()=>{
            this.bettershiping_checkbox.checked = true
            this.bettershiping_label.classList.remove("unchecked");
            this.cashOnDelivery_label.classList.remove("unchecked");
            this.WarningTexts();
            this.enableButtons();
            this.hideSpinners();
          })
        })
      }
      else{
        try {
          this.cashOnDelivery_checkbox.disabled = true;
          const customerID = theme.customer_id;
          this.disableButtons();
          this.showSpinners();
          await this.repository.setCashOnDeliveryInfo(customerID, this.valueCash);
        } catch (e) {
          this.cashOnDelivery_checkbox.checked = !this.cashOnDelivery_checkbox.checked;
        } finally {
          this.cashOnDelivery_checkbox.disabled = false;
          let boolValue = (this.valueCash === "true");
          if (!boolValue) {
            this.cashOnDelivery_label.classList.add("unchecked");
            this.cashOnDelivery_label.classList.remove("checked");
          }
          else {
            this.cashOnDelivery_label.classList.remove("unchecked");
            this.cashOnDelivery_label.classList.add("checked");
          }
          this.WarningTexts();
          this.enableButtons();
          this.hideSpinners();
        }
      }
    }

    async onEmailChange(e) {
      try {
        this.email_checkbox.disabled = true;
        const customerID = theme.customer_id;
        await this.repository.setSiteInfo(customerID, {
          hideEmail: !e.target.checked,
        });
      } catch (e) {
        this.email_checkbox.checked = !this.email_checkbox.checked;
      } finally {
        this.email_checkbox.disabled = false;

        if (!e.target.checked) this.email_label.classList.add("unchecked");
        else this.email_label.classList.remove("unchecked");
      }
    }

    async onPwsChange(e) {
      try {
        this.pws_checkbox.disabled = true;
        const customerID = theme.customer_id;
        await this.repository.setSiteInfo(customerID, {
          hidePersonalSite: !e.target.checked,
        });
      } catch (e) {
        this.pws_checkbox.checked = !this.pws_checkbox.checked;
      } finally {
        this.pws_checkbox.disabled = false;

        if (!e.target.checked) this.pws_label.classList.add("unchecked");
        else this.pws_label.classList.remove("unchecked");
      }
    }

    async onPhoneChange(e) {
      try {
        this.phone_checkbox.disabled = true;
        const customerID = theme.customer_id;
        await this.repository.setSiteInfo(customerID, {
          hidePhone: !e.target.checked,
        });
      } catch (e) {
        this.phone_checkbox.checked = !this.phone_checkbox.checked;
      } finally {
        this.phone_checkbox.disabled = false;

        if (!e.target.checked) this.phone_label.classList.add("unchecked");
        else this.phone_label.classList.remove("unchecked");
      }
    }
  }

  class DashboardContactMethodPref {
    static selectors = {
      contact_method_input: "data-contact-method-pref",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;
      this.contact_method_inputs = this.wrapper.querySelectorAll(
        `[${DashboardContactMethodPref.selectors.contact_method_input}]`
      );

      this.error_modal = new DashboardErrorModal();
      this.repository = new Repository();

      this.init();
    }

    init() {
      this.contact_method_inputs.forEach((input) => {
        input.addEventListener("change", this.onContactMethodSubmit.bind(this));
      });

      const contactMethod1 = $("[data-contact-method-pref-1]");
      const contactMethod2 = $("[data-contact-method-pref-2]");
      const contactMethod3 = $("[data-contact-method-pref-3]");

      contactMethod1.change((e) => {
        const value = e.target.value;
        if (contactMethod2.val() === value) contactMethod2.val("");
        if (contactMethod3.val() === value) contactMethod3.val("");
        this.updateContactMethodPref();
      });

      contactMethod2.change((e) => {
        const value = e.target.value;
        if (contactMethod1.val() === value) contactMethod1.val("");
        if (contactMethod3.val() === value) contactMethod3.val("");
        this.updateContactMethodPref();
      });

      contactMethod3.change((e) => {
        const value = e.target.value;
        if (contactMethod1.val() === value) contactMethod1.val("");
        if (contactMethod2.val() === value) contactMethod2.val("");
        this.updateContactMethodPref();
      });
    }

    async updateContactMethodPref() {
      const values = [
        $("[data-contact-method-pref-1]").val(),
        $("[data-contact-method-pref-2]").val(),
        $("[data-contact-method-pref-3]").val(),
      ].join(",");

      try {
        const customerID = theme.customer_id;
        await this.repository.setContactMethodPref(customerID, values);
      } catch (e) {
        console.error(e);
      }
    }

    async onContactMethodSubmit() {
      const selectedInput = this.wrapper.querySelector(
        `[${DashboardContactMethodPref.selectors.contact_method_input}]:checked`
      );
      const selected = selectedInput.getAttribute(DashboardContactMethodPref.selectors.contact_method_input);

      try {
        const customerID = theme.customer_id;
        await this.repository.setContactMethodPref(customerID, selected);
      } catch (e) {
        this.error_modal.showError(e);
        console.error(e);
      }
    }
  }

  class DashboardSelectedBanners {
    static selectors = {
      banner_checkbox: "[data-banner-toggle]",
      banner_card: "[data-banner-card]",
      banner_label: "[data-banner-label]",
      banner_spinner: "[data-banner-spinner]",
      header_preview: "[data-simulated-header-preview]",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;
      this.banner_checkboxes = Array.from(
        this.wrapper.querySelectorAll(DashboardSelectedBanners.selectors.banner_checkbox)
      );
      this.preview = this.wrapper.querySelector(DashboardSelectedBanners.selectors.header_preview);
      this.repository = new Repository();

      this.init();
    }

    init() {
      if (!this.banner_checkboxes.length) return;

      this.banner_checkboxes.forEach((checkbox) => {
        this.syncBannerCard(checkbox);
        checkbox.addEventListener("change", this.onBannerChange.bind(this));
      });

      this.syncPreview();
    }

    getSelectedBannersValue() {
      return this.banner_checkboxes.map((checkbox) => (checkbox.checked ? "1" : "0")).join(",");
    }

    getBannerCard(checkbox) {
      return checkbox.closest(DashboardSelectedBanners.selectors.banner_card);
    }

    syncBannerCard(checkbox) {
      const card = this.getBannerCard(checkbox);
      if (!card) return;

      const label = card.querySelector(DashboardSelectedBanners.selectors.banner_label);
      if (label) {
        if (checkbox.checked) label.classList.remove("unchecked");
        else label.classList.add("unchecked");
      }

      card.dataset.bannerActive = checkbox.checked ? "true" : "false";
    }

    syncPreview() {
      if (!this.preview) return;

      const activeBanner = this.banner_checkboxes.find((checkbox) => checkbox.checked);
      const fallbackBanner = this.banner_checkboxes[0];
      const previewValue = activeBanner?.dataset.bannerPreview || fallbackBanner?.dataset.bannerPreview || "banner-01";

      this.preview.dataset.banner = previewValue;
    }

    setDisabled(disabled) {
      this.banner_checkboxes.forEach((checkbox) => {
        checkbox.disabled = disabled;
      });
    }

    showSpinner(card) {
      const spinner = card?.querySelector(DashboardSelectedBanners.selectors.banner_spinner);
      if (spinner) spinner.style.display = "block";
    }

    hideSpinner(card) {
      const spinner = card?.querySelector(DashboardSelectedBanners.selectors.banner_spinner);
      if (spinner) spinner.style.display = "none";
    }

    async onBannerChange(event) {
      const checkbox = event.currentTarget;
      const previousChecked = !checkbox.checked;
      const card = this.getBannerCard(checkbox);

      this.syncBannerCard(checkbox);
      this.syncPreview();
      this.setDisabled(true);
      this.showSpinner(card);

      try {
        const customerID = theme.customer_id;
        await this.repository.setSelectedBanners(customerID, this.getSelectedBannersValue());
      } catch (e) {
        checkbox.checked = previousChecked;
        this.syncBannerCard(checkbox);
        this.syncPreview();
        console.error(e);
      } finally {
        this.hideSpinner(card);
        this.setDisabled(false);
      }
    }
  }

  class DashboardHeaderColor {
    static selectors = {
      color_select: "[data-simulated-header-color]",
      header_preview: "[data-simulated-header-preview]",
      spinner: "[data-header-color-spinner]",
    };

    constructor(wrapper) {
      this.wrapper = wrapper;
      this.color_select = this.wrapper.querySelector(DashboardHeaderColor.selectors.color_select);
      this.preview = this.wrapper.querySelector(DashboardHeaderColor.selectors.header_preview);
      this.spinner = this.wrapper.querySelector(DashboardHeaderColor.selectors.spinner);
      this.repository = new Repository();
      this.currentValue = this.color_select?.value || "amarillo";

      this.init();
    }

    init() {
      if (!this.color_select) return;

      this.syncPreview();
      this.color_select.addEventListener("change", this.onColorChange.bind(this));
    }

    syncPreview() {
      if (!this.preview || !this.color_select) return;
      this.preview.dataset.color = this.color_select.value || "amarillo";
    }

    showSpinner() {
      if (this.spinner) this.spinner.style.display = "block";
    }

    hideSpinner() {
      if (this.spinner) this.spinner.style.display = "none";
    }

    async onColorChange() {
      const previousValue = this.currentValue || "amarillo";
      const nextValue = this.color_select.value || "amarillo";

      this.syncPreview();
      this.color_select.disabled = true;
      this.showSpinner();

      try {
        const customerID = theme.customer_id;
        await this.repository.setSelectedHeaderColor(customerID, nextValue);
        this.currentValue = nextValue;
      } catch (e) {
        this.color_select.value = previousValue;
        this.syncPreview();
        console.error(e);
      } finally {
        this.hideSpinner();
        this.color_select.disabled = false;
      }
    }
  }

  class DashboardFormValidator {
    constructor() {}

    getBannedWords() {
      const getBannedWords = loadScript({
        json: window.theme.assets.banned_words,
      });
      return getBannedWords
        .then((words) => {
          return words;
        })
        .catch((e) => {
          //console.log("failed to load banned words script");
          //console.log(e);
        });
    }

    validateTextInput(text, allowUrl = false) {
      if (allowUrl) return /^[a-zA-Z0-9À-ÿ\s-._~:/?#[\]@!$&'()*+,;=%]+$/.test(text);
      return /^[a-zA-Z0-9À-ÿ\s-]+$/.test(text);
    }
  
    async validateTextAreaInput(text) {
      this.banned_words = await this.getBannedWords();
      const wordsArr = Object.values(this.banned_words.personalize).flat();
      const wordsRegex = new RegExp(wordsArr.join("|"), "gi");
      const hasBannedWords = wordsRegex.test(text);
      return {
        isValid: !hasBannedWords,
        hasBannedWords: hasBannedWords,
      };
    }

    async validateSiteName(sitename) {
      this.banned_words = await this.getBannedWords();
      const wordsArr = this.banned_words.sitename;
      const charsRegex = /^[a-zA-Z0-9]+([_-][a-zA-Z0-9]+)*$/g;
      const wordsRegex = new RegExp(wordsArr.join("|"), "gi");
      const hasBannedWords = wordsRegex.test(sitename);
      return {
        isValid: charsRegex.test(sitename) && !hasBannedWords,
        hasBannedWords: hasBannedWords,
      };
    }
  }

  class DashboardPersonalize {
    static selectors = {
      about_you_modal: "[data-aboutyou-modal]",
      site_name_modal: "[data-sitename-modal]",
      delete_modal: "[data-delete-modal]",
      edit_modal: "[data-edit-modal]",
      add_modal: "[data-add-modal]",
    };

    constructor(section) {
      this.wrapper = section;
      this.about_you_modal = this.wrapper.querySelector(DashboardPersonalize.selectors.about_you_modal);
      this.dashboard_personalize_aboutyou = new DashboardAboutYou(this.wrapper, this.about_you_modal);
      this.dashboard_hideinfo = new DashboardHidePartnerInfo(this.wrapper);
      this.dashboard_contact_method_pref = new DashboardContactMethodPref(this.wrapper);
      this.dashboard_selected_banners = new DashboardSelectedBanners(this.wrapper);
      this.dashboard_header_color = new DashboardHeaderColor(this.wrapper);
      this.dashboard_personalize_reorder = new DashboardReorder(this.wrapper);
      this.site_name_modal = this.wrapper.querySelector(DashboardPersonalize.selectors.site_name_modal);
      this.dashboard_personalize_siteName = new DashboardSiteName(this.wrapper, this.site_name_modal);

      this.delete_modal_elems = this.wrapper.querySelectorAll(DashboardPersonalize.selectors.delete_modal);
      this.delete_modal_elems.forEach((elem) => new DashboardFeaturedProductDeleteModal(section, elem));

      this.delete_modal_elems = this.wrapper.querySelectorAll(DashboardPersonalize.selectors.edit_modal);
      this.delete_modal_elems.forEach((elem) => new DashboardFeaturedProductEditModal(section, elem));

      this.add_modal_elem = this.wrapper.querySelector(DashboardPersonalize.selectors.add_modal);
      new DashboardFeaturedProductAddModal(section, this.add_modal_elem);

      modal("personalize");
    }
  }

  class PartnerPicks {
    constructor(section) {
      this.wrapper = section;
      this.addBtn = this.wrapper.querySelector(Dashboard.selectors.addBtn);
      this.idInput = this.wrapper.querySelector(Dashboard.selectors.idInput);

      this.editBtns = this.wrapper.querySelectorAll(Dashboard.selectors.edit);
      this.deleteBtns = this.wrapper.querySelectorAll(Dashboard.selectors.delete);

      this.repository = new Repository();

      this.init();
    }

    init() {
      this.event();
    }

    event() {
      if (this.addBtn) {
        this.addBtn.addEventListener("click", async (event) => {
          const productID = this.idInput.value;
          if (productID) this.addFeaturedProduct(productID);
        });
      }

      this.deleteBtns.forEach((deleteBtn) => {
        deleteBtn.addEventListener("click", () => {
          const metafieldKey = deleteBtn.dataset.metafieldKey;
          if (metafieldKey) this.deleteFeaturedProduct(metafieldKey);
        });
      });

      this.editBtns.forEach((editBtn) => {
        editBtn.addEventListener("click", () => {
          const metafieldKey = editBtn.dataset.metafieldKey;
          const feedbackElem = this.wrapper.querySelector(`[data-pick-feedback="${metafieldKey}"]`);
          const feedback = feedbackElem.value;
          if (metafieldKey && feedback) this.editFeaturedProduct(metafieldKey, feedback);
        });
      });
    }

    async addFeaturedProduct(productID) {
      try {
        const customerID = theme.customer_id;
        await this.repository.addFeaturedProduct(productID, customerID);
        location.reload();
      } catch (e) {
        console.error(e);
      }
    }

    async deleteFeaturedProduct(metafieldKey) {
      try {
        const customerID = theme.customer_id;
        await this.repository.deleteFeaturedProduct(metafieldKey, customerID);
        location.reload();
      } catch (e) {
        console.error(e);
      }
    }

    async editFeaturedProduct(metafieldKey, feedback) {
      try {
        const customerID = theme.customer_id;
        await this.repository.editFeaturedProduct(metafieldKey, customerID, feedback);
        location.reload();
      } catch (e) {
        console.error(e);
      }
    }
  }

  const dashboard = {
    onLoad() {
      new Dashboard(this.container);
    },
  };

  register("customer-dashboard", [dashboard]);

  const wrap = (toWrap, wrapperClass = "", wrapper) => {
    wrapper = wrapper || document.createElement("div");
    wrapper.classList.add(wrapperClass);
    toWrap.parentNode.insertBefore(wrapper, toWrap);
    return wrapper.appendChild(toWrap);
  };

  document.addEventListener("DOMContentLoaded", function () {
    window.isRTL = document.documentElement.getAttribute("dir") === "rtl";

    // Load all registered sections on the page.
    load("*");

    // Animate on scroll
    if (window.theme.settings.animate_scroll) {
      AOS.init({ once: true });
      document.body.classList.add("aos-initialized");
      document.body.classList.add("theme-animate-scroll");
    }

    // Animate on hover
    if (window.theme.settings.animate_hover) {
      document.body.classList.add("theme-animate-hover");
    }

    // When images load, clear the background color
    document.addEventListener("lazyloaded", function (event) {
      const lazyImage = event.target.parentNode;
      if (lazyImage.classList.contains("lazy-image")) {
        lazyImage.style.backgroundImage = "none";
      }
    });

    // Target tables to make them scrollable
    const tableSelectors = ".rte table";
    const tables = document.querySelectorAll(tableSelectors);
    tables.forEach((table) => {
      wrap(table, "rte__table-wrapper");
    });

    // Target iframes to make them responsive
    const iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe';
    const frames = document.querySelectorAll(iframeSelectors);
    frames.forEach((frame) => {
      wrap(frame, "rte__video-wrapper");
    });

    document.addEventListener("mousedown", () => {
      document.body.classList.remove("focus-enabled");
    });
    document.addEventListener("keyup", (event) => {
      if (event.keyCode === 9) {
        document.body.classList.add("focus-enabled");
      }
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (window.navigator.cookieEnabled) {
      document.documentElement.className = document.documentElement.className.replace(
        "supports-no-cookies",
        "supports-cookies"
      );
    }

    // Common a11y fixes
    focusHash();
    bindInPageLinks();

    let hasNativeSmoothScroll = "scrollBehavior" in document.documentElement.style;
    if (!hasNativeSmoothScroll) {
      loadScript({ url: window.theme.assets.smoothscroll });
    }
  });
})(
  themeVendor.FlickityFade,
  themeVendor.BodyScrollLock,
  themeVendor.MicroModal,
  themeVendor.Rellax,
  themeVendor.Flickity,
  themeVendor.themeCurrency,
  themeVendor.Sqrl,
  themeVendor.axios,
  themeVendor.themeAddresses,
  themeVendor.ellipsis,
  themeVendor.FlickitySync,
  themeVendor.AOS
);
